import { defineComponent as ip, computed as I, watch as Ae, h as Wu, onMounted as mt, onUpdated as Hg, onBeforeUnmount as Yl, inject as Oe, reactive as ai, readonly as bi, resolveComponent as $, createElementBlock as U, openBlock as D, createVNode as q, withCtx as j, createTextVNode as Me, toDisplayString as Q, normalizeClass as He, createElementVNode as R, renderSlot as nt, createBlock as W, createSlots as Zl, effectScope as $g, getCurrentScope as Fg, onScopeDispose as Vg, shallowRef as fe, nextTick as Ct, toValue as ve, getCurrentInstance as Xl, toRef as op, ref as J, customRef as zg, watchEffect as ap, unref as V, markRaw as Wg, toRaw as Gg, withDirectives as bn, normalizeStyle as ht, vShow as sp, Fragment as gt, createCommentVNode as ee, useTemplateRef as yn, renderList as nr, resolveDynamicComponent as si, isRef as lp, defineAsyncComponent as G, Suspense as Yg, useCssVars as up, withModifiers as cl, toRefs as Kl, provide as ti, onUnmounted as cp, withKeys as Gu } from "vue";
import Yu from "axios";
import Zg, { useVuelidate as dp } from "@vuelidate/core";
import fp from "vuedraggable";
const hp = Symbol("wormhole");
function pp() {
  const n = Oe(hp);
  if (!n)
    throw new Error(`
    [portal-vue]: Necessary Injection not found. Make sur you installed the plugin properly.`);
  return n;
}
const vp = typeof window < "u";
function Xg(n, e) {
  return n.map((t, r) => [r, t]).sort(function(t, r) {
    return e(t[1], r[1]) || t[0] - r[0];
  }).map((t) => t[1]);
}
function Kg(n, e) {
  const t = pp();
  function r() {
    if (!vp)
      return;
    const { to: o, name: a, order: s } = n;
    e.default ? t.open({
      to: o,
      from: a,
      order: s,
      content: e.default
    }) : i();
  }
  function i(o) {
    t.close({
      to: o ?? n.to,
      from: n.name
    });
  }
  mt(() => {
    n.disabled || r();
  }), Hg(() => {
    n.disabled ? i() : r();
  }), Yl(() => {
    i();
  }), Ae(
    () => n.to,
    (o, a) => {
      n.disabled || (a && a !== o && i(a), r());
    }
  );
}
const Qg = ip({
  compatConfig: { MODE: 3 },
  name: "portal",
  props: {
    disabled: { type: Boolean },
    name: { type: [String, Symbol], default: () => Symbol() },
    order: { type: Number },
    slotProps: { type: Object, default: () => ({}) },
    to: {
      type: String,
      default: () => String(Math.round(Math.random() * 1e7))
    }
  },
  setup(n, { slots: e }) {
    return Kg(n, e), () => n.disabled && e.default ? e.default(n.slotProps) : null;
  }
}), Jg = (n, { slots: e }) => {
  var t;
  return (t = e.default) == null ? void 0 : t.call(e);
}, dl = ip({
  compatConfig: { MODE: 3 },
  name: "portalTarget",
  props: {
    multiple: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    slotProps: { type: Object, default: () => ({}) }
  },
  emits: ["change"],
  setup(n, { emit: e, slots: t }) {
    const r = pp(), i = I(
      () => {
        const o = r.getContentForTarget(
          n.name,
          n.multiple
        ), a = t.wrapper, s = o.map((u) => u.content(n.slotProps)), l = a ? s.flatMap(
          (u) => u.length ? a(u) : []
        ) : s.flat(1);
        return {
          vnodes: l,
          vnodesFn: () => l
        };
      }
    );
    return Ae(
      i,
      ({ vnodes: o }) => {
        const a = o.length > 0, s = r.transports.get(n.name), l = s ? [...s.keys()] : [];
        e("change", { hasContent: a, sources: l });
      },
      { flush: "post" }
    ), () => {
      var o;
      return i.value.vnodes.length ? [
        Wu("div", {
          style: "display: none",
          key: "__portal-vue-hacky-scoped-slot-repair__"
        }),
        Wu(Jg, i.value.vnodesFn)
      ] : (o = t.default) == null ? void 0 : o.call(t);
    };
  }
});
function em(n = !0) {
  const e = ai(/* @__PURE__ */ new Map());
  function t(a) {
    if (!vp)
      return;
    const { to: s, from: l, content: u, order: c = 1 / 0 } = a;
    if (!s || !l || !u)
      return;
    e.has(s) || e.set(s, /* @__PURE__ */ new Map());
    const d = e.get(s), f = {
      to: s,
      from: l,
      content: u,
      order: c
    };
    d.set(l, f);
  }
  function r(a) {
    const { to: s, from: l } = a;
    if (!s || !l)
      return;
    const u = e.get(s);
    !u || (u.delete(l), u.size || e.delete(s));
  }
  function i(a, s) {
    const l = e.get(a);
    if (!l)
      return [];
    const u = Array.from((l == null ? void 0 : l.values()) || []);
    return s ? Xg(
      u,
      (c, d) => c.order - d.order
    ) : [u.pop()];
  }
  const o = {
    open: t,
    close: r,
    transports: e,
    getContentForTarget: i
  };
  return n ? bi(o) : o;
}
const tm = em();
function rm(n, e = {}) {
  e.portalName !== !1 && n.component(e.portalName || "Portal", Qg), e.portalTargetName !== !1 && n.component(e.portalTargetName || "PortalTarget", dl);
  const t = e.wormhole ?? tm;
  n.provide(hp, t);
}
const qe = "BASE_COLUMN", Cn = "LAYOUT_NODE_SINGLE_COLUMN", wn = "LAYOUT_NODE_DOUBLE_COLUMN", Tn = "LAYOUT_NODE_TRIPLE_COLUMN", Sn = "LAYOUT_NODE_QUADRUPLE_COLUMN", Hr = "LAYOUT_NODE_FULL_WIDTH_COLUMN", xn = "LAYOUT_NODE_LEFT_SIDEBAR", An = "LAYOUT_NODE_RIGHT_SIDEBAR", et = "LAYOUT_NODE_SHARED_CONTENT", $r = "CONTENT_NODE_TEXT", ri = "CONTENT_NODE_HEADING", Hn = "CONTENT_NODE_IMAGE", fl = "CONTENT_NODE_CODE", hl = "CONTENT_NODE_SPACER", On = "CONTENT_NODE_GALLERY", pl = "CONTENT_NODE_VIDEO", vl = "CONTENT_NODE_SEPARATOR", gl = "CONTENT_NODE_BUTTON", ml = "CONTENT_NODE_FORM", _l = "CONTENT_NODE_QUOTE", En = "CONTENT_NODE_SLIDER", In = "CONTENT_NODE_CARD", bl = "CONTENT_NODE_TABLE", Ut = "CONTENT_NODE_ACCORDION", St = "CONTENT_NODE_PANEL", li = "CONTENT_NODE_LIST", ui = "CONTENT_NODE_NAVIGATION", Nn = "CONTENT_NODE_SHARED_CONTENT_ERROR", mr = "layout", _r = "content", Ql = "sub_content", Zu = "default", dw = "light", fw = "dark", Jl = [
  {
    name: "One Column",
    icon: "OneColumnIcon",
    type: Cn
  },
  {
    name: "Two Columns",
    icon: "TwoColumnsIcon",
    type: wn
  },
  {
    name: "Three Columns",
    icon: "ThreeColumnsIcon",
    type: Tn
  },
  {
    name: "Four Columns",
    icon: "FourColumnsIcon",
    type: Sn
  },
  {
    name: "Left Sidebar",
    icon: "LeftSidebarIcon",
    type: xn
  },
  {
    name: "Right Sidebar",
    icon: "RightSidebarIcon",
    type: An
  },
  {
    name: "Full Width",
    icon: "FullWidthIcon",
    type: Hr
  }
].map((n) => ({ ...n, group: mr })), yi = [
  {
    name: "Heading",
    icon: "HeadingIcon",
    type: ri
  },
  {
    name: "Text",
    icon: "TextIcon",
    type: $r
  },
  {
    name: "Image",
    icon: "ImageIcon",
    type: Hn
  },
  {
    name: "Gallery",
    icon: "GalleryIcon",
    type: On
  },
  {
    name: "Slider",
    icon: "SliderIcon",
    type: En
  },
  {
    name: "Code",
    icon: "EmbedIcon",
    type: fl
  },
  {
    name: "Video",
    icon: "VideoIcon",
    type: pl
  },
  {
    name: "Accordion",
    icon: "AccordionIcon",
    type: Ut
  },
  {
    name: "Spacer",
    icon: "SpacerIcon",
    type: hl
  },
  {
    name: "Separator",
    icon: "SeparatorIcon",
    type: vl
  },
  {
    name: "Card",
    icon: "CardIcon",
    type: In
  },
  {
    name: "Table",
    icon: "TableIcon",
    type: bl
  },
  {
    name: "Quote",
    icon: "QuoteIcon",
    type: _l
  },
  {
    name: "Form",
    icon: "FormIcon",
    type: ml
  },
  {
    name: "Button",
    icon: "ButtonIcon",
    type: gl
  },
  {
    name: "List",
    type: li
  },
  {
    name: "Navigation",
    icon: "NavigationIcon",
    type: ui
  },
  {
    name: "SharedContentError",
    icon: "",
    type: Nn
  }
].map((n) => ({ ...n, group: _r, component: `${n.name}Node` })), gp = [
  {
    name: "Accordion Panel",
    component: "AccordionPanelNode",
    type: St
  }
].map((n) => ({ ...n, group: Ql })), nm = [
  li
], im = [
  Nn
], Lt = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  DARK: "#333333"
};
var Xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $t(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Bi, Xu;
function om() {
  if (Xu) return Bi;
  Xu = 1;
  function n() {
    this.__data__ = [], this.size = 0;
  }
  return Bi = n, Bi;
}
var Ui, Ku;
function Ci() {
  if (Ku) return Ui;
  Ku = 1;
  function n(e, t) {
    return e === t || e !== e && t !== t;
  }
  return Ui = n, Ui;
}
var ji, Qu;
function wi() {
  if (Qu) return ji;
  Qu = 1;
  var n = Ci();
  function e(t, r) {
    for (var i = t.length; i--; )
      if (n(t[i][0], r))
        return i;
    return -1;
  }
  return ji = e, ji;
}
var Hi, Ju;
function am() {
  if (Ju) return Hi;
  Ju = 1;
  var n = wi(), e = Array.prototype, t = e.splice;
  function r(i) {
    var o = this.__data__, a = n(o, i);
    if (a < 0)
      return !1;
    var s = o.length - 1;
    return a == s ? o.pop() : t.call(o, a, 1), --this.size, !0;
  }
  return Hi = r, Hi;
}
var $i, ec;
function sm() {
  if (ec) return $i;
  ec = 1;
  var n = wi();
  function e(t) {
    var r = this.__data__, i = n(r, t);
    return i < 0 ? void 0 : r[i][1];
  }
  return $i = e, $i;
}
var Fi, tc;
function lm() {
  if (tc) return Fi;
  tc = 1;
  var n = wi();
  function e(t) {
    return n(this.__data__, t) > -1;
  }
  return Fi = e, Fi;
}
var Vi, rc;
function um() {
  if (rc) return Vi;
  rc = 1;
  var n = wi();
  function e(t, r) {
    var i = this.__data__, o = n(i, t);
    return o < 0 ? (++this.size, i.push([t, r])) : i[o][1] = r, this;
  }
  return Vi = e, Vi;
}
var zi, nc;
function Ti() {
  if (nc) return zi;
  nc = 1;
  var n = om(), e = am(), t = sm(), r = lm(), i = um();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, zi = o, zi;
}
var Wi, ic;
function cm() {
  if (ic) return Wi;
  ic = 1;
  var n = Ti();
  function e() {
    this.__data__ = new n(), this.size = 0;
  }
  return Wi = e, Wi;
}
var Gi, oc;
function dm() {
  if (oc) return Gi;
  oc = 1;
  function n(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
  }
  return Gi = n, Gi;
}
var Yi, ac;
function fm() {
  if (ac) return Yi;
  ac = 1;
  function n(e) {
    return this.__data__.get(e);
  }
  return Yi = n, Yi;
}
var Zi, sc;
function hm() {
  if (sc) return Zi;
  sc = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return Zi = n, Zi;
}
var Xi, lc;
function mp() {
  if (lc) return Xi;
  lc = 1;
  var n = typeof Xn == "object" && Xn && Xn.Object === Object && Xn;
  return Xi = n, Xi;
}
var Ki, uc;
function Et() {
  if (uc) return Ki;
  uc = 1;
  var n = mp(), e = typeof self == "object" && self && self.Object === Object && self, t = n || e || Function("return this")();
  return Ki = t, Ki;
}
var Qi, cc;
function Si() {
  if (cc) return Qi;
  cc = 1;
  var n = Et(), e = n.Symbol;
  return Qi = e, Qi;
}
var Ji, dc;
function pm() {
  if (dc) return Ji;
  dc = 1;
  var n = Si(), e = Object.prototype, t = e.hasOwnProperty, r = e.toString, i = n ? n.toStringTag : void 0;
  function o(a) {
    var s = t.call(a, i), l = a[i];
    try {
      a[i] = void 0;
      var u = !0;
    } catch {
    }
    var c = r.call(a);
    return u && (s ? a[i] = l : delete a[i]), c;
  }
  return Ji = o, Ji;
}
var eo, fc;
function vm() {
  if (fc) return eo;
  fc = 1;
  var n = Object.prototype, e = n.toString;
  function t(r) {
    return e.call(r);
  }
  return eo = t, eo;
}
var to, hc;
function tn() {
  if (hc) return to;
  hc = 1;
  var n = Si(), e = pm(), t = vm(), r = "[object Null]", i = "[object Undefined]", o = n ? n.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? i : r : o && o in Object(s) ? e(s) : t(s);
  }
  return to = a, to;
}
var ro, pc;
function Ft() {
  if (pc) return ro;
  pc = 1;
  function n(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return ro = n, ro;
}
var no, vc;
function eu() {
  if (vc) return no;
  vc = 1;
  var n = tn(), e = Ft(), t = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
  function a(s) {
    if (!e(s))
      return !1;
    var l = n(s);
    return l == r || l == i || l == t || l == o;
  }
  return no = a, no;
}
var io, gc;
function gm() {
  if (gc) return io;
  gc = 1;
  var n = Et(), e = n["__core-js_shared__"];
  return io = e, io;
}
var oo, mc;
function mm() {
  if (mc) return oo;
  mc = 1;
  var n = gm(), e = function() {
    var r = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function t(r) {
    return !!e && e in r;
  }
  return oo = t, oo;
}
var ao, _c;
function _p() {
  if (_c) return ao;
  _c = 1;
  var n = Function.prototype, e = n.toString;
  function t(r) {
    if (r != null) {
      try {
        return e.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return ao = t, ao;
}
var so, bc;
function _m() {
  if (bc) return so;
  bc = 1;
  var n = eu(), e = mm(), t = Ft(), r = _p(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, c = RegExp(
    "^" + l.call(u).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(f) {
    if (!t(f) || e(f))
      return !1;
    var h = n(f) ? c : o;
    return h.test(r(f));
  }
  return so = d, so;
}
var lo, yc;
function bm() {
  if (yc) return lo;
  yc = 1;
  function n(e, t) {
    return e == null ? void 0 : e[t];
  }
  return lo = n, lo;
}
var uo, Cc;
function Nr() {
  if (Cc) return uo;
  Cc = 1;
  var n = _m(), e = bm();
  function t(r, i) {
    var o = e(r, i);
    return n(o) ? o : void 0;
  }
  return uo = t, uo;
}
var co, wc;
function tu() {
  if (wc) return co;
  wc = 1;
  var n = Nr(), e = Et(), t = n(e, "Map");
  return co = t, co;
}
var fo, Tc;
function xi() {
  if (Tc) return fo;
  Tc = 1;
  var n = Nr(), e = n(Object, "create");
  return fo = e, fo;
}
var ho, Sc;
function ym() {
  if (Sc) return ho;
  Sc = 1;
  var n = xi();
  function e() {
    this.__data__ = n ? n(null) : {}, this.size = 0;
  }
  return ho = e, ho;
}
var po, xc;
function Cm() {
  if (xc) return po;
  xc = 1;
  function n(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return po = n, po;
}
var vo, Ac;
function wm() {
  if (Ac) return vo;
  Ac = 1;
  var n = xi(), e = "__lodash_hash_undefined__", t = Object.prototype, r = t.hasOwnProperty;
  function i(o) {
    var a = this.__data__;
    if (n) {
      var s = a[o];
      return s === e ? void 0 : s;
    }
    return r.call(a, o) ? a[o] : void 0;
  }
  return vo = i, vo;
}
var go, Oc;
function Tm() {
  if (Oc) return go;
  Oc = 1;
  var n = xi(), e = Object.prototype, t = e.hasOwnProperty;
  function r(i) {
    var o = this.__data__;
    return n ? o[i] !== void 0 : t.call(o, i);
  }
  return go = r, go;
}
var mo, Ec;
function Sm() {
  if (Ec) return mo;
  Ec = 1;
  var n = xi(), e = "__lodash_hash_undefined__";
  function t(r, i) {
    var o = this.__data__;
    return this.size += this.has(r) ? 0 : 1, o[r] = n && i === void 0 ? e : i, this;
  }
  return mo = t, mo;
}
var _o, Ic;
function xm() {
  if (Ic) return _o;
  Ic = 1;
  var n = ym(), e = Cm(), t = wm(), r = Tm(), i = Sm();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, _o = o, _o;
}
var bo, Nc;
function Am() {
  if (Nc) return bo;
  Nc = 1;
  var n = xm(), e = Ti(), t = tu();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new n(),
      map: new (t || e)(),
      string: new n()
    };
  }
  return bo = r, bo;
}
var yo, kc;
function Om() {
  if (kc) return yo;
  kc = 1;
  function n(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return yo = n, yo;
}
var Co, Dc;
function Ai() {
  if (Dc) return Co;
  Dc = 1;
  var n = Om();
  function e(t, r) {
    var i = t.__data__;
    return n(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return Co = e, Co;
}
var wo, Rc;
function Em() {
  if (Rc) return wo;
  Rc = 1;
  var n = Ai();
  function e(t) {
    var r = n(this, t).delete(t);
    return this.size -= r ? 1 : 0, r;
  }
  return wo = e, wo;
}
var To, Pc;
function Im() {
  if (Pc) return To;
  Pc = 1;
  var n = Ai();
  function e(t) {
    return n(this, t).get(t);
  }
  return To = e, To;
}
var So, Mc;
function Nm() {
  if (Mc) return So;
  Mc = 1;
  var n = Ai();
  function e(t) {
    return n(this, t).has(t);
  }
  return So = e, So;
}
var xo, Lc;
function km() {
  if (Lc) return xo;
  Lc = 1;
  var n = Ai();
  function e(t, r) {
    var i = n(this, t), o = i.size;
    return i.set(t, r), this.size += i.size == o ? 0 : 1, this;
  }
  return xo = e, xo;
}
var Ao, qc;
function ru() {
  if (qc) return Ao;
  qc = 1;
  var n = Am(), e = Em(), t = Im(), r = Nm(), i = km();
  function o(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return o.prototype.clear = n, o.prototype.delete = e, o.prototype.get = t, o.prototype.has = r, o.prototype.set = i, Ao = o, Ao;
}
var Oo, Bc;
function Dm() {
  if (Bc) return Oo;
  Bc = 1;
  var n = Ti(), e = tu(), t = ru(), r = 200;
  function i(o, a) {
    var s = this.__data__;
    if (s instanceof n) {
      var l = s.__data__;
      if (!e || l.length < r - 1)
        return l.push([o, a]), this.size = ++s.size, this;
      s = this.__data__ = new t(l);
    }
    return s.set(o, a), this.size = s.size, this;
  }
  return Oo = i, Oo;
}
var Eo, Uc;
function bp() {
  if (Uc) return Eo;
  Uc = 1;
  var n = Ti(), e = cm(), t = dm(), r = fm(), i = hm(), o = Dm();
  function a(s) {
    var l = this.__data__ = new n(s);
    this.size = l.size;
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = i, a.prototype.set = o, Eo = a, Eo;
}
var Io, jc;
function yp() {
  if (jc) return Io;
  jc = 1;
  var n = Nr(), e = function() {
    try {
      var t = n(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return Io = e, Io;
}
var No, Hc;
function nu() {
  if (Hc) return No;
  Hc = 1;
  var n = yp();
  function e(t, r, i) {
    r == "__proto__" && n ? n(t, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : t[r] = i;
  }
  return No = e, No;
}
var ko, $c;
function Cp() {
  if ($c) return ko;
  $c = 1;
  var n = nu(), e = Ci();
  function t(r, i, o) {
    (o !== void 0 && !e(r[i], o) || o === void 0 && !(i in r)) && n(r, i, o);
  }
  return ko = t, ko;
}
var Do, Fc;
function Rm() {
  if (Fc) return Do;
  Fc = 1;
  function n(e) {
    return function(t, r, i) {
      for (var o = -1, a = Object(t), s = i(t), l = s.length; l--; ) {
        var u = s[e ? l : ++o];
        if (r(a[u], u, a) === !1)
          break;
      }
      return t;
    };
  }
  return Do = n, Do;
}
var Ro, Vc;
function wp() {
  if (Vc) return Ro;
  Vc = 1;
  var n = Rm(), e = n();
  return Ro = e, Ro;
}
var cn = { exports: {} };
cn.exports;
var zc;
function Tp() {
  return zc || (zc = 1, function(n, e) {
    var t = Et(), r = e && !e.nodeType && e, i = r && !0 && n && !n.nodeType && n, o = i && i.exports === r, a = o ? t.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, c) {
      if (c)
        return u.slice();
      var d = u.length, f = s ? s(d) : new u.constructor(d);
      return u.copy(f), f;
    }
    n.exports = l;
  }(cn, cn.exports)), cn.exports;
}
var Po, Wc;
function Pm() {
  if (Wc) return Po;
  Wc = 1;
  var n = Et(), e = n.Uint8Array;
  return Po = e, Po;
}
var Mo, Gc;
function iu() {
  if (Gc) return Mo;
  Gc = 1;
  var n = Pm();
  function e(t) {
    var r = new t.constructor(t.byteLength);
    return new n(r).set(new n(t)), r;
  }
  return Mo = e, Mo;
}
var Lo, Yc;
function Sp() {
  if (Yc) return Lo;
  Yc = 1;
  var n = iu();
  function e(t, r) {
    var i = r ? n(t.buffer) : t.buffer;
    return new t.constructor(i, t.byteOffset, t.length);
  }
  return Lo = e, Lo;
}
var qo, Zc;
function xp() {
  if (Zc) return qo;
  Zc = 1;
  function n(e, t) {
    var r = -1, i = e.length;
    for (t || (t = Array(i)); ++r < i; )
      t[r] = e[r];
    return t;
  }
  return qo = n, qo;
}
var Bo, Xc;
function Mm() {
  if (Xc) return Bo;
  Xc = 1;
  var n = Ft(), e = Object.create, t = /* @__PURE__ */ function() {
    function r() {
    }
    return function(i) {
      if (!n(i))
        return {};
      if (e)
        return e(i);
      r.prototype = i;
      var o = new r();
      return r.prototype = void 0, o;
    };
  }();
  return Bo = t, Bo;
}
var Uo, Kc;
function Ap() {
  if (Kc) return Uo;
  Kc = 1;
  function n(e, t) {
    return function(r) {
      return e(t(r));
    };
  }
  return Uo = n, Uo;
}
var jo, Qc;
function ou() {
  if (Qc) return jo;
  Qc = 1;
  var n = Ap(), e = n(Object.getPrototypeOf, Object);
  return jo = e, jo;
}
var Ho, Jc;
function Oi() {
  if (Jc) return Ho;
  Jc = 1;
  var n = Object.prototype;
  function e(t) {
    var r = t && t.constructor, i = typeof r == "function" && r.prototype || n;
    return t === i;
  }
  return Ho = e, Ho;
}
var $o, ed;
function Op() {
  if (ed) return $o;
  ed = 1;
  var n = Mm(), e = ou(), t = Oi();
  function r(i) {
    return typeof i.constructor == "function" && !t(i) ? n(e(i)) : {};
  }
  return $o = r, $o;
}
var Fo, td;
function sr() {
  if (td) return Fo;
  td = 1;
  function n(e) {
    return e != null && typeof e == "object";
  }
  return Fo = n, Fo;
}
var Vo, rd;
function Lm() {
  if (rd) return Vo;
  rd = 1;
  var n = tn(), e = sr(), t = "[object Arguments]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return Vo = r, Vo;
}
var zo, nd;
function au() {
  if (nd) return zo;
  nd = 1;
  var n = Lm(), e = sr(), t = Object.prototype, r = t.hasOwnProperty, i = t.propertyIsEnumerable, o = n(/* @__PURE__ */ function() {
    return arguments;
  }()) ? n : function(a) {
    return e(a) && r.call(a, "callee") && !i.call(a, "callee");
  };
  return zo = o, zo;
}
var Wo, id;
function lr() {
  if (id) return Wo;
  id = 1;
  var n = Array.isArray;
  return Wo = n, Wo;
}
var Go, od;
function Ep() {
  if (od) return Go;
  od = 1;
  var n = 9007199254740991;
  function e(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= n;
  }
  return Go = e, Go;
}
var Yo, ad;
function $n() {
  if (ad) return Yo;
  ad = 1;
  var n = eu(), e = Ep();
  function t(r) {
    return r != null && e(r.length) && !n(r);
  }
  return Yo = t, Yo;
}
var Zo, sd;
function qm() {
  if (sd) return Zo;
  sd = 1;
  var n = $n(), e = sr();
  function t(r) {
    return e(r) && n(r);
  }
  return Zo = t, Zo;
}
var dn = { exports: {} }, Xo, ld;
function Bm() {
  if (ld) return Xo;
  ld = 1;
  function n() {
    return !1;
  }
  return Xo = n, Xo;
}
dn.exports;
var ud;
function Ei() {
  return ud || (ud = 1, function(n, e) {
    var t = Et(), r = Bm(), i = e && !e.nodeType && e, o = i && !0 && n && !n.nodeType && n, a = o && o.exports === i, s = a ? t.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    n.exports = u;
  }(dn, dn.exports)), dn.exports;
}
var Ko, cd;
function Um() {
  if (cd) return Ko;
  cd = 1;
  var n = tn(), e = ou(), t = sr(), r = "[object Object]", i = Function.prototype, o = Object.prototype, a = i.toString, s = o.hasOwnProperty, l = a.call(Object);
  function u(c) {
    if (!t(c) || n(c) != r)
      return !1;
    var d = e(c);
    if (d === null)
      return !0;
    var f = s.call(d, "constructor") && d.constructor;
    return typeof f == "function" && f instanceof f && a.call(f) == l;
  }
  return Ko = u, Ko;
}
var Qo, dd;
function jm() {
  if (dd) return Qo;
  dd = 1;
  var n = tn(), e = Ep(), t = sr(), r = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", c = "[object Number]", d = "[object Object]", f = "[object RegExp]", h = "[object Set]", g = "[object String]", p = "[object WeakMap]", v = "[object ArrayBuffer]", b = "[object DataView]", _ = "[object Float32Array]", y = "[object Float64Array]", C = "[object Int8Array]", w = "[object Int16Array]", m = "[object Int32Array]", T = "[object Uint8Array]", x = "[object Uint8ClampedArray]", A = "[object Uint16Array]", M = "[object Uint32Array]", O = {};
  O[_] = O[y] = O[C] = O[w] = O[m] = O[T] = O[x] = O[A] = O[M] = !0, O[r] = O[i] = O[v] = O[o] = O[b] = O[a] = O[s] = O[l] = O[u] = O[c] = O[d] = O[f] = O[h] = O[g] = O[p] = !1;
  function S(P) {
    return t(P) && e(P.length) && !!O[n(P)];
  }
  return Qo = S, Qo;
}
var Jo, fd;
function su() {
  if (fd) return Jo;
  fd = 1;
  function n(e) {
    return function(t) {
      return e(t);
    };
  }
  return Jo = n, Jo;
}
var fn = { exports: {} };
fn.exports;
var hd;
function lu() {
  return hd || (hd = 1, function(n, e) {
    var t = mp(), r = e && !e.nodeType && e, i = r && !0 && n && !n.nodeType && n, o = i && i.exports === r, a = o && t.process, s = function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    n.exports = s;
  }(fn, fn.exports)), fn.exports;
}
var ea, pd;
function uu() {
  if (pd) return ea;
  pd = 1;
  var n = jm(), e = su(), t = lu(), r = t && t.isTypedArray, i = r ? e(r) : n;
  return ea = i, ea;
}
var ta, vd;
function Ip() {
  if (vd) return ta;
  vd = 1;
  function n(e, t) {
    if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
      return e[t];
  }
  return ta = n, ta;
}
var ra, gd;
function Np() {
  if (gd) return ra;
  gd = 1;
  var n = nu(), e = Ci(), t = Object.prototype, r = t.hasOwnProperty;
  function i(o, a, s) {
    var l = o[a];
    (!(r.call(o, a) && e(l, s)) || s === void 0 && !(a in o)) && n(o, a, s);
  }
  return ra = i, ra;
}
var na, md;
function Fn() {
  if (md) return na;
  md = 1;
  var n = Np(), e = nu();
  function t(r, i, o, a) {
    var s = !o;
    o || (o = {});
    for (var l = -1, u = i.length; ++l < u; ) {
      var c = i[l], d = a ? a(o[c], r[c], c, o, r) : void 0;
      d === void 0 && (d = r[c]), s ? e(o, c, d) : n(o, c, d);
    }
    return o;
  }
  return na = t, na;
}
var ia, _d;
function Hm() {
  if (_d) return ia;
  _d = 1;
  function n(e, t) {
    for (var r = -1, i = Array(e); ++r < e; )
      i[r] = t(r);
    return i;
  }
  return ia = n, ia;
}
var oa, bd;
function kp() {
  if (bd) return oa;
  bd = 1;
  var n = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function t(r, i) {
    var o = typeof r;
    return i = i ?? n, !!i && (o == "number" || o != "symbol" && e.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return oa = t, oa;
}
var aa, yd;
function Dp() {
  if (yd) return aa;
  yd = 1;
  var n = Hm(), e = au(), t = lr(), r = Ei(), i = kp(), o = uu(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, c) {
    var d = t(u), f = !d && e(u), h = !d && !f && r(u), g = !d && !f && !h && o(u), p = d || f || h || g, v = p ? n(u.length, String) : [], b = v.length;
    for (var _ in u)
      (c || s.call(u, _)) && !(p && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      i(_, b))) && v.push(_);
    return v;
  }
  return aa = l, aa;
}
var sa, Cd;
function $m() {
  if (Cd) return sa;
  Cd = 1;
  function n(e) {
    var t = [];
    if (e != null)
      for (var r in Object(e))
        t.push(r);
    return t;
  }
  return sa = n, sa;
}
var la, wd;
function Fm() {
  if (wd) return la;
  wd = 1;
  var n = Ft(), e = Oi(), t = $m(), r = Object.prototype, i = r.hasOwnProperty;
  function o(a) {
    if (!n(a))
      return t(a);
    var s = e(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !i.call(a, u)) || l.push(u);
    return l;
  }
  return la = o, la;
}
var ua, Td;
function Vn() {
  if (Td) return ua;
  Td = 1;
  var n = Dp(), e = Fm(), t = $n();
  function r(i) {
    return t(i) ? n(i, !0) : e(i);
  }
  return ua = r, ua;
}
var ca, Sd;
function Vm() {
  if (Sd) return ca;
  Sd = 1;
  var n = Fn(), e = Vn();
  function t(r) {
    return n(r, e(r));
  }
  return ca = t, ca;
}
var da, xd;
function zm() {
  if (xd) return da;
  xd = 1;
  var n = Cp(), e = Tp(), t = Sp(), r = xp(), i = Op(), o = au(), a = lr(), s = qm(), l = Ei(), u = eu(), c = Ft(), d = Um(), f = uu(), h = Ip(), g = Vm();
  function p(v, b, _, y, C, w, m) {
    var T = h(v, _), x = h(b, _), A = m.get(x);
    if (A) {
      n(v, _, A);
      return;
    }
    var M = w ? w(T, x, _ + "", v, b, m) : void 0, O = M === void 0;
    if (O) {
      var S = a(x), P = !S && l(x), N = !S && !P && f(x);
      M = x, S || P || N ? a(T) ? M = T : s(T) ? M = r(T) : P ? (O = !1, M = e(x, !0)) : N ? (O = !1, M = t(x, !0)) : M = [] : d(x) || o(x) ? (M = T, o(T) ? M = g(T) : (!c(T) || u(T)) && (M = i(x))) : O = !1;
    }
    O && (m.set(x, M), C(M, x, y, w, m), m.delete(x)), n(v, _, M);
  }
  return da = p, da;
}
var fa, Ad;
function Wm() {
  if (Ad) return fa;
  Ad = 1;
  var n = bp(), e = Cp(), t = wp(), r = zm(), i = Ft(), o = Vn(), a = Ip();
  function s(l, u, c, d, f) {
    l !== u && t(u, function(h, g) {
      if (f || (f = new n()), i(h))
        r(l, u, g, c, s, d, f);
      else {
        var p = d ? d(a(l, g), h, g + "", l, u, f) : void 0;
        p === void 0 && (p = h), e(l, g, p);
      }
    }, o);
  }
  return fa = s, fa;
}
var ha, Od;
function cu() {
  if (Od) return ha;
  Od = 1;
  function n(e) {
    return e;
  }
  return ha = n, ha;
}
var pa, Ed;
function Gm() {
  if (Ed) return pa;
  Ed = 1;
  function n(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);
      case 1:
        return e.call(t, r[0]);
      case 2:
        return e.call(t, r[0], r[1]);
      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }
    return e.apply(t, r);
  }
  return pa = n, pa;
}
var va, Id;
function Ym() {
  if (Id) return va;
  Id = 1;
  var n = Gm(), e = Math.max;
  function t(r, i, o) {
    return i = e(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var a = arguments, s = -1, l = e(a.length - i, 0), u = Array(l); ++s < l; )
        u[s] = a[i + s];
      s = -1;
      for (var c = Array(i + 1); ++s < i; )
        c[s] = a[s];
      return c[i] = o(u), n(r, this, c);
    };
  }
  return va = t, va;
}
var ga, Nd;
function Zm() {
  if (Nd) return ga;
  Nd = 1;
  function n(e) {
    return function() {
      return e;
    };
  }
  return ga = n, ga;
}
var ma, kd;
function Xm() {
  if (kd) return ma;
  kd = 1;
  var n = Zm(), e = yp(), t = cu(), r = e ? function(i, o) {
    return e(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: n(o),
      writable: !0
    });
  } : t;
  return ma = r, ma;
}
var _a, Dd;
function Km() {
  if (Dd) return _a;
  Dd = 1;
  var n = 800, e = 16, t = Date.now;
  function r(i) {
    var o = 0, a = 0;
    return function() {
      var s = t(), l = e - (s - a);
      if (a = s, l > 0) {
        if (++o >= n)
          return arguments[0];
      } else
        o = 0;
      return i.apply(void 0, arguments);
    };
  }
  return _a = r, _a;
}
var ba, Rd;
function Qm() {
  if (Rd) return ba;
  Rd = 1;
  var n = Xm(), e = Km(), t = e(n);
  return ba = t, ba;
}
var ya, Pd;
function Jm() {
  if (Pd) return ya;
  Pd = 1;
  var n = cu(), e = Ym(), t = Qm();
  function r(i, o) {
    return t(e(i, o, n), i + "");
  }
  return ya = r, ya;
}
var Ca, Md;
function e0() {
  if (Md) return Ca;
  Md = 1;
  var n = Ci(), e = $n(), t = kp(), r = Ft();
  function i(o, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? e(s) && t(a, s.length) : l == "string" && a in s) ? n(s[a], o) : !1;
  }
  return Ca = i, Ca;
}
var wa, Ld;
function t0() {
  if (Ld) return wa;
  Ld = 1;
  var n = Jm(), e = e0();
  function t(r) {
    return n(function(i, o) {
      var a = -1, s = o.length, l = s > 1 ? o[s - 1] : void 0, u = s > 2 ? o[2] : void 0;
      for (l = r.length > 3 && typeof l == "function" ? (s--, l) : void 0, u && e(o[0], o[1], u) && (l = s < 3 ? void 0 : l, s = 1), i = Object(i); ++a < s; ) {
        var c = o[a];
        c && r(i, c, a, l);
      }
      return i;
    });
  }
  return wa = t, wa;
}
var Ta, qd;
function r0() {
  if (qd) return Ta;
  qd = 1;
  var n = Wm(), e = t0(), t = e(function(r, i, o) {
    n(r, i, o);
  });
  return Ta = t, Ta;
}
var n0 = r0();
const Rp = /* @__PURE__ */ $t(n0), i0 = (n) => Jl.reduce((e, t) => (e[t.type] = {
  marginAllowed: !!(n != null && n.marginAllowed),
  paddingAllowed: !!(n != null && n.paddingAllowed),
  backgroundColorAllowed: !!(n != null && n.backgroundColorAllowed),
  backgroundImageAllowed: !!(n != null && n.backgroundImageAllowed)
}, e), {}), Rr = () => ({
  editor: void 0,
  colorPalette: void 0,
  enabledOptions: void 0,
  extensions: void 0,
  removeExtensions: void 0,
  addExtensions: void 0,
  allowLinks: !0,
  disableFontSizeEditing: !1
});
class Bd {
  constructor(e = {}) {
    var i, o, a, s, l, u, c;
    const t = {
      locale: "en",
      id: null,
      api: {
        localUploader: !1,
        images: "/v1/assets",
        forms: "",
        secondaryOrgId: null,
        // This is a hack to get around different API responses while FAAS is implemented
        projectParent: "cms"
      },
      customProperties: {
        nodesIncluded: [],
        nodesExcluded: [],
        experimentalFeatures: {
          roundedLayouts: !0
        },
        global: {
          customAttributesAllowed: !0,
          backgroundColorAllowed: !0,
          backgroundImageAllowed: !0,
          marginAllowed: !0,
          paddingAllowed: !0,
          confirmOnDeleteDialogAllowed: !0,
          focusNewNodeOnCreate: !0,
          maxNestingLevelsAllowed: 4,
          rootElementsWidth: "85%",
          rootElementsMaxWidth: "1920px",
          sharedContentAllowed: !1,
          showConfirmOnDeleteDialog: !1,
          headerSlotOptional: !1,
          footerSlotOptional: !1,
          showHeaderSlot: !1,
          showFooterSlot: !1,
          undoLimit: 100,
          backgroundColorPalette: {
            colors: []
          }
        },
        RTEBar: {
          disabled: !1,
          fontSizes: void 0,
          removeDefaultActions: void 0,
          removeOptions: void 0,
          linkModalOptions: { allowRelative: !0 }
        },
        ...i0((i = e == null ? void 0 : e.customProperties) == null ? void 0 : i.global),
        CONTENT_NODE_HEADING: Rr(),
        CONTENT_NODE_TEXT: Rr(),
        CONTENT_NODE_TABLE: Rr(),
        CONTENT_NODE_CARD: {
          decorativeImageAllowed: !0,
          heading: Rr(),
          text: Rr(),
          uploadLimitMb: 10
        },
        CONTENT_NODE_IMAGE: {
          acceptedFileTypes: [
            "image/png",
            "image/jpeg"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          lightboxAllowed: !0,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_CODE: {
          allowScripts: !0
        },
        CONTENT_NODE_SPACER: {
          minHeight: 20,
          maxHeight: 1e3
        },
        CONTENT_NODE_GALLERY: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          focalPointAllowed: !0,
          lightboxAllowed: !0,
          minColumnsAllowed: 1,
          maxColumnsAllowed: 10,
          maxImagesAllowed: 20,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_VIDEO: {},
        CONTENT_NODE_SEPARATOR: {
          maxThickness: 10
        },
        CONTENT_NODE_BUTTON: {
          icons: {
            global_icons: [],
            custom_icons: []
          },
          textareaMaxLength: 40
        },
        CONTENT_NODE_FORM: {},
        CONTENT_NODE_QUOTE: {},
        CONTENT_NODE_SLIDER: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          decorativeImageAllowed: !0,
          maxImagesAllowed: 30,
          transitionSpeedMin: 3,
          transitionSpeedMax: 6,
          uploadLimitMb: 10
        },
        CONTENT_NODE_ACCORDION: {},
        CONTENT_NODE_PANEL: {},
        CONTENT_NODE_LIST: {
          legacyListOptions: {
            ...Rr(),
            enabledOptions: ["bold", "italic", "strike", "color", "add-link"]
          }
        },
        CONTENT_NODE_NAVIGATION: {
          siteMenu: []
        }
      },
      sharedContent: {
        content: {},
        createSharedContentAllowed: !0,
        editSharedContentAllowed: !0,
        detachSharedContentAllowed: !0,
        onContentCreated: ((o = e.sharedContent) == null ? void 0 : o.onContentCreated) || null,
        onSaveContentEdited: ((a = e.sharedContent) == null ? void 0 : a.onSaveContentEdited) || null,
        onCancelContentEdited: ((s = e.sharedContent) == null ? void 0 : s.onCancelContentEdited) || null,
        onContentDetached: ((l = e.sharedContent) == null ? void 0 : l.onContentDetached) || null,
        onOpenSettings: ((u = e.sharedContent) == null ? void 0 : u.onOpenSettings) || null,
        onSharedContentDeleted: ((c = e.sharedContent) == null ? void 0 : c.onSharedContentDeleted) || null
      },
      legacyAdapters: {
        pageToBuilder: null
      },
      assets: {},
      theme: {
        headingColor: null,
        linkColor: null,
        mainColor: null,
        primaryColor: null,
        secondaryColor: null
      },
      structure: {
        id: "root",
        name: "Root",
        type: qe,
        properties: {
          backgroundColor: {
            toggle: !1,
            value: ""
          },
          backgroundImage: {
            toggle: !1,
            image: null
          },
          margin: {
            value: 0
          },
          padding: {
            value: 0
          },
          borderRadius: {
            value: 0
          }
        },
        nodes: []
      }
    }, r = Rp({}, t, e);
    Object.keys(r).forEach((d) => {
      this[`_${d}`] = r[d];
    });
  }
  get assets() {
    return this._assets;
  }
  set assets(e) {
    this._assets = e;
  }
  get id() {
    return this._id;
  }
  get structure() {
    return this._structure;
  }
  get api() {
    return this._api;
  }
  get sharedContent() {
    return this._sharedContent;
  }
  set sharedContent(e) {
    this._sharedContent = e;
  }
  get theme() {
    return this._theme;
  }
  set theme(e) {
    this._theme = e;
  }
  get icons() {
    return this._assets.icons;
  }
  get customProperties() {
    return this._customProperties;
  }
  get legacyAdapters() {
    return this._legacyAdapters;
  }
  get locale() {
    return this._locale;
  }
}
const o0 = (n) => ({
  activeNode: null,
  editingSharedContent: {
    node: null,
    boundingRect: null,
    originalContent: null
  },
  builder: null,
  editor: null,
  isLinkModalOpen: !1,
  isCodeModalOpen: !1,
  nodeDragging: null,
  showCustomAttributesSidebar: !1,
  userAgent: "windows",
  addAsset(e) {
    this.builder.assets = {
      ...this.builder.assets,
      ...e
    };
  },
  setActiveNode(e) {
    this.showCustomAttributesSidebar = !1, this.activeNode = e;
  },
  clearActiveNode() {
    this.showCustomAttributesSidebar = !1, this.activeNode = null;
  },
  clearEditor() {
    this.editor = {
      editor: {},
      editorKey: "",
      enabledOptions: [],
      removeOptions: [],
      colorPalette: {}
    };
  },
  removeFavorite({ id: e }) {
    this.builder.favorites = this.builder.favorites.filter((t) => t.id !== e);
  },
  emitToConsumingApp(e, t) {
    n(e, t);
  }
}), a0 = ({ customProperties: n, structure: e, theme: t }) => {
  const r = "#004b8d", i = "#8369cb", o = "#ad98e6", a = "#B1CB69", s = "#0000ee", l = "#2a5a5a", { properties: u } = e, { backgroundColorAllowed: c } = n.global, d = t.mainColor || Lt.DARK, f = t.headingColor || Lt.DARK, h = t.linkColor || s;
  return {
    // THEME VARIABLES
    "--color-favorite": a,
    "--color-heading": f,
    "--color-link": h,
    "--color-main": d,
    "--color-main-10": `${d}10`,
    "--color-main-20": `${d}20`,
    "--color-main-30": `${d}30`,
    "--font-family": "'Neue Haas Grotesk Disp', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    // BUILDER VARIABLES
    "--builder-background-color": c && u.backgroundColor.toggle && u.backgroundColor.value,
    "--color-layout": r,
    "--color-content": i,
    "--color-sub-content": o,
    "--color-shared-content": l,
    // PB CUSTOM COLOR VARIABLES
    "--pb-black": "#000000",
    "--pb-black-10": "#0000001a",
    "--pb-black-20": "#00000033",
    "--pb-grey-35": "#cccccc",
    "--pb-purple-45": "#ab91dd",
    "--pb-transparent": "#ffffff00",
    "--pb-white-10": "#ffffff1a",
    "--pb-white-90": "#ffffffe6",
    "--pb-code-background-color": "#091E4214",
    // LAYOUT VARIABLES
    "--layout-outline": "1px dashed hsla(0, 0%, 49%, 0.5)",
    "--lightbox-background": "rgba(0, 0, 0, .85)",
    // SIDEBAR VARIABLES
    "--sidebar-width": "240px",
    "--block-container-max-height": "800px"
  };
}, K = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, i] of e)
    t[r] = i;
  return t;
}, s0 = {
  name: "ColorPalette",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    colorPalette: {
      type: Array,
      required: !0
    }
  },
  computed: {
    colorValue: {
      get() {
        return this.modelValue;
      },
      set(n) {
        this.$emit("update:modelValue", n);
      }
    },
    backgroundColors() {
      if (!this.colorPalette.length) return [Lt.WHITE];
      const n = this.colorPalette.map((t) => (t == null ? void 0 : t.hex) || t || Lt.WHITE), e = /* @__PURE__ */ new Set([Lt.WHITE, ...n]);
      return Array.from(e);
    }
  }
};
function l0(n, e, t, r, i, o) {
  const a = $("a-form-color-input"), s = $("a-button");
  return D(), U("div", { class: "inline-control space-between gap-10" }, [
    q(a, {
      class: "background-color-input",
      "model-value": o.colorValue,
      "palette-only": !0,
      palette: o.backgroundColors,
      "header-text": n.$t("builder.backgroundColor.subTitle"),
      "onUpdate:modelValue": e[0] || (e[0] = (l) => o.colorValue = l),
      "onReset:modelValue": e[1] || (e[1] = (l) => o.colorValue = "#ffffff"),
      width: "160px"
    }, null, 8, ["model-value", "palette", "header-text"]),
    q(s, {
      class: "clear-button",
      variant: "link",
      onClick: e[2] || (e[2] = (l) => n.$emit("clear"))
    }, {
      default: j(() => [
        Me(Q(n.$t("builder.clear")), 1)
      ]),
      _: 1
    })
  ]);
}
const u0 = /* @__PURE__ */ K(s0, [["render", l0], ["__scopeId", "data-v-ccf96737"]]), c0 = {
  name: "NodeControl",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
};
function d0(n, e, t, r, i, o) {
  return D(), U("div", {
    class: He(["node-control", { disabled: t.disabled }])
  }, [
    R("div", { class: "control-header" }, [
      R("div", { class: "control-title" }, [
        nt(n.$slots, "title", {}, void 0, !0)
      ]),
      nt(n.$slots, "control", {}, void 0, !0)
    ]),
    R("div", { class: "control-content" }, [
      nt(n.$slots, "content", {}, void 0, !0)
    ])
  ], 2);
}
const xr = /* @__PURE__ */ K(c0, [["render", d0], ["__scopeId", "data-v-256bf46a"]]), f0 = {
  name: "BackgroundColorControl",
  components: {
    ColorPalette: u0,
    NodeControl: xr
  },
  inject: ["state"],
  props: {
    node: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    backgroundColor: {
      get() {
        var n, e, t;
        return ((t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) == null ? void 0 : t.value) || Lt.WHITE;
      },
      set(n) {
        this.$emit("update", "value", n);
      }
    },
    toggle: {
      get() {
        var n, e, t;
        return ((t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) == null ? void 0 : t.toggle) || !1;
      },
      set(n) {
        this.$emit("update", "toggle", n);
      }
    },
    backgroundColorPalette() {
      var e, t, r, i;
      const { colors: n = [] } = (i = (r = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : r.global) == null ? void 0 : i.backgroundColorPalette;
      return n;
    }
  }
};
function h0(n, e, t, r, i, o) {
  const a = $("a-toggle"), s = $("ColorPalette"), l = $("NodeControl");
  return D(), W(l, null, Zl({
    title: j(() => [
      R("h4", null, Q(n.$t("builder.backgroundColor.title")), 1)
    ]),
    control: j(() => [
      q(a, {
        id: "background-color-toggle",
        modelValue: o.toggle,
        "onUpdate:modelValue": e[0] || (e[0] = (u) => o.toggle = u)
      }, null, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    o.toggle ? {
      name: "content",
      fn: j(() => [
        q(s, {
          modelValue: o.backgroundColor,
          "onUpdate:modelValue": e[1] || (e[1] = (u) => o.backgroundColor = u),
          "color-palette": o.backgroundColorPalette,
          onClear: e[2] || (e[2] = (u) => o.backgroundColor = null)
        }, null, 8, ["modelValue", "color-palette"])
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const Pp = /* @__PURE__ */ K(f0, [["render", h0]]);
function It(n) {
  return Fg() ? (Vg(n), !0) : !1;
}
function Mp(n) {
  let e = 0, t, r;
  const i = () => {
    e -= 1, r && e <= 0 && (r.stop(), t = void 0, r = void 0);
  };
  return (...o) => (e += 1, r || (r = $g(!0), t = r.run(() => n(...o))), It(i), t);
}
const rn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Lp = (n) => n != null, p0 = Object.prototype.toString, qp = (n) => p0.call(n) === "[object Object]", v0 = () => +Date.now(), ut = () => {
}, yl = /* @__PURE__ */ g0();
function g0() {
  var n, e;
  return rn && ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function m0(n, e) {
  function t(...r) {
    return new Promise((i, o) => {
      Promise.resolve(n(() => e.apply(this, r), { fn: e, thisArg: this, args: r })).then(i).catch(o);
    });
  }
  return t;
}
const Bp = (n) => n();
function _0(n, e = {}) {
  let t, r, i = ut;
  const o = (l) => {
    clearTimeout(l), i(), i = ut;
  };
  let a;
  return (l) => {
    const u = ve(n), c = ve(e.maxWait);
    return t && o(t), u <= 0 || c !== void 0 && c <= 0 ? (r && (o(r), r = null), Promise.resolve(l())) : new Promise((d, f) => {
      i = e.rejectOnCancel ? f : d, a = l, c && !r && (r = setTimeout(() => {
        t && o(t), r = null, d(a());
      }, c)), t = setTimeout(() => {
        r && o(r), r = null, d(l());
      }, u);
    });
  };
}
function b0(n = Bp, e = {}) {
  const {
    initialState: t = "active"
  } = e, r = ci(t === "active");
  function i() {
    r.value = !1;
  }
  function o() {
    r.value = !0;
  }
  const a = (...s) => {
    r.value && n(...s);
  };
  return { isActive: bi(r), pause: i, resume: o, eventFilter: a };
}
function y0(n) {
  let e;
  function t() {
    return e || (e = n()), e;
  }
  return t.reset = async () => {
    const r = e;
    e = void 0, r && await r;
  }, t;
}
function C0(n) {
  return Xl();
}
function er(n) {
  return Array.isArray(n) ? n : [n];
}
function ci(...n) {
  if (n.length !== 1)
    return op(...n);
  const e = n[0];
  return typeof e == "function" ? bi(zg(() => ({ get: e, set: ut }))) : J(e);
}
function w0(n, e = !0, t) {
  C0() ? mt(n, t) : e ? n() : Ct(n);
}
function T0(n, e, t = {}) {
  const {
    immediate: r = !0,
    immediateCallback: i = !1
  } = t, o = fe(!1);
  let a = null;
  function s() {
    a && (clearTimeout(a), a = null);
  }
  function l() {
    o.value = !1, s();
  }
  function u(...c) {
    i && n(), s(), o.value = !0, a = setTimeout(() => {
      o.value = !1, a = null, n(...c);
    }, ve(e));
  }
  return r && (o.value = !0, rn && u()), It(l), {
    isPending: bi(o),
    start: u,
    stop: l
  };
}
function S0(n, e, t = {}) {
  const {
    eventFilter: r = Bp,
    ...i
  } = t, o = m0(
    r,
    e
  );
  let a, s, l;
  if (i.flush === "sync") {
    const u = fe(!1);
    s = () => {
    }, a = (c) => {
      u.value = !0, c(), u.value = !1;
    }, l = Ae(
      n,
      (...c) => {
        u.value || o(...c);
      },
      i
    );
  } else {
    const u = [], c = fe(0), d = fe(0);
    s = () => {
      c.value = d.value;
    }, u.push(
      Ae(
        n,
        () => {
          d.value++;
        },
        { ...i, flush: "sync" }
      )
    ), a = (f) => {
      const h = d.value;
      f(), c.value += d.value - h;
    }, u.push(
      Ae(
        n,
        (...f) => {
          const h = c.value > 0 && c.value === d.value;
          c.value = 0, d.value = 0, !h && o(...f);
        },
        i
      )
    ), l = () => {
      u.forEach((f) => f());
    };
  }
  return { stop: l, ignoreUpdates: a, ignorePrevAsyncUpdates: s };
}
function Up(n, e, t) {
  return Ae(
    n,
    e,
    {
      ...t,
      immediate: !0
    }
  );
}
function kt(n, e, t) {
  return Ae(
    n,
    (i, o, a) => {
      i && e(i, o, a);
    },
    {
      ...t,
      once: !1
    }
  );
}
const Vt = rn ? window : void 0, jp = rn ? window.navigator : void 0;
function Ar(n) {
  var e;
  const t = ve(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function De(...n) {
  const e = [], t = () => {
    e.forEach((s) => s()), e.length = 0;
  }, r = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), i = I(() => {
    const s = er(ve(n[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), o = Up(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((u) => Ar(u))) != null ? l : [Vt].filter((u) => u != null),
        er(ve(i.value ? n[1] : n[0])),
        er(V(i.value ? n[2] : n[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ve(i.value ? n[3] : n[2])
      ];
    },
    ([s, l, u, c]) => {
      if (t(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = qp(c) ? { ...c } : c;
      e.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => u.map((g) => r(f, h, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    o(), t();
  };
  return It(t), a;
}
function x0() {
  const n = fe(!1), e = Xl();
  return e && mt(() => {
    n.value = !0;
  }, e), n;
}
function Ii(n) {
  const e = x0();
  return I(() => (e.value, !!n()));
}
function Hp(n, e, t = {}) {
  const { window: r = Vt, ...i } = t;
  let o;
  const a = Ii(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const f = ve(n), h = er(f).map(Ar).filter(Lp);
    return new Set(h);
  }), u = Ae(
    () => l.value,
    (f) => {
      s(), a.value && f.size && (o = new MutationObserver(e), f.forEach((h) => o.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => o == null ? void 0 : o.takeRecords(), d = () => {
    u(), s();
  };
  return It(d), {
    isSupported: a,
    stop: d,
    takeRecords: c
  };
}
function A0(n, e, t = {}) {
  const {
    window: r = Vt,
    document: i = r == null ? void 0 : r.document,
    flush: o = "sync"
  } = t;
  if (!r || !i)
    return ut;
  let a;
  const s = (c) => {
    a == null || a(), a = c;
  }, l = ap(() => {
    const c = Ar(n);
    if (c) {
      const { stop: d } = Hp(
        i,
        (f) => {
          f.map((g) => [...g.removedNodes]).flat().some((g) => g === c || g.contains(c)) && e(f);
        },
        {
          window: r,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: o }), u = () => {
    l(), s();
  };
  return It(u), u;
}
function Ud(n = {}) {
  var e;
  const {
    window: t = Vt,
    deep: r = !0,
    triggerOnRemoval: i = !1
  } = n, o = (e = n.document) != null ? e : t == null ? void 0 : t.document, a = () => {
    var u;
    let c = o == null ? void 0 : o.activeElement;
    if (r)
      for (; c != null && c.shadowRoot; )
        c = (u = c == null ? void 0 : c.shadowRoot) == null ? void 0 : u.activeElement;
    return c;
  }, s = fe(), l = () => {
    s.value = a();
  };
  if (t) {
    const u = {
      capture: !0,
      passive: !0
    };
    De(
      t,
      "blur",
      (c) => {
        c.relatedTarget === null && l();
      },
      u
    ), De(
      t,
      "focus",
      l,
      u
    );
  }
  return i && A0(s, l, { document: o }), l(), s;
}
function jd(n, e = {}) {
  const {
    controls: t = !1,
    navigator: r = jp
  } = e, i = Ii(() => r && "permissions" in r), o = fe(), a = typeof n == "string" ? { name: n } : n, s = fe(), l = () => {
    var c, d;
    s.value = (d = (c = o.value) == null ? void 0 : c.state) != null ? d : "prompt";
  };
  De(o, "change", l, { passive: !0 });
  const u = y0(async () => {
    if (i.value) {
      if (!o.value)
        try {
          o.value = await r.permissions.query(a);
        } catch {
          o.value = void 0;
        } finally {
          l();
        }
      if (t)
        return Gg(o.value);
    }
  });
  return u(), t ? {
    state: s,
    isSupported: i,
    query: u
  } : s;
}
function O0(n = {}) {
  const {
    navigator: e = jp,
    read: t = !1,
    source: r,
    copiedDuring: i = 1500,
    legacy: o = !1
  } = n, a = Ii(() => e && "clipboard" in e), s = jd("clipboard-read"), l = jd("clipboard-write"), u = I(() => a.value || o), c = fe(""), d = fe(!1), f = T0(() => d.value = !1, i, { immediate: !1 });
  async function h() {
    let _ = !(a.value && b(s.value));
    if (!_)
      try {
        c.value = await e.clipboard.readText();
      } catch {
        _ = !0;
      }
    _ && (c.value = v());
  }
  u.value && t && De(["copy", "cut"], h, { passive: !0 });
  async function g(_ = ve(r)) {
    if (u.value && _ != null) {
      let y = !(a.value && b(l.value));
      if (!y)
        try {
          await e.clipboard.writeText(_);
        } catch {
          y = !0;
        }
      y && p(_), c.value = _, d.value = !0, f.start();
    }
  }
  function p(_) {
    const y = document.createElement("textarea");
    y.value = _ ?? "", y.style.position = "absolute", y.style.opacity = "0", document.body.appendChild(y), y.select(), document.execCommand("copy"), y.remove();
  }
  function v() {
    var _, y, C;
    return (C = (y = (_ = document == null ? void 0 : document.getSelection) == null ? void 0 : _.call(document)) == null ? void 0 : y.toString()) != null ? C : "";
  }
  function b(_) {
    return _ === "granted" || _ === "prompt";
  }
  return {
    isSupported: u,
    text: c,
    copied: d,
    copy: g
  };
}
function $p(n) {
  return JSON.parse(JSON.stringify(n));
}
function Fp(n) {
  return n;
}
function E0(n, e) {
  return n.value = e;
}
function I0(n) {
  return n ? typeof n == "function" ? n : $p : Fp;
}
function N0(n) {
  return n ? typeof n == "function" ? n : $p : Fp;
}
function k0(n, e = {}) {
  const {
    clone: t = !1,
    dump: r = I0(t),
    parse: i = N0(t),
    setSource: o = E0
  } = e;
  function a() {
    return Wg({
      snapshot: r(n.value),
      timestamp: v0()
    });
  }
  const s = J(a()), l = J([]), u = J([]), c = (y) => {
    o(n, i(y.snapshot)), s.value = y;
  }, d = () => {
    l.value.unshift(s.value), s.value = a(), e.capacity && l.value.length > e.capacity && l.value.splice(e.capacity, Number.POSITIVE_INFINITY), u.value.length && u.value.splice(0, u.value.length);
  }, f = () => {
    l.value.splice(0, l.value.length), u.value.splice(0, u.value.length);
  }, h = () => {
    const y = l.value.shift();
    y && (u.value.unshift(s.value), c(y));
  }, g = () => {
    const y = u.value.shift();
    y && (l.value.unshift(s.value), c(y));
  }, p = () => {
    c(s.value);
  }, v = I(() => [s.value, ...l.value]), b = I(() => l.value.length > 0), _ = I(() => u.value.length > 0);
  return {
    source: n,
    undoStack: l,
    redoStack: u,
    last: s,
    history: v,
    canUndo: b,
    canRedo: _,
    clear: f,
    commit: d,
    reset: p,
    undo: h,
    redo: g
  };
}
function D0(n, e = {}) {
  const {
    deep: t = !1,
    flush: r = "pre",
    eventFilter: i
  } = e, {
    eventFilter: o,
    pause: a,
    resume: s,
    isActive: l
  } = b0(i), {
    ignoreUpdates: u,
    ignorePrevAsyncUpdates: c,
    stop: d
  } = S0(
    n,
    v,
    { deep: t, flush: r, eventFilter: o }
  );
  function f(C, w) {
    c(), u(() => {
      C.value = w;
    });
  }
  const h = k0(n, { ...e, clone: e.clone || t, setSource: f }), { clear: g, commit: p } = h;
  function v() {
    c(), p();
  }
  function b(C) {
    s(), C && v();
  }
  function _(C) {
    let w = !1;
    const m = () => w = !0;
    u(() => {
      C(m);
    }), w || v();
  }
  function y() {
    d(), g();
  }
  return {
    ...h,
    isTracking: l,
    pause: a,
    resume: b,
    commit: v,
    batch: _,
    dispose: y
  };
}
function Vp(n, e = {}) {
  const t = e.debounce ? _0(e.debounce) : void 0;
  return {
    ...D0(n, { ...e, eventFilter: t })
  };
}
function du(n, e = {}) {
  var t, r;
  const i = fe(!1), o = fe(null);
  let a = 0, s = !0;
  if (rn) {
    const l = typeof e == "function" ? { onDrop: e } : e, u = (t = l.multiple) != null ? t : !0, c = (r = l.preventDefaultForUnhandled) != null ? r : !1, d = (v) => {
      var b, _;
      const y = Array.from((_ = (b = v.dataTransfer) == null ? void 0 : b.files) != null ? _ : []);
      return y.length === 0 ? null : u ? y : [y[0]];
    }, f = (v) => {
      const b = V(l.dataTypes);
      return typeof b == "function" ? b(v) : b != null && b.length ? v.length === 0 ? !1 : v.every(
        (_) => b.some((y) => _.includes(y))
      ) : !0;
    }, h = (v) => {
      const b = Array.from(v ?? []).map((C) => C.type), _ = f(b), y = u || v.length <= 1;
      return _ && y;
    }, g = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), p = (v, b) => {
      var _, y, C, w, m, T;
      const x = (_ = v.dataTransfer) == null ? void 0 : _.items;
      if (s = (y = x && h(x)) != null ? y : !1, c && v.preventDefault(), !g() && !s) {
        v.dataTransfer && (v.dataTransfer.dropEffect = "none");
        return;
      }
      v.preventDefault(), v.dataTransfer && (v.dataTransfer.dropEffect = "copy");
      const A = d(v);
      switch (b) {
        case "enter":
          a += 1, i.value = !0, (C = l.onEnter) == null || C.call(l, null, v);
          break;
        case "over":
          (w = l.onOver) == null || w.call(l, null, v);
          break;
        case "leave":
          a -= 1, a === 0 && (i.value = !1), (m = l.onLeave) == null || m.call(l, null, v);
          break;
        case "drop":
          a = 0, i.value = !1, s && (o.value = A, (T = l.onDrop) == null || T.call(l, A, v));
          break;
      }
    };
    De(n, "dragenter", (v) => p(v, "enter")), De(n, "dragover", (v) => p(v, "over")), De(n, "dragleave", (v) => p(v, "leave")), De(n, "drop", (v) => p(v, "drop"));
  }
  return {
    files: o,
    isOverDropZone: i
  };
}
function fu(n, e, t = {}) {
  const { window: r = Vt, ...i } = t;
  let o;
  const a = Ii(() => r && "ResizeObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const d = ve(n);
    return Array.isArray(d) ? d.map((f) => Ar(f)) : [Ar(d)];
  }), u = Ae(
    l,
    (d) => {
      if (s(), a.value && r) {
        o = new ResizeObserver(e);
        for (const f of d)
          f && o.observe(f, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    s(), u();
  };
  return It(c), {
    isSupported: a,
    stop: c
  };
}
function zp(n, e = {}) {
  const {
    reset: t = !0,
    windowResize: r = !0,
    windowScroll: i = !0,
    immediate: o = !0,
    updateTiming: a = "sync"
  } = e, s = fe(0), l = fe(0), u = fe(0), c = fe(0), d = fe(0), f = fe(0), h = fe(0), g = fe(0);
  function p() {
    const b = Ar(n);
    if (!b) {
      t && (s.value = 0, l.value = 0, u.value = 0, c.value = 0, d.value = 0, f.value = 0, h.value = 0, g.value = 0);
      return;
    }
    const _ = b.getBoundingClientRect();
    s.value = _.height, l.value = _.bottom, u.value = _.left, c.value = _.right, d.value = _.top, f.value = _.width, h.value = _.x, g.value = _.y;
  }
  function v() {
    a === "sync" ? p() : a === "next-frame" && requestAnimationFrame(() => p());
  }
  return fu(n, v), Ae(() => Ar(n), (b) => !b && v()), Hp(n, v, {
    attributeFilter: ["style", "class"]
  }), i && De("scroll", v, { capture: !0, passive: !0 }), r && De("resize", v, { passive: !0 }), w0(() => {
    o && v();
  }), {
    height: s,
    bottom: l,
    left: u,
    right: c,
    top: d,
    width: f,
    x: h,
    y: g,
    update: v
  };
}
const R0 = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function P0(n = {}) {
  const {
    reactive: e = !1,
    target: t = Vt,
    aliasMap: r = R0,
    passive: i = !0,
    onEventFired: o = ut
  } = n, a = ai(/* @__PURE__ */ new Set()), s = {
    toJSON() {
      return {};
    },
    current: a
  }, l = e ? ai(s) : s, u = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  function d(p, v) {
    p in l && (e ? l[p] = v : l[p].value = v);
  }
  function f() {
    a.clear();
    for (const p of c)
      d(p, !1);
  }
  function h(p, v) {
    var b, _;
    const y = (b = p.key) == null ? void 0 : b.toLowerCase(), w = [(_ = p.code) == null ? void 0 : _.toLowerCase(), y].filter(Boolean);
    y && (v ? a.add(y) : a.delete(y));
    for (const m of w)
      c.add(m), d(m, v);
    y === "meta" && !v ? (u.forEach((m) => {
      a.delete(m), d(m, !1);
    }), u.clear()) : typeof p.getModifierState == "function" && p.getModifierState("Meta") && v && [...a, ...w].forEach((m) => u.add(m));
  }
  De(t, "keydown", (p) => (h(p, !0), o(p)), { passive: i }), De(t, "keyup", (p) => (h(p, !1), o(p)), { passive: i }), De("blur", f, { passive: i }), De("focus", f, { passive: i });
  const g = new Proxy(
    l,
    {
      get(p, v, b) {
        if (typeof v != "string")
          return Reflect.get(p, v, b);
        if (v = v.toLowerCase(), v in r && (v = r[v]), !(v in l))
          if (/[+_-]/.test(v)) {
            const y = v.split(/[+_-]/g).map((C) => C.trim());
            l[v] = I(() => y.map((C) => ve(g[C])).every(Boolean));
          } else
            l[v] = fe(!1);
        const _ = Reflect.get(p, v, b);
        return e ? ve(_) : _;
      }
    }
  );
  return g;
}
function M0(n) {
  var e;
  const t = (e = n.rangeCount) != null ? e : 0;
  return Array.from({ length: t }, (r, i) => n.getRangeAt(i));
}
function L0(n = {}) {
  const {
    window: e = Vt
  } = n, t = J(null), r = I(() => {
    var s, l;
    return (l = (s = t.value) == null ? void 0 : s.toString()) != null ? l : "";
  }), i = I(() => t.value ? M0(t.value) : []), o = I(() => i.value.map((s) => s.getBoundingClientRect()));
  function a() {
    t.value = null, e && (t.value = e.getSelection());
  }
  return e && De(e.document, "selectionchange", a, { passive: !0 }), {
    text: r,
    rects: o,
    ranges: i,
    selection: t
  };
}
function q0(n = Vt, e) {
  n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(e) : e();
}
function hw(n = {}) {
  var e, t;
  const { window: r = Vt } = n, i = ci(n == null ? void 0 : n.element), o = ci((e = n == null ? void 0 : n.input) != null ? e : ""), a = (t = n == null ? void 0 : n.styleProp) != null ? t : "height", s = fe(1), l = fe(0);
  function u() {
    var c;
    if (!i.value)
      return;
    let d = "";
    i.value.style[a] = "1px", s.value = (c = i.value) == null ? void 0 : c.scrollHeight;
    const f = ve(n == null ? void 0 : n.styleTarget);
    f ? f.style[a] = `${s.value}px` : d = `${s.value}px`, i.value.style[a] = d;
  }
  return Ae([o, i], () => Ct(u), { immediate: !0 }), Ae(s, () => {
    var c;
    return (c = n == null ? void 0 : n.onResize) == null ? void 0 : c.call(n);
  }), fu(i, ([{ contentRect: c }]) => {
    l.value !== c.width && q0(r, () => {
      l.value = c.width, u();
    });
  }), n != null && n.watch && Ae(n.watch, u, { immediate: !0, deep: !0 }), {
    textarea: i,
    input: o,
    triggerResize: u
  };
}
const Hd = (n) => /* eslint-disable-next-line no-useless-escape */ /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(n), B0 = (n) => {
  if (n !== "" && n !== void 0 && !Hd(n))
    return new Promise((e, t) => {
      const r = new FileReader();
      r.readAsDataURL(n), r.onloadend = (i) => {
        e(r.result);
      }, r.onerror = (i) => {
        t(i);
      };
    });
  if (Hd(n))
    return Promise.resolve(n);
}, Wp = (n, e, t = 10) => {
  var i;
  if (!n.size || !n.type) return !1;
  const r = !((i = n.name) != null && i.includes(".")) || !e.includes(n.type);
  return hu(n, t) || r || n.type === "";
}, hu = (n, e = 10) => n.size / 1e6 > e, U0 = (n) => ({
  [n.content.assetId]: {
    url: n.assetUrl,
    file: n.content.imageFile
  }
}), pw = (n, e) => {
  const t = Object.keys(e)[0];
  return !n.hasOwnProperty(t);
};
var Sa, $d;
function j0() {
  if ($d) return Sa;
  $d = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length; ++r < i && t(e[r], r, e) !== !1; )
      ;
    return e;
  }
  return Sa = n, Sa;
}
var xa, Fd;
function H0() {
  if (Fd) return xa;
  Fd = 1;
  var n = Ap(), e = n(Object.keys, Object);
  return xa = e, xa;
}
var Aa, Vd;
function Gp() {
  if (Vd) return Aa;
  Vd = 1;
  var n = Oi(), e = H0(), t = Object.prototype, r = t.hasOwnProperty;
  function i(o) {
    if (!n(o))
      return e(o);
    var a = [];
    for (var s in Object(o))
      r.call(o, s) && s != "constructor" && a.push(s);
    return a;
  }
  return Aa = i, Aa;
}
var Oa, zd;
function Ni() {
  if (zd) return Oa;
  zd = 1;
  var n = Dp(), e = Gp(), t = $n();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return Oa = r, Oa;
}
var Ea, Wd;
function $0() {
  if (Wd) return Ea;
  Wd = 1;
  var n = Fn(), e = Ni();
  function t(r, i) {
    return r && n(i, e(i), r);
  }
  return Ea = t, Ea;
}
var Ia, Gd;
function F0() {
  if (Gd) return Ia;
  Gd = 1;
  var n = Fn(), e = Vn();
  function t(r, i) {
    return r && n(i, e(i), r);
  }
  return Ia = t, Ia;
}
var Na, Yd;
function V0() {
  if (Yd) return Na;
  Yd = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, o = 0, a = []; ++r < i; ) {
      var s = e[r];
      t(s, r, e) && (a[o++] = s);
    }
    return a;
  }
  return Na = n, Na;
}
var ka, Zd;
function Yp() {
  if (Zd) return ka;
  Zd = 1;
  function n() {
    return [];
  }
  return ka = n, ka;
}
var Da, Xd;
function pu() {
  if (Xd) return Da;
  Xd = 1;
  var n = V0(), e = Yp(), t = Object.prototype, r = t.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(a) {
    return a == null ? [] : (a = Object(a), n(i(a), function(s) {
      return r.call(a, s);
    }));
  } : e;
  return Da = o, Da;
}
var Ra, Kd;
function z0() {
  if (Kd) return Ra;
  Kd = 1;
  var n = Fn(), e = pu();
  function t(r, i) {
    return n(r, e(r), i);
  }
  return Ra = t, Ra;
}
var Pa, Qd;
function Zp() {
  if (Qd) return Pa;
  Qd = 1;
  function n(e, t) {
    for (var r = -1, i = t.length, o = e.length; ++r < i; )
      e[o + r] = t[r];
    return e;
  }
  return Pa = n, Pa;
}
var Ma, Jd;
function Xp() {
  if (Jd) return Ma;
  Jd = 1;
  var n = Zp(), e = ou(), t = pu(), r = Yp(), i = Object.getOwnPropertySymbols, o = i ? function(a) {
    for (var s = []; a; )
      n(s, t(a)), a = e(a);
    return s;
  } : r;
  return Ma = o, Ma;
}
var La, ef;
function W0() {
  if (ef) return La;
  ef = 1;
  var n = Fn(), e = Xp();
  function t(r, i) {
    return n(r, e(r), i);
  }
  return La = t, La;
}
var qa, tf;
function Kp() {
  if (tf) return qa;
  tf = 1;
  var n = Zp(), e = lr();
  function t(r, i, o) {
    var a = i(r);
    return e(r) ? a : n(a, o(r));
  }
  return qa = t, qa;
}
var Ba, rf;
function G0() {
  if (rf) return Ba;
  rf = 1;
  var n = Kp(), e = pu(), t = Ni();
  function r(i) {
    return n(i, t, e);
  }
  return Ba = r, Ba;
}
var Ua, nf;
function Y0() {
  if (nf) return Ua;
  nf = 1;
  var n = Kp(), e = Xp(), t = Vn();
  function r(i) {
    return n(i, t, e);
  }
  return Ua = r, Ua;
}
var ja, of;
function Z0() {
  if (of) return ja;
  of = 1;
  var n = Nr(), e = Et(), t = n(e, "DataView");
  return ja = t, ja;
}
var Ha, af;
function X0() {
  if (af) return Ha;
  af = 1;
  var n = Nr(), e = Et(), t = n(e, "Promise");
  return Ha = t, Ha;
}
var $a, sf;
function Qp() {
  if (sf) return $a;
  sf = 1;
  var n = Nr(), e = Et(), t = n(e, "Set");
  return $a = t, $a;
}
var Fa, lf;
function K0() {
  if (lf) return Fa;
  lf = 1;
  var n = Nr(), e = Et(), t = n(e, "WeakMap");
  return Fa = t, Fa;
}
var Va, uf;
function ki() {
  if (uf) return Va;
  uf = 1;
  var n = Z0(), e = tu(), t = X0(), r = Qp(), i = K0(), o = tn(), a = _p(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", c = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", h = a(n), g = a(e), p = a(t), v = a(r), b = a(i), _ = o;
  return (n && _(new n(new ArrayBuffer(1))) != f || e && _(new e()) != s || t && _(t.resolve()) != u || r && _(new r()) != c || i && _(new i()) != d) && (_ = function(y) {
    var C = o(y), w = C == l ? y.constructor : void 0, m = w ? a(w) : "";
    if (m)
      switch (m) {
        case h:
          return f;
        case g:
          return s;
        case p:
          return u;
        case v:
          return c;
        case b:
          return d;
      }
    return C;
  }), Va = _, Va;
}
var za, cf;
function Q0() {
  if (cf) return za;
  cf = 1;
  var n = Object.prototype, e = n.hasOwnProperty;
  function t(r) {
    var i = r.length, o = new r.constructor(i);
    return i && typeof r[0] == "string" && e.call(r, "index") && (o.index = r.index, o.input = r.input), o;
  }
  return za = t, za;
}
var Wa, df;
function J0() {
  if (df) return Wa;
  df = 1;
  var n = iu();
  function e(t, r) {
    var i = r ? n(t.buffer) : t.buffer;
    return new t.constructor(i, t.byteOffset, t.byteLength);
  }
  return Wa = e, Wa;
}
var Ga, ff;
function e_() {
  if (ff) return Ga;
  ff = 1;
  var n = /\w*$/;
  function e(t) {
    var r = new t.constructor(t.source, n.exec(t));
    return r.lastIndex = t.lastIndex, r;
  }
  return Ga = e, Ga;
}
var Ya, hf;
function t_() {
  if (hf) return Ya;
  hf = 1;
  var n = Si(), e = n ? n.prototype : void 0, t = e ? e.valueOf : void 0;
  function r(i) {
    return t ? Object(t.call(i)) : {};
  }
  return Ya = r, Ya;
}
var Za, pf;
function r_() {
  if (pf) return Za;
  pf = 1;
  var n = iu(), e = J0(), t = e_(), r = t_(), i = Sp(), o = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", c = "[object Set]", d = "[object String]", f = "[object Symbol]", h = "[object ArrayBuffer]", g = "[object DataView]", p = "[object Float32Array]", v = "[object Float64Array]", b = "[object Int8Array]", _ = "[object Int16Array]", y = "[object Int32Array]", C = "[object Uint8Array]", w = "[object Uint8ClampedArray]", m = "[object Uint16Array]", T = "[object Uint32Array]";
  function x(A, M, O) {
    var S = A.constructor;
    switch (M) {
      case h:
        return n(A);
      case o:
      case a:
        return new S(+A);
      case g:
        return e(A, O);
      case p:
      case v:
      case b:
      case _:
      case y:
      case C:
      case w:
      case m:
      case T:
        return i(A, O);
      case s:
        return new S();
      case l:
      case d:
        return new S(A);
      case u:
        return t(A);
      case c:
        return new S();
      case f:
        return r(A);
    }
  }
  return Za = x, Za;
}
var Xa, vf;
function n_() {
  if (vf) return Xa;
  vf = 1;
  var n = ki(), e = sr(), t = "[object Map]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return Xa = r, Xa;
}
var Ka, gf;
function i_() {
  if (gf) return Ka;
  gf = 1;
  var n = n_(), e = su(), t = lu(), r = t && t.isMap, i = r ? e(r) : n;
  return Ka = i, Ka;
}
var Qa, mf;
function o_() {
  if (mf) return Qa;
  mf = 1;
  var n = ki(), e = sr(), t = "[object Set]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return Qa = r, Qa;
}
var Ja, _f;
function a_() {
  if (_f) return Ja;
  _f = 1;
  var n = o_(), e = su(), t = lu(), r = t && t.isSet, i = r ? e(r) : n;
  return Ja = i, Ja;
}
var es, bf;
function s_() {
  if (bf) return es;
  bf = 1;
  var n = bp(), e = j0(), t = Np(), r = $0(), i = F0(), o = Tp(), a = xp(), s = z0(), l = W0(), u = G0(), c = Y0(), d = ki(), f = Q0(), h = r_(), g = Op(), p = lr(), v = Ei(), b = i_(), _ = Ft(), y = a_(), C = Ni(), w = Vn(), m = 1, T = 2, x = 4, A = "[object Arguments]", M = "[object Array]", O = "[object Boolean]", S = "[object Date]", P = "[object Error]", N = "[object Function]", E = "[object GeneratorFunction]", L = "[object Map]", H = "[object Number]", z = "[object Object]", te = "[object RegExp]", le = "[object Set]", ce = "[object String]", ae = "[object Symbol]", ue = "[object WeakMap]", de = "[object ArrayBuffer]", ye = "[object DataView]", pt = "[object Float32Array]", cr = "[object Float64Array]", Y = "[object Int8Array]", k = "[object Int16Array]", B = "[object Int32Array]", F = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", oe = "[object Uint16Array]", ge = "[object Uint32Array]", X = {};
  X[A] = X[M] = X[de] = X[ye] = X[O] = X[S] = X[pt] = X[cr] = X[Y] = X[k] = X[B] = X[L] = X[H] = X[z] = X[te] = X[le] = X[ce] = X[ae] = X[F] = X[Z] = X[oe] = X[ge] = !0, X[P] = X[N] = X[ue] = !1;
  function $e(ne, Ce, Qe, Gn, Nt, bt) {
    var Fe, Yn = Ce & m, Zn = Ce & T, Ug = Ce & x;
    if (Qe && (Fe = Nt ? Qe(ne, Gn, Nt, bt) : Qe(ne)), Fe !== void 0)
      return Fe;
    if (!_(ne))
      return ne;
    var $u = p(ne);
    if ($u) {
      if (Fe = f(ne), !Yn)
        return a(ne, Fe);
    } else {
      var Dr = d(ne), Fu = Dr == N || Dr == E;
      if (v(ne))
        return o(ne, Yn);
      if (Dr == z || Dr == A || Fu && !Nt) {
        if (Fe = Zn || Fu ? {} : g(ne), !Yn)
          return Zn ? l(ne, i(Fe, ne)) : s(ne, r(Fe, ne));
      } else {
        if (!X[Dr])
          return Nt ? ne : {};
        Fe = h(ne, Dr, Yn);
      }
    }
    bt || (bt = new n());
    var Vu = bt.get(ne);
    if (Vu)
      return Vu;
    bt.set(ne, Fe), y(ne) ? ne.forEach(function(zt) {
      Fe.add($e(zt, Ce, Qe, zt, ne, bt));
    }) : b(ne) && ne.forEach(function(zt, dr) {
      Fe.set(dr, $e(zt, Ce, Qe, dr, ne, bt));
    });
    var jg = Ug ? Zn ? c : u : Zn ? w : C, zu = $u ? void 0 : jg(ne);
    return e(zu || ne, function(zt, dr) {
      zu && (dr = zt, zt = ne[dr]), t(Fe, dr, $e(zt, Ce, Qe, dr, ne, bt));
    }), Fe;
  }
  return es = $e, es;
}
var ts, yf;
function l_() {
  if (yf) return ts;
  yf = 1;
  var n = s_(), e = 1, t = 4;
  function r(i) {
    return n(i, e | t);
  }
  return ts = r, ts;
}
var u_ = l_();
const Or = /* @__PURE__ */ $t(u_);
var rs, Cf;
function vu() {
  if (Cf) return rs;
  Cf = 1;
  var n = tn(), e = sr(), t = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || e(i) && n(i) == t;
  }
  return rs = r, rs;
}
var ns, wf;
function c_() {
  if (wf) return ns;
  wf = 1;
  var n = lr(), e = vu(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(o, a) {
    if (n(o))
      return !1;
    var s = typeof o;
    return s == "number" || s == "symbol" || s == "boolean" || o == null || e(o) ? !0 : r.test(o) || !t.test(o) || a != null && o in Object(a);
  }
  return ns = i, ns;
}
var is, Tf;
function d_() {
  if (Tf) return is;
  Tf = 1;
  var n = ru(), e = "Expected a function";
  function t(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(e);
    var o = function() {
      var a = arguments, s = i ? i.apply(this, a) : a[0], l = o.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return o.cache = l.set(s, u) || l, u;
    };
    return o.cache = new (t.Cache || n)(), o;
  }
  return t.Cache = n, is = t, is;
}
var os, Sf;
function f_() {
  if (Sf) return os;
  Sf = 1;
  var n = d_(), e = 500;
  function t(r) {
    var i = n(r, function(a) {
      return o.size === e && o.clear(), a;
    }), o = i.cache;
    return i;
  }
  return os = t, os;
}
var as, xf;
function h_() {
  if (xf) return as;
  xf = 1;
  var n = f_(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, r = n(function(i) {
    var o = [];
    return i.charCodeAt(0) === 46 && o.push(""), i.replace(e, function(a, s, l, u) {
      o.push(l ? u.replace(t, "$1") : s || a);
    }), o;
  });
  return as = r, as;
}
var ss, Af;
function p_() {
  if (Af) return ss;
  Af = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, o = Array(i); ++r < i; )
      o[r] = t(e[r], r, e);
    return o;
  }
  return ss = n, ss;
}
var ls, Of;
function v_() {
  if (Of) return ls;
  Of = 1;
  var n = Si(), e = p_(), t = lr(), r = vu(), i = n ? n.prototype : void 0, o = i ? i.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (t(s))
      return e(s, a) + "";
    if (r(s))
      return o ? o.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return ls = a, ls;
}
var us, Ef;
function zn() {
  if (Ef) return us;
  Ef = 1;
  var n = v_();
  function e(t) {
    return t == null ? "" : n(t);
  }
  return us = e, us;
}
var cs, If;
function g_() {
  if (If) return cs;
  If = 1;
  var n = lr(), e = c_(), t = h_(), r = zn();
  function i(o, a) {
    return n(o) ? o : e(o, a) ? [o] : t(r(o));
  }
  return cs = i, cs;
}
var ds, Nf;
function m_() {
  if (Nf) return ds;
  Nf = 1;
  var n = vu();
  function e(t) {
    if (typeof t == "string" || n(t))
      return t;
    var r = t + "";
    return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
  }
  return ds = e, ds;
}
var fs, kf;
function __() {
  if (kf) return fs;
  kf = 1;
  var n = g_(), e = m_();
  function t(r, i) {
    i = n(i, r);
    for (var o = 0, a = i.length; r != null && o < a; )
      r = r[e(i[o++])];
    return o && o == a ? r : void 0;
  }
  return fs = t, fs;
}
var hs, Df;
function b_() {
  if (Df) return hs;
  Df = 1;
  var n = __();
  function e(t, r, i) {
    var o = t == null ? void 0 : n(t, r);
    return o === void 0 ? i : o;
  }
  return hs = e, hs;
}
var y_ = b_();
const gu = /* @__PURE__ */ $t(y_);
var C_ = Ft();
const Di = /* @__PURE__ */ $t(C_);
var ps, Rf;
function w_() {
  if (Rf) return ps;
  Rf = 1;
  var n = wp(), e = Ni();
  function t(r, i) {
    return r && n(r, i, e);
  }
  return ps = t, ps;
}
var vs, Pf;
function T_() {
  if (Pf) return vs;
  Pf = 1;
  var n = cu();
  function e(t) {
    return typeof t == "function" ? t : n;
  }
  return vs = e, vs;
}
var gs, Mf;
function S_() {
  if (Mf) return gs;
  Mf = 1;
  var n = w_(), e = T_();
  function t(r, i) {
    return r && n(r, e(i));
  }
  return gs = t, gs;
}
var x_ = S_();
const Ri = /* @__PURE__ */ $t(x_), Pe = () => ({
  anchorTag: "",
  customClasses: []
}), Wt = (n = {}) => ({
  ...n.roundedLayouts && {
    borderRadius: {
      value: 0
    }
  },
  backgroundColor: {
    toggle: !1,
    value: null
  },
  backgroundImage: {
    toggle: !1,
    image: null
  },
  margin: {
    linked: !0,
    value: 10,
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  },
  padding: {
    linked: !0,
    value: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  ...Pe()
}), A_ = () => ({
  name: "Base Column",
  type: qe,
  nodes: []
}), se = () => crypto.randomUUID(), ze = (n, e = {}) => {
  if (!n) return null;
  switch (n.type) {
    case qe:
      return {
        ...A_()
      };
    case Cn:
      return {
        id: se(),
        name: "One Column",
        type: Cn,
        properties: { ...Wt(e) },
        nodes: [ze({ type: qe })]
      };
    case wn:
      return {
        id: se(),
        name: "Two Columns",
        type: wn,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => ze({ type: qe }))
      };
    case Tn:
      return {
        id: se(),
        name: "Three Columns",
        type: Tn,
        properties: { ...Wt(e) },
        nodes: new Array(3).fill(null).map((t) => ze({ type: qe }))
      };
    case Sn:
      return {
        id: se(),
        name: "Four Columns",
        type: Sn,
        properties: { ...Wt(e) },
        nodes: new Array(4).fill(null).map((t) => ze({ type: qe }))
      };
    case Hr:
      return {
        id: se(),
        name: "Full Width",
        type: Hr,
        properties: {
          ...Wt(e),
          margin: {
            linked: !1,
            value: 0,
            top: 10,
            bottom: 10,
            left: 0,
            right: 0
          }
        },
        nodes: [ze({ type: qe })]
      };
    case xn:
      return {
        id: se(),
        name: "Left Sidebar",
        type: xn,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => ze({ type: qe }))
      };
    case An:
      return {
        id: se(),
        name: "Right Sidebar",
        type: An,
        properties: { ...Wt(e) },
        nodes: new Array(2).fill(null).map((t) => ze({ type: qe }))
      };
    case et:
      if (!n.sharedContentId) {
        console.error("Node must have a sharedContentId UUID property");
        return;
      }
      return {
        id: se(),
        name: "Shared content",
        type: et,
        properties: {
          ...Wt(e),
          margin: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          padding: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }
        },
        sharedContentId: n.sharedContentId,
        nodes: [ze({ type: qe })]
      };
  }
}, yr = (n, e = {}) => {
  if (!n) return null;
  const { id: t, type: r, content: i, parentId: o } = n;
  switch (r) {
    case ri:
      return {
        id: t || se(),
        name: "Heading",
        type: ri,
        content: {
          html: (i == null ? void 0 : i.html) || ""
        },
        properties: {
          ...Pe()
        }
      };
    case $r:
      return {
        id: t || se(),
        name: "Text",
        type: $r,
        content: {
          html: (i == null ? void 0 : i.html) || ""
        },
        properties: {
          ...Pe()
        }
      };
    case Hn:
      return {
        ...new Bt()
      };
    case On:
      return {
        id: se(),
        name: "Gallery",
        type: On,
        content: {
          images: []
        },
        properties: {
          columnsCount: 4,
          isLightbox: !1,
          showCaptions: !1,
          captionsAlignment: "center",
          ...Pe()
        }
      };
    case pl:
      return {
        id: se(),
        name: "Video",
        type: pl,
        content: {
          embeddableUrl: ""
        },
        properties: {
          columnPercentage: 100,
          isResized: !1,
          videoAlignment: "center",
          ...Pe()
        }
      };
    case fl:
      return {
        id: se(),
        name: "Code",
        type: fl,
        content: {
          html: ""
        },
        properties: {
          hasScriptTag: !1,
          ...Pe()
        }
      };
    case hl:
      return {
        id: se(),
        name: "Spacer",
        type: hl,
        properties: {
          height: 20,
          isTransparent: !1,
          backgroundColor: Lt.WHITE,
          ...Pe()
        }
      };
    case vl:
      return {
        id: se(),
        name: "Separator",
        type: vl,
        properties: {
          thickness: 1,
          width: 100,
          color: "",
          style: "solid",
          ...Pe()
        }
      };
    case _l:
      return {
        id: se(),
        name: "Quote",
        type: _l,
        content: {
          quote: "",
          author: "",
          source: ""
        },
        properties: {
          design: "design-1",
          color: e.mainColor || Lt.BLACK,
          ...Pe()
        }
      };
    case En:
      return {
        id: se(),
        name: "Slider",
        type: En,
        content: {
          images: []
        },
        properties: {
          showDots: !0,
          dotsPosition: "top",
          showArrows: !0,
          arrowsPosition: "top",
          isAutoplay: !0,
          transitionSpeed: 3,
          ...Pe()
        }
      };
    case In:
      return {
        id: se(),
        name: "Card",
        type: In,
        content: {
          heading: yr({ type: ri }),
          text: yr({ type: $r }),
          image: new Bt()
        },
        properties: {
          design: "box-shadow",
          showHeadline: !0,
          showImage: !0,
          imagePosition: "left",
          wrapText: !1,
          ...Pe()
        }
      };
    case ml:
      return {
        id: se(),
        name: "Form",
        type: ml,
        content: {
          formId: null
        },
        properties: {
          showOneQuestionAtATime: !1,
          ...Pe()
        }
      };
    case gl:
      return {
        id: se(),
        name: "Button",
        type: gl,
        content: {
          buttons: [N_()]
        },
        properties: {
          type: "regular",
          theme: "light",
          size: "regular",
          pillShape: !1,
          alignment: "left",
          style: "1",
          hasIcons: !1,
          ...Pe()
        }
      };
    case bl:
      return {
        id: se(),
        name: "Table",
        type: bl,
        content: {
          html: ""
        },
        properties: {
          theme: Zu,
          alternatingColors: !0,
          ...Pe()
        }
      };
    case Ut:
      const a = {
        id: se(),
        name: "Accordion",
        type: Ut,
        nodes: [],
        properties: {
          theme: Zu,
          iconStyle: "plus",
          allowMultipleOpenPanels: !0,
          ...Pe()
        }
      }, s = {
        ...ze({ type: qe }),
        nodes: [
          yr({
            type: St,
            parentId: a.id
          })
        ]
      };
      return a.nodes.push(s), a;
    case St:
      return {
        id: se(),
        name: "Accordion Panel",
        type: St,
        properties: {
          text: "",
          panelExpanded: !0,
          defaultToExpanded: !1,
          ...Pe()
        },
        parentAccordionId: o,
        nodes: [ze({ type: qe })]
      };
    case li:
      return {
        id: se(),
        name: "List",
        type: li,
        content: {
          items: [k_()]
        },
        properties: {
          design: "simple",
          format: "disc",
          ...Pe()
        }
      };
    case ui:
      return {
        id: se(),
        name: "Navigation",
        type: ui,
        content: {
          selectedPageId: null,
          selectedChildrenIds: []
        },
        properties: {
          design: "style-1",
          color: e.mainColor || Lt.BLACK,
          isSiteMenuSynced: !1
        }
      };
    case Nn:
      return {
        id: t || se(),
        name: "Shared Component Error",
        type: Nn
      };
  }
}, ir = (n) => !!Jl.find((e) => e.type === n.type), Jp = (n) => !!yi.find((e) => e.type === n.type), ev = (n) => n.type === qe, vw = (n) => {
  switch (n.type) {
    case wn:
    case Tn:
    case xn:
    case An:
    case Sn:
      return !0;
    default:
      return !1;
  }
}, O_ = (n) => !!gp.find((e) => e.type === n.type), E_ = (n, e) => e ? n.type === qe && n.nodes.length === 0 : !1, I_ = (n) => ir(n) ? mr : Jp(n) ? _r : O_(n) ? Ql : "", kn = (n = {}, e = 0, t = null) => {
  var a;
  if (!((a = n.nodes) != null && a.length)) return { ...Or(n), id: se() };
  const r = se(), i = n.type === Ut ? r : t, o = (n.nodes || []).map((s) => kn(s, e + 1, i)) || [];
  return {
    ...Or(n),
    hasAnimated: !1,
    id: r,
    nodes: o,
    ...n.type === St && { parentAccordionId: t }
  };
}, gw = (n) => yr(n), mw = () => new Bt(), N_ = () => ({
  id: se(),
  title: "",
  icon: null,
  iconId: null,
  link: "",
  newTab: !1
}), k_ = () => ({
  id: se(),
  content: yr({ type: $r }),
  details: yr({ type: $r })
}), D_ = ({ customProperties: n = null }) => n ? yi.some((e) => {
  var o, a, s, l, u;
  const t = (a = (o = n[e.type]) == null ? void 0 : o.colorPalette) == null ? void 0 : a.enabled, r = (u = (l = (s = n[e.type]) == null ? void 0 : s.colorPalette) == null ? void 0 : l.colors) == null ? void 0 : u.length;
  return n.hasOwnProperty(e.type) && t && !!r;
}) : !1, qt = (n, e) => {
  if (gu(n, "id") === e) return n;
  let t = null, r = (n == null ? void 0 : n.nodes) || {};
  return Ri(r, (i) => {
    if (Di(i) && (t = qt(i, e), t))
      return !1;
  }), t;
}, Mt = (n, e, t = null) => {
  if (n.id === e) {
    const r = t == null ? void 0 : t.nodes.indexOf(n);
    return { parent: t, index: r };
  }
  if (n.nodes && Array.isArray(n.nodes))
    for (let r = 0; r < n.nodes.length; r++) {
      const i = n.nodes[r], o = Mt(i, e, n);
      if (o) return o;
    }
  return null;
}, tv = (n, e, t = null, r = null, i = -1) => {
  if (n.id === e) {
    const o = (t == null ? void 0 : t.type) === "BASE_COLUMN" ? r : t, a = (t == null ? void 0 : t.type) === "BASE_COLUMN" ? i : t == null ? void 0 : t.nodes.indexOf(n);
    return { parent: o, grandparent: r, index: a };
  }
  if (n.nodes && Array.isArray(n.nodes))
    for (let o = 0; o < n.nodes.length; o++) {
      const a = n.nodes[o], s = tv(
        a,
        e,
        n,
        t,
        o
      );
      if (s) return s;
    }
  return null;
}, Lf = (n) => n.type === St, rv = (n) => {
  if (gu(n, "type") === Ut) return !0;
  let e = !1, t = n.nodes || {};
  return Ri(t, (r) => {
    if (Di(r) && (e = rv(r), e))
      return !1;
  }), e;
}, nv = (n, e) => {
  if (gu(n, "type") === e) return !0;
  let t = !1, r = n.nodes || {};
  return Ri(r, (i) => {
    if (Di(i) && (t = nv(i, e), t))
      return !1;
  }), t;
}, R_ = (n = {}) => Object.values(n).some((e) => !!e);
class Bt {
  constructor(e = {}) {
    const t = {
      id: se(),
      name: "Image",
      type: Hn,
      content: {
        assetId: "",
        altText: "",
        caption: "",
        imageFile: null,
        // We need to remove this at some point since its not being used outside of builder
        link: ""
      },
      properties: {
        actionOnClick: "no-action",
        captionAlignment: "center",
        columnPercentage: 100,
        focalPointPosition: {
          x: 50,
          y: 50
        },
        imageAlignment: "center",
        isDecorative: !1,
        isResized: !1,
        naturalWidth: null,
        naturalHeight: null,
        newTab: !1,
        preferredWidth: null,
        preferredHeight: null,
        resizeMode: "actual-size",
        showCaption: null,
        // Necessary to distinguish from old pages that havent been adapted
        backgroundPosition: "fill",
        tilePercentage: 100,
        rotation: 0,
        // Not used right now, just left overs from an old idea
        anchorTag: "",
        customClasses: [""]
      }
    }, r = Rp(t, e);
    Object.assign(this, r);
  }
}
const P_ = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M4%2017.2105V10.2105C4%209.65823%204.44772%209.21051%205%209.21051H7.38197C7.76074%209.21051%208.107%208.99651%208.27639%208.65772L8.72361%207.7633C8.893%207.42451%209.23926%207.21051%209.61803%207.21051H14.382C14.7607%207.21051%2015.107%207.42451%2015.2764%207.7633L15.7236%208.65772C15.893%208.99651%2016.2393%209.21051%2016.618%209.21051H19C19.5523%209.21051%2020%209.65823%2020%2010.2105V17.2105C20%2017.7628%2019.5523%2018.2105%2019%2018.2105H5C4.44772%2018.2105%204%2017.7628%204%2017.2105Z'%20stroke='var(--primary-dark)'%20/%3e%3ccircle%20cx='12'%20cy='13.2105'%20r='3'%20stroke='var(---primary-dark)'%20/%3e%3c/svg%3e";
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function qf(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function iv(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qf(Object(t), !0).forEach(function(r) {
      B_(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : qf(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function M_(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function ov(n) {
  var e = M_(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Cl(n) {
  "@babel/helpers - typeof";
  return Cl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Cl(n);
}
function L_(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Bf(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, ov(r.key), r);
  }
}
function q_(n, e, t) {
  return e && Bf(n.prototype, e), t && Bf(n, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function B_(n, e, t) {
  return e = ov(e), e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function av(n) {
  return U_(n) || j_(n) || H_(n) || $_();
}
function U_(n) {
  if (Array.isArray(n)) return wl(n);
}
function j_(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function H_(n, e) {
  if (n) {
    if (typeof n == "string") return wl(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return wl(n, e);
  }
}
function wl(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function $_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Pi = typeof window < "u" && typeof window.document < "u", At = Pi ? window : {}, mu = Pi && At.document.documentElement ? "ontouchstart" in At.document.documentElement : !1, _u = Pi ? "PointerEvent" in At : !1, me = "cropper", bu = "all", sv = "crop", lv = "move", uv = "zoom", fr = "e", hr = "w", Pr = "s", Gt = "n", on = "ne", an = "nw", sn = "se", ln = "sw", Tl = "".concat(me, "-crop"), Uf = "".concat(me, "-disabled"), We = "".concat(me, "-hidden"), jf = "".concat(me, "-hide"), F_ = "".concat(me, "-invisible"), di = "".concat(me, "-modal"), Sl = "".concat(me, "-move"), Dn = "".concat(me, "Action"), Kn = "".concat(me, "Preview"), yu = "crop", cv = "move", dv = "none", xl = "crop", Al = "cropend", Ol = "cropmove", El = "cropstart", Hf = "dblclick", V_ = mu ? "touchstart" : "mousedown", z_ = mu ? "touchmove" : "mousemove", W_ = mu ? "touchend touchcancel" : "mouseup", $f = _u ? "pointerdown" : V_, Ff = _u ? "pointermove" : z_, Vf = _u ? "pointerup pointercancel" : W_, zf = "ready", Wf = "resize", Gf = "wheel", Il = "zoom", Yf = "image/jpeg", G_ = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Y_ = /^data:/, Z_ = /^data:image\/jpeg;base64,/, X_ = /^img|canvas$/i, fv = 200, hv = 100, Zf = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: yu,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: fv,
  minContainerHeight: hv,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, K_ = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Q_ = Number.isNaN || At.isNaN;
function re(n) {
  return typeof n == "number" && !Q_(n);
}
var Xf = function(e) {
  return e > 0 && e < 1 / 0;
};
function ms(n) {
  return typeof n > "u";
}
function Er(n) {
  return Cl(n) === "object" && n !== null;
}
var J_ = Object.prototype.hasOwnProperty;
function qr(n) {
  if (!Er(n))
    return !1;
  try {
    var e = n.constructor, t = e.prototype;
    return e && t && J_.call(t, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function Ve(n) {
  return typeof n == "function";
}
var e1 = Array.prototype.slice;
function pv(n) {
  return Array.from ? Array.from(n) : e1.call(n);
}
function Ne(n, e) {
  return n && Ve(e) && (Array.isArray(n) || re(n.length) ? pv(n).forEach(function(t, r) {
    e.call(n, t, r, n);
  }) : Er(n) && Object.keys(n).forEach(function(t) {
    e.call(n, n[t], t, n);
  })), n;
}
var _e = Object.assign || function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    r[i - 1] = arguments[i];
  return Er(e) && r.length > 0 && r.forEach(function(o) {
    Er(o) && Object.keys(o).forEach(function(a) {
      e[a] = o[a];
    });
  }), e;
}, t1 = /\.\d*(?:0|9){12}\d*$/;
function Fr(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return t1.test(n) ? Math.round(n * e) / e : n;
}
var r1 = /^width|height|left|top|marginLeft|marginTop$/;
function Yt(n, e) {
  var t = n.style;
  Ne(e, function(r, i) {
    r1.test(i) && re(r) && (r = "".concat(r, "px")), t[i] = r;
  });
}
function n1(n, e) {
  return n.classList ? n.classList.contains(e) : n.className.indexOf(e) > -1;
}
function ke(n, e) {
  if (e) {
    if (re(n.length)) {
      Ne(n, function(r) {
        ke(r, e);
      });
      return;
    }
    if (n.classList) {
      n.classList.add(e);
      return;
    }
    var t = n.className.trim();
    t ? t.indexOf(e) < 0 && (n.className = "".concat(t, " ").concat(e)) : n.className = e;
  }
}
function xt(n, e) {
  if (e) {
    if (re(n.length)) {
      Ne(n, function(t) {
        xt(t, e);
      });
      return;
    }
    if (n.classList) {
      n.classList.remove(e);
      return;
    }
    n.className.indexOf(e) >= 0 && (n.className = n.className.replace(e, ""));
  }
}
function Br(n, e, t) {
  if (e) {
    if (re(n.length)) {
      Ne(n, function(r) {
        Br(r, e, t);
      });
      return;
    }
    t ? ke(n, e) : xt(n, e);
  }
}
var i1 = /([a-z\d])([A-Z])/g;
function Cu(n) {
  return n.replace(i1, "$1-$2").toLowerCase();
}
function Nl(n, e) {
  return Er(n[e]) ? n[e] : n.dataset ? n.dataset[e] : n.getAttribute("data-".concat(Cu(e)));
}
function Rn(n, e, t) {
  Er(t) ? n[e] = t : n.dataset ? n.dataset[e] = t : n.setAttribute("data-".concat(Cu(e)), t);
}
function o1(n, e) {
  if (Er(n[e]))
    try {
      delete n[e];
    } catch {
      n[e] = void 0;
    }
  else if (n.dataset)
    try {
      delete n.dataset[e];
    } catch {
      n.dataset[e] = void 0;
    }
  else
    n.removeAttribute("data-".concat(Cu(e)));
}
var vv = /\s\s*/, gv = function() {
  var n = !1;
  if (Pi) {
    var e = !1, t = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return n = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(o) {
        e = o;
      }
    });
    At.addEventListener("test", t, r), At.removeEventListener("test", t, r);
  }
  return n;
}();
function vt(n, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = t;
  e.trim().split(vv).forEach(function(o) {
    if (!gv) {
      var a = n.listeners;
      a && a[o] && a[o][t] && (i = a[o][t], delete a[o][t], Object.keys(a[o]).length === 0 && delete a[o], Object.keys(a).length === 0 && delete n.listeners);
    }
    n.removeEventListener(o, i, r);
  });
}
function st(n, e, t) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = t;
  e.trim().split(vv).forEach(function(o) {
    if (r.once && !gv) {
      var a = n.listeners, s = a === void 0 ? {} : a;
      i = function() {
        delete s[o][t], n.removeEventListener(o, i, r);
        for (var u = arguments.length, c = new Array(u), d = 0; d < u; d++)
          c[d] = arguments[d];
        t.apply(n, c);
      }, s[o] || (s[o] = {}), s[o][t] && n.removeEventListener(o, s[o][t], r), s[o][t] = i, n.listeners = s;
    }
    n.addEventListener(o, i, r);
  });
}
function Vr(n, e, t) {
  var r;
  return Ve(Event) && Ve(CustomEvent) ? r = new CustomEvent(e, {
    detail: t,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(e, !0, !0, t)), n.dispatchEvent(r);
}
function mv(n) {
  var e = n.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var _s = At.location, a1 = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Kf(n) {
  var e = n.match(a1);
  return e !== null && (e[1] !== _s.protocol || e[2] !== _s.hostname || e[3] !== _s.port);
}
function Qf(n) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return n + (n.indexOf("?") === -1 ? "?" : "&") + e;
}
function vn(n) {
  var e = n.rotate, t = n.scaleX, r = n.scaleY, i = n.translateX, o = n.translateY, a = [];
  re(i) && i !== 0 && a.push("translateX(".concat(i, "px)")), re(o) && o !== 0 && a.push("translateY(".concat(o, "px)")), re(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), re(t) && t !== 1 && a.push("scaleX(".concat(t, ")")), re(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var s = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function s1(n) {
  var e = iv({}, n), t = 0;
  return Ne(n, function(r, i) {
    delete e[i], Ne(e, function(o) {
      var a = Math.abs(r.startX - o.startX), s = Math.abs(r.startY - o.startY), l = Math.abs(r.endX - o.endX), u = Math.abs(r.endY - o.endY), c = Math.sqrt(a * a + s * s), d = Math.sqrt(l * l + u * u), f = (d - c) / c;
      Math.abs(f) > Math.abs(t) && (t = f);
    });
  }), t;
}
function Qn(n, e) {
  var t = n.pageX, r = n.pageY, i = {
    endX: t,
    endY: r
  };
  return e ? i : iv({
    startX: t,
    startY: r
  }, i);
}
function l1(n) {
  var e = 0, t = 0, r = 0;
  return Ne(n, function(i) {
    var o = i.startX, a = i.startY;
    e += o, t += a, r += 1;
  }), e /= r, t /= r, {
    pageX: e,
    pageY: t
  };
}
function Zt(n) {
  var e = n.aspectRatio, t = n.height, r = n.width, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", o = Xf(r), a = Xf(t);
  if (o && a) {
    var s = t * e;
    i === "contain" && s > r || i === "cover" && s < r ? t = r / e : r = t * e;
  } else o ? t = r / e : a && (r = t * e);
  return {
    width: r,
    height: t
  };
}
function u1(n) {
  var e = n.width, t = n.height, r = n.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: t,
      height: e
    };
  var i = r % 90 * Math.PI / 180, o = Math.sin(i), a = Math.cos(i), s = e * a + t * o, l = e * o + t * a;
  return r > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function c1(n, e, t, r) {
  var i = e.aspectRatio, o = e.naturalWidth, a = e.naturalHeight, s = e.rotate, l = s === void 0 ? 0 : s, u = e.scaleX, c = u === void 0 ? 1 : u, d = e.scaleY, f = d === void 0 ? 1 : d, h = t.aspectRatio, g = t.naturalWidth, p = t.naturalHeight, v = r.fillColor, b = v === void 0 ? "transparent" : v, _ = r.imageSmoothingEnabled, y = _ === void 0 ? !0 : _, C = r.imageSmoothingQuality, w = C === void 0 ? "low" : C, m = r.maxWidth, T = m === void 0 ? 1 / 0 : m, x = r.maxHeight, A = x === void 0 ? 1 / 0 : x, M = r.minWidth, O = M === void 0 ? 0 : M, S = r.minHeight, P = S === void 0 ? 0 : S, N = document.createElement("canvas"), E = N.getContext("2d"), L = Zt({
    aspectRatio: h,
    width: T,
    height: A
  }), H = Zt({
    aspectRatio: h,
    width: O,
    height: P
  }, "cover"), z = Math.min(L.width, Math.max(H.width, g)), te = Math.min(L.height, Math.max(H.height, p)), le = Zt({
    aspectRatio: i,
    width: T,
    height: A
  }), ce = Zt({
    aspectRatio: i,
    width: O,
    height: P
  }, "cover"), ae = Math.min(le.width, Math.max(ce.width, o)), ue = Math.min(le.height, Math.max(ce.height, a)), de = [-ae / 2, -ue / 2, ae, ue];
  return N.width = Fr(z), N.height = Fr(te), E.fillStyle = b, E.fillRect(0, 0, z, te), E.save(), E.translate(z / 2, te / 2), E.rotate(l * Math.PI / 180), E.scale(c, f), E.imageSmoothingEnabled = y, E.imageSmoothingQuality = w, E.drawImage.apply(E, [n].concat(av(de.map(function(ye) {
    return Math.floor(Fr(ye));
  })))), E.restore(), N;
}
var _v = String.fromCharCode;
function d1(n, e, t) {
  var r = "";
  t += e;
  for (var i = e; i < t; i += 1)
    r += _v(n.getUint8(i));
  return r;
}
var f1 = /^data:.*,/;
function h1(n) {
  var e = n.replace(f1, ""), t = atob(e), r = new ArrayBuffer(t.length), i = new Uint8Array(r);
  return Ne(i, function(o, a) {
    i[a] = t.charCodeAt(a);
  }), r;
}
function p1(n, e) {
  for (var t = [], r = 8192, i = new Uint8Array(n); i.length > 0; )
    t.push(_v.apply(null, pv(i.subarray(0, r)))), i = i.subarray(r);
  return "data:".concat(e, ";base64,").concat(btoa(t.join("")));
}
function v1(n) {
  var e = new DataView(n), t;
  try {
    var r, i, o;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, s = 2; s + 1 < a; ) {
        if (e.getUint8(s) === 255 && e.getUint8(s + 1) === 225) {
          i = s;
          break;
        }
        s += 1;
      }
    if (i) {
      var l = i + 4, u = i + 10;
      if (d1(e, l, 4) === "Exif") {
        var c = e.getUint16(u);
        if (r = c === 18761, (r || c === 19789) && e.getUint16(u + 2, r) === 42) {
          var d = e.getUint32(u + 4, r);
          d >= 8 && (o = u + d);
        }
      }
    }
    if (o) {
      var f = e.getUint16(o, r), h, g;
      for (g = 0; g < f; g += 1)
        if (h = o + g * 12 + 2, e.getUint16(h, r) === 274) {
          h += 8, t = e.getUint16(h, r), e.setUint16(h, 1, r);
          break;
        }
    }
  } catch {
    t = 1;
  }
  return t;
}
function g1(n) {
  var e = 0, t = 1, r = 1;
  switch (n) {
    // Flip horizontal
    case 2:
      t = -1;
      break;
    // Rotate left 180°
    case 3:
      e = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      e = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      e = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      e = 90, t = -1;
      break;
    // Rotate left 90°
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: t,
    scaleY: r
  };
}
var m1 = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, r = this.container, i = this.cropper, o = Number(t.minContainerWidth), a = Number(t.minContainerHeight);
    ke(i, We), xt(e, We);
    var s = {
      width: Math.max(r.offsetWidth, o >= 0 ? o : fv),
      height: Math.max(r.offsetHeight, a >= 0 ? a : hv)
    };
    this.containerData = s, Yt(i, {
      width: s.width,
      height: s.height
    }), ke(e, We), xt(i, We);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, r = this.options.viewMode, i = Math.abs(t.rotate) % 180 === 90, o = i ? t.naturalHeight : t.naturalWidth, a = i ? t.naturalWidth : t.naturalHeight, s = o / a, l = e.width, u = e.height;
    e.height * s > e.width ? r === 3 ? l = e.height * s : u = e.width / s : r === 3 ? u = e.width / s : l = e.height * s;
    var c = {
      aspectRatio: s,
      naturalWidth: o,
      naturalHeight: a,
      width: l,
      height: u
    };
    this.canvasData = c, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = _e({}, c);
  },
  limitCanvas: function(e, t) {
    var r = this.options, i = this.containerData, o = this.canvasData, a = this.cropBoxData, s = r.viewMode, l = o.aspectRatio, u = this.cropped && a;
    if (e) {
      var c = Number(r.minCanvasWidth) || 0, d = Number(r.minCanvasHeight) || 0;
      s > 1 ? (c = Math.max(c, i.width), d = Math.max(d, i.height), s === 3 && (d * l > c ? c = d * l : d = c / l)) : s > 0 && (c ? c = Math.max(c, u ? a.width : 0) : d ? d = Math.max(d, u ? a.height : 0) : u && (c = a.width, d = a.height, d * l > c ? c = d * l : d = c / l));
      var f = Zt({
        aspectRatio: l,
        width: c,
        height: d
      });
      c = f.width, d = f.height, o.minWidth = c, o.minHeight = d, o.maxWidth = 1 / 0, o.maxHeight = 1 / 0;
    }
    if (t)
      if (s > (u ? 0 : 1)) {
        var h = i.width - o.width, g = i.height - o.height;
        o.minLeft = Math.min(0, h), o.minTop = Math.min(0, g), o.maxLeft = Math.max(0, h), o.maxTop = Math.max(0, g), u && this.limited && (o.minLeft = Math.min(a.left, a.left + (a.width - o.width)), o.minTop = Math.min(a.top, a.top + (a.height - o.height)), o.maxLeft = a.left, o.maxTop = a.top, s === 2 && (o.width >= i.width && (o.minLeft = Math.min(0, h), o.maxLeft = Math.max(0, h)), o.height >= i.height && (o.minTop = Math.min(0, g), o.maxTop = Math.max(0, g))));
      } else
        o.minLeft = -o.width, o.minTop = -o.height, o.maxLeft = i.width, o.maxTop = i.height;
  },
  renderCanvas: function(e, t) {
    var r = this.canvasData, i = this.imageData;
    if (t) {
      var o = u1({
        width: i.naturalWidth * Math.abs(i.scaleX || 1),
        height: i.naturalHeight * Math.abs(i.scaleY || 1),
        degree: i.rotate || 0
      }), a = o.width, s = o.height, l = r.width * (a / r.naturalWidth), u = r.height * (s / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (u - r.height) / 2, r.width = l, r.height = u, r.aspectRatio = a / s, r.naturalWidth = a, r.naturalHeight = s, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, Yt(this.canvas, _e({
      width: r.width,
      height: r.height
    }, vn({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, r = this.imageData, i = r.naturalWidth * (t.width / t.naturalWidth), o = r.naturalHeight * (t.height / t.naturalHeight);
    _e(r, {
      width: i,
      height: o,
      left: (t.width - i) / 2,
      top: (t.height - o) / 2
    }), Yt(this.image, _e({
      width: r.width,
      height: r.height
    }, vn(_e({
      translateX: r.left,
      translateY: r.top
    }, r)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, r = e.aspectRatio || e.initialAspectRatio, i = Number(e.autoCropArea) || 0.8, o = {
      width: t.width,
      height: t.height
    };
    r && (t.height * r > t.width ? o.height = o.width / r : o.width = o.height * r), this.cropBoxData = o, this.limitCropBox(!0, !0), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), o.width = Math.max(o.minWidth, o.width * i), o.height = Math.max(o.minHeight, o.height * i), o.left = t.left + (t.width - o.width) / 2, o.top = t.top + (t.height - o.height) / 2, o.oldLeft = o.left, o.oldTop = o.top, this.initialCropBoxData = _e({}, o);
  },
  limitCropBox: function(e, t) {
    var r = this.options, i = this.containerData, o = this.canvasData, a = this.cropBoxData, s = this.limited, l = r.aspectRatio;
    if (e) {
      var u = Number(r.minCropBoxWidth) || 0, c = Number(r.minCropBoxHeight) || 0, d = s ? Math.min(i.width, o.width, o.width + o.left, i.width - o.left) : i.width, f = s ? Math.min(i.height, o.height, o.height + o.top, i.height - o.top) : i.height;
      u = Math.min(u, i.width), c = Math.min(c, i.height), l && (u && c ? c * l > u ? c = u / l : u = c * l : u ? c = u / l : c && (u = c * l), f * l > d ? f = d / l : d = f * l), a.minWidth = Math.min(u, d), a.minHeight = Math.min(c, f), a.maxWidth = d, a.maxHeight = f;
    }
    t && (s ? (a.minLeft = Math.max(0, o.left), a.minTop = Math.max(0, o.top), a.maxLeft = Math.min(i.width, o.left + o.width) - a.width, a.maxTop = Math.min(i.height, o.top + o.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = i.width - a.width, a.maxTop = i.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, e.movable && e.cropBoxMovable && Rn(this.face, Dn, r.width >= t.width && r.height >= t.height ? lv : bu), Yt(this.cropBox, _e({
      width: r.width,
      height: r.height
    }, vn({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Vr(this.element, xl, this.getData());
  }
}, _1 = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, r = this.options.preview, i = t ? this.crossOriginUrl : this.url, o = e.alt || "The image to preview", a = document.createElement("img");
    if (t && (a.crossOrigin = t), a.src = i, a.alt = o, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var s = r;
      typeof r == "string" ? s = e.ownerDocument.querySelectorAll(r) : r.querySelector && (s = [r]), this.previews = s, Ne(s, function(l) {
        var u = document.createElement("img");
        Rn(l, Kn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), t && (u.crossOrigin = t), u.src = i, u.alt = o, u.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(u);
      });
    }
  },
  resetPreview: function() {
    Ne(this.previews, function(e) {
      var t = Nl(e, Kn);
      Yt(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, o1(e, Kn);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, r = this.cropBoxData, i = r.width, o = r.height, a = e.width, s = e.height, l = r.left - t.left - e.left, u = r.top - t.top - e.top;
    !this.cropped || this.disabled || (Yt(this.viewBoxImage, _e({
      width: a,
      height: s
    }, vn(_e({
      translateX: -l,
      translateY: -u
    }, e)))), Ne(this.previews, function(c) {
      var d = Nl(c, Kn), f = d.width, h = d.height, g = f, p = h, v = 1;
      i && (v = f / i, p = o * v), o && p > h && (v = h / o, g = i * v, p = h), Yt(c, {
        width: g,
        height: p
      }), Yt(c.getElementsByTagName("img")[0], _e({
        width: a * v,
        height: s * v
      }, vn(_e({
        translateX: -l * v,
        translateY: -u * v
      }, e))));
    }));
  }
}, b1 = {
  bind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    Ve(t.cropstart) && st(e, El, t.cropstart), Ve(t.cropmove) && st(e, Ol, t.cropmove), Ve(t.cropend) && st(e, Al, t.cropend), Ve(t.crop) && st(e, xl, t.crop), Ve(t.zoom) && st(e, Il, t.zoom), st(r, $f, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && st(r, Gf, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && st(r, Hf, this.onDblclick = this.dblclick.bind(this)), st(e.ownerDocument, Ff, this.onCropMove = this.cropMove.bind(this)), st(e.ownerDocument, Vf, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && st(window, Wf, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, r = this.cropper;
    Ve(t.cropstart) && vt(e, El, t.cropstart), Ve(t.cropmove) && vt(e, Ol, t.cropmove), Ve(t.cropend) && vt(e, Al, t.cropend), Ve(t.crop) && vt(e, xl, t.crop), Ve(t.zoom) && vt(e, Il, t.zoom), vt(r, $f, this.onCropStart), t.zoomable && t.zoomOnWheel && vt(r, Gf, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && vt(r, Hf, this.onDblclick), vt(e.ownerDocument, Ff, this.onCropMove), vt(e.ownerDocument, Vf, this.onCropEnd), t.responsive && vt(window, Wf, this.onResize);
  }
}, y1 = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, r = this.containerData, i = t.offsetWidth / r.width, o = t.offsetHeight / r.height, a = Math.abs(i - 1) > Math.abs(o - 1) ? i : o;
      if (a !== 1) {
        var s, l;
        e.restore && (s = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(Ne(s, function(u, c) {
          s[c] = u * a;
        })), this.setCropBoxData(Ne(l, function(u, c) {
          l[c] = u * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === dv || this.setDragMode(n1(this.dragBox, Tl) ? cv : yu);
  },
  wheel: function(e) {
    var t = this, r = Number(this.options.wheelZoomRatio) || 0.1, i = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? i = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? i = -e.wheelDelta / 120 : e.detail && (i = e.detail > 0 ? 1 : -1), this.zoom(-i * r, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, r = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (re(t) && t !== 1 || re(r) && r !== 0 || e.ctrlKey))) {
      var i = this.options, o = this.pointers, a;
      e.changedTouches ? Ne(e.changedTouches, function(s) {
        o[s.identifier] = Qn(s);
      }) : o[e.pointerId || 0] = Qn(e), Object.keys(o).length > 1 && i.zoomable && i.zoomOnTouch ? a = uv : a = Nl(e.target, Dn), G_.test(a) && Vr(this.element, El, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === sv && (this.cropping = !0, ke(this.dragBox, di)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var r = this.pointers;
      e.preventDefault(), Vr(this.element, Ol, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? Ne(e.changedTouches, function(i) {
        _e(r[i.identifier] || {}, Qn(i, !0));
      }) : _e(r[e.pointerId || 0] || {}, Qn(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, r = this.pointers;
      e.changedTouches ? Ne(e.changedTouches, function(i) {
        delete r[i.identifier];
      }) : delete r[e.pointerId || 0], t && (e.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, Br(this.dragBox, di, this.cropped && this.options.modal)), Vr(this.element, Al, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, C1 = {
  change: function(e) {
    var t = this.options, r = this.canvasData, i = this.containerData, o = this.cropBoxData, a = this.pointers, s = this.action, l = t.aspectRatio, u = o.left, c = o.top, d = o.width, f = o.height, h = u + d, g = c + f, p = 0, v = 0, b = i.width, _ = i.height, y = !0, C;
    !l && e.shiftKey && (l = d && f ? d / f : 1), this.limited && (p = o.minLeft, v = o.minTop, b = p + Math.min(i.width, r.width, r.left + r.width), _ = v + Math.min(i.height, r.height, r.top + r.height));
    var w = a[Object.keys(a)[0]], m = {
      x: w.endX - w.startX,
      y: w.endY - w.startY
    }, T = function(A) {
      switch (A) {
        case fr:
          h + m.x > b && (m.x = b - h);
          break;
        case hr:
          u + m.x < p && (m.x = p - u);
          break;
        case Gt:
          c + m.y < v && (m.y = v - c);
          break;
        case Pr:
          g + m.y > _ && (m.y = _ - g);
          break;
      }
    };
    switch (s) {
      // Move crop box
      case bu:
        u += m.x, c += m.y;
        break;
      // Resize crop box
      case fr:
        if (m.x >= 0 && (h >= b || l && (c <= v || g >= _))) {
          y = !1;
          break;
        }
        T(fr), d += m.x, d < 0 && (s = hr, d = -d, u -= d), l && (f = d / l, c += (o.height - f) / 2);
        break;
      case Gt:
        if (m.y <= 0 && (c <= v || l && (u <= p || h >= b))) {
          y = !1;
          break;
        }
        T(Gt), f -= m.y, c += m.y, f < 0 && (s = Pr, f = -f, c -= f), l && (d = f * l, u += (o.width - d) / 2);
        break;
      case hr:
        if (m.x <= 0 && (u <= p || l && (c <= v || g >= _))) {
          y = !1;
          break;
        }
        T(hr), d -= m.x, u += m.x, d < 0 && (s = fr, d = -d, u -= d), l && (f = d / l, c += (o.height - f) / 2);
        break;
      case Pr:
        if (m.y >= 0 && (g >= _ || l && (u <= p || h >= b))) {
          y = !1;
          break;
        }
        T(Pr), f += m.y, f < 0 && (s = Gt, f = -f, c -= f), l && (d = f * l, u += (o.width - d) / 2);
        break;
      case on:
        if (l) {
          if (m.y <= 0 && (c <= v || h >= b)) {
            y = !1;
            break;
          }
          T(Gt), f -= m.y, c += m.y, d = f * l;
        } else
          T(Gt), T(fr), m.x >= 0 ? h < b ? d += m.x : m.y <= 0 && c <= v && (y = !1) : d += m.x, m.y <= 0 ? c > v && (f -= m.y, c += m.y) : (f -= m.y, c += m.y);
        d < 0 && f < 0 ? (s = ln, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = an, d = -d, u -= d) : f < 0 && (s = sn, f = -f, c -= f);
        break;
      case an:
        if (l) {
          if (m.y <= 0 && (c <= v || u <= p)) {
            y = !1;
            break;
          }
          T(Gt), f -= m.y, c += m.y, d = f * l, u += o.width - d;
        } else
          T(Gt), T(hr), m.x <= 0 ? u > p ? (d -= m.x, u += m.x) : m.y <= 0 && c <= v && (y = !1) : (d -= m.x, u += m.x), m.y <= 0 ? c > v && (f -= m.y, c += m.y) : (f -= m.y, c += m.y);
        d < 0 && f < 0 ? (s = sn, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = on, d = -d, u -= d) : f < 0 && (s = ln, f = -f, c -= f);
        break;
      case ln:
        if (l) {
          if (m.x <= 0 && (u <= p || g >= _)) {
            y = !1;
            break;
          }
          T(hr), d -= m.x, u += m.x, f = d / l;
        } else
          T(Pr), T(hr), m.x <= 0 ? u > p ? (d -= m.x, u += m.x) : m.y >= 0 && g >= _ && (y = !1) : (d -= m.x, u += m.x), m.y >= 0 ? g < _ && (f += m.y) : f += m.y;
        d < 0 && f < 0 ? (s = on, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = sn, d = -d, u -= d) : f < 0 && (s = an, f = -f, c -= f);
        break;
      case sn:
        if (l) {
          if (m.x >= 0 && (h >= b || g >= _)) {
            y = !1;
            break;
          }
          T(fr), d += m.x, f = d / l;
        } else
          T(Pr), T(fr), m.x >= 0 ? h < b ? d += m.x : m.y >= 0 && g >= _ && (y = !1) : d += m.x, m.y >= 0 ? g < _ && (f += m.y) : f += m.y;
        d < 0 && f < 0 ? (s = an, f = -f, d = -d, c -= f, u -= d) : d < 0 ? (s = ln, d = -d, u -= d) : f < 0 && (s = on, f = -f, c -= f);
        break;
      // Move canvas
      case lv:
        this.move(m.x, m.y), y = !1;
        break;
      // Zoom canvas
      case uv:
        this.zoom(s1(a), e), y = !1;
        break;
      // Create crop box
      case sv:
        if (!m.x || !m.y) {
          y = !1;
          break;
        }
        C = mv(this.cropper), u = w.startX - C.left, c = w.startY - C.top, d = o.minWidth, f = o.minHeight, m.x > 0 ? s = m.y > 0 ? sn : on : m.x < 0 && (u -= d, s = m.y > 0 ? ln : an), m.y < 0 && (c -= f), this.cropped || (xt(this.cropBox, We), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    y && (o.width = d, o.height = f, o.left = u, o.top = c, this.action = s, this.renderCropBox()), Ne(a, function(x) {
      x.startX = x.endX, x.startY = x.endY;
    });
  }
}, w1 = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && ke(this.dragBox, di), xt(this.cropBox, We), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = _e({}, this.initialImageData), this.canvasData = _e({}, this.initialCanvasData), this.cropBoxData = _e({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (_e(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), xt(this.dragBox, di), ke(this.cropBox, We)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, Ne(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, xt(this.cropper, Uf)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, ke(this.cropper, Uf)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[me] ? (e[me] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, i = r.left, o = r.top;
    return this.moveTo(ms(e) ? e : i + Number(e), ms(t) ? t : o + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.canvasData, i = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (re(e) && (r.left = e, i = !0), re(t) && (r.top = t, i = !0), i && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var r = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(r.width * e / r.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, r) {
    var i = this.options, o = this.canvasData, a = o.width, s = o.height, l = o.naturalWidth, u = o.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && i.zoomable) {
      var c = l * e, d = u * e;
      if (Vr(this.element, Il, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var f = this.pointers, h = mv(this.cropper), g = f && Object.keys(f).length ? l1(f) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        o.left -= (c - a) * ((g.pageX - h.left - o.left) / a), o.top -= (d - s) * ((g.pageY - h.top - o.top) / s);
      } else qr(t) && re(t.x) && re(t.y) ? (o.left -= (c - a) * ((t.x - o.left) / a), o.top -= (d - s) * ((t.y - o.top) / s)) : (o.left -= (c - a) / 2, o.top -= (d - s) / 2);
      o.width = c, o.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), re(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, re(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(re(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, r = this.imageData, i = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (re(e) && (r.scaleX = e, i = !0), re(t) && (r.scaleY = t, i = !0), i && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, r = this.imageData, i = this.canvasData, o = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: o.left - i.left,
        y: o.top - i.top,
        width: o.width,
        height: o.height
      };
      var s = r.width / r.naturalWidth;
      if (Ne(a, function(c, d) {
        a[d] = c / s;
      }), e) {
        var l = Math.round(a.y + a.height), u = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = u - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (a.rotate = r.rotate || 0), t.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, r = this.imageData, i = this.canvasData, o = {};
    if (this.ready && !this.disabled && qr(e)) {
      var a = !1;
      t.rotatable && re(e.rotate) && e.rotate !== r.rotate && (r.rotate = e.rotate, a = !0), t.scalable && (re(e.scaleX) && e.scaleX !== r.scaleX && (r.scaleX = e.scaleX, a = !0), re(e.scaleY) && e.scaleY !== r.scaleY && (r.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var s = r.width / r.naturalWidth;
      re(e.x) && (o.left = e.x * s + i.left), re(e.y) && (o.top = e.y * s + i.top), re(e.width) && (o.width = e.width * s), re(e.height) && (o.height = e.height * s), this.setCropBoxData(o);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? _e({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? _e({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && Ne(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      t[r] = e[r];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, r = t.aspectRatio;
    return this.ready && !this.disabled && qr(e) && (re(e.left) && (t.left = e.left), re(e.top) && (t.top = e.top), re(e.width) ? (t.width = e.width, t.height = e.width / r) : re(e.height) && (t.height = e.height, t.width = e.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, r = this.options.aspectRatio, i, o;
    return this.ready && this.cropped && !this.disabled && qr(e) && (re(e.left) && (t.left = e.left), re(e.top) && (t.top = e.top), re(e.width) && e.width !== t.width && (i = !0, t.width = e.width), re(e.height) && e.height !== t.height && (o = !0, t.height = e.height), r && (i ? t.height = t.width / r : o && (t.width = t.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, r = c1(this.image, this.imageData, t, e);
    if (!this.cropped)
      return r;
    var i = this.getData(e.rounded), o = i.x, a = i.y, s = i.width, l = i.height, u = r.width / Math.floor(t.naturalWidth);
    u !== 1 && (o *= u, a *= u, s *= u, l *= u);
    var c = s / l, d = Zt({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), f = Zt({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), h = Zt({
      aspectRatio: c,
      width: e.width || (u !== 1 ? r.width : s),
      height: e.height || (u !== 1 ? r.height : l)
    }), g = h.width, p = h.height;
    g = Math.min(d.width, Math.max(f.width, g)), p = Math.min(d.height, Math.max(f.height, p));
    var v = document.createElement("canvas"), b = v.getContext("2d");
    v.width = Fr(g), v.height = Fr(p), b.fillStyle = e.fillColor || "transparent", b.fillRect(0, 0, g, p);
    var _ = e.imageSmoothingEnabled, y = _ === void 0 ? !0 : _, C = e.imageSmoothingQuality;
    b.imageSmoothingEnabled = y, C && (b.imageSmoothingQuality = C);
    var w = r.width, m = r.height, T = o, x = a, A, M, O, S, P, N;
    T <= -s || T > w ? (T = 0, A = 0, O = 0, P = 0) : T <= 0 ? (O = -T, T = 0, A = Math.min(w, s + T), P = A) : T <= w && (O = 0, A = Math.min(s, w - T), P = A), A <= 0 || x <= -l || x > m ? (x = 0, M = 0, S = 0, N = 0) : x <= 0 ? (S = -x, x = 0, M = Math.min(m, l + x), N = M) : x <= m && (S = 0, M = Math.min(l, m - x), N = M);
    var E = [T, x, A, M];
    if (P > 0 && N > 0) {
      var L = g / s;
      E.push(O * L, S * L, P * L, N * L);
    }
    return b.drawImage.apply(b, [r].concat(av(E.map(function(H) {
      return Math.floor(Fr(H));
    })))), v;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !ms(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, r = this.dragBox, i = this.face;
    if (this.ready && !this.disabled) {
      var o = e === yu, a = t.movable && e === cv;
      e = o || a ? e : dv, t.dragMode = e, Rn(r, Dn, e), Br(r, Tl, o), Br(r, Sl, a), t.cropBoxMovable || (Rn(i, Dn, e), Br(i, Tl, o), Br(i, Sl, a));
    }
    return this;
  }
}, T1 = At.Cropper, bv = /* @__PURE__ */ function() {
  function n(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (L_(this, n), !e || !X_.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = _e({}, Zf, qr(t) && t), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return q_(n, [{
    key: "init",
    value: function() {
      var t = this.element, r = t.tagName.toLowerCase(), i;
      if (!t[me]) {
        if (t[me] = this, r === "img") {
          if (this.isImg = !0, i = t.getAttribute("src") || "", this.originalUrl = i, !i)
            return;
          i = t.src;
        } else r === "canvas" && window.HTMLCanvasElement && (i = t.toDataURL());
        this.load(i);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var r = this;
      if (t) {
        this.url = t, this.imageData = {};
        var i = this.element, o = this.options;
        if (!o.rotatable && !o.scalable && (o.checkOrientation = !1), !o.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Y_.test(t)) {
          Z_.test(t) ? this.read(h1(t)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), s = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = s, a.onerror = s, a.ontimeout = s, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Yf && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, o.checkCrossOrigin && Kf(t) && i.crossOrigin && (t = Qf(t)), a.open("GET", t, !0), a.responseType = "arraybuffer", a.withCredentials = i.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var r = this.options, i = this.imageData, o = v1(t), a = 0, s = 1, l = 1;
      if (o > 1) {
        this.url = p1(t, Yf);
        var u = g1(o);
        a = u.rotate, s = u.scaleX, l = u.scaleY;
      }
      r.rotatable && (i.rotate = a), r.scalable && (i.scaleX = s, i.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, r = this.url, i = t.crossOrigin, o = r;
      this.options.checkCrossOrigin && Kf(r) && (i || (i = "anonymous"), o = Qf(r)), this.crossOrigin = i, this.crossOriginUrl = o;
      var a = document.createElement("img");
      i && (a.crossOrigin = i), a.src = o || r, a.alt = t.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), ke(a, jf), t.parentNode.insertBefore(a, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var i = At.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(At.navigator.userAgent), o = function(u, c) {
        _e(t.imageData, {
          naturalWidth: u,
          naturalHeight: c,
          aspectRatio: u / c
        }), t.initialImageData = _e({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (r.naturalWidth && !i) {
        o(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), s = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        o(a.width, a.height), i || s.removeChild(a);
      }, a.src = r.src, i || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", s.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, r = this.options, i = this.image, o = t.parentNode, a = document.createElement("div");
        a.innerHTML = K_;
        var s = a.querySelector(".".concat(me, "-container")), l = s.querySelector(".".concat(me, "-canvas")), u = s.querySelector(".".concat(me, "-drag-box")), c = s.querySelector(".".concat(me, "-crop-box")), d = c.querySelector(".".concat(me, "-face"));
        this.container = o, this.cropper = s, this.canvas = l, this.dragBox = u, this.cropBox = c, this.viewBox = s.querySelector(".".concat(me, "-view-box")), this.face = d, l.appendChild(i), ke(t, We), o.insertBefore(s, t.nextSibling), xt(i, jf), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, ke(c, We), r.guides || ke(c.getElementsByClassName("".concat(me, "-dashed")), We), r.center || ke(c.getElementsByClassName("".concat(me, "-center")), We), r.background && ke(s, "".concat(me, "-bg")), r.highlight || ke(d, F_), r.cropBoxMovable && (ke(d, Sl), Rn(d, Dn, bu)), r.cropBoxResizable || (ke(c.getElementsByClassName("".concat(me, "-line")), We), ke(c.getElementsByClassName("".concat(me, "-point")), We)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), Ve(r.ready) && st(t, zf, r.ready, {
          once: !0
        }), Vr(t, zf);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), xt(this.element, We);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = T1, n;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      _e(Zf, qr(t) && t);
    }
  }]);
}();
_e(bv.prototype, m1, _1, b1, y1, C1, w1);
const S1 = {
  name: "FocalPoint",
  props: {
    modelValue: {
      type: Object,
      // default position to the focal point to start
      default: () => ({
        x: 50,
        y: 50
      })
    },
    src: {
      type: String,
      default: () => ""
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      pin: null,
      // local position for the focal point
      localFocalPoint: {
        x: 50,
        y: 50
      },
      // style for the container based on the loaded image
      focalContainerStyle: {
        height: 0,
        width: 0,
        left: 0,
        top: 0
      },
      pinPositioned: !1,
      isModified: !1
    };
  },
  computed: {
    pinStyle() {
      if (!this.pin)
        return null;
      const { width: n, height: e } = this.pin;
      if (!this.localFocalPoint)
        return {
          left: this.s(50, n),
          top: this.s(50, e)
        };
      const { x: t, y: r } = this.localFocalPoint;
      return {
        left: this.s(t, n),
        top: this.s(r, e)
      };
    }
  },
  watch: {
    modelValue(n) {
      this.localFocalPoint = n;
    }
  },
  mounted() {
    this.pin = this.$refs.pin.getBoundingClientRect(), this.modelValue && (this.localFocalPoint = { ...this.modelValue });
  },
  // Remove event listeners on destroy
  beforeUnmount() {
    window !== "undefined" && (window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp));
  },
  methods: {
    click(n) {
      this.isModified = !0, this.$emit("update:modelValue", this.getPercentage(n));
    },
    // Every position needs to be transformed to percentage
    getPercentage(n) {
      const { offsetX: e, offsetY: t } = n, { width: r, height: i } = this.$refs.focalContainer.getBoundingClientRect();
      return {
        x: this.calculatePercentage(e, r),
        y: this.calculatePercentage(t, i)
      };
    },
    // This helps for the drag event of the focal point
    handleContainerMouseMove(n) {
      this.localFocalPoint = this.getPercentage(n);
    },
    // Calculate mouse position on mouse up
    handlePointerMouseUp(n) {
      typeof window < "u" && (this.$refs.focalContainer.removeEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp), this.$refs.pin.style.pointerEvents = "", this.$emit("input", this.localFocalPoint));
    },
    // Calculate mouse position on mouse down
    handlePointerMouseDown(n) {
      typeof window < "u" && (this.$refs.focalContainer.addEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), this.$refs.pin.style.pointerEvents = "none", window.addEventListener("mouseup", this.handlePointerMouseUp), window.addEventListener("blur", this.handlePointerMouseUp));
    },
    loadVirtualImage() {
      const { height: n, width: e } = this.getRenderedImageSize(this.$refs.image), { clientHeight: t = 0, clientWidth: r = 0 } = this.$refs.image.parentNode;
      this.focalContainerStyle = {
        height: n,
        width: e,
        left: (r - e) / 2,
        top: (t - n) / 2
      }, this.pinPositioned = !0;
    },
    getRenderedImageSize(n) {
      const {
        width: e,
        height: t,
        naturalWidth: r,
        naturalHeight: i
      } = n, o = r / i, a = e / t;
      let s, l;
      return o > a ? (l = e, s = e / o) : (l = t * o, s = t), { height: s, width: l };
    },
    calculatePercentage(n, e) {
      return Math.round(n * 100 / e);
    },
    s(n, e) {
      return `calc(${n}% - ${e / 2}px)`;
    },
    // Allow setting focal point from image cropper
    setFocalPoint(n) {
      n && n.x > -1 && n.y > -1 && (this.localFocalPoint = { ...n }), this.$emit("input", this.localFocalPoint);
    },
    // Allow returning focal point to center position from image cropper
    resetFocalPoint() {
      this.localFocalPoint = { x: 50, y: 50 }, this.$emit("input", this.localFocalPoint);
    }
  }
};
function x1(n, e, t, r, i, o) {
  return D(), U("div", { class: "focal-point" }, [
    R("img", {
      ref: "image",
      src: t.src,
      name: "image",
      class: "virtual-image",
      onLoad: e[0] || (e[0] = (...a) => o.loadVirtualImage && o.loadVirtualImage(...a))
    }, null, 40, ["src"]),
    bn(R("div", {
      ref: "focalContainer",
      style: ht({
        height: `${i.focalContainerStyle.height}px`,
        width: `${i.focalContainerStyle.width}px`,
        left: `${i.focalContainerStyle.left}px`,
        top: `${i.focalContainerStyle.top}px`,
        position: "absolute"
      }),
      onClick: e[2] || (e[2] = (...a) => o.click && o.click(...a))
    }, [
      R("div", {
        ref: "pin",
        style: ht(o.pinStyle),
        class: "focal-point-pin",
        onMousedown: e[1] || (e[1] = (...a) => o.handlePointerMouseDown && o.handlePointerMouseDown(...a))
      }, [
        nt(n.$slots, "pin")
      ], 36)
    ], 4), [
      [sp, t.focalPointAllowed]
    ])
  ]);
}
const A1 = /* @__PURE__ */ K(S1, [["render", x1]]), O1 = {};
function E1(n, e) {
  return D(), U("svg", {
    width: "33",
    height: "34",
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("circle", {
      cx: "16.5",
      cy: "17.2773",
      r: "16",
      fill: "black",
      "fill-opacity": "0.5",
      stroke: "white"
    }),
    R("rect", {
      x: "16",
      y: "10.7734",
      width: "1",
      height: "5",
      rx: "0.5",
      fill: "white"
    }),
    R("rect", {
      x: "16",
      y: "18.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      fill: "white"
    }),
    R("rect", {
      x: "23",
      y: "16.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "rotate(90 23 16.7773)",
      fill: "white"
    }),
    R("rect", {
      x: "15",
      y: "16.7773",
      width: "1",
      height: "5",
      rx: "0.5",
      transform: "rotate(90 15 16.7773)",
      fill: "white"
    })
  ]);
}
const yv = /* @__PURE__ */ K(O1, [["render", E1]]), _w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yv
}, Symbol.toStringTag, { value: "Module" })), I1 = {
  components: {
    FocalPoint: A1,
    FocalPointIcon: yv
  },
  props: {
    image: {
      type: Object,
      required: !0
    },
    isCropping: {
      type: Boolean,
      required: !1
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    },
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      cropper: null,
      localFocalPoint: { x: 50, y: 50 },
      showFocusImage: !0
    };
  },
  watch: {
    isCropping(n) {
      n ? this.cropper.crop() : this.cropper.clear();
    },
    localFocalPoint(n, e) {
      (n.x !== e.x || n.y !== e.y) && this.$emit("focal-point-changed", n);
    }
  },
  mounted() {
    var n;
    (n = this.image) != null && n.properties.focalPointPosition && (this.localFocalPoint = this.image.properties.focalPointPosition), this.cropper = new bv(this.$refs.img, {
      zoomable: !1,
      viewMode: 1,
      autoCropArea: 1,
      autoCrop: !1,
      background: !1,
      modal: !0,
      ready: () => {
        this.enableEditingIfCropperIsReady();
      },
      ...this.$attrs
    });
  },
  computed: {
    src() {
      return this.image.previewUrl;
    },
    alt() {
      return this.image.alt_text;
    }
  },
  methods: {
    enableEditingIfCropperIsReady() {
      this.$emit("set-natural-size", {
        width: this.cropper.initialImageData.naturalWidth,
        height: this.cropper.initialImageData.naturalHeight
      }), this.$emit("enable-editing", !0);
    },
    fn(n, ...e) {
      return this.cropper[n](...e);
    }
  }
};
function N1(n, e, t, r, i, o) {
  const a = $("FocalPointIcon"), s = $("FocalPoint");
  return D(), U("div", { class: "image-container" }, [
    bn(R("div", { class: "focal-point-container" }, [
      q(s, {
        modelValue: i.localFocalPoint,
        "onUpdate:modelValue": e[0] || (e[0] = (l) => i.localFocalPoint = l),
        "is-selected": t.isSelected,
        src: o.src,
        "focal-point-allowed": t.focalPointAllowed
      }, {
        pin: j(() => [
          q(a)
        ]),
        _: 1
      }, 8, ["modelValue", "is-selected", "src", "focal-point-allowed"])
    ], 512), [
      [sp, !t.isCropping]
    ]),
    R("img", {
      ref: "img",
      class: "image",
      src: o.src,
      alt: o.alt
    }, null, 8, ["src", "alt"])
  ]);
}
const k1 = /* @__PURE__ */ K(I1, [["render", N1], ["__scopeId", "data-v-0642fe82"]]), D1 = {};
function R1(n, e) {
  return D(), U("svg", {
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("path", {
      d: "M5.5 3.57143V1M5.5 7.42857V14.5H19M1 5.5H14.5V12.5714M14.5 16.4286V19",
      stroke: "var(--purple)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]);
}
const Cv = /* @__PURE__ */ K(D1, [["render", R1]]), bw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cv
}, Symbol.toStringTag, { value: "Module" })), P1 = {
  name: "ImageEditorControls",
  components: {
    CropIcon: Cv
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    isCropping: Boolean,
    disableResetButton: Boolean
  }
};
function M1(n, e, t, r, i, o) {
  const a = $("a-button"), s = $("CropIcon"), l = $("a-icon");
  return D(), U("div", { class: "image-controls" }, [
    t.isCropping ? (D(), U(gt, { key: 0 }, [
      q(a, {
        variant: "secondary",
        onClick: e[0] || (e[0] = (u) => n.$emit("confirm-crop"))
      }, {
        default: j(() => [
          Me(Q(n.$t("builder.imageUploader.confirmCrop")), 1)
        ]),
        _: 1
      }),
      q(a, {
        variant: "secondary",
        class: "cancel-crop",
        onClick: e[1] || (e[1] = (u) => n.$emit("cancel-crop"))
      }, {
        default: j(() => [
          Me(Q(n.$t("builder.imageUploader.cancelCrop")), 1)
        ]),
        _: 1
      })
    ], 64)) : (D(), U(gt, { key: 1 }, [
      R("input", {
        ref: "replaceImageInput",
        hidden: "",
        class: "file-input",
        type: "file",
        accept: t.acceptedFileTypes,
        onChange: e[2] || (e[2] = (u) => n.$emit("replace-image", u))
      }, null, 40, ["accept"]),
      q(a, {
        variant: "secondary",
        onClick: e[3] || (e[3] = (u) => n.$refs.replaceImageInput.click())
      }, {
        default: j(() => [
          Me(Q(n.$t("builder.imageUploader.replace")), 1)
        ]),
        _: 1
      }),
      q(a, {
        variant: "secondary",
        class: "begin-crop",
        size: "small",
        "aria-label": "Crop Image",
        onClick: e[4] || (e[4] = (u) => n.$emit("begin-crop"))
      }, {
        default: j(() => [
          q(s)
        ]),
        _: 1
      }),
      q(a, {
        variant: "secondary",
        class: "rotate-left",
        size: "small",
        "aria-label": "Rotate Left",
        onClick: e[5] || (e[5] = (u) => n.$emit("rotate", -90))
      }, {
        default: j(() => [
          q(l, { icon: "24:arrow-counter-clockwise" })
        ]),
        _: 1
      }),
      q(a, {
        variant: "secondary",
        class: "rotate-right",
        size: "small",
        "aria-label": "Rotate Right",
        onClick: e[6] || (e[6] = (u) => n.$emit("rotate", 90))
      }, {
        default: j(() => [
          q(l, { icon: "24:arrow-clockwise" })
        ]),
        _: 1
      }),
      q(a, {
        disabled: t.disableResetButton,
        variant: "secondary",
        class: "reset-button",
        onClick: e[7] || (e[7] = (u) => n.$emit("reset-image"))
      }, {
        default: j(() => [
          Me(Q(n.$t("builder.imageUploader.reset")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 64))
  ]);
}
const L1 = /* @__PURE__ */ K(P1, [["render", M1], ["__scopeId", "data-v-a8e27e8f"]]), q1 = {};
function B1(n, e) {
  return D(), U("svg", {
    id: "info_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14"
  }, [
    R("circle", {
      class: "cls-1",
      cx: "7",
      cy: "7",
      r: "7"
    }),
    R("path", {
      id: "i",
      class: "cls-2",
      d: "M1277.7,1701.09h1.86l0.99-5.1h-1.86Zm1.3-6.09h1.75l0.19-1.06h-1.86Z",
      transform: "translate(-1272 -1691)"
    })
  ]);
}
const wv = /* @__PURE__ */ K(q1, [["render", B1], ["__scopeId", "data-v-88c4d34d"]]), yw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wv
}, Symbol.toStringTag, { value: "Module" })), U1 = {
  setup: (n) => ({
    v$: dp({
      $registerAs: n.validationName
    })
  }),
  name: "ImageEditor",
  components: {
    InfoIcon: wv,
    ImageCropper: k1,
    ImageEditorControls: L1
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    validationName: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    isSelected: Boolean
  },
  validations() {
    return {
      image: {
        content: {
          altText: {
            required: (n) => this.decorativeAllowed && this.image.properties.isDecorative || this.isBg ? !0 : (n == null ? void 0 : n.length) > 0
          }
        }
      }
    };
  },
  data() {
    return {
      isCropping: !1,
      originalImage: null,
      changedImageFile: !1
    };
  },
  mounted() {
    this.originalImage = Or(this.image);
  },
  computed: {
    image: {
      get() {
        return this.modelValue;
      },
      set(n) {
        this.$emit("update:modelValue", n);
      }
    },
    showError() {
      return this.v$.$error;
    }
  },
  methods: {
    beginCrop() {
      this.isCropping = !0, this.$emit("begin-crop"), this.$refs.imageCropper.fn("crop");
    },
    async confirmCrop() {
      await this.storeCroppedData(), this.cancelCrop();
    },
    cancelCrop() {
      this.$refs.imageCropper.fn("clear"), this.$emit("end-crop"), this.isCropping = !1;
    },
    focalPointChanged(n) {
      this.changedImageFile = !0, n && (this.image.properties.focalPointPosition = n);
    },
    async storeCroppedData() {
      const { type: n = "image/jpeg", name: e = "croppedImage.jpeg" } = this.image.content.imageFile || {}, t = await new Promise(
        (i) => this.$refs.imageCropper.fn("getCroppedCanvas", { imageSmoothingEnabled: !1 }).toBlob(
          (o) => {
            i(o);
          },
          n,
          1
        )
      ), r = new File([t], e, { type: n });
      this.replaceCurrentImage(r);
    },
    replaceCurrentImage(n) {
      if (this.changedImageFile = !0, hu(n)) {
        this.$emit("exceeds-upload-limit");
        return;
      }
      if (Wp(n, this.acceptedFileTypes)) return;
      this.applyNewNaturalSize();
      const e = URL.createObjectURL(n);
      this.$refs.imageCropper.fn("replace", e), URL.revokeObjectURL(this.image.previewUrl), this.image = new Bt({
        ...this.image,
        previewUrl: e,
        imageModified: !0,
        content: {
          ...this.image.content,
          imageFile: n
        },
        properties: {
          ...this.image.properties,
          focalPointPosition: { x: 50, y: 50 }
        }
      });
    },
    applyNewNaturalSize() {
      const n = this.$refs.imageCropper.fn("getCroppedCanvas").width, e = this.$refs.imageCropper.fn("getCroppedCanvas").height;
      this.image.properties.naturalWidth = n, this.image.properties.naturalHeight = e, this.image.properties.preferredWidth = n, this.image.properties.preferredHeight = e;
    },
    resetImage() {
      const { imageFile: n } = this.originalImage.content;
      this.focalPointChanged(this.originalImage.properties.focalPointPosition), this.replaceCurrentImage(n), this.changedImageFile = !1;
    },
    async rotate(n) {
      this.$emit("is-rotating", !0), this.$refs.imageCropper.fn("rotate", n), await this.storeCroppedData(), this.$emit("is-rotating", !1);
    },
    uploadNewImage(n) {
      const e = n.target.files[0];
      n.target.value = "", this.replaceCurrentImage(e);
    },
    setNaturalSize({ width: n, height: e }) {
      this.image.properties.naturalWidth = n, this.image.properties.naturalHeight = e, (this.image.properties.preferredWidth === null || this.image.properties.preferredHeight === null) && (this.image.properties.preferredWidth = n, this.image.properties.preferredHeight = e);
    }
  }
};
function j1(n, e, t, r, i, o) {
  const a = $("ImageCropper"), s = $("ImageEditorControls"), l = $("a-form-input"), u = $("a-checkbox"), c = $("InfoIcon"), d = $("a-tooltip");
  return t.isSelected ? (D(), U("div", { key: 0 }, [
    R("div", { class: "image-preview" }, [
      q(a, {
        ref: "imageCropper",
        image: o.image,
        "is-cropping": i.isCropping,
        "focal-point-allowed": t.focalPointAllowed,
        "is-selected": t.isSelected,
        onSetNaturalSize: o.setNaturalSize,
        onFocalPointChanged: o.focalPointChanged
      }, null, 8, ["image", "is-cropping", "focal-point-allowed", "is-selected", "onSetNaturalSize", "onFocalPointChanged"])
    ]),
    q(s, {
      "is-cropping": i.isCropping,
      "disable-reset-button": !i.changedImageFile,
      onBeginCrop: o.beginCrop,
      onCancelCrop: o.cancelCrop,
      onConfirmCrop: o.confirmCrop,
      onResetImage: o.resetImage,
      onReplaceImage: o.uploadNewImage,
      onRotate: o.rotate
    }, null, 8, ["is-cropping", "disable-reset-button", "onBeginCrop", "onCancelCrop", "onConfirmCrop", "onResetImage", "onReplaceImage", "onRotate"]),
    R("div", { class: "text-inputs" }, [
      t.isBg ? ee("", !0) : (D(), U("div", {
        key: 0,
        class: "alt-text"
      }, [
        q(l, {
          id: "alt-text",
          modelValue: o.image.content.altText,
          "onUpdate:modelValue": e[0] || (e[0] = (f) => o.image.content.altText = f),
          disabled: o.image.properties.isDecorative,
          "show-error": o.showError,
          "error-message": n.$t("builder.imageUploader.altTextRequired"),
          label: n.$t("builder.imageUploader.altText"),
          placeholder: n.$t("builder.imageUploader.imageDescriptionPlaceholder"),
          required: ""
        }, null, 8, ["modelValue", "disabled", "show-error", "error-message", "label", "placeholder"]),
        t.decorativeAllowed ? (D(), U("div", {
          key: 0,
          class: "decorative-input"
        }, [
          q(u, {
            checked: o.image.properties.isDecorative,
            "onUpdate:checked": e[1] || (e[1] = ({ checked: f }) => o.image.properties.isDecorative = f)
          }, {
            default: j(() => [
              Me(Q(n.$t("builder.imageUploader.decorativeImage")), 1)
            ]),
            _: 1
          }, 8, ["checked"]),
          q(d, {
            label: n.$t("builder.imageUploader.decorativeImageTooltip"),
            position: "right",
            size: "small"
          }, {
            default: j(() => [
              q(c)
            ]),
            _: 1
          }, 8, ["label"])
        ])) : ee("", !0)
      ])),
      t.captionsAllowed ? (D(), U("div", {
        key: 1,
        class: "caption-text"
      }, [
        q(l, {
          id: "caption-text",
          modelValue: o.image.content.caption,
          "onUpdate:modelValue": e[2] || (e[2] = (f) => o.image.content.caption = f),
          label: n.$t("builder.imageUploader.caption"),
          placeholder: n.$t("builder.imageUploader.captionPlaceholder")
        }, null, 8, ["modelValue", "label", "placeholder"])
      ])) : ee("", !0)
    ])
  ])) : ee("", !0);
}
const H1 = /* @__PURE__ */ K(U1, [["render", j1], ["__scopeId", "data-v-a3b557c3"]]), Tv = {
  __name: "ImageIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M957.988,1395.53c0,0.01-.005.02-0.007,0.04A1.5,1.5,0,0,1,956.5,1397H938.511a1.5,1.5,0,0,1-1.5-1.5v-14a1.5,1.5,0,0,1,1.5-1.5H956.5a1.5,1.5,0,0,1,1.5,1.5v14C958,1395.51,957.989,1395.52,957.988,1395.53Zm-19.977-.03a0.5,0.5,0,0,0,.5.5H956.5a0.5,0.5,0,0,0,.471-0.35l-4.549-5.46-3.619,2.71a0.494,0.494,0,0,1-.653-0.05l-3.662-5.67-6.472,5.55v2.77Zm18.984-14a0.5,0.5,0,0,0-.5-0.5H938.511a0.5,0.5,0,0,0-.5.5v9.91l6.173-5.29a0.5,0.5,0,0,1,.679.03l3.682,5.69,3.652-2.74a0.5,0.5,0,0,1,.684.08l4.114,4.94V1381.5Zm-6,4a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,951,1385.5Zm2,0a0.5,0.5,0,1,0-.5.5A0.5,0.5,0,0,0,953,1385.5Z",
        transform: "translate(-932.5 -1373.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, $1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tv
}, Symbol.toStringTag, { value: "Module" })), F1 = 1e6, V1 = {
  __name: "ImageThumbnails",
  props: {
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    images: {
      type: Array,
      required: !0
    },
    currentImageIndex: {
      type: Number,
      default: 0
    },
    maxFilesAllowed: {
      type: Number,
      default: 1
    },
    maxImageSize: {
      type: Number,
      default: 10
    }
  },
  emits: [
    "select-image-index",
    "exceeds-upload-limit",
    "images-uploaded"
  ],
  setup(n, { emit: e }) {
    const t = n, r = e, i = yn("newFileInput"), o = yn("dropZoneRef"), a = (u) => {
      var d, f, h, g;
      if (!((f = (d = u.target) == null ? void 0 : d.files) != null && f[0])) return;
      const c = (g = (h = u.target) == null ? void 0 : h.files) == null ? void 0 : g[0];
      s(c);
    }, s = (u) => {
      if (u.size / F1 > t.maxImageSize) {
        r("exceeds-upload-limit");
        return;
      }
      r("images-uploaded", u), i.value && (i.value.value = "");
    };
    return du(o, {
      onDrop: (u) => {
        const c = Array.from(u)[0];
        c && s(c);
      },
      multiple: !1,
      dataTypes: t.acceptedFileTypes
    }), (u, c) => {
      const d = $("a-button");
      return D(), U("div", {
        ref_key: "dropZoneRef",
        ref: o,
        class: "all-images"
      }, [
        R("input", {
          ref_key: "newFileInput",
          ref: i,
          hidden: "",
          type: "file",
          accept: n.acceptedFileTypes,
          onChange: a
        }, null, 40, ["accept"]),
        (D(!0), U(gt, null, nr(n.images, (f, h) => (D(), U("div", {
          key: h,
          class: "image-thumbnail-container"
        }, [
          R("img", {
            src: f.previewUrl,
            class: He(["preview-image", {
              selected: n.currentImageIndex === h
            }]),
            onClick: (g) => r("select-image-index", h)
          }, null, 10, ["src", "onClick"])
        ]))), 128)),
        n.images.length < n.maxFilesAllowed ? (D(), W(d, {
          key: 0,
          class: "new-image-button preview-image",
          variant: "none",
          onClick: c[0] || (c[0] = (f) => {
            var h;
            return (h = i.value) == null ? void 0 : h.click();
          })
        }, {
          default: j(() => [
            q(Tv),
            R("p", { class: "add-new-image" }, Q(u.$t("builder.imageUploader.addNewImage")), 1)
          ]),
          _: 1
        })) : ee("", !0)
      ], 512);
    };
  }
}, z1 = /* @__PURE__ */ K(V1, [["__scopeId", "data-v-f2807731"]]), W1 = {
  name: "ImageUploaderV3",
  components: {
    ImageEditor: H1,
    ImageThumbnails: z1
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    images: {
      type: Array,
      required: !0
    },
    maxFiles: {
      type: Number,
      default: 1
    },
    initialImageIndex: {
      type: Number,
      default: 0
    },
    uploadApi: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    localUploader: Boolean,
    // TODO: Delete when implementing FAAS
    projectParent: {
      type: String,
      default: ""
    },
    isEditing: Boolean
  },
  setup: () => ({ v$: Zg() }),
  data() {
    return {
      currentImageIndex: 0,
      isCropping: !1,
      isRotating: !1,
      isUploading: !1,
      workingImages: []
    };
  },
  computed: {
    dialogHeader() {
      return this.isEditing ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  watch: {
    initialImageIndex(n) {
      this.selectImage(n);
    }
  },
  created() {
    this.workingImages = this.images.map((n) => {
      const e = Or(n);
      return {
        ...e,
        previewUrl: e.assetUrl || URL.createObjectURL(e.content.imageFile),
        imageModified: !1,
        isBg: this.isBg
      };
    }), this.selectImage(this.initialImageIndex);
  },
  methods: {
    addNewImageFile(n) {
      if (this.fileHasValidationError(n))
        return;
      const e = URL.createObjectURL(n);
      this.workingImages.push(
        new Bt({
          imageModified: !1,
          previewUrl: e,
          content: {
            imageFile: n
          }
        })
      ), this.currentImageIndex = this.workingImages.length - 1;
    },
    async createCmsRequest(n) {
      const e = {
        create_px2560: !1,
        create_px1920: !1,
        create_px1600: !1,
        create_px1280: !1,
        create_px960: !1,
        create_px600: !1
      }, t = await B0(n.content.imageFile);
      return Yu.post(this.uploadApi, {
        asset: {
          file_base64: t,
          upload_options: e
        }
      });
    },
    createUploadRequests() {
      return this.workingImages.map((n) => {
        const e = new FormData();
        if (e.append("file", n.content.imageFile), n.content.assetId === "" || n.imageModified)
          switch (this.projectParent) {
            case "cms":
              return this.createCmsRequest(n);
            default:
              return Yu.post(this.uploadApi, e, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
          }
        return Promise.resolve({
          data: { id: n.content.assetId },
          status: 201
        });
      });
    },
    fileHasValidationError(n) {
      const e = n.size / 1e6 > this.uploadLimit;
      return this.acceptedFileTypes.includes(n.type) ? e ? (console.error("File size exceeds limit"), !0) : !1 : (console.error("Unsupported File"), !0);
    },
    selectImage(n) {
      this.currentImageIndex = n >= 0 ? n : this.workingImages.length - 1;
    },
    async uploadImages() {
      if (this.v$.$touch(), this.v$.$error) {
        const t = [];
        this.workingImages.forEach((r, i) => {
          var o;
          (o = this.v$.$getResultsForChild(`image-${i}`)) != null && o.$error && t.push(i);
        }), this.currentImageIndex = t[0];
        return;
      }
      this.isUploading = !0;
      let n = null;
      if (!this.localUploader) {
        const t = this.createUploadRequests();
        if (n = await Promise.allSettled(t), n.some((r) => r.status === "rejected")) {
          this.isUploading = !1;
          return;
        }
      }
      const e = this.workingImages.map((t, r) => {
        var o, a;
        URL.revokeObjectURL(t.previewUrl);
        const i = this.localUploader ? URL.createObjectURL(this.workingImages[r].content.imageFile) : this.getImageAssetUrl(n[r]);
        return new Bt({
          ...t,
          assetUrl: i,
          content: {
            ...t.content,
            assetId: this.localUploader ? crypto.randomUUID() : (a = (o = n[r].value) == null ? void 0 : o.data) == null ? void 0 : a.id,
            assetUrl: i
          }
        });
      });
      this.$emit("images-changed", e), this.isUploading = !1;
    },
    // TODO: Delete when implementing FAAS
    getImageAssetUrl(n) {
      var e, t, r, i, o;
      if (this.projectParent === "engage")
        return ((t = (e = n.value) == null ? void 0 : e.data) == null ? void 0 : t.file) || "";
      if (this.projectParent === "cms")
        return ((o = (i = (r = n.value) == null ? void 0 : r.data) == null ? void 0 : i.file) == null ? void 0 : o.url) || "";
    }
  }
};
function G1(n, e, t, r, i, o) {
  const a = $("a-dialog-header"), s = $("ImageThumbnails"), l = $("ImageEditor"), u = $("a-dialog-content"), c = $("a-button"), d = $("a-dialog-footer"), f = $("a-dialog");
  return D(), W(f, {
    show: "",
    "no-close-on-overlay": "",
    size: "l",
    class: "image-editor",
    onClose: e[5] || (e[5] = (h) => n.$emit("close"))
  }, {
    default: j(() => [
      q(a, null, {
        default: j(() => [
          Me(Q(o.dialogHeader), 1)
        ]),
        _: 1
      }),
      q(u, { class: "content" }, {
        default: j(() => [
          t.maxFiles > 1 ? (D(), W(s, {
            key: 0,
            "accepted-file-types": t.acceptedFileTypes,
            images: i.workingImages,
            "max-files-allowed": t.maxFiles,
            "current-image-index": i.currentImageIndex,
            onImagesUploaded: o.addNewImageFile,
            onSelectImageIndex: o.selectImage,
            onExceedsUploadLimit: e[0] || (e[0] = (h) => n.$emit("exceeds-upload-limit"))
          }, null, 8, ["accepted-file-types", "images", "max-files-allowed", "current-image-index", "onImagesUploaded", "onSelectImageIndex"])) : ee("", !0),
          (D(!0), U(gt, null, nr(i.workingImages, (h, g) => (D(), U("div", { key: g }, [
            q(l, {
              modelValue: i.workingImages[g],
              "onUpdate:modelValue": (p) => i.workingImages[g] = p,
              "is-selected": g === i.currentImageIndex,
              "validation-name": `image-${g}`,
              "accepted-file-types": t.acceptedFileTypes,
              "captions-allowed": t.captionsAllowed,
              "decorative-allowed": t.decorativeAllowed,
              "is-bg": t.isBg,
              "focal-point-allowed": t.focalPointAllowed,
              onBeginCrop: e[1] || (e[1] = (p) => i.isCropping = !0),
              onEndCrop: e[2] || (e[2] = (p) => i.isCropping = !1),
              onIsRotating: e[3] || (e[3] = (p) => i.isRotating = p),
              onExceedsUploadLimit: e[4] || (e[4] = (p) => n.$emit("exceeds-upload-limit"))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "is-selected", "validation-name", "accepted-file-types", "captions-allowed", "decorative-allowed", "is-bg", "focal-point-allowed"])
          ]))), 128))
        ]),
        _: 1
      }),
      q(d, { class: "footer" }, {
        default: j(() => [
          q(c, {
            variant: "primary",
            disabled: i.isCropping || i.isRotating || i.isUploading,
            onClick: o.uploadImages
          }, {
            default: j(() => [
              Me(Q(n.$t("builder.imageUploader.upload")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const Y1 = /* @__PURE__ */ K(W1, [["render", G1], ["__scopeId", "data-v-4fc29ffc"]]), Z1 = {
  __name: "BackgroundImageControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    assets: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    uploadApi: {
      type: String,
      required: !0
    }
  },
  emits: ["update", "asset-entry"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Oe("state"), o = J(null), a = J(!1), s = J(null), l = [
      {
        label: "Fill",
        value: "fill"
      },
      {
        label: "Tile",
        value: "tile"
      },
      {
        label: "Center",
        value: "center"
      }
    ], u = ["image/png", "image/jpg", "image/jpeg", "image/gif"], c = I(() => [s.value || d.value]), d = I({
      get() {
        var N, E, L;
        return (L = (E = (N = t.node) == null ? void 0 : N.properties) == null ? void 0 : E.backgroundImage) == null ? void 0 : L.image;
      },
      set(N) {
        r("update", "image", N);
      }
    }), f = I({
      get() {
        var N, E;
        return ((E = (N = d.value) == null ? void 0 : N.properties) == null ? void 0 : E.backgroundPosition) || "fill";
      },
      set(N) {
        d.value.properties.backgroundPosition = N;
      }
    }), h = I({
      get() {
        var N, E;
        return ((E = (N = d.value) == null ? void 0 : N.properties) == null ? void 0 : E.tilePercentage) || 100;
      },
      set(N) {
        d.value.properties.tilePercentage = N;
      }
    }), g = I(() => {
      var N, E;
      return (E = (N = t.node) == null ? void 0 : N.properties) == null ? void 0 : E.backgroundImage;
    }), p = I(() => {
      var L, H, z, te, le, ce, ae, ue, de, ye, pt, cr;
      let N = {};
      switch ((H = (L = d.value) == null ? void 0 : L.properties) == null ? void 0 : H.backgroundPosition) {
        case "center":
          N = {
            "background-position": "center",
            "background-repeat": "no-repeat",
            "background-size": "contain"
          };
          break;
        case "fill":
          N = {
            "background-repeat": "no-repeat",
            "background-size": "cover",
            "background-position": `${((le = (te = (z = d.value) == null ? void 0 : z.properties) == null ? void 0 : te.focalPointPosition) == null ? void 0 : le.x) || 50}% ${((ue = (ae = (ce = d.value) == null ? void 0 : ce.properties) == null ? void 0 : ae.focalPointPosition) == null ? void 0 : ue.y) || 50}%`
          };
          break;
        case "tile":
          N = {
            "background-repeat": "repeat",
            "background-size": `${((ye = (de = d.value) == null ? void 0 : de.properties) == null ? void 0 : ye.tilePercentage) || 100}%`
          };
          break;
      }
      const E = (cr = (pt = d.value) == null ? void 0 : pt.content) != null && cr.assetId ? `url(${v.value.url})` : `url("${P_}")`;
      return {
        ...N,
        backgroundImage: E
      };
    }), v = I(() => {
      var N, E;
      return t.assets[(E = (N = d.value) == null ? void 0 : N.content) == null ? void 0 : E.assetId] || "";
    }), b = I(
      () => {
        var N, E;
        return (E = (N = d.value) == null ? void 0 : N.content) != null && E.assetId ? "builder.imageUploader.editImage" : "builder.imageUploader.uploadImage";
      }
    ), _ = (N) => {
      d.value === null && (d.value = new Bt()), r("update", "toggle", N);
    }, y = () => {
      var N, E, L;
      (E = (N = d.value) == null ? void 0 : N.content) != null && E.assetId ? x() : (L = o.value) == null || L.click();
    }, C = () => {
      o.value && (o.value.value = ""), a.value = !0;
    }, w = (N) => {
      var L;
      const E = Array.from((L = N.target) == null ? void 0 : L.files);
      !E || E.length !== 1 || m(E[0]);
    }, m = (N) => {
      const E = N.name.includes("."), L = N.type === "", H = Wp(N, u);
      if (hu(N)) {
        O();
        return;
      }
      !E || L || H || (s.value = new Bt({
        content: {
          imageFile: N
        },
        properties: {
          isDecorative: !0
        }
      }), C());
    }, T = (N) => {
      const E = N[0];
      E.assetUrl && r("asset-entry", U0(E)), d.value = E, a.value = !1, s.value = null;
    }, x = () => {
      a.value = !0;
    }, A = () => {
      d.value = new Bt(), s.value = null;
    }, M = () => {
      s.value = null, a.value = !1;
    }, O = () => {
      i.emitToConsumingApp("toast-message", {
        message: "10 MB Limit Exceeded",
        type: "error"
      });
    }, S = yn("imageDropZone");
    return du(S, {
      onDrop: (N) => {
        N && N.length === 1 && m(N[0]);
      },
      multiple: !1,
      dataTypes: u
    }), (N, E) => {
      var ce;
      const L = $("a-toggle"), H = $("a-button"), z = $("portal"), te = $("a-form-input"), le = $("a-form-radio-group");
      return D(), W(xr, null, Zl({
        title: j(() => [
          R("h4", null, Q(N.$t("builder.backgroundImage.title")), 1)
        ]),
        control: j(() => [
          q(L, {
            "model-value": g.value.toggle,
            "onUpdate:modelValue": E[0] || (E[0] = (ae) => _(ae))
          }, null, 8, ["model-value"])
        ]),
        _: 2
      }, [
        (ce = g.value) != null && ce.toggle ? {
          name: "content",
          fn: j(() => {
            var ae;
            return [
              R("div", {
                ref_key: "imageDropZone",
                ref: S,
                class: "inline-control gap-5"
              }, [
                R("input", {
                  ref_key: "fileInput",
                  ref: o,
                  type: "file",
                  hidden: "",
                  accept: u,
                  onChange: w,
                  onClick: E[1] || (E[1] = (ue) => ue.target.value = null)
                }, null, 544),
                R("div", {
                  class: "image-thumbnail",
                  style: ht(p.value),
                  onClick: y
                }, null, 4),
                q(H, {
                  variant: "tertiary",
                  onClick: y
                }, {
                  default: j(() => [
                    Me(Q(N.$t(b.value)), 1)
                  ]),
                  _: 1
                }),
                a.value ? (D(), W(z, {
                  key: 0,
                  to: "root-dialog-container"
                }, {
                  default: j(() => [
                    q(Y1, {
                      "is-bg": "",
                      "max-files": 1,
                      images: c.value,
                      "local-uploader": V(i).builder.api.localUploader,
                      "upload-api": n.uploadApi,
                      "project-parent": V(i).builder.api.projectParent,
                      onExceedsUploadLimit: O,
                      onImagesChanged: T,
                      onClose: M
                    }, null, 8, ["images", "local-uploader", "upload-api", "project-parent"])
                  ]),
                  _: 1
                })) : ee("", !0),
                (ae = d.value.content) != null && ae.assetId ? (D(), W(H, {
                  key: 1,
                  class: "clear-button",
                  variant: "link",
                  onClick: A
                }, {
                  default: j(() => [
                    Me(Q(N.$t("builder.clear")), 1)
                  ]),
                  _: 1
                })) : ee("", !0)
              ], 512),
              R("div", { class: "inline-control position-radio-group" }, [
                q(le, {
                  label: N.$t("builder.backgroundImage.position"),
                  options: l,
                  modelValue: f.value,
                  "onUpdate:modelValue": E[3] || (E[3] = (ue) => f.value = ue)
                }, {
                  "content-tile": j(() => [
                    R("div", null, [
                      q(te, {
                        modelValue: h.value,
                        "onUpdate:modelValue": E[2] || (E[2] = (ue) => h.value = ue),
                        class: "tile-input",
                        type: "number",
                        width: "70px",
                        height: "40px",
                        label: `${N.$t("builder.backgroundImage.tile")} (%)`,
                        min: 1,
                        max: 100
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label", "modelValue"])
              ])
            ];
          }),
          key: "0"
        } : void 0
      ]), 1024);
    };
  }
}, Sv = /* @__PURE__ */ K(Z1, [["__scopeId", "data-v-dc1dc409"]]), X1 = {};
function K1(n, e) {
  return D(), U("svg", {
    id: "backButtonIcon",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("path", {
      id: "background",
      d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
      fill: "none"
    }),
    R("path", {
      id: "arrow",
      d: "M25 17C25.5523 17 26 16.5523 26 16C26 15.4477 25.5523 15 25 15L25 17ZM7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071L13.6569 23.0711C14.0474 23.4616 14.6805 23.4616 15.0711 23.0711C15.4616 22.6805 15.4616 22.0474 15.0711 21.6569L9.41421 16L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L7.29289 15.2929ZM25 15L8 15L8 17L25 17L25 15Z",
      fill: "var(--purple)"
    })
  ]);
}
const xv = /* @__PURE__ */ K(X1, [["render", K1]]), Cw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xv
}, Symbol.toStringTag, { value: "Module" })), Q1 = {
  name: "SidebarHeader",
  components: {
    BackIcon: xv
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
function J1(n, e, t, r, i, o) {
  const a = $("BackIcon");
  return D(), U("div", { class: "header" }, [
    R("div", {
      class: "sidebar-back-button",
      onClick: e[0] || (e[0] = (s) => n.$emit("close-sidebar"))
    }, [
      q(a)
    ]),
    R("h4", null, Q(t.title), 1)
  ]);
}
const wu = /* @__PURE__ */ K(Q1, [["render", J1], ["__scopeId", "data-v-fcc5486e"]]), eb = {
  name: "GlobalSettings",
  components: {
    BackgroundColorControl: Pp,
    BackgroundImageControl: Sv,
    NodeControl: xr,
    SidebarHeader: wu
  },
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    }
  },
  inject: ["state"],
  computed: {
    globalCustomProperties() {
      var n, e;
      return ((e = (n = this.builder) == null ? void 0 : n.customProperties) == null ? void 0 : e.global) || {};
    },
    structure() {
      return this.builder.structure;
    }
  }
};
function tb(n, e, t, r, i, o) {
  const a = $("SidebarHeader"), s = $("a-toggle"), l = $("NodeControl"), u = $("BackgroundColorControl"), c = $("BackgroundImageControl");
  return D(), U(gt, null, [
    q(a, {
      title: n.$t("builder.builderTabs.globalSettings"),
      onCloseSidebar: e[0] || (e[0] = (d) => n.$emit("close-sidebar"))
    }, null, 8, ["title"]),
    o.globalCustomProperties.headerSlotOptional ? (D(), W(l, { key: 0 }, {
      title: j(() => [
        R("h4", null, Q(n.$t("builder.header")), 1)
      ]),
      control: j(() => [
        q(s, {
          modelValue: o.globalCustomProperties.showHeaderSlot,
          "onUpdate:modelValue": e[1] || (e[1] = (d) => o.globalCustomProperties.showHeaderSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : ee("", !0),
    o.globalCustomProperties.footerSlotOptional ? (D(), W(l, { key: 1 }, {
      title: j(() => [
        R("h4", null, Q(n.$t("builder.footer")), 1)
      ]),
      control: j(() => [
        q(s, {
          modelValue: o.globalCustomProperties.showFooterSlot,
          "onUpdate:modelValue": e[2] || (e[2] = (d) => o.globalCustomProperties.showFooterSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : ee("", !0),
    o.globalCustomProperties.backgroundColorAllowed ? (D(), W(u, {
      key: 2,
      node: o.structure,
      onUpdate: e[3] || (e[3] = (d, f) => o.structure.properties.backgroundColor[d] = f)
    }, null, 8, ["node"])) : ee("", !0),
    o.globalCustomProperties.backgroundImageAllowed ? (D(), W(c, {
      key: 3,
      node: o.structure,
      assets: o.state.builder.assets,
      "upload-api": o.state.builder.api.images,
      onUpdate: e[4] || (e[4] = (d, f) => o.structure.properties.backgroundImage[d] = f),
      onAssetEntry: e[5] || (e[5] = (d) => o.state.addAsset(d))
    }, null, 8, ["node", "assets", "upload-api"])) : ee("", !0),
    o.globalCustomProperties.confirmOnDeleteDialogAllowed ? (D(), W(l, { key: 4 }, {
      title: j(() => [
        R("h4", null, Q(n.$t("builder.controls.global.showConfirmationDialog")), 1)
      ]),
      control: j(() => [
        q(s, {
          modelValue: o.globalCustomProperties.showConfirmOnDeleteDialog,
          "onUpdate:modelValue": e[6] || (e[6] = (d) => o.globalCustomProperties.showConfirmOnDeleteDialog = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : ee("", !0),
    q(l, null, {
      title: j(() => [
        R("h4", null, Q(n.$t("builder.controls.global.focusNewNodeOnCreate")), 1)
      ]),
      control: j(() => [
        q(s, {
          modelValue: o.globalCustomProperties.focusNewNodeOnCreate,
          "onUpdate:modelValue": e[7] || (e[7] = (d) => o.globalCustomProperties.focusNewNodeOnCreate = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64);
}
const rb = /* @__PURE__ */ K(eb, [["render", tb], ["__scopeId", "data-v-c08ba7c5"]]), nb = {
  __name: "AccordionIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      R("rect", {
        x: "5",
        y: "9",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("rect", {
        x: "5",
        y: "21",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M21 13H6L6 18H21V13ZM6 12C5.44772 12 5 12.4477 5 13V18C5 18.5523 5.44772 19 6 19H21C21.5523 19 22 18.5523 22 18V13C22 12.4477 21.5523 12 21 12H6Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("rect", {
        x: "24",
        y: "15",
        width: "3",
        height: "1",
        rx: "0.5",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 9C26.1791 9 26 8.82091 26 8.6V8.4C26 8.17909 25.8209 8 25.6 8H25.4C25.1791 8 25 8.17909 25 8.4V8.6C25 8.82091 24.8209 9 24.6 9H24.4C24.1791 9 24 9.17909 24 9.4V9.6C24 9.82091 24.1791 10 24.4 10H24.6C24.8209 10 25 10.1791 25 10.4V10.6C25 10.8209 25.1791 11 25.4 11H25.6C25.8209 11 26 10.8209 26 10.6V10.4C26 10.1791 26.1791 10 26.4 10H26.6C26.8209 10 27 9.82091 27 9.6V9.4C27 9.17909 26.8209 9 26.6 9H26.4Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 21C26.1791 21 26 20.8209 26 20.6V20.4C26 20.1791 25.8209 20 25.6 20H25.4C25.1791 20 25 20.1791 25 20.4V20.6C25 20.8209 24.8209 21 24.6 21H24.4C24.1791 21 24 21.1791 24 21.4V21.6C24 21.8209 24.1791 22 24.4 22H24.6C24.8209 22 25 22.1791 25 22.4V22.6C25 22.8209 25.1791 23 25.4 23H25.6C25.8209 23 26 22.8209 26 22.6V22.4C26 22.1791 26.1791 22 26.4 22H26.6C26.8209 22 27 21.8209 27 21.6V21.4C27 21.1791 26.8209 21 26.6 21H26.4Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, ib = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nb
}, Symbol.toStringTag, { value: "Module" })), ob = {
  __name: "ButtonIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "30",
      height: "30",
      viewBox: "0 0 33 10",
      fill: "none"
    }, [
      R("rect", {
        x: "0.5",
        y: "0.5",
        width: "32",
        height: "9",
        fill: "transparent",
        stroke: t.value
      }, null, 8, ["stroke"])
    ]));
  }
}, ab = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ob
}, Symbol.toStringTag, { value: "Module" })), sb = {
  __name: "CardIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        id: "card",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        "fill-rule": "evenodd",
        d: "M938,1887h20a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H938a2,2,0,0,1-2-2v-11A2,2,0,0,1,938,1887Z",
        transform: "translate(-933 -1879.5)"
      }, null, 8, ["stroke"])
    ]));
  }
}, lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sb
}, Symbol.toStringTag, { value: "Module" })), ub = {
  __name: "EmbedIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        id: "embed",
        class: "cls-1",
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M934,1538.82l9.986-5.82v1.34l-9.155,5.17v0.04l9.155,6.13v1.33L934,1540.2v-1.38Zm25,0-9.986-5.82v1.34l9.155,5.17v0.04l-9.155,6.13v1.33L959,1540.2v-1.38Z",
        transform: "translate(-931.5 -1525)"
      }, null, 8, ["fill"])
    ]));
  }
}, cb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ub
}, Symbol.toStringTag, { value: "Module" })), db = {
  __name: "FormIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none"
    }, [
      R("path", {
        d: "M10 7.5C10 6.67157 10.6716 6 11.5 6H22.5C23.3284 6 24 6.67157 24 7.5V21.5C24 22.3284 23.3284 23 22.5 23H22V22H22.5C22.7761 22 23 21.7762 23 21.5V7.5C23 7.22385 22.7761 7 22.5 7H11.5C11.2239 7 11 7.22385 11 7.5V8H10V7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 12H18V13H10V12Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 15H18V16H10V15Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M18 18H10V19H18V18Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M10 21H18V22H10V21Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 10.5C7 9.67157 7.67157 9 8.5 9H19.5C20.3284 9 21 9.67157 21 10.5V24.5C21 25.3284 20.3284 26 19.5 26H8.5C7.67157 26 7 25.3284 7 24.5V10.5ZM8.5 10C8.22385 10 8 10.2238 8 10.5V24.5C8 24.7762 8.22385 25 8.5 25H19.5C19.7761 25 20 24.7762 20 24.5V10.5C20 10.2238 19.7761 10 19.5 10H8.5Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, fb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: db
}, Symbol.toStringTag, { value: "Module" })), hb = {
  __name: "FourColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "51",
      height: "17",
      viewBox: "0 0 51 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "13.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "26.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "39.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, pb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hb
}, Symbol.toStringTag, { value: "Module" })), vb = {
  __name: "FullWidthIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "56",
      height: "17",
      viewBox: "0 0 56 17"
    }, [
      R("rect", {
        id: "full-width",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "55",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vb
}, Symbol.toStringTag, { value: "Module" })), mb = {
  __name: "GalleryIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1052.53,1392a0.5,0.5,0,0,1-.5-0.5v-9.27a0.24,0.24,0,0,0-.23-0.23h-16.53a0.233,0.233,0,0,0-.23.23v0.27a0.5,0.5,0,0,1-.5.5,0.5,0.5,0,0,1-.5-0.5v-0.27a1.229,1.229,0,0,1,1.23-1.23h16.53a1.236,1.236,0,0,1,1.23,1.23v9.27A0.5,0.5,0,0,1,1052.53,1392Zm-1.5-7.74v12.48a1.249,1.249,0,0,1-1.23,1.26h-17.53a1.249,1.249,0,0,1-1.23-1.26v-3.38h0v-9.1a1.249,1.249,0,0,1,1.23-1.26h17.53A1.249,1.249,0,0,1,1051.03,1384.26Zm-18.99,12.48a0.254,0.254,0,0,0,.23.26h17.53a0.254,0.254,0,0,0,.23-0.26v-0.38a0.449,0.449,0,0,1-.13-0.1l-4.39-5.03-2.62,2.62a0.5,0.5,0,0,1-.38.15,0.5,0.5,0,0,1-.36-0.18l-4.65-5.58-5.46,5.34v3.16Zm0-12.48v7.92l5.15-5.04a0.468,0.468,0,0,1,.37-0.14,0.5,0.5,0,0,1,.36.18l4.65,5.58,2.61-2.61a0.463,0.463,0,0,1,.37-0.15,0.494,0.494,0,0,1,.36.17l4.12,4.72v-10.63a0.254,0.254,0,0,0-.23-0.26h-17.53A0.254,0.254,0,0,0,1032.04,1384.26Zm13.43,4.74a1.5,1.5,0,1,1,1.49-1.5A1.5,1.5,0,0,1,1045.47,1389Zm0-2a0.5,0.5,0,0,0-.5.5A0.5,0.5,0,1,0,1045.47,1387Z",
        transform: "translate(-1027.03 -1374.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, _b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mb
}, Symbol.toStringTag, { value: "Module" })), bb = {
  __name: "HeadingIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M954,1322v-9h-2v-1a2.636,2.636,0,0,0,.546.18,2.124,2.124,0,0,0,.726-0.3,1.913,1.913,0,0,0,.529-0.57,4.728,4.728,0,0,0,.427-1.32H955v11.99Zm-6-6h-7v6l-1-.01v-11.98l1-.01v5h7v-5l0.923,0.01v11.98L948,1322v-6Z",
        transform: "translate(-932.5 -1301)"
      }, null, 8, ["fill"])
    ]));
  }
}, yb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bb
}, Symbol.toStringTag, { value: "Module" })), Cb = {
  __name: "LeftSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      id: "left_sidebar",
      "data-name": "left sidebar",
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        id: "Rectangle_2133_copy_21",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        id: "Rectangle_2133_copy_21-2",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cb
}, Symbol.toStringTag, { value: "Module" })), Tb = {
  __name: "NavigationIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19 1H5C4.44771 1 4 1.44772 4 2V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V2C20 1.44772 19.5523 1 19 1ZM5 0C3.89543 0 3 0.89543 3 2V22C3 23.1046 3.89543 24 5 24H19C20.1046 24 21 23.1046 21 22V2C21 0.895431 20.1046 0 19 0H5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 4.5C8 4.22386 8.22386 4 8.5 4H16.5C16.7761 4 17 4.22386 17 4.5C17 4.77614 16.7761 5 16.5 5H8.5C8.22386 5 8 4.77614 8 4.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 4.5C7 4.77614 6.77614 5 6.5 5C6.22386 5 6 4.77614 6 4.5C6 4.22386 6.22386 4 6.5 4C6.77614 4 7 4.22386 7 4.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 7.5C8 7.22386 8.22386 7 8.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H8.5C8.22386 8 8 7.77614 8 7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 7.5C7 7.77614 6.77614 8 6.5 8C6.22386 8 6 7.77614 6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 10.5C8 10.2239 8.22386 10 8.5 10H16.5C16.7761 10 17 10.2239 17 10.5C17 10.7761 16.7761 11 16.5 11H8.5C8.22386 11 8 10.7761 8 10.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 13.5C8 13.2239 8.22386 13 8.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H8.5C8.22386 14 8 13.7761 8 13.5Z",
        fill: t.value
      }, null, 8, ["fill"]),
      R("path", {
        d: "M7 13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5C6 13.2239 6.22386 13 6.5 13C6.77614 13 7 13.2239 7 13.5Z",
        fill: t.value
      }, null, 8, ["fill"])
    ]));
  }
}, Sb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tb
}, Symbol.toStringTag, { value: "Module" })), xb = {
  __name: "OneColumnIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "39",
      height: "17",
      viewBox: "0 0 39 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "38",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Ab = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xb
}, Symbol.toStringTag, { value: "Module" })), Ob = {
  __name: "QuoteIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: "none",
        stroke: t.value,
        "fill-rule": "evenodd",
        d: "M1042.18,1981s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1051.97,1977.66,1042.18,1981,1042.18,1981Zm-13,0s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1038.97,1977.66,1029.18,1981,1029.18,1981Z",
        transform: "translate(-1025.045 -1956.5)"
      }, null, 8, ["stroke"])
    ]));
  }
}, Eb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ob
}, Symbol.toStringTag, { value: "Module" })), Ib = {
  __name: "RightSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Nb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ib
}, Symbol.toStringTag, { value: "Module" })), kb = {
  __name: "SeparatorIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1031,1680v-1h26v1h-26Z",
        transform: "translate(-1029 -1664.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Db = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kb
}, Symbol.toStringTag, { value: "Module" })), Rb = {
  __name: "SliderIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M959.5,1472a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,959.5,1472Zm-3,1a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,956.5,1473Zm-3,0h-12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,.5-0.5h12a0.5,0.5,0,0,1,.5.5v12A0.5,0.5,0,0,1,953.5,1473Zm-0.5-12H942v11h11v-11Zm-14.5,12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,938.5,1473Zm-3-1a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,935.5,1472Z",
        transform: "translate(-932.5 -1451.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Pb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rb
}, Symbol.toStringTag, { value: "Module" })), Mb = {
  __name: "SpacerIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "2",
        y: "7.5",
        width: "26",
        height: "15"
      }, null, 8, ["stroke"])
    ]));
  }
}, Lb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mb
}, Symbol.toStringTag, { value: "Module" })), qb = {
  __name: "TableIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M957,1979H933v-15h25v15h-1Zm-21-14h-2v6h2v-6Zm0,7h-2v6h2v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Z",
        transform: "translate(-930.5 -1956.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, Bb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qb
}, Symbol.toStringTag, { value: "Module" })), Ub = {
  __name: "TextIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1052.13,1313.42a2.093,2.093,0,0,0-1.41-.45,2.323,2.323,0,0,0-1.08.24,2.229,2.229,0,0,0-.78.65,2.777,2.777,0,0,0-.47.96,4.427,4.427,0,0,0-.16,1.18,4.485,4.485,0,0,0,.16,1.18,2.728,2.728,0,0,0,.47.95,2.279,2.279,0,0,0,1.86.88,2.1,2.1,0,0,0,1.48-.5,2.029,2.029,0,0,0,.62-1.39h1.19a3.024,3.024,0,0,1-.98,2.14,3.415,3.415,0,0,1-2.31.75,3.7,3.7,0,0,1-1.55-.32,3.487,3.487,0,0,1-1.17-.86,3.773,3.773,0,0,1-.74-1.28,4.388,4.388,0,0,1-.26-1.55,4.483,4.483,0,0,1,.26-1.56,3.825,3.825,0,0,1,.74-1.27,3.357,3.357,0,0,1,1.17-.86,3.554,3.554,0,0,1,1.55-.32,3.406,3.406,0,0,1,2.23.71,3.113,3.113,0,0,1,1.06,1.94h-1.22A1.957,1.957,0,0,0,1052.13,1313.42Zm-8.02,5.48a3,3,0,0,1-1.05.82,3.338,3.338,0,0,1-1.4.29,3.1,3.1,0,0,1-1.37-.29,2.933,2.933,0,0,1-1.06-.95h-0.03v1.03H1038v-10.81h1.2v4.08h0.03a3.43,3.43,0,0,1,1.03-.95,2.856,2.856,0,0,1,1.45-.35,3.079,3.079,0,0,1,1.33.28,3,3,0,0,1,1.04.8,3.889,3.889,0,0,1,.67,1.3,5.809,5.809,0,0,1,.24,1.74,5.975,5.975,0,0,1-.23,1.7A3.921,3.921,0,0,1,1044.11,1318.9Zm-0.5-4.22a2.971,2.971,0,0,0-.4-0.98,1.891,1.891,0,0,0-.67-0.65,1.812,1.812,0,0,0-.95-0.24,2.289,2.289,0,0,0-1.1.25,2.027,2.027,0,0,0-.76.66,3.1,3.1,0,0,0-.45.99,4.564,4.564,0,0,0-.15,1.19,4.71,4.71,0,0,0,.15,1.23,2.8,2.8,0,0,0,.45.97,2.306,2.306,0,0,0,.77.65,2.439,2.439,0,0,0,1.07.23,1.948,1.948,0,0,0,.96-0.23,2.013,2.013,0,0,0,.68-0.65,2.75,2.75,0,0,0,.4-0.97,5.2,5.2,0,0,0,.14-1.23A5.3,5.3,0,0,0,1043.61,1314.68Zm-8.26,5.12a1.19,1.19,0,0,1-1.29-1.13h-0.02a3.19,3.19,0,0,1-.4.43,2.659,2.659,0,0,1-.54.39,5.528,5.528,0,0,1-.69.35,2.128,2.128,0,0,1-.86.17,3.557,3.557,0,0,1-1-.13,2.2,2.2,0,0,1-.81-0.4,1.781,1.781,0,0,1-.54-0.67,2.193,2.193,0,0,1-.19-0.96,2.3,2.3,0,0,1,.24-1.12,2.01,2.01,0,0,1,.69-0.7,3.312,3.312,0,0,1,1.03-.41c0.41-.1.84-0.18,1.3-0.27,0.27-.03.51-0.08,0.73-0.12a3.2,3.2,0,0,0,.57-0.18,0.941,0.941,0,0,0,.37-0.3,0.845,0.845,0,0,0,.13-0.5,1.213,1.213,0,0,0-.43-1.01,1.919,1.919,0,0,0-1.25-.35,2.048,2.048,0,0,0-1.38.4,1.689,1.689,0,0,0-.49,1.27h-1.13a2.687,2.687,0,0,1,.2-1.02,2.108,2.108,0,0,1,.56-0.82,2.609,2.609,0,0,1,.93-0.53,3.9,3.9,0,0,1,1.3-.2,4.817,4.817,0,0,1,1.1.12,2.464,2.464,0,0,1,.88.41,1.882,1.882,0,0,1,.58.74,2.763,2.763,0,0,1,.21,1.14v3.61a1.172,1.172,0,0,0,.16.69,0.373,0.373,0,0,0,.35.16,1.112,1.112,0,0,0,.29-0.04h0.04v0.86c-0.08.03-.16,0.06-0.26,0.09A1.943,1.943,0,0,1,1035.35,1319.8Zm-1.26-4.04a3.667,3.667,0,0,1-.76.33,8.639,8.639,0,0,1-.95.22c-0.29.06-.57,0.12-0.83,0.18a2.471,2.471,0,0,0-.68.26,1.327,1.327,0,0,0-.45.43,1.292,1.292,0,0,0-.16.68,1.309,1.309,0,0,0,.13.63,1.065,1.065,0,0,0,.36.37,1.308,1.308,0,0,0,.49.18,2.76,2.76,0,0,0,.57.06,2.474,2.474,0,0,0,1.02-.2,2.373,2.373,0,0,0,.71-0.5,1.934,1.934,0,0,0,.41-0.65,1.983,1.983,0,0,0,.14-0.7v-1.29Z",
        transform: "translate(-1026.5 -1299.5)"
      }, null, 8, ["fill"])
    ]));
  }
}, jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ub
}, Symbol.toStringTag, { value: "Module" })), Hb = {
  __name: "ThreeColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "47",
      height: "17",
      viewBox: "0 0 47 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, $b = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hb
}, Symbol.toStringTag, { value: "Module" })), Fb = {
  __name: "TwoColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "43",
      height: "17",
      viewBox: "0 0 43 17"
    }, [
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, ["stroke"]),
      R("rect", {
        fill: "transparent",
        stroke: t.value,
        "stroke-width": "1px",
        x: "22.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, ["stroke"])
    ]));
  }
}, Vb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fb
}, Symbol.toStringTag, { value: "Module" })), zb = {
  __name: "VideoIcon",
  props: {
    isHovering: Boolean
  },
  setup(n) {
    const e = n, t = I(
      () => e.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (r, i) => (D(), U("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, [
      R("path", {
        fill: t.value,
        "fill-rule": "evenodd",
        d: "M1049.98,1474.5a1.5,1.5,0,0,1-1.49,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h8a0.142,0.142,0,0,1,.06.02,0.2,0.2,0,0,1,.07.01,0.477,0.477,0,0,1,.22.12l5,6a0.464,0.464,0,0,1,.12.23,0.127,0.127,0,0,1,.01.06c0,0.02.01,0.04,0.01,0.06v12Zm-13.99-17v17a0.508,0.508,0,0,0,.5.5h12a0.508,0.508,0,0,0,.5-0.5V1463h-4.5a0.5,0.5,0,0,1-.5-0.5V1457h-7.5A0.508,0.508,0,0,0,1035.99,1457.5Zm9,0.21V1462h3.29Zm0.72,10.24a0.532,0.532,0,0,1,.28.45,0.522,0.522,0,0,1-.27.45l-6,3.09a0.465,0.465,0,0,1-.23.06,0.484,0.484,0,0,1-.26-0.07,0.507,0.507,0,0,1-.24-0.43v-6a0.5,0.5,0,0,1,.23-0.42,0.531,0.531,0,0,1,.49-0.03Zm-5.72,2.73,4.38-2.26-4.38-2.12v4.38Z",
        transform: "translate(-1027.5 -1451)"
      }, null, 8, ["fill"])
    ]));
  }
}, Wb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zb
}, Symbol.toStringTag, { value: "Module" })), nn = rn ? window : void 0;
function Xt(n) {
  var e;
  const t = ve(n);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
function Pt(...n) {
  const e = [], t = () => {
    e.forEach((s) => s()), e.length = 0;
  }, r = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), i = I(() => {
    const s = er(ve(n[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), o = Up(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((u) => Xt(u))) != null ? l : [nn].filter((u) => u != null),
        er(ve(i.value ? n[1] : n[0])),
        er(V(i.value ? n[2] : n[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        ve(i.value ? n[3] : n[2])
      ];
    },
    ([s, l, u, c]) => {
      if (t(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = qp(c) ? { ...c } : c;
      e.push(
        ...s.flatMap(
          (f) => l.flatMap(
            (h) => u.map((g) => r(f, h, g, d))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    o(), t();
  };
  return It(t), a;
}
let Jf = !1;
function eh(n, e, t = {}) {
  const { window: r = nn, ignore: i = [], capture: o = !0, detectIframe: a = !1, controls: s = !1 } = t;
  if (!r)
    return s ? { stop: ut, cancel: ut, trigger: ut } : ut;
  if (yl && !Jf) {
    Jf = !0;
    const v = { passive: !0 };
    Array.from(r.document.body.children).forEach((b) => Pt(b, "click", ut, v)), Pt(r.document.documentElement, "click", ut, v);
  }
  let l = !0;
  const u = (v) => ve(i).some((b) => {
    if (typeof b == "string")
      return Array.from(r.document.querySelectorAll(b)).some((_) => _ === v.target || v.composedPath().includes(_));
    {
      const _ = Xt(b);
      return _ && (v.target === _ || v.composedPath().includes(_));
    }
  });
  function c(v) {
    const b = ve(v);
    return b && b.$.subTree.shapeFlag === 16;
  }
  function d(v, b) {
    const _ = ve(v), y = _.$.subTree && _.$.subTree.children;
    return y == null || !Array.isArray(y) ? !1 : y.some((C) => C.el === b.target || b.composedPath().includes(C.el));
  }
  const f = (v) => {
    const b = Xt(n);
    if (v.target != null && !(!(b instanceof Element) && c(n) && d(n, v)) && !(!b || b === v.target || v.composedPath().includes(b))) {
      if ("detail" in v && v.detail === 0 && (l = !u(v)), !l) {
        l = !0;
        return;
      }
      e(v);
    }
  };
  let h = !1;
  const g = [
    Pt(r, "click", (v) => {
      h || (h = !0, setTimeout(() => {
        h = !1;
      }, 0), f(v));
    }, { passive: !0, capture: o }),
    Pt(r, "pointerdown", (v) => {
      const b = Xt(n);
      l = !u(v) && !!(b && !v.composedPath().includes(b));
    }, { passive: !0 }),
    a && Pt(r, "blur", (v) => {
      setTimeout(() => {
        var b;
        const _ = Xt(n);
        ((b = r.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !(_ != null && _.contains(r.document.activeElement)) && e(v);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), p = () => g.forEach((v) => v());
  return s ? {
    stop: p,
    cancel: () => {
      l = !1;
    },
    trigger: (v) => {
      l = !0, f(v), l = !1;
    }
  } : p;
}
const ww = {
  mounted(n, e) {
    const t = !e.modifiers.bubble;
    if (typeof e.value == "function")
      n.__onClickOutside_stop = eh(n, e.value, { capture: t });
    else {
      const [r, i] = e.value;
      n.__onClickOutside_stop = eh(n, r, Object.assign({ capture: t }, i));
    }
  },
  unmounted(n) {
    n.__onClickOutside_stop();
  }
};
function Gb(n) {
  return typeof n == "function" ? n : typeof n == "string" ? (e) => e.key === n : Array.isArray(n) ? (e) => n.includes(e.key) : () => !0;
}
function th(...n) {
  let e, t, r = {};
  n.length === 3 ? (e = n[0], t = n[1], r = n[2]) : n.length === 2 ? typeof n[1] == "object" ? (e = !0, t = n[0], r = n[1]) : (e = n[0], t = n[1]) : (e = !0, t = n[0]);
  const {
    target: i = nn,
    eventName: o = "keydown",
    passive: a = !1,
    dedupe: s = !1
  } = r, l = Gb(e);
  return Pt(i, o, (c) => {
    c.repeat && ve(s) || l(c) && t(c);
  }, a);
}
const Tw = {
  mounted(n, e) {
    var t, r;
    const i = (r = (t = e.arg) == null ? void 0 : t.split(",")) != null ? r : !0;
    if (typeof e.value == "function")
      th(i, e.value, {
        target: n
      });
    else {
      const [o, a] = e.value;
      th(i, o, {
        target: n,
        ...a
      });
    }
  }
};
function Yb() {
  const n = fe(!1), e = Xl();
  return e && mt(() => {
    n.value = !0;
  }, e), n;
}
function Zb(n) {
  const e = Yb();
  return I(() => (e.value, !!n()));
}
function Xb(n, e, t = {}) {
  const { window: r = nn, ...i } = t;
  let o;
  const a = Zb(() => r && "MutationObserver" in r), s = () => {
    o && (o.disconnect(), o = void 0);
  }, l = I(() => {
    const f = ve(n), h = er(f).map(Xt).filter(Lp);
    return new Set(h);
  }), u = Ae(
    () => l.value,
    (f) => {
      s(), a.value && f.size && (o = new MutationObserver(e), f.forEach((h) => o.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => o == null ? void 0 : o.takeRecords(), d = () => {
    u(), s();
  };
  return It(d), {
    isSupported: a,
    stop: d,
    takeRecords: c
  };
}
function Kb(n, e, t = {}) {
  const {
    window: r = nn,
    document: i = r == null ? void 0 : r.document,
    flush: o = "sync"
  } = t;
  if (!r || !i)
    return ut;
  let a;
  const s = (c) => {
    a == null || a(), a = c;
  }, l = ap(() => {
    const c = Xt(n);
    if (c) {
      const { stop: d } = Xb(
        i,
        (f) => {
          f.map((g) => [...g.removedNodes]).flat().some((g) => g === c || g.contains(c)) && e(f);
        },
        {
          window: r,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: o }), u = () => {
    l(), s();
  };
  return It(u), u;
}
function rh(n, e = {}) {
  const {
    delayEnter: t = 0,
    delayLeave: r = 0,
    triggerOnRemoval: i = !1,
    window: o = nn
  } = e, a = fe(!1);
  let s;
  const l = (u) => {
    const c = u ? t : r;
    s && (clearTimeout(s), s = void 0), c ? s = setTimeout(() => a.value = u, c) : a.value = u;
  };
  return o && (Pt(n, "mouseenter", () => l(!0), { passive: !0 }), Pt(n, "mouseleave", () => l(!1), { passive: !0 }), i && Kb(
    I(() => Xt(n)),
    () => l(!1)
  )), a;
}
const kl = {
  mounted(n, e) {
    const t = e.value;
    if (typeof t == "function") {
      const r = rh(n);
      Ae(r, (i) => t(i));
    } else {
      const [r, i] = t, o = rh(n, i);
      Ae(o, (a) => r(a));
    }
  }
};
function bs(n) {
  return typeof Window < "u" && n instanceof Window ? n.document.documentElement : typeof Document < "u" && n instanceof Document ? n.documentElement : n;
}
function Av(n) {
  const e = window.getComputedStyle(n);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && n.clientWidth < n.scrollWidth || e.overflowY === "auto" && n.clientHeight < n.scrollHeight)
    return !0;
  {
    const t = n.parentNode;
    return !t || t.tagName === "BODY" ? !1 : Av(t);
  }
}
function Qb(n) {
  const e = n || window.event, t = e.target;
  return Av(t) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const ys = /* @__PURE__ */ new WeakMap();
function Jb(n, e = !1) {
  const t = fe(e);
  let r = null, i = "";
  Ae(ci(n), (s) => {
    const l = bs(ve(s));
    if (l) {
      const u = l;
      if (ys.get(u) || ys.set(u, u.style.overflow), u.style.overflow !== "hidden" && (i = u.style.overflow), u.style.overflow === "hidden")
        return t.value = !0;
      if (t.value)
        return u.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const o = () => {
    const s = bs(ve(n));
    !s || t.value || (yl && (r = Pt(
      s,
      "touchmove",
      (l) => {
        Qb(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", t.value = !0);
  }, a = () => {
    const s = bs(ve(n));
    !s || !t.value || (yl && (r == null || r()), s.style.overflow = i, ys.delete(s), t.value = !1);
  };
  return It(a), I({
    get() {
      return t.value;
    },
    set(s) {
      s ? o() : a();
    }
  });
}
function ey() {
  let n = !1;
  const e = fe(!1);
  return (t, r) => {
    if (e.value = r.value, n)
      return;
    n = !0;
    const i = Jb(t, r.value);
    Ae(e, (o) => i.value = o);
  };
}
ey();
var Cs, nh;
function ty() {
  if (nh) return Cs;
  nh = 1;
  function n(e, t, r) {
    var i = -1, o = e.length;
    t < 0 && (t = -t > o ? 0 : o + t), r = r > o ? o : r, r < 0 && (r += o), o = t > r ? 0 : r - t >>> 0, t >>>= 0;
    for (var a = Array(o); ++i < o; )
      a[i] = e[i + t];
    return a;
  }
  return Cs = n, Cs;
}
var ws, ih;
function ry() {
  if (ih) return ws;
  ih = 1;
  var n = ty();
  function e(t, r, i) {
    var o = t.length;
    return i = i === void 0 ? o : i, !r && i >= o ? t : n(t, r, i);
  }
  return ws = e, ws;
}
var Ts, oh;
function Ov() {
  if (oh) return Ts;
  oh = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\ufe0e\\ufe0f", a = "\\u200d", s = RegExp("[" + a + n + i + o + "]");
  function l(u) {
    return s.test(u);
  }
  return Ts = l, Ts;
}
var Ss, ah;
function ny() {
  if (ah) return Ss;
  ah = 1;
  function n(e) {
    return e.split("");
  }
  return Ss = n, Ss;
}
var xs, sh;
function iy() {
  if (sh) return xs;
  sh = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\ufe0e\\ufe0f", a = "[" + n + "]", s = "[" + i + "]", l = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + s + "|" + l + ")", c = "[^" + n + "]", d = "(?:\\ud83c[\\udde6-\\uddff]){2}", f = "[\\ud800-\\udbff][\\udc00-\\udfff]", h = "\\u200d", g = u + "?", p = "[" + o + "]?", v = "(?:" + h + "(?:" + [c, d, f].join("|") + ")" + p + g + ")*", b = p + g + v, _ = "(?:" + [c + s + "?", s, d, f, a].join("|") + ")", y = RegExp(l + "(?=" + l + ")|" + _ + b, "g");
  function C(w) {
    return w.match(y) || [];
  }
  return xs = C, xs;
}
var As, lh;
function oy() {
  if (lh) return As;
  lh = 1;
  var n = ny(), e = Ov(), t = iy();
  function r(i) {
    return e(i) ? t(i) : n(i);
  }
  return As = r, As;
}
var Os, uh;
function ay() {
  if (uh) return Os;
  uh = 1;
  var n = ry(), e = Ov(), t = oy(), r = zn();
  function i(o) {
    return function(a) {
      a = r(a);
      var s = e(a) ? t(a) : void 0, l = s ? s[0] : a.charAt(0), u = s ? n(s, 1).join("") : a.slice(1);
      return l[o]() + u;
    };
  }
  return Os = i, Os;
}
var Es, ch;
function sy() {
  if (ch) return Es;
  ch = 1;
  var n = ay(), e = n("toUpperCase");
  return Es = e, Es;
}
var Is, dh;
function Ev() {
  if (dh) return Is;
  dh = 1;
  var n = zn(), e = sy();
  function t(r) {
    return e(n(r).toLowerCase());
  }
  return Is = t, Is;
}
var Ns, fh;
function ly() {
  if (fh) return Ns;
  fh = 1;
  function n(e, t, r, i) {
    var o = -1, a = e == null ? 0 : e.length;
    for (i && a && (r = e[++o]); ++o < a; )
      r = t(r, e[o], o, e);
    return r;
  }
  return Ns = n, Ns;
}
var ks, hh;
function uy() {
  if (hh) return ks;
  hh = 1;
  function n(e) {
    return function(t) {
      return e == null ? void 0 : e[t];
    };
  }
  return ks = n, ks;
}
var Ds, ph;
function cy() {
  if (ph) return Ds;
  ph = 1;
  var n = uy(), e = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, t = n(e);
  return Ds = t, Ds;
}
var Rs, vh;
function dy() {
  if (vh) return Rs;
  vh = 1;
  var n = cy(), e = zn(), t = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", a = r + i + o, s = "[" + a + "]", l = RegExp(s, "g");
  function u(c) {
    return c = e(c), c && c.replace(t, n).replace(l, "");
  }
  return Rs = u, Rs;
}
var Ps, gh;
function fy() {
  if (gh) return Ps;
  gh = 1;
  var n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function e(t) {
    return t.match(n) || [];
  }
  return Ps = e, Ps;
}
var Ms, mh;
function hy() {
  if (mh) return Ms;
  mh = 1;
  var n = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function e(t) {
    return n.test(t);
  }
  return Ms = e, Ms;
}
var Ls, _h;
function py() {
  if (_h) return Ls;
  _h = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, o = "\\u2700-\\u27bf", a = "a-z\\xdf-\\xf6\\xf8-\\xff", s = "\\xac\\xb1\\xd7\\xf7", l = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", u = "\\u2000-\\u206f", c = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", d = "A-Z\\xc0-\\xd6\\xd8-\\xde", f = "\\ufe0e\\ufe0f", h = s + l + u + c, g = "['’]", p = "[" + h + "]", v = "[" + i + "]", b = "\\d+", _ = "[" + o + "]", y = "[" + a + "]", C = "[^" + n + h + b + o + a + d + "]", w = "\\ud83c[\\udffb-\\udfff]", m = "(?:" + v + "|" + w + ")", T = "[^" + n + "]", x = "(?:\\ud83c[\\udde6-\\uddff]){2}", A = "[\\ud800-\\udbff][\\udc00-\\udfff]", M = "[" + d + "]", O = "\\u200d", S = "(?:" + y + "|" + C + ")", P = "(?:" + M + "|" + C + ")", N = "(?:" + g + "(?:d|ll|m|re|s|t|ve))?", E = "(?:" + g + "(?:D|LL|M|RE|S|T|VE))?", L = m + "?", H = "[" + f + "]?", z = "(?:" + O + "(?:" + [T, x, A].join("|") + ")" + H + L + ")*", te = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", le = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ce = H + L + z, ae = "(?:" + [_, x, A].join("|") + ")" + ce, ue = RegExp([
    M + "?" + y + "+" + N + "(?=" + [p, M, "$"].join("|") + ")",
    P + "+" + E + "(?=" + [p, M + S, "$"].join("|") + ")",
    M + "?" + S + "+" + N,
    M + "+" + E,
    le,
    te,
    b,
    ae
  ].join("|"), "g");
  function de(ye) {
    return ye.match(ue) || [];
  }
  return Ls = de, Ls;
}
var qs, bh;
function vy() {
  if (bh) return qs;
  bh = 1;
  var n = fy(), e = hy(), t = zn(), r = py();
  function i(o, a, s) {
    return o = t(o), a = s ? void 0 : a, a === void 0 ? e(o) ? r(o) : n(o) : o.match(a) || [];
  }
  return qs = i, qs;
}
var Bs, yh;
function gy() {
  if (yh) return Bs;
  yh = 1;
  var n = ly(), e = dy(), t = vy(), r = "['’]", i = RegExp(r, "g");
  function o(a) {
    return function(s) {
      return n(t(e(s).replace(i, "")), a, "");
    };
  }
  return Bs = o, Bs;
}
var Us, Ch;
function my() {
  if (Ch) return Us;
  Ch = 1;
  var n = Ev(), e = gy(), t = e(function(r, i, o) {
    return i = i.toLowerCase(), r + (o ? n(i) : i);
  });
  return Us = t, Us;
}
var _y = my();
const by = /* @__PURE__ */ $t(_y), yy = {
  __name: "DefaultNodeIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    groupType: {
      type: String,
      default: "",
      validator: (n) => ["layout", "content"].includes(n)
    }
  },
  setup(n) {
    const e = n, t = /* @__PURE__ */ Object.assign({
      "/src/assets/icons/nodes/AccordionIcon.vue": ib,
      "/src/assets/icons/nodes/ButtonIcon.vue": ab,
      "/src/assets/icons/nodes/CardIcon.vue": lb,
      "/src/assets/icons/nodes/EmbedIcon.vue": cb,
      "/src/assets/icons/nodes/FormIcon.vue": fb,
      "/src/assets/icons/nodes/FourColumnsIcon.vue": pb,
      "/src/assets/icons/nodes/FullWidthIcon.vue": gb,
      "/src/assets/icons/nodes/GalleryIcon.vue": _b,
      "/src/assets/icons/nodes/HeadingIcon.vue": yb,
      "/src/assets/icons/nodes/ImageIcon.vue": $1,
      "/src/assets/icons/nodes/LeftSidebarIcon.vue": wb,
      "/src/assets/icons/nodes/NavigationIcon.vue": Sb,
      "/src/assets/icons/nodes/OneColumnIcon.vue": Ab,
      "/src/assets/icons/nodes/QuoteIcon.vue": Eb,
      "/src/assets/icons/nodes/RightSidebarIcon.vue": Nb,
      "/src/assets/icons/nodes/SeparatorIcon.vue": Db,
      "/src/assets/icons/nodes/SliderIcon.vue": Pb,
      "/src/assets/icons/nodes/SpacerIcon.vue": Lb,
      "/src/assets/icons/nodes/TableIcon.vue": Bb,
      "/src/assets/icons/nodes/TextIcon.vue": jb,
      "/src/assets/icons/nodes/ThreeColumnsIcon.vue": $b,
      "/src/assets/icons/nodes/TwoColumnsIcon.vue": Vb,
      "/src/assets/icons/nodes/VideoIcon.vue": Wb
    }), r = I(() => {
      var l;
      const s = `/src/assets/icons/nodes/${e.node.icon}.vue`;
      return ((l = t[s]) == null ? void 0 : l.default) || null;
    }), i = I(
      () => `builder.${e.groupType}.${by(e.node.name)}.title`
    ), o = J(!1), a = (s) => o.value = s;
    return (s, l) => bn((D(), U("div", {
      class: He(["block", n.groupType]),
      onDblclick: l[0] || (l[0] = (u) => s.$emit("add-node"))
    }, [
      (D(), W(si(r.value), {
        class: "icon",
        "is-hovering": o.value
      }, null, 8, ["is-hovering"])),
      R("p", { class: "node-name" }, Q(s.$t(i.value)), 1)
    ], 34)), [
      [V(kl), a]
    ]);
  }
}, Cy = /* @__PURE__ */ K(yy, [["__scopeId", "data-v-00b6ed94"]]), wy = {};
function Ty(n, e) {
  return D(), U("div", { class: "pb-overlay" });
}
const Sy = /* @__PURE__ */ K(wy, [["render", Ty], ["__scopeId", "data-v-f6f53f85"]]);
function Dt(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Iv(n, e) {
  n.prototype = Object.create(e.prototype), n.prototype.constructor = n, n.__proto__ = e;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var it = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, Zr = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, Tu, Le, be, ct = 1e8, pe = 1 / ct, Dl = Math.PI * 2, xy = Dl / 4, Ay = 0, Nv = Math.sqrt, Oy = Math.cos, Ey = Math.sin, Re = function(e) {
  return typeof e == "string";
}, Se = function(e) {
  return typeof e == "function";
}, jt = function(e) {
  return typeof e == "number";
}, Su = function(e) {
  return typeof e > "u";
}, Ot = function(e) {
  return typeof e == "object";
}, Ge = function(e) {
  return e !== !1;
}, xu = function() {
  return typeof window < "u";
}, Jn = function(e) {
  return Se(e) || Re(e);
}, kv = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, Ue = Array.isArray, Rl = /(?:-?\.?\d|\.)+/gi, Dv = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Ur = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, js = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Rv = /[+-]=-?[.\d]+/, Pv = /[^,'"\[\]\s]+/gi, Iy = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, we, yt, Pl, Au, ot = {}, fi = {}, Mv, Lv = function(e) {
  return (fi = Xr(e, ot)) && Ke;
}, Ou = function(e, t) {
  return console.warn("Invalid property", e, "set to", t, "Missing plugin? gsap.registerPlugin()");
}, Pn = function(e, t) {
  return !t && console.warn(e);
}, qv = function(e, t) {
  return e && (ot[e] = t) && fi && (fi[e] = t) || ot;
}, Mn = function() {
  return 0;
}, Ny = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, ni = {
  suppressEvents: !0,
  kill: !1
}, ky = {
  suppressEvents: !0
}, Eu = {}, tr = [], Ml = {}, Bv, Je = {}, Hs = {}, wh = 30, ii = [], Iu = "", Nu = function(e) {
  var t = e[0], r, i;
  if (Ot(t) || Se(t) || (e = [e]), !(r = (t._gsap || {}).harness)) {
    for (i = ii.length; i-- && !ii[i].targetTest(t); )
      ;
    r = ii[i];
  }
  for (i = e.length; i--; )
    e[i] && (e[i]._gsap || (e[i]._gsap = new lg(e[i], r))) || e.splice(i, 1);
  return e;
}, Cr = function(e) {
  return e._gsap || Nu(dt(e))[0]._gsap;
}, Uv = function(e, t, r) {
  return (r = e[t]) && Se(r) ? e[t]() : Su(r) && e.getAttribute && e.getAttribute(t) || r;
}, Ye = function(e, t) {
  return (e = e.split(",")).forEach(t) || e;
}, xe = function(e) {
  return Math.round(e * 1e5) / 1e5 || 0;
}, Ie = function(e) {
  return Math.round(e * 1e7) / 1e7 || 0;
}, zr = function(e, t) {
  var r = t.charAt(0), i = parseFloat(t.substr(2));
  return e = parseFloat(e), r === "+" ? e + i : r === "-" ? e - i : r === "*" ? e * i : e / i;
}, Dy = function(e, t) {
  for (var r = t.length, i = 0; e.indexOf(t[i]) < 0 && ++i < r; )
    ;
  return i < r;
}, hi = function() {
  var e = tr.length, t = tr.slice(0), r, i;
  for (Ml = {}, tr.length = 0, r = 0; r < e; r++)
    i = t[r], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, ku = function(e) {
  return !!(e._initted || e._startAt || e.add);
}, jv = function(e, t, r, i) {
  tr.length && !Le && hi(), e.render(t, r, !!(Le && t < 0 && ku(e))), tr.length && !Le && hi();
}, Hv = function(e) {
  var t = parseFloat(e);
  return (t || t === 0) && (e + "").match(Pv).length < 2 ? t : Re(e) ? e.trim() : e;
}, $v = function(e) {
  return e;
}, at = function(e, t) {
  for (var r in t)
    r in e || (e[r] = t[r]);
  return e;
}, Ry = function(e) {
  return function(t, r) {
    for (var i in r)
      i in t || i === "duration" && e || i === "ease" || (t[i] = r[i]);
  };
}, Xr = function(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}, Th = function n(e, t) {
  for (var r in t)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (e[r] = Ot(t[r]) ? n(e[r] || (e[r] = {}), t[r]) : t[r]);
  return e;
}, pi = function(e, t) {
  var r = {}, i;
  for (i in e)
    i in t || (r[i] = e[i]);
  return r;
}, gn = function(e) {
  var t = e.parent || we, r = e.keyframes ? Ry(Ue(e.keyframes)) : at;
  if (Ge(e.inherit))
    for (; t; )
      r(e, t.vars.defaults), t = t.parent || t._dp;
  return e;
}, Py = function(e, t) {
  for (var r = e.length, i = r === t.length; i && r-- && e[r] === t[r]; )
    ;
  return r < 0;
}, Fv = function(e, t, r, i, o) {
  var a = e[i], s;
  if (o)
    for (s = t[o]; a && a[o] > s; )
      a = a._prev;
  return a ? (t._next = a._next, a._next = t) : (t._next = e[r], e[r] = t), t._next ? t._next._prev = t : e[i] = t, t._prev = a, t.parent = t._dp = e, t;
}, Mi = function(e, t, r, i) {
  r === void 0 && (r = "_first"), i === void 0 && (i = "_last");
  var o = t._prev, a = t._next;
  o ? o._next = a : e[r] === t && (e[r] = a), a ? a._prev = o : e[i] === t && (e[i] = o), t._next = t._prev = t.parent = null;
}, or = function(e, t) {
  e.parent && (!t || e.parent.autoRemoveChildren) && e.parent.remove && e.parent.remove(e), e._act = 0;
}, wr = function(e, t) {
  if (e && (!t || t._end > e._dur || t._start < 0))
    for (var r = e; r; )
      r._dirty = 1, r = r.parent;
  return e;
}, My = function(e) {
  for (var t = e.parent; t && t.parent; )
    t._dirty = 1, t.totalDuration(), t = t.parent;
  return e;
}, Ll = function(e, t, r, i) {
  return e._startAt && (Le ? e._startAt.revert(ni) : e.vars.immediateRender && !e.vars.autoRevert || e._startAt.render(t, !0, i));
}, Ly = function n(e) {
  return !e || e._ts && n(e.parent);
}, Sh = function(e) {
  return e._repeat ? Kr(e._tTime, e = e.duration() + e._rDelay) * e : 0;
}, Kr = function(e, t) {
  var r = Math.floor(e = Ie(e / t));
  return e && r === e ? r - 1 : r;
}, vi = function(e, t) {
  return (e - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
}, Li = function(e) {
  return e._end = Ie(e._start + (e._tDur / Math.abs(e._ts || e._rts || pe) || 0));
}, qi = function(e, t) {
  var r = e._dp;
  return r && r.smoothChildTiming && e._ts && (e._start = Ie(r._time - (e._ts > 0 ? t / e._ts : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts)), Li(e), r._dirty || wr(r, e)), e;
}, Vv = function(e, t) {
  var r;
  if ((t._time || !t._dur && t._initted || t._start < e._time && (t._dur || !t.add)) && (r = vi(e.rawTime(), t), (!t._dur || Wn(0, t.totalDuration(), r) - t._tTime > pe) && t.render(r, !0)), wr(e, t)._dp && e._initted && e._time >= e._dur && e._ts) {
    if (e._dur < e.duration())
      for (r = e; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    e._zTime = -pe;
  }
}, wt = function(e, t, r, i) {
  return t.parent && or(t), t._start = Ie((jt(r) ? r : r || e !== we ? lt(e, r, t) : e._time) + t._delay), t._end = Ie(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Fv(e, t, "_first", "_last", e._sort ? "_start" : 0), ql(t) || (e._recent = t), i || Vv(e, t), e._ts < 0 && qi(e, e._tTime), e;
}, zv = function(e, t) {
  return (ot.ScrollTrigger || Ou("scrollTrigger", t)) && ot.ScrollTrigger.create(t, e);
}, Wv = function(e, t, r, i, o) {
  if (Ru(e, t, o), !e._initted)
    return 1;
  if (!r && e._pt && !Le && (e._dur && e.vars.lazy !== !1 || !e._dur && e.vars.lazy) && Bv !== tt.frame)
    return tr.push(e), e._lazy = [o, i], 1;
}, qy = function n(e) {
  var t = e.parent;
  return t && t._ts && t._initted && !t._lock && (t.rawTime() < 0 || n(t));
}, ql = function(e) {
  var t = e.data;
  return t === "isFromStart" || t === "isStart";
}, By = function(e, t, r, i) {
  var o = e.ratio, a = t < 0 || !t && (!e._start && qy(e) && !(!e._initted && ql(e)) || (e._ts < 0 || e._dp._ts < 0) && !ql(e)) ? 0 : 1, s = e._rDelay, l = 0, u, c, d;
  if (s && e._repeat && (l = Wn(0, e._tDur, t), c = Kr(l, s), e._yoyo && c & 1 && (a = 1 - a), c !== Kr(e._tTime, s) && (o = 1 - a, e.vars.repeatRefresh && e._initted && e.invalidate())), a !== o || Le || i || e._zTime === pe || !t && e._zTime) {
    if (!e._initted && Wv(e, t, i, r, l))
      return;
    for (d = e._zTime, e._zTime = t || (r ? pe : 0), r || (r = t && !d), e.ratio = a, e._from && (a = 1 - a), e._time = 0, e._tTime = l, u = e._pt; u; )
      u.r(a, u.d), u = u._next;
    t < 0 && Ll(e, t, r, !0), e._onUpdate && !r && rt(e, "onUpdate"), l && e._repeat && !r && e.parent && rt(e, "onRepeat"), (t >= e._tDur || t < 0) && e.ratio === a && (a && or(e, 1), !r && !Le && (rt(e, a ? "onComplete" : "onReverseComplete", !0), e._prom && e._prom()));
  } else e._zTime || (e._zTime = t);
}, Uy = function(e, t, r) {
  var i;
  if (r > t)
    for (i = e._first; i && i._start <= r; ) {
      if (i.data === "isPause" && i._start > t)
        return i;
      i = i._next;
    }
  else
    for (i = e._last; i && i._start >= r; ) {
      if (i.data === "isPause" && i._start < t)
        return i;
      i = i._prev;
    }
}, Qr = function(e, t, r, i) {
  var o = e._repeat, a = Ie(t) || 0, s = e._tTime / e._tDur;
  return s && !i && (e._time *= a / e._dur), e._dur = a, e._tDur = o ? o < 0 ? 1e10 : Ie(a * (o + 1) + e._rDelay * o) : a, s > 0 && !i && qi(e, e._tTime = e._tDur * s), e.parent && Li(e), r || wr(e.parent, e), e;
}, xh = function(e) {
  return e instanceof je ? wr(e) : Qr(e, e._dur);
}, jy = {
  _start: 0,
  endTime: Mn,
  totalDuration: Mn
}, lt = function n(e, t, r) {
  var i = e.labels, o = e._recent || jy, a = e.duration() >= ct ? o.endTime(!1) : e._dur, s, l, u;
  return Re(t) && (isNaN(t) || t in i) ? (l = t.charAt(0), u = t.substr(-1) === "%", s = t.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (t = t.replace(/=/, "")), (l === "<" ? o._start : o.endTime(o._repeat >= 0)) + (parseFloat(t.substr(1)) || 0) * (u ? (s < 0 ? o : r).totalDuration() / 100 : 1)) : s < 0 ? (t in i || (i[t] = a), i[t]) : (l = parseFloat(t.charAt(s - 1) + t.substr(s + 1)), u && r && (l = l / 100 * (Ue(r) ? r[0] : r).totalDuration()), s > 1 ? n(e, t.substr(0, s - 1), r) + l : a + l)) : t == null ? a : +t;
}, mn = function(e, t, r) {
  var i = jt(t[1]), o = (i ? 2 : 1) + (e < 2 ? 0 : 1), a = t[o], s, l;
  if (i && (a.duration = t[1]), a.parent = r, e) {
    for (s = a, l = r; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = Ge(l.vars.inherit) && l.parent;
    a.immediateRender = Ge(s.immediateRender), e < 2 ? a.runBackwards = 1 : a.startAt = t[o - 1];
  }
  return new Ee(t[0], a, t[o + 1]);
}, ur = function(e, t) {
  return e || e === 0 ? t(e) : t;
}, Wn = function(e, t, r) {
  return r < e ? e : r > t ? t : r;
}, Be = function(e, t) {
  return !Re(e) || !(t = Iy.exec(e)) ? "" : t[1];
}, Hy = function(e, t, r) {
  return ur(r, function(i) {
    return Wn(e, t, i);
  });
}, Bl = [].slice, Gv = function(e, t) {
  return e && Ot(e) && "length" in e && (!t && !e.length || e.length - 1 in e && Ot(e[0])) && !e.nodeType && e !== yt;
}, $y = function(e, t, r) {
  return r === void 0 && (r = []), e.forEach(function(i) {
    var o;
    return Re(i) && !t || Gv(i, 1) ? (o = r).push.apply(o, dt(i)) : r.push(i);
  }) || r;
}, dt = function(e, t, r) {
  return be && !t && be.selector ? be.selector(e) : Re(e) && !r && (Pl || !Jr()) ? Bl.call((t || Au).querySelectorAll(e), 0) : Ue(e) ? $y(e, r) : Gv(e) ? Bl.call(e, 0) : e ? [e] : [];
}, Ul = function(e) {
  return e = dt(e)[0] || Pn("Invalid scope") || {}, function(t) {
    var r = e.current || e.nativeElement || e;
    return dt(t, r.querySelectorAll ? r : r === e ? Pn("Invalid scope") || Au.createElement("div") : e);
  };
}, Yv = function(e) {
  return e.sort(function() {
    return 0.5 - Math.random();
  });
}, Zv = function(e) {
  if (Se(e))
    return e;
  var t = Ot(e) ? e : {
    each: e
  }, r = Tr(t.ease), i = t.from || 0, o = parseFloat(t.base) || 0, a = {}, s = i > 0 && i < 1, l = isNaN(i) || s, u = t.axis, c = i, d = i;
  return Re(i) ? c = d = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !s && l && (c = i[0], d = i[1]), function(f, h, g) {
    var p = (g || t).length, v = a[p], b, _, y, C, w, m, T, x, A;
    if (!v) {
      if (A = t.grid === "auto" ? 0 : (t.grid || [1, ct])[1], !A) {
        for (T = -ct; T < (T = g[A++].getBoundingClientRect().left) && A < p; )
          ;
        A < p && A--;
      }
      for (v = a[p] = [], b = l ? Math.min(A, p) * c - 0.5 : i % A, _ = A === ct ? 0 : l ? p * d / A - 0.5 : i / A | 0, T = 0, x = ct, m = 0; m < p; m++)
        y = m % A - b, C = _ - (m / A | 0), v[m] = w = u ? Math.abs(u === "y" ? C : y) : Nv(y * y + C * C), w > T && (T = w), w < x && (x = w);
      i === "random" && Yv(v), v.max = T - x, v.min = x, v.v = p = (parseFloat(t.amount) || parseFloat(t.each) * (A > p ? p - 1 : u ? u === "y" ? p / A : A : Math.max(A, p / A)) || 0) * (i === "edges" ? -1 : 1), v.b = p < 0 ? o - p : o, v.u = Be(t.amount || t.each) || 0, r = r && p < 0 ? og(r) : r;
    }
    return p = (v[f] - v.min) / v.max || 0, Ie(v.b + (r ? r(p) : p) * v.v) + v.u;
  };
}, jl = function(e) {
  var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
  return function(r) {
    var i = Ie(Math.round(parseFloat(r) / e) * e * t);
    return (i - i % 1) / t + (jt(r) ? 0 : Be(r));
  };
}, Xv = function(e, t) {
  var r = Ue(e), i, o;
  return !r && Ot(e) && (i = r = e.radius || ct, e.values ? (e = dt(e.values), (o = !jt(e[0])) && (i *= i)) : e = jl(e.increment)), ur(t, r ? Se(e) ? function(a) {
    return o = e(a), Math.abs(o - a) <= i ? o : a;
  } : function(a) {
    for (var s = parseFloat(o ? a.x : a), l = parseFloat(o ? a.y : 0), u = ct, c = 0, d = e.length, f, h; d--; )
      o ? (f = e[d].x - s, h = e[d].y - l, f = f * f + h * h) : f = Math.abs(e[d] - s), f < u && (u = f, c = d);
    return c = !i || u <= i ? e[c] : a, o || c === a || jt(a) ? c : c + Be(a);
  } : jl(e));
}, Kv = function(e, t, r, i) {
  return ur(Ue(e) ? !t : r === !0 ? !!(r = 0) : !i, function() {
    return Ue(e) ? e[~~(Math.random() * e.length)] : (r = r || 1e-5) && (i = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((e - r / 2 + Math.random() * (t - e + r * 0.99)) / r) * r * i) / i;
  });
}, Fy = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(i) {
    return t.reduce(function(o, a) {
      return a(o);
    }, i);
  };
}, Vy = function(e, t) {
  return function(r) {
    return e(parseFloat(r)) + (t || Be(r));
  };
}, zy = function(e, t, r) {
  return Jv(e, t, 0, 1, r);
}, Qv = function(e, t, r) {
  return ur(r, function(i) {
    return e[~~t(i)];
  });
}, Wy = function n(e, t, r) {
  var i = t - e;
  return Ue(e) ? Qv(e, n(0, e.length), t) : ur(r, function(o) {
    return (i + (o - e) % i) % i + e;
  });
}, Gy = function n(e, t, r) {
  var i = t - e, o = i * 2;
  return Ue(e) ? Qv(e, n(0, e.length - 1), t) : ur(r, function(a) {
    return a = (o + (a - e) % o) % o || 0, e + (a > i ? o - a : a);
  });
}, Ln = function(e) {
  for (var t = 0, r = "", i, o, a, s; ~(i = e.indexOf("random(", t)); )
    a = e.indexOf(")", i), s = e.charAt(i + 7) === "[", o = e.substr(i + 7, a - i - 7).match(s ? Pv : Rl), r += e.substr(t, i - t) + Kv(s ? o : +o[0], s ? 0 : +o[1], +o[2] || 1e-5), t = a + 1;
  return r + e.substr(t, e.length - t);
}, Jv = function(e, t, r, i, o) {
  var a = t - e, s = i - r;
  return ur(o, function(l) {
    return r + ((l - e) / a * s || 0);
  });
}, Yy = function n(e, t, r, i) {
  var o = isNaN(e + t) ? 0 : function(h) {
    return (1 - h) * e + h * t;
  };
  if (!o) {
    var a = Re(e), s = {}, l, u, c, d, f;
    if (r === !0 && (i = 1) && (r = null), a)
      e = {
        p: e
      }, t = {
        p: t
      };
    else if (Ue(e) && !Ue(t)) {
      for (c = [], d = e.length, f = d - 2, u = 1; u < d; u++)
        c.push(n(e[u - 1], e[u]));
      d--, o = function(g) {
        g *= d;
        var p = Math.min(f, ~~g);
        return c[p](g - p);
      }, r = t;
    } else i || (e = Xr(Ue(e) ? [] : {}, e));
    if (!c) {
      for (l in t)
        Du.call(s, e, l, "get", t[l]);
      o = function(g) {
        return Lu(g, s) || (a ? e.p : e);
      };
    }
  }
  return ur(r, o);
}, Ah = function(e, t, r) {
  var i = e.labels, o = ct, a, s, l;
  for (a in i)
    s = i[a] - t, s < 0 == !!r && s && o > (s = Math.abs(s)) && (l = a, o = s);
  return l;
}, rt = function(e, t, r) {
  var i = e.vars, o = i[t], a = be, s = e._ctx, l, u, c;
  if (o)
    return l = i[t + "Params"], u = i.callbackScope || e, r && tr.length && hi(), s && (be = s), c = l ? o.apply(u, l) : o.call(u), be = a, c;
}, hn = function(e) {
  return or(e), e.scrollTrigger && e.scrollTrigger.kill(!!Le), e.progress() < 1 && rt(e, "onInterrupt"), e;
}, jr, eg = [], tg = function(e) {
  if (e)
    if (e = !e.name && e.default || e, xu() || e.headless) {
      var t = e.name, r = Se(e), i = t && !r && e.init ? function() {
        this._props = [];
      } : e, o = {
        init: Mn,
        render: Lu,
        add: Du,
        kill: cC,
        modifier: uC,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: Mu,
        aliases: {},
        register: 0
      };
      if (Jr(), e !== i) {
        if (Je[t])
          return;
        at(i, at(pi(e, o), a)), Xr(i.prototype, Xr(o, pi(e, a))), Je[i.prop = t] = i, e.targetTest && (ii.push(i), Eu[t] = 1), t = (t === "css" ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
      }
      qv(t, i), e.register && e.register(Ke, i, Ze);
    } else
      eg.push(e);
}, he = 255, pn = {
  aqua: [0, he, he],
  lime: [0, he, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, he],
  navy: [0, 0, 128],
  white: [he, he, he],
  olive: [128, 128, 0],
  yellow: [he, he, 0],
  orange: [he, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [he, 0, 0],
  pink: [he, 192, 203],
  cyan: [0, he, he],
  transparent: [he, he, he, 0]
}, $s = function(e, t, r) {
  return e += e < 0 ? 1 : e > 1 ? -1 : 0, (e * 6 < 1 ? t + (r - t) * e * 6 : e < 0.5 ? r : e * 3 < 2 ? t + (r - t) * (2 / 3 - e) * 6 : t) * he + 0.5 | 0;
}, rg = function(e, t, r) {
  var i = e ? jt(e) ? [e >> 16, e >> 8 & he, e & he] : 0 : pn.black, o, a, s, l, u, c, d, f, h, g;
  if (!i) {
    if (e.substr(-1) === "," && (e = e.substr(0, e.length - 1)), pn[e])
      i = pn[e];
    else if (e.charAt(0) === "#") {
      if (e.length < 6 && (o = e.charAt(1), a = e.charAt(2), s = e.charAt(3), e = "#" + o + o + a + a + s + s + (e.length === 5 ? e.charAt(4) + e.charAt(4) : "")), e.length === 9)
        return i = parseInt(e.substr(1, 6), 16), [i >> 16, i >> 8 & he, i & he, parseInt(e.substr(7), 16) / 255];
      e = parseInt(e.substr(1), 16), i = [e >> 16, e >> 8 & he, e & he];
    } else if (e.substr(0, 3) === "hsl") {
      if (i = g = e.match(Rl), !t)
        l = +i[0] % 360 / 360, u = +i[1] / 100, c = +i[2] / 100, a = c <= 0.5 ? c * (u + 1) : c + u - c * u, o = c * 2 - a, i.length > 3 && (i[3] *= 1), i[0] = $s(l + 1 / 3, o, a), i[1] = $s(l, o, a), i[2] = $s(l - 1 / 3, o, a);
      else if (~e.indexOf("="))
        return i = e.match(Dv), r && i.length < 4 && (i[3] = 1), i;
    } else
      i = e.match(Rl) || pn.transparent;
    i = i.map(Number);
  }
  return t && !g && (o = i[0] / he, a = i[1] / he, s = i[2] / he, d = Math.max(o, a, s), f = Math.min(o, a, s), c = (d + f) / 2, d === f ? l = u = 0 : (h = d - f, u = c > 0.5 ? h / (2 - d - f) : h / (d + f), l = d === o ? (a - s) / h + (a < s ? 6 : 0) : d === a ? (s - o) / h + 2 : (o - a) / h + 4, l *= 60), i[0] = ~~(l + 0.5), i[1] = ~~(u * 100 + 0.5), i[2] = ~~(c * 100 + 0.5)), r && i.length < 4 && (i[3] = 1), i;
}, ng = function(e) {
  var t = [], r = [], i = -1;
  return e.split(rr).forEach(function(o) {
    var a = o.match(Ur) || [];
    t.push.apply(t, a), r.push(i += a.length + 1);
  }), t.c = r, t;
}, Oh = function(e, t, r) {
  var i = "", o = (e + i).match(rr), a = t ? "hsla(" : "rgba(", s = 0, l, u, c, d;
  if (!o)
    return e;
  if (o = o.map(function(f) {
    return (f = rg(f, t, 1)) && a + (t ? f[0] + "," + f[1] + "%," + f[2] + "%," + f[3] : f.join(",")) + ")";
  }), r && (c = ng(e), l = r.c, l.join(i) !== c.c.join(i)))
    for (u = e.replace(rr, "1").split(Ur), d = u.length - 1; s < d; s++)
      i += u[s] + (~l.indexOf(s) ? o.shift() || a + "0,0,0,0)" : (c.length ? c : o.length ? o : r).shift());
  if (!u)
    for (u = e.split(rr), d = u.length - 1; s < d; s++)
      i += u[s] + o[s];
  return i + u[d];
}, rr = function() {
  var n = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", e;
  for (e in pn)
    n += "|" + e + "\\b";
  return new RegExp(n + ")", "gi");
}(), Zy = /hsl[a]?\(/, ig = function(e) {
  var t = e.join(" "), r;
  if (rr.lastIndex = 0, rr.test(t))
    return r = Zy.test(t), e[1] = Oh(e[1], r), e[0] = Oh(e[0], r, ng(e[1])), !0;
}, qn, tt = function() {
  var n = Date.now, e = 500, t = 33, r = n(), i = r, o = 1e3 / 240, a = o, s = [], l, u, c, d, f, h, g = function p(v) {
    var b = n() - i, _ = v === !0, y, C, w, m;
    if ((b > e || b < 0) && (r += b - t), i += b, w = i - r, y = w - a, (y > 0 || _) && (m = ++d.frame, f = w - d.time * 1e3, d.time = w = w / 1e3, a += y + (y >= o ? 4 : o - y), C = 1), _ || (l = u(p)), C)
      for (h = 0; h < s.length; h++)
        s[h](w, f, m, v);
  };
  return d = {
    time: 0,
    frame: 0,
    tick: function() {
      g(!0);
    },
    deltaRatio: function(v) {
      return f / (1e3 / (v || 60));
    },
    wake: function() {
      Mv && (!Pl && xu() && (yt = Pl = window, Au = yt.document || {}, ot.gsap = Ke, (yt.gsapVersions || (yt.gsapVersions = [])).push(Ke.version), Lv(fi || yt.GreenSockGlobals || !yt.gsap && yt || {}), eg.forEach(tg)), c = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && d.sleep(), u = c || function(v) {
        return setTimeout(v, a - d.time * 1e3 + 1 | 0);
      }, qn = 1, g(2));
    },
    sleep: function() {
      (c ? cancelAnimationFrame : clearTimeout)(l), qn = 0, u = Mn;
    },
    lagSmoothing: function(v, b) {
      e = v || 1 / 0, t = Math.min(b || 33, e);
    },
    fps: function(v) {
      o = 1e3 / (v || 240), a = d.time * 1e3 + o;
    },
    add: function(v, b, _) {
      var y = b ? function(C, w, m, T) {
        v(C, w, m, T), d.remove(y);
      } : v;
      return d.remove(v), s[_ ? "unshift" : "push"](y), Jr(), y;
    },
    remove: function(v, b) {
      ~(b = s.indexOf(v)) && s.splice(b, 1) && h >= b && h--;
    },
    _listeners: s
  }, d;
}(), Jr = function() {
  return !qn && tt.wake();
}, ie = {}, Xy = /^[\d.\-M][\d.\-,\s]/, Ky = /["']/g, Qy = function(e) {
  for (var t = {}, r = e.substr(1, e.length - 3).split(":"), i = r[0], o = 1, a = r.length, s, l, u; o < a; o++)
    l = r[o], s = o !== a - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, s), t[i] = isNaN(u) ? u.replace(Ky, "").trim() : +u, i = l.substr(s + 1).trim();
  return t;
}, Jy = function(e) {
  var t = e.indexOf("(") + 1, r = e.indexOf(")"), i = e.indexOf("(", t);
  return e.substring(t, ~i && i < r ? e.indexOf(")", r + 1) : r);
}, eC = function(e) {
  var t = (e + "").split("("), r = ie[t[0]];
  return r && t.length > 1 && r.config ? r.config.apply(null, ~e.indexOf("{") ? [Qy(t[1])] : Jy(e).split(",").map(Hv)) : ie._CE && Xy.test(e) ? ie._CE("", e) : r;
}, og = function(e) {
  return function(t) {
    return 1 - e(1 - t);
  };
}, ag = function n(e, t) {
  for (var r = e._first, i; r; )
    r instanceof je ? n(r, t) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== t && (r.timeline ? n(r.timeline, t) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = t)), r = r._next;
}, Tr = function(e, t) {
  return e && (Se(e) ? e : ie[e] || eC(e)) || t;
}, kr = function(e, t, r, i) {
  r === void 0 && (r = function(l) {
    return 1 - t(1 - l);
  }), i === void 0 && (i = function(l) {
    return l < 0.5 ? t(l * 2) / 2 : 1 - t((1 - l) * 2) / 2;
  });
  var o = {
    easeIn: t,
    easeOut: r,
    easeInOut: i
  }, a;
  return Ye(e, function(s) {
    ie[s] = ot[s] = o, ie[a = s.toLowerCase()] = r;
    for (var l in o)
      ie[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = ie[s + "." + l] = o[l];
  }), o;
}, sg = function(e) {
  return function(t) {
    return t < 0.5 ? (1 - e(1 - t * 2)) / 2 : 0.5 + e((t - 0.5) * 2) / 2;
  };
}, Fs = function n(e, t, r) {
  var i = t >= 1 ? t : 1, o = (r || (e ? 0.3 : 0.45)) / (t < 1 ? t : 1), a = o / Dl * (Math.asin(1 / i) || 0), s = function(c) {
    return c === 1 ? 1 : i * Math.pow(2, -10 * c) * Ey((c - a) * o) + 1;
  }, l = e === "out" ? s : e === "in" ? function(u) {
    return 1 - s(1 - u);
  } : sg(s);
  return o = Dl / o, l.config = function(u, c) {
    return n(e, u, c);
  }, l;
}, Vs = function n(e, t) {
  t === void 0 && (t = 1.70158);
  var r = function(a) {
    return a ? --a * a * ((t + 1) * a + t) + 1 : 0;
  }, i = e === "out" ? r : e === "in" ? function(o) {
    return 1 - r(1 - o);
  } : sg(r);
  return i.config = function(o) {
    return n(e, o);
  }, i;
};
Ye("Linear,Quad,Cubic,Quart,Quint,Strong", function(n, e) {
  var t = e < 5 ? e + 1 : e;
  kr(n + ",Power" + (t - 1), e ? function(r) {
    return Math.pow(r, t);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, t);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, t) / 2 : 1 - Math.pow((1 - r) * 2, t) / 2;
  });
});
ie.Linear.easeNone = ie.none = ie.Linear.easeIn;
kr("Elastic", Fs("in"), Fs("out"), Fs());
(function(n, e) {
  var t = 1 / e, r = 2 * t, i = 2.5 * t, o = function(s) {
    return s < t ? n * s * s : s < r ? n * Math.pow(s - 1.5 / e, 2) + 0.75 : s < i ? n * (s -= 2.25 / e) * s + 0.9375 : n * Math.pow(s - 2.625 / e, 2) + 0.984375;
  };
  kr("Bounce", function(a) {
    return 1 - o(1 - a);
  }, o);
})(7.5625, 2.75);
kr("Expo", function(n) {
  return Math.pow(2, 10 * (n - 1)) * n + n * n * n * n * n * n * (1 - n);
});
kr("Circ", function(n) {
  return -(Nv(1 - n * n) - 1);
});
kr("Sine", function(n) {
  return n === 1 ? 1 : -Oy(n * xy) + 1;
});
kr("Back", Vs("in"), Vs("out"), Vs());
ie.SteppedEase = ie.steps = ot.SteppedEase = {
  config: function(e, t) {
    e === void 0 && (e = 1);
    var r = 1 / e, i = e + (t ? 0 : 1), o = t ? 1 : 0, a = 1 - pe;
    return function(s) {
      return ((i * Wn(0, a, s) | 0) + o) * r;
    };
  }
};
Zr.ease = ie["quad.out"];
Ye("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(n) {
  return Iu += n + "," + n + "Params,";
});
var lg = function(e, t) {
  this.id = Ay++, e._gsap = this, this.target = e, this.harness = t, this.get = t ? t.get : Uv, this.set = t ? t.getSetter : Mu;
}, Bn = /* @__PURE__ */ function() {
  function n(t) {
    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Qr(this, +t.duration, 1, 1), this.data = t.data, be && (this._ctx = be, be.data.push(this)), qn || tt.wake();
  }
  var e = n.prototype;
  return e.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, e.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, e.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, Qr(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, e.totalTime = function(r, i) {
    if (Jr(), !arguments.length)
      return this._tTime;
    var o = this._dp;
    if (o && o.smoothChildTiming && this._ts) {
      for (qi(this, r), !o._dp || o.parent || Vv(o, this); o && o.parent; )
        o.parent._time !== o._start + (o._ts >= 0 ? o._tTime / o._ts : (o.totalDuration() - o._tTime) / -o._ts) && o.totalTime(o._tTime, !0), o = o.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && wt(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !i || this._initted && Math.abs(this._zTime) === pe || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), jv(this, r, i)), this;
  }, e.time = function(r, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + Sh(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), i) : this._time;
  }, e.totalProgress = function(r, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, e.progress = function(r, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + Sh(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, e.iteration = function(r, i) {
    var o = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * o, i) : this._repeat ? Kr(this._tTime, o) + 1 : 1;
  }, e.timeScale = function(r, i) {
    if (!arguments.length)
      return this._rts === -pe ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var o = this.parent && this._ts ? vi(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -pe ? 0 : this._rts, this.totalTime(Wn(-Math.abs(this._delay), this.totalDuration(), o), i !== !1), Li(this), My(this);
  }, e.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Jr(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== pe && (this._tTime -= pe)))), this) : this._ps;
  }, e.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && wt(i, this, r - this._delay), this;
    }
    return this._start;
  }, e.endTime = function(r) {
    return this._start + (Ge(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, e.rawTime = function(r) {
    var i = this.parent || this._dp;
    return i ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? vi(i.rawTime(r), this) : this._tTime : this._tTime;
  }, e.revert = function(r) {
    r === void 0 && (r = ky);
    var i = Le;
    return Le = r, ku(this) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), Le = i, this;
  }, e.globalTime = function(r) {
    for (var i = this, o = arguments.length ? r : i.rawTime(); i; )
      o = i._start + o / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : o;
  }, e.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, xh(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, e.repeatDelay = function(r) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = r, xh(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, e.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, e.seek = function(r, i) {
    return this.totalTime(lt(this, r), Ge(i));
  }, e.restart = function(r, i) {
    return this.play().totalTime(r ? -this._delay : 0, Ge(i)), this._dur || (this._zTime = -pe), this;
  }, e.play = function(r, i) {
    return r != null && this.seek(r, i), this.reversed(!1).paused(!1);
  }, e.reverse = function(r, i) {
    return r != null && this.seek(r || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, e.pause = function(r, i) {
    return r != null && this.seek(r, i), this.paused(!0);
  }, e.resume = function() {
    return this.paused(!1);
  }, e.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -pe : 0)), this) : this._rts < 0;
  }, e.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -pe, this;
  }, e.isActive = function() {
    var r = this.parent || this._dp, i = this._start, o;
    return !!(!r || this._ts && this._initted && r.isActive() && (o = r.rawTime(!0)) >= i && o < this.endTime(!0) - pe);
  }, e.eventCallback = function(r, i, o) {
    var a = this.vars;
    return arguments.length > 1 ? (i ? (a[r] = i, o && (a[r + "Params"] = o), r === "onUpdate" && (this._onUpdate = i)) : delete a[r], this) : a[r];
  }, e.then = function(r) {
    var i = this;
    return new Promise(function(o) {
      var a = Se(r) ? r : $v, s = function() {
        var u = i.then;
        i.then = null, Se(a) && (a = a(i)) && (a.then || a === i) && (i.then = u), o(a), i.then = u;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? s() : i._prom = s;
    });
  }, e.kill = function() {
    hn(this);
  }, n;
}();
at(Bn.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -pe,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var je = /* @__PURE__ */ function(n) {
  Iv(e, n);
  function e(r, i) {
    var o;
    return r === void 0 && (r = {}), o = n.call(this, r) || this, o.labels = {}, o.smoothChildTiming = !!r.smoothChildTiming, o.autoRemoveChildren = !!r.autoRemoveChildren, o._sort = Ge(r.sortChildren), we && wt(r.parent || we, Dt(o), i), r.reversed && o.reverse(), r.paused && o.paused(!0), r.scrollTrigger && zv(Dt(o), r.scrollTrigger), o;
  }
  var t = e.prototype;
  return t.to = function(i, o, a) {
    return mn(0, arguments, this), this;
  }, t.from = function(i, o, a) {
    return mn(1, arguments, this), this;
  }, t.fromTo = function(i, o, a, s) {
    return mn(2, arguments, this), this;
  }, t.set = function(i, o, a) {
    return o.duration = 0, o.parent = this, gn(o).repeatDelay || (o.repeat = 0), o.immediateRender = !!o.immediateRender, new Ee(i, o, lt(this, a), 1), this;
  }, t.call = function(i, o, a) {
    return wt(this, Ee.delayedCall(0, i, o), a);
  }, t.staggerTo = function(i, o, a, s, l, u, c) {
    return a.duration = o, a.stagger = a.stagger || s, a.onComplete = u, a.onCompleteParams = c, a.parent = this, new Ee(i, a, lt(this, l)), this;
  }, t.staggerFrom = function(i, o, a, s, l, u, c) {
    return a.runBackwards = 1, gn(a).immediateRender = Ge(a.immediateRender), this.staggerTo(i, o, a, s, l, u, c);
  }, t.staggerFromTo = function(i, o, a, s, l, u, c, d) {
    return s.startAt = a, gn(s).immediateRender = Ge(s.immediateRender), this.staggerTo(i, o, s, l, u, c, d);
  }, t.render = function(i, o, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, c = i <= 0 ? 0 : Ie(i), d = this._zTime < 0 != i < 0 && (this._initted || !u), f, h, g, p, v, b, _, y, C, w, m, T;
    if (this !== we && c > l && i >= 0 && (c = l), c !== this._tTime || a || d) {
      if (s !== this._time && u && (c += this._time - s, i += this._time - s), f = c, C = this._start, y = this._ts, b = !y, d && (u || (s = this._zTime), (i || !o) && (this._zTime = i)), this._repeat) {
        if (m = this._yoyo, v = u + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(v * 100 + i, o, a);
        if (f = Ie(c % v), c === l ? (p = this._repeat, f = u) : (w = Ie(c / v), p = ~~w, p && p === w && (f = u, p--), f > u && (f = u)), w = Kr(this._tTime, v), !s && this._tTime && w !== p && this._tTime - w * v - this._dur <= 0 && (w = p), m && p & 1 && (f = u - f, T = 1), p !== w && !this._lock) {
          var x = m && w & 1, A = x === (m && p & 1);
          if (p < w && (x = !x), s = x ? 0 : c % u ? u : c, this._lock = 1, this.render(s || (T ? 0 : Ie(p * v)), o, !u)._lock = 0, this._tTime = c, !o && this.parent && rt(this, "onRepeat"), this.vars.repeatRefresh && !T && (this.invalidate()._lock = 1), s && s !== this._time || b !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, A && (this._lock = 2, s = x ? u : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !T && this.invalidate()), this._lock = 0, !this._ts && !b)
            return this;
          ag(this, T);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (_ = Uy(this, Ie(s), Ie(f)), _ && (c -= f - (f = _._start))), this._tTime = c, this._time = f, this._act = !y, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, s = 0), !s && c && !o && !w && (rt(this, "onStart"), this._tTime !== c))
        return this;
      if (f >= s && i >= 0)
        for (h = this._first; h; ) {
          if (g = h._next, (h._act || f >= h._start) && h._ts && _ !== h) {
            if (h.parent !== this)
              return this.render(i, o, a);
            if (h.render(h._ts > 0 ? (f - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (f - h._start) * h._ts, o, a), f !== this._time || !this._ts && !b) {
              _ = 0, g && (c += this._zTime = -pe);
              break;
            }
          }
          h = g;
        }
      else {
        h = this._last;
        for (var M = i < 0 ? i : f; h; ) {
          if (g = h._prev, (h._act || M <= h._end) && h._ts && _ !== h) {
            if (h.parent !== this)
              return this.render(i, o, a);
            if (h.render(h._ts > 0 ? (M - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (M - h._start) * h._ts, o, a || Le && ku(h)), f !== this._time || !this._ts && !b) {
              _ = 0, g && (c += this._zTime = M ? -pe : pe);
              break;
            }
          }
          h = g;
        }
      }
      if (_ && !o && (this.pause(), _.render(f >= s ? 0 : -pe)._zTime = f >= s ? 1 : -1, this._ts))
        return this._start = C, Li(this), this.render(i, o, a);
      this._onUpdate && !o && rt(this, "onUpdate", !0), (c === l && this._tTime >= this.totalDuration() || !c && s) && (C === this._start || Math.abs(y) !== Math.abs(this._ts)) && (this._lock || ((i || !u) && (c === l && this._ts > 0 || !c && this._ts < 0) && or(this, 1), !o && !(i < 0 && !s) && (c || s || !l) && (rt(this, c === l && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, t.add = function(i, o) {
    var a = this;
    if (jt(o) || (o = lt(this, o, i)), !(i instanceof Bn)) {
      if (Ue(i))
        return i.forEach(function(s) {
          return a.add(s, o);
        }), this;
      if (Re(i))
        return this.addLabel(i, o);
      if (Se(i))
        i = Ee.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? wt(this, i, o) : this;
  }, t.getChildren = function(i, o, a, s) {
    i === void 0 && (i = !0), o === void 0 && (o = !0), a === void 0 && (a = !0), s === void 0 && (s = -ct);
    for (var l = [], u = this._first; u; )
      u._start >= s && (u instanceof Ee ? o && l.push(u) : (a && l.push(u), i && l.push.apply(l, u.getChildren(!0, o, a)))), u = u._next;
    return l;
  }, t.getById = function(i) {
    for (var o = this.getChildren(1, 1, 1), a = o.length; a--; )
      if (o[a].vars.id === i)
        return o[a];
  }, t.remove = function(i) {
    return Re(i) ? this.removeLabel(i) : Se(i) ? this.killTweensOf(i) : (i.parent === this && Mi(this, i), i === this._recent && (this._recent = this._last), wr(this));
  }, t.totalTime = function(i, o) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Ie(tt.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), n.prototype.totalTime.call(this, i, o), this._forcing = 0, this) : this._tTime;
  }, t.addLabel = function(i, o) {
    return this.labels[i] = lt(this, o), this;
  }, t.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, t.addPause = function(i, o, a) {
    var s = Ee.delayedCall(0, o || Mn, a);
    return s.data = "isPause", this._hasPause = 1, wt(this, s, lt(this, i));
  }, t.removePause = function(i) {
    var o = this._first;
    for (i = lt(this, i); o; )
      o._start === i && o.data === "isPause" && or(o), o = o._next;
  }, t.killTweensOf = function(i, o, a) {
    for (var s = this.getTweensOf(i, a), l = s.length; l--; )
      Kt !== s[l] && s[l].kill(i, o);
    return this;
  }, t.getTweensOf = function(i, o) {
    for (var a = [], s = dt(i), l = this._first, u = jt(o), c; l; )
      l instanceof Ee ? Dy(l._targets, s) && (u ? (!Kt || l._initted && l._ts) && l.globalTime(0) <= o && l.globalTime(l.totalDuration()) > o : !o || l.isActive()) && a.push(l) : (c = l.getTweensOf(s, o)).length && a.push.apply(a, c), l = l._next;
    return a;
  }, t.tweenTo = function(i, o) {
    o = o || {};
    var a = this, s = lt(a, i), l = o, u = l.startAt, c = l.onStart, d = l.onStartParams, f = l.immediateRender, h, g = Ee.to(a, at({
      ease: o.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: o.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale()) || pe,
      onStart: function() {
        if (a.pause(), !h) {
          var v = o.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale());
          g._dur !== v && Qr(g, v, 0, 1).render(g._time, !0, !0), h = 1;
        }
        c && c.apply(g, d || []);
      }
    }, o));
    return f ? g.render(0) : g;
  }, t.tweenFromTo = function(i, o, a) {
    return this.tweenTo(o, at({
      startAt: {
        time: lt(this, i)
      }
    }, a));
  }, t.recent = function() {
    return this._recent;
  }, t.nextLabel = function(i) {
    return i === void 0 && (i = this._time), Ah(this, lt(this, i));
  }, t.previousLabel = function(i) {
    return i === void 0 && (i = this._time), Ah(this, lt(this, i), 1);
  }, t.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + pe);
  }, t.shiftChildren = function(i, o, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, u; s; )
      s._start >= a && (s._start += i, s._end += i), s = s._next;
    if (o)
      for (u in l)
        l[u] >= a && (l[u] += i);
    return wr(this);
  }, t.invalidate = function(i) {
    var o = this._first;
    for (this._lock = 0; o; )
      o.invalidate(i), o = o._next;
    return n.prototype.invalidate.call(this, i);
  }, t.clear = function(i) {
    i === void 0 && (i = !0);
    for (var o = this._first, a; o; )
      a = o._next, this.remove(o), o = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), wr(this);
  }, t.totalDuration = function(i) {
    var o = 0, a = this, s = a._last, l = ct, u, c, d;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -i : i));
    if (a._dirty) {
      for (d = a.parent; s; )
        u = s._prev, s._dirty && s.totalDuration(), c = s._start, c > l && a._sort && s._ts && !a._lock ? (a._lock = 1, wt(a, s, c - s._delay, 1)._lock = 0) : l = c, c < 0 && s._ts && (o -= c, (!d && !a._dp || d && d.smoothChildTiming) && (a._start += c / a._ts, a._time -= c, a._tTime -= c), a.shiftChildren(-c, !1, -1 / 0), l = 0), s._end > o && s._ts && (o = s._end), s = u;
      Qr(a, a === we && a._time > o ? a._time : o, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, e.updateRoot = function(i) {
    if (we._ts && (jv(we, vi(i, we)), Bv = tt.frame), tt.frame >= wh) {
      wh += it.autoSleep || 120;
      var o = we._first;
      if ((!o || !o._ts) && it.autoSleep && tt._listeners.length < 2) {
        for (; o && !o._ts; )
          o = o._next;
        o || tt.sleep();
      }
    }
  }, e;
}(Bn);
at(je.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var tC = function(e, t, r, i, o, a, s) {
  var l = new Ze(this._pt, e, t, 0, 1, pg, null, o), u = 0, c = 0, d, f, h, g, p, v, b, _;
  for (l.b = r, l.e = i, r += "", i += "", (b = ~i.indexOf("random(")) && (i = Ln(i)), a && (_ = [r, i], a(_, e, t), r = _[0], i = _[1]), f = r.match(js) || []; d = js.exec(i); )
    g = d[0], p = i.substring(u, d.index), h ? h = (h + 1) % 5 : p.substr(-5) === "rgba(" && (h = 1), g !== f[c++] && (v = parseFloat(f[c - 1]) || 0, l._pt = {
      _next: l._pt,
      p: p || c === 1 ? p : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: v,
      c: g.charAt(1) === "=" ? zr(v, g) - v : parseFloat(g) - v,
      m: h && h < 4 ? Math.round : 0
    }, u = js.lastIndex);
  return l.c = u < i.length ? i.substring(u, i.length) : "", l.fp = s, (Rv.test(i) || b) && (l.e = 0), this._pt = l, l;
}, Du = function(e, t, r, i, o, a, s, l, u, c) {
  Se(i) && (i = i(o || 0, e, a));
  var d = e[t], f = r !== "get" ? r : Se(d) ? u ? e[t.indexOf("set") || !Se(e["get" + t.substr(3)]) ? t : "get" + t.substr(3)](u) : e[t]() : d, h = Se(d) ? u ? aC : fg : Pu, g;
  if (Re(i) && (~i.indexOf("random(") && (i = Ln(i)), i.charAt(1) === "=" && (g = zr(f, i) + (Be(f) || 0), (g || g === 0) && (i = g))), !c || f !== i || Hl)
    return !isNaN(f * i) && i !== "" ? (g = new Ze(this._pt, e, t, +f || 0, i - (f || 0), typeof d == "boolean" ? lC : hg, 0, h), u && (g.fp = u), s && g.modifier(s, this, e), this._pt = g) : (!d && !(t in e) && Ou(t, i), tC.call(this, e, t, f, i, h, l || it.stringFilter, u));
}, rC = function(e, t, r, i, o) {
  if (Se(e) && (e = _n(e, o, t, r, i)), !Ot(e) || e.style && e.nodeType || Ue(e) || kv(e))
    return Re(e) ? _n(e, o, t, r, i) : e;
  var a = {}, s;
  for (s in e)
    a[s] = _n(e[s], o, t, r, i);
  return a;
}, ug = function(e, t, r, i, o, a) {
  var s, l, u, c;
  if (Je[e] && (s = new Je[e]()).init(o, s.rawVars ? t[e] : rC(t[e], i, o, a, r), r, i, a) !== !1 && (r._pt = l = new Ze(r._pt, o, e, 0, 1, s.render, s, 0, s.priority), r !== jr))
    for (u = r._ptLookup[r._targets.indexOf(o)], c = s._props.length; c--; )
      u[s._props[c]] = l;
  return s;
}, Kt, Hl, Ru = function n(e, t, r) {
  var i = e.vars, o = i.ease, a = i.startAt, s = i.immediateRender, l = i.lazy, u = i.onUpdate, c = i.runBackwards, d = i.yoyoEase, f = i.keyframes, h = i.autoRevert, g = e._dur, p = e._startAt, v = e._targets, b = e.parent, _ = b && b.data === "nested" ? b.vars.targets : v, y = e._overwrite === "auto" && !Tu, C = e.timeline, w, m, T, x, A, M, O, S, P, N, E, L, H;
  if (C && (!f || !o) && (o = "none"), e._ease = Tr(o, Zr.ease), e._yEase = d ? og(Tr(d === !0 ? o : d, Zr.ease)) : 0, d && e._yoyo && !e._repeat && (d = e._yEase, e._yEase = e._ease, e._ease = d), e._from = !C && !!i.runBackwards, !C || f && !i.stagger) {
    if (S = v[0] ? Cr(v[0]).harness : 0, L = S && i[S.prop], w = pi(i, Eu), p && (p._zTime < 0 && p.progress(1), t < 0 && c && s && !h ? p.render(-1, !0) : p.revert(c && g ? ni : Ny), p._lazy = 0), a) {
      if (or(e._startAt = Ee.set(v, at({
        data: "isStart",
        overwrite: !1,
        parent: b,
        immediateRender: !0,
        lazy: !p && Ge(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return rt(e, "onUpdate");
        },
        stagger: 0
      }, a))), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Le || !s && !h) && e._startAt.revert(ni), s && g && t <= 0 && r <= 0) {
        t && (e._zTime = t);
        return;
      }
    } else if (c && g && !p) {
      if (t && (s = !1), T = at({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !p && Ge(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: b
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, w), L && (T[S.prop] = L), or(e._startAt = Ee.set(v, T)), e._startAt._dp = 0, e._startAt._sat = e, t < 0 && (Le ? e._startAt.revert(ni) : e._startAt.render(-1, !0)), e._zTime = t, !s)
        n(e._startAt, pe, pe);
      else if (!t)
        return;
    }
    for (e._pt = e._ptCache = 0, l = g && Ge(l) || l && !g, m = 0; m < v.length; m++) {
      if (A = v[m], O = A._gsap || Nu(v)[m]._gsap, e._ptLookup[m] = N = {}, Ml[O.id] && tr.length && hi(), E = _ === v ? m : _.indexOf(A), S && (P = new S()).init(A, L || w, e, E, _) !== !1 && (e._pt = x = new Ze(e._pt, A, P.name, 0, 1, P.render, P, 0, P.priority), P._props.forEach(function(z) {
        N[z] = x;
      }), P.priority && (M = 1)), !S || L)
        for (T in w)
          Je[T] && (P = ug(T, w, e, E, A, _)) ? P.priority && (M = 1) : N[T] = x = Du.call(e, A, T, "get", w[T], E, _, 0, i.stringFilter);
      e._op && e._op[m] && e.kill(A, e._op[m]), y && e._pt && (Kt = e, we.killTweensOf(A, N, e.globalTime(t)), H = !e.parent, Kt = 0), e._pt && l && (Ml[O.id] = 1);
    }
    M && vg(e), e._onInit && e._onInit(e);
  }
  e._onUpdate = u, e._initted = (!e._op || e._pt) && !H, f && t <= 0 && C.render(ct, !0, !0);
}, nC = function(e, t, r, i, o, a, s, l) {
  var u = (e._pt && e._ptCache || (e._ptCache = {}))[t], c, d, f, h;
  if (!u)
    for (u = e._ptCache[t] = [], f = e._ptLookup, h = e._targets.length; h--; ) {
      if (c = f[h][t], c && c.d && c.d._pt)
        for (c = c.d._pt; c && c.p !== t && c.fp !== t; )
          c = c._next;
      if (!c)
        return Hl = 1, e.vars[t] = "+=0", Ru(e, s), Hl = 0, l ? Pn(t + " not eligible for reset") : 1;
      u.push(c);
    }
  for (h = u.length; h--; )
    d = u[h], c = d._pt || d, c.s = (i || i === 0) && !o ? i : c.s + (i || 0) + a * c.c, c.c = r - c.s, d.e && (d.e = xe(r) + Be(d.e)), d.b && (d.b = c.s + Be(d.b));
}, iC = function(e, t) {
  var r = e[0] ? Cr(e[0]).harness : 0, i = r && r.aliases, o, a, s, l;
  if (!i)
    return t;
  o = Xr({}, t);
  for (a in i)
    if (a in o)
      for (l = i[a].split(","), s = l.length; s--; )
        o[l[s]] = o[a];
  return o;
}, oC = function(e, t, r, i) {
  var o = t.ease || i || "power1.inOut", a, s;
  if (Ue(t))
    s = r[e] || (r[e] = []), t.forEach(function(l, u) {
      return s.push({
        t: u / (t.length - 1) * 100,
        v: l,
        e: o
      });
    });
  else
    for (a in t)
      s = r[a] || (r[a] = []), a === "ease" || s.push({
        t: parseFloat(e),
        v: t[a],
        e: o
      });
}, _n = function(e, t, r, i, o) {
  return Se(e) ? e.call(t, r, i, o) : Re(e) && ~e.indexOf("random(") ? Ln(e) : e;
}, cg = Iu + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", dg = {};
Ye(cg + ",id,stagger,delay,duration,paused,scrollTrigger", function(n) {
  return dg[n] = 1;
});
var Ee = /* @__PURE__ */ function(n) {
  Iv(e, n);
  function e(r, i, o, a) {
    var s;
    typeof i == "number" && (o.duration = i, i = o, o = null), s = n.call(this, a ? i : gn(i)) || this;
    var l = s.vars, u = l.duration, c = l.delay, d = l.immediateRender, f = l.stagger, h = l.overwrite, g = l.keyframes, p = l.defaults, v = l.scrollTrigger, b = l.yoyoEase, _ = i.parent || we, y = (Ue(r) || kv(r) ? jt(r[0]) : "length" in i) ? [r] : dt(r), C, w, m, T, x, A, M, O;
    if (s._targets = y.length ? Nu(y) : Pn("GSAP target " + r + " not found. https://gsap.com", !it.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = h, g || f || Jn(u) || Jn(c)) {
      if (i = s.vars, C = s.timeline = new je({
        data: "nested",
        defaults: p || {},
        targets: _ && _.data === "nested" ? _.vars.targets : y
      }), C.kill(), C.parent = C._dp = Dt(s), C._start = 0, f || Jn(u) || Jn(c)) {
        if (T = y.length, M = f && Zv(f), Ot(f))
          for (x in f)
            ~cg.indexOf(x) && (O || (O = {}), O[x] = f[x]);
        for (w = 0; w < T; w++)
          m = pi(i, dg), m.stagger = 0, b && (m.yoyoEase = b), O && Xr(m, O), A = y[w], m.duration = +_n(u, Dt(s), w, A, y), m.delay = (+_n(c, Dt(s), w, A, y) || 0) - s._delay, !f && T === 1 && m.delay && (s._delay = c = m.delay, s._start += c, m.delay = 0), C.to(A, m, M ? M(w, A, y) : 0), C._ease = ie.none;
        C.duration() ? u = c = 0 : s.timeline = 0;
      } else if (g) {
        gn(at(C.vars.defaults, {
          ease: "none"
        })), C._ease = Tr(g.ease || i.ease || "none");
        var S = 0, P, N, E;
        if (Ue(g))
          g.forEach(function(L) {
            return C.to(y, L, ">");
          }), C.duration();
        else {
          m = {};
          for (x in g)
            x === "ease" || x === "easeEach" || oC(x, g[x], m, g.easeEach);
          for (x in m)
            for (P = m[x].sort(function(L, H) {
              return L.t - H.t;
            }), S = 0, w = 0; w < P.length; w++)
              N = P[w], E = {
                ease: N.e,
                duration: (N.t - (w ? P[w - 1].t : 0)) / 100 * u
              }, E[x] = N.v, C.to(y, E, S), S += E.duration;
          C.duration() < u && C.to({}, {
            duration: u - C.duration()
          });
        }
      }
      u || s.duration(u = C.duration());
    } else
      s.timeline = 0;
    return h === !0 && !Tu && (Kt = Dt(s), we.killTweensOf(y), Kt = 0), wt(_, Dt(s), o), i.reversed && s.reverse(), i.paused && s.paused(!0), (d || !u && !g && s._start === Ie(_._time) && Ge(d) && Ly(Dt(s)) && _.data !== "nested") && (s._tTime = -pe, s.render(Math.max(0, -c) || 0)), v && zv(Dt(s), v), s;
  }
  var t = e.prototype;
  return t.render = function(i, o, a) {
    var s = this._time, l = this._tDur, u = this._dur, c = i < 0, d = i > l - pe && !c ? l : i < pe ? 0 : i, f, h, g, p, v, b, _, y, C;
    if (!u)
      By(this, i, o, a);
    else if (d !== this._tTime || !i || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c || this._lazy) {
      if (f = d, y = this.timeline, this._repeat) {
        if (p = u + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(p * 100 + i, o, a);
        if (f = Ie(d % p), d === l ? (g = this._repeat, f = u) : (v = Ie(d / p), g = ~~v, g && g === v ? (f = u, g--) : f > u && (f = u)), b = this._yoyo && g & 1, b && (C = this._yEase, f = u - f), v = Kr(this._tTime, p), f === s && !a && this._initted && g === v)
          return this._tTime = d, this;
        g !== v && (y && this._yEase && ag(y, b), this.vars.repeatRefresh && !b && !this._lock && f !== p && this._initted && (this._lock = a = 1, this.render(Ie(p * g), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Wv(this, c ? i : f, a, o, d))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && g !== v))
          return this;
        if (u !== this._dur)
          return this.render(i, o, a);
      }
      if (this._tTime = d, this._time = f, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = _ = (C || this._ease)(f / u), this._from && (this.ratio = _ = 1 - _), !s && d && !o && !v && (rt(this, "onStart"), this._tTime !== d))
        return this;
      for (h = this._pt; h; )
        h.r(_, h.d), h = h._next;
      y && y.render(i < 0 ? i : y._dur * y._ease(f / this._dur), o, a) || this._startAt && (this._zTime = i), this._onUpdate && !o && (c && Ll(this, i, o, a), rt(this, "onUpdate")), this._repeat && g !== v && this.vars.onRepeat && !o && this.parent && rt(this, "onRepeat"), (d === this._tDur || !d) && this._tTime === d && (c && !this._onUpdate && Ll(this, i, !0, !0), (i || !u) && (d === this._tDur && this._ts > 0 || !d && this._ts < 0) && or(this, 1), !o && !(c && !s) && (d || s || b) && (rt(this, d === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(d < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, t.targets = function() {
    return this._targets;
  }, t.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), n.prototype.invalidate.call(this, i);
  }, t.resetTo = function(i, o, a, s, l) {
    qn || tt.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), c;
    return this._initted || Ru(this, u), c = this._ease(u / this._dur), nC(this, i, o, a, s, c, u, l) ? this.resetTo(i, o, a, s, 1) : (qi(this, 0), this.parent || Fv(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, t.kill = function(i, o) {
    if (o === void 0 && (o = "all"), !i && (!o || o === "all"))
      return this._lazy = this._pt = 0, this.parent ? hn(this) : this.scrollTrigger && this.scrollTrigger.kill(!!Le), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, o, Kt && Kt.vars.overwrite !== !0)._first || hn(this), this.parent && a !== this.timeline.totalDuration() && Qr(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = i ? dt(i) : s, u = this._ptLookup, c = this._pt, d, f, h, g, p, v, b;
    if ((!o || o === "all") && Py(s, l))
      return o === "all" && (this._pt = 0), hn(this);
    for (d = this._op = this._op || [], o !== "all" && (Re(o) && (p = {}, Ye(o, function(_) {
      return p[_] = 1;
    }), o = p), o = iC(s, o)), b = s.length; b--; )
      if (~l.indexOf(s[b])) {
        f = u[b], o === "all" ? (d[b] = o, g = f, h = {}) : (h = d[b] = d[b] || {}, g = o);
        for (p in g)
          v = f && f[p], v && ((!("kill" in v.d) || v.d.kill(p) === !0) && Mi(this, v, "_pt"), delete f[p]), h !== "all" && (h[p] = 1);
      }
    return this._initted && !this._pt && c && hn(this), this;
  }, e.to = function(i, o) {
    return new e(i, o, arguments[2]);
  }, e.from = function(i, o) {
    return mn(1, arguments);
  }, e.delayedCall = function(i, o, a, s) {
    return new e(o, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: o,
      onReverseComplete: o,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, e.fromTo = function(i, o, a) {
    return mn(2, arguments);
  }, e.set = function(i, o) {
    return o.duration = 0, o.repeatDelay || (o.repeat = 0), new e(i, o);
  }, e.killTweensOf = function(i, o, a) {
    return we.killTweensOf(i, o, a);
  }, e;
}(Bn);
at(Ee.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Ye("staggerTo,staggerFrom,staggerFromTo", function(n) {
  Ee[n] = function() {
    var e = new je(), t = Bl.call(arguments, 0);
    return t.splice(n === "staggerFromTo" ? 5 : 4, 0, 0), e[n].apply(e, t);
  };
});
var Pu = function(e, t, r) {
  return e[t] = r;
}, fg = function(e, t, r) {
  return e[t](r);
}, aC = function(e, t, r, i) {
  return e[t](i.fp, r);
}, sC = function(e, t, r) {
  return e.setAttribute(t, r);
}, Mu = function(e, t) {
  return Se(e[t]) ? fg : Su(e[t]) && e.setAttribute ? sC : Pu;
}, hg = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e6) / 1e6, t);
}, lC = function(e, t) {
  return t.set(t.t, t.p, !!(t.s + t.c * e), t);
}, pg = function(e, t) {
  var r = t._pt, i = "";
  if (!e && t.b)
    i = t.b;
  else if (e === 1 && t.e)
    i = t.e;
  else {
    for (; r; )
      i = r.p + (r.m ? r.m(r.s + r.c * e) : Math.round((r.s + r.c * e) * 1e4) / 1e4) + i, r = r._next;
    i += t.c;
  }
  t.set(t.t, t.p, i, t);
}, Lu = function(e, t) {
  for (var r = t._pt; r; )
    r.r(e, r.d), r = r._next;
}, uC = function(e, t, r, i) {
  for (var o = this._pt, a; o; )
    a = o._next, o.p === i && o.modifier(e, t, r), o = a;
}, cC = function(e) {
  for (var t = this._pt, r, i; t; )
    i = t._next, t.p === e && !t.op || t.op === e ? Mi(this, t, "_pt") : t.dep || (r = 1), t = i;
  return !r;
}, dC = function(e, t, r, i) {
  i.mSet(e, t, i.m.call(i.tween, r, i.mt), i);
}, vg = function(e) {
  for (var t = e._pt, r, i, o, a; t; ) {
    for (r = t._next, i = o; i && i.pr > t.pr; )
      i = i._next;
    (t._prev = i ? i._prev : a) ? t._prev._next = t : o = t, (t._next = i) ? i._prev = t : a = t, t = r;
  }
  e._pt = o;
}, Ze = /* @__PURE__ */ function() {
  function n(t, r, i, o, a, s, l, u, c) {
    this.t = r, this.s = o, this.c = a, this.p = i, this.r = s || hg, this.d = l || this, this.set = u || Pu, this.pr = c || 0, this._next = t, t && (t._prev = this);
  }
  var e = n.prototype;
  return e.modifier = function(r, i, o) {
    this.mSet = this.mSet || this.set, this.set = dC, this.m = r, this.mt = o, this.tween = i;
  }, n;
}();
Ye(Iu + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(n) {
  return Eu[n] = 1;
});
ot.TweenMax = ot.TweenLite = Ee;
ot.TimelineLite = ot.TimelineMax = je;
we = new je({
  sortChildren: !1,
  defaults: Zr,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
it.stringFilter = ig;
var Sr = [], oi = {}, fC = [], Eh = 0, hC = 0, zs = function(e) {
  return (oi[e] || fC).map(function(t) {
    return t();
  });
}, $l = function() {
  var e = Date.now(), t = [];
  e - Eh > 2 && (zs("matchMediaInit"), Sr.forEach(function(r) {
    var i = r.queries, o = r.conditions, a, s, l, u;
    for (s in i)
      a = yt.matchMedia(i[s]).matches, a && (l = 1), a !== o[s] && (o[s] = a, u = 1);
    u && (r.revert(), l && t.push(r));
  }), zs("matchMediaRevert"), t.forEach(function(r) {
    return r.onMatch(r, function(i) {
      return r.add(null, i);
    });
  }), Eh = e, zs("matchMedia"));
}, gg = /* @__PURE__ */ function() {
  function n(t, r) {
    this.selector = r && Ul(r), this.data = [], this._r = [], this.isReverted = !1, this.id = hC++, t && this.add(t);
  }
  var e = n.prototype;
  return e.add = function(r, i, o) {
    Se(r) && (o = i, i = r, r = Se);
    var a = this, s = function() {
      var u = be, c = a.selector, d;
      return u && u !== a && u.data.push(a), o && (a.selector = Ul(o)), be = a, d = i.apply(a, arguments), Se(d) && a._r.push(d), be = u, a.selector = c, a.isReverted = !1, d;
    };
    return a.last = s, r === Se ? s(a, function(l) {
      return a.add(null, l);
    }) : r ? a[r] = s : s;
  }, e.ignore = function(r) {
    var i = be;
    be = null, r(this), be = i;
  }, e.getTweens = function() {
    var r = [];
    return this.data.forEach(function(i) {
      return i instanceof n ? r.push.apply(r, i.getTweens()) : i instanceof Ee && !(i.parent && i.parent.data === "nested") && r.push(i);
    }), r;
  }, e.clear = function() {
    this._r.length = this.data.length = 0;
  }, e.kill = function(r, i) {
    var o = this;
    if (r ? function() {
      for (var s = o.getTweens(), l = o.data.length, u; l--; )
        u = o.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(c) {
          return s.splice(s.indexOf(c), 1);
        }));
      for (s.map(function(c) {
        return {
          g: c._dur || c._delay || c._sat && !c._sat.vars.immediateRender ? c.globalTime(0) : -1 / 0,
          t: c
        };
      }).sort(function(c, d) {
        return d.g - c.g || -1 / 0;
      }).forEach(function(c) {
        return c.t.revert(r);
      }), l = o.data.length; l--; )
        u = o.data[l], u instanceof je ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof Ee) && u.revert && u.revert(r);
      o._r.forEach(function(c) {
        return c(r, o);
      }), o.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), i)
      for (var a = Sr.length; a--; )
        Sr[a].id === this.id && Sr.splice(a, 1);
  }, e.revert = function(r) {
    this.kill(r || {});
  }, n;
}(), pC = /* @__PURE__ */ function() {
  function n(t) {
    this.contexts = [], this.scope = t, be && be.data.push(this);
  }
  var e = n.prototype;
  return e.add = function(r, i, o) {
    Ot(r) || (r = {
      matches: r
    });
    var a = new gg(0, o || this.scope), s = a.conditions = {}, l, u, c;
    be && !a.selector && (a.selector = be.selector), this.contexts.push(a), i = a.add("onMatch", i), a.queries = r;
    for (u in r)
      u === "all" ? c = 1 : (l = yt.matchMedia(r[u]), l && (Sr.indexOf(a) < 0 && Sr.push(a), (s[u] = l.matches) && (c = 1), l.addListener ? l.addListener($l) : l.addEventListener("change", $l)));
    return c && i(a, function(d) {
      return a.add(null, d);
    }), this;
  }, e.revert = function(r) {
    this.kill(r || {});
  }, e.kill = function(r) {
    this.contexts.forEach(function(i) {
      return i.kill(r, !0);
    });
  }, n;
}(), gi = {
  registerPlugin: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    t.forEach(function(i) {
      return tg(i);
    });
  },
  timeline: function(e) {
    return new je(e);
  },
  getTweensOf: function(e, t) {
    return we.getTweensOf(e, t);
  },
  getProperty: function(e, t, r, i) {
    Re(e) && (e = dt(e)[0]);
    var o = Cr(e || {}).get, a = r ? $v : Hv;
    return r === "native" && (r = ""), e && (t ? a((Je[t] && Je[t].get || o)(e, t, r, i)) : function(s, l, u) {
      return a((Je[s] && Je[s].get || o)(e, s, l, u));
    });
  },
  quickSetter: function(e, t, r) {
    if (e = dt(e), e.length > 1) {
      var i = e.map(function(c) {
        return Ke.quickSetter(c, t, r);
      }), o = i.length;
      return function(c) {
        for (var d = o; d--; )
          i[d](c);
      };
    }
    e = e[0] || {};
    var a = Je[t], s = Cr(e), l = s.harness && (s.harness.aliases || {})[t] || t, u = a ? function(c) {
      var d = new a();
      jr._pt = 0, d.init(e, r ? c + r : c, jr, 0, [e]), d.render(1, d), jr._pt && Lu(1, jr);
    } : s.set(e, l);
    return a ? u : function(c) {
      return u(e, l, r ? c + r : c, s, 1);
    };
  },
  quickTo: function(e, t, r) {
    var i, o = Ke.to(e, at((i = {}, i[t] = "+=0.1", i.paused = !0, i.stagger = 0, i), r || {})), a = function(l, u, c) {
      return o.resetTo(t, l, u, c);
    };
    return a.tween = o, a;
  },
  isTweening: function(e) {
    return we.getTweensOf(e, !0).length > 0;
  },
  defaults: function(e) {
    return e && e.ease && (e.ease = Tr(e.ease, Zr.ease)), Th(Zr, e || {});
  },
  config: function(e) {
    return Th(it, e || {});
  },
  registerEffect: function(e) {
    var t = e.name, r = e.effect, i = e.plugins, o = e.defaults, a = e.extendTimeline;
    (i || "").split(",").forEach(function(s) {
      return s && !Je[s] && !ot[s] && Pn(t + " effect requires " + s + " plugin.");
    }), Hs[t] = function(s, l, u) {
      return r(dt(s), at(l || {}, o), u);
    }, a && (je.prototype[t] = function(s, l, u) {
      return this.add(Hs[t](s, Ot(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(e, t) {
    ie[e] = Tr(t);
  },
  parseEase: function(e, t) {
    return arguments.length ? Tr(e, t) : ie;
  },
  getById: function(e) {
    return we.getById(e);
  },
  exportRoot: function(e, t) {
    e === void 0 && (e = {});
    var r = new je(e), i, o;
    for (r.smoothChildTiming = Ge(e.smoothChildTiming), we.remove(r), r._dp = 0, r._time = r._tTime = we._time, i = we._first; i; )
      o = i._next, (t || !(!i._dur && i instanceof Ee && i.vars.onComplete === i._targets[0])) && wt(r, i, i._start - i._delay), i = o;
    return wt(we, r, 0), r;
  },
  context: function(e, t) {
    return e ? new gg(e, t) : be;
  },
  matchMedia: function(e) {
    return new pC(e);
  },
  matchMediaRefresh: function() {
    return Sr.forEach(function(e) {
      var t = e.conditions, r, i;
      for (i in t)
        t[i] && (t[i] = !1, r = 1);
      r && e.revert();
    }) || $l();
  },
  addEventListener: function(e, t) {
    var r = oi[e] || (oi[e] = []);
    ~r.indexOf(t) || r.push(t);
  },
  removeEventListener: function(e, t) {
    var r = oi[e], i = r && r.indexOf(t);
    i >= 0 && r.splice(i, 1);
  },
  utils: {
    wrap: Wy,
    wrapYoyo: Gy,
    distribute: Zv,
    random: Kv,
    snap: Xv,
    normalize: zy,
    getUnit: Be,
    clamp: Hy,
    splitColor: rg,
    toArray: dt,
    selector: Ul,
    mapRange: Jv,
    pipe: Fy,
    unitize: Vy,
    interpolate: Yy,
    shuffle: Yv
  },
  install: Lv,
  effects: Hs,
  ticker: tt,
  updateRoot: je.updateRoot,
  plugins: Je,
  globalTimeline: we,
  core: {
    PropTween: Ze,
    globals: qv,
    Tween: Ee,
    Timeline: je,
    Animation: Bn,
    getCache: Cr,
    _removeLinkedListItem: Mi,
    reverting: function() {
      return Le;
    },
    context: function(e) {
      return e && be && (be.data.push(e), e._ctx = be), be;
    },
    suppressOverwrites: function(e) {
      return Tu = e;
    }
  }
};
Ye("to,from,fromTo,delayedCall,set,killTweensOf", function(n) {
  return gi[n] = Ee[n];
});
tt.add(je.updateRoot);
jr = gi.to({}, {
  duration: 0
});
var vC = function(e, t) {
  for (var r = e._pt; r && r.p !== t && r.op !== t && r.fp !== t; )
    r = r._next;
  return r;
}, gC = function(e, t) {
  var r = e._targets, i, o, a;
  for (i in t)
    for (o = r.length; o--; )
      a = e._ptLookup[o][i], a && (a = a.d) && (a._pt && (a = vC(a, i)), a && a.modifier && a.modifier(t[i], e, r[o], i));
}, Ws = function(e, t) {
  return {
    name: e,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, o, a) {
      a._onInit = function(s) {
        var l, u;
        if (Re(o) && (l = {}, Ye(o, function(c) {
          return l[c] = 1;
        }), o = l), t) {
          l = {};
          for (u in o)
            l[u] = t(o[u]);
          o = l;
        }
        gC(s, o);
      };
    }
  };
}, Ke = gi.registerPlugin({
  name: "attr",
  init: function(e, t, r, i, o) {
    var a, s, l;
    this.tween = r;
    for (a in t)
      l = e.getAttribute(a) || "", s = this.add(e, "setAttribute", (l || 0) + "", t[a], i, o, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(e, t) {
    for (var r = t._pt; r; )
      Le ? r.set(r.t, r.p, r.b, r) : r.r(e, r.d), r = r._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(e, t) {
    for (var r = t.length; r--; )
      this.add(e, r, e[r] || 0, t[r], 0, 0, 0, 0, 0, 1);
  }
}, Ws("roundProps", jl), Ws("modifiers"), Ws("snap", Xv)) || gi;
Ee.version = je.version = Ke.version = "3.13.0";
Mv = 1;
xu() && Jr();
ie.Power0;
ie.Power1;
ie.Power2;
ie.Power3;
ie.Power4;
ie.Linear;
ie.Quad;
ie.Cubic;
ie.Quart;
ie.Quint;
ie.Strong;
ie.Elastic;
ie.Back;
ie.SteppedEase;
ie.Bounce;
ie.Sine;
ie.Expo;
ie.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Ih, Qt, Wr, qu, br, Nh, Bu, mC = function() {
  return typeof window < "u";
}, Ht = {}, gr = 180 / Math.PI, Gr = Math.PI / 180, Mr = Math.atan2, kh = 1e8, Uu = /([A-Z])/g, _C = /(left|right|width|margin|padding|x)/i, bC = /[\s,\(]\S/, Tt = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, Fl = function(e, t) {
  return t.set(t.t, t.p, Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, yC = function(e, t) {
  return t.set(t.t, t.p, e === 1 ? t.e : Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u, t);
}, CC = function(e, t) {
  return t.set(t.t, t.p, e ? Math.round((t.s + t.c * e) * 1e4) / 1e4 + t.u : t.b, t);
}, wC = function(e, t) {
  var r = t.s + t.c * e;
  t.set(t.t, t.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + t.u, t);
}, mg = function(e, t) {
  return t.set(t.t, t.p, e ? t.e : t.b, t);
}, _g = function(e, t) {
  return t.set(t.t, t.p, e !== 1 ? t.b : t.e, t);
}, TC = function(e, t, r) {
  return e.style[t] = r;
}, SC = function(e, t, r) {
  return e.style.setProperty(t, r);
}, xC = function(e, t, r) {
  return e._gsap[t] = r;
}, AC = function(e, t, r) {
  return e._gsap.scaleX = e._gsap.scaleY = r;
}, OC = function(e, t, r, i, o) {
  var a = e._gsap;
  a.scaleX = a.scaleY = r, a.renderTransform(o, a);
}, EC = function(e, t, r, i, o) {
  var a = e._gsap;
  a[t] = r, a.renderTransform(o, a);
}, Te = "transform", Xe = Te + "Origin", IC = function n(e, t) {
  var r = this, i = this.target, o = i.style, a = i._gsap;
  if (e in Ht && o) {
    if (this.tfm = this.tfm || {}, e !== "transform")
      e = Tt[e] || e, ~e.indexOf(",") ? e.split(",").forEach(function(s) {
        return r.tfm[s] = Rt(i, s);
      }) : this.tfm[e] = a.x ? a[e] : Rt(i, e), e === Xe && (this.tfm.zOrigin = a.zOrigin);
    else
      return Tt.transform.split(",").forEach(function(s) {
        return n.call(r, s, t);
      });
    if (this.props.indexOf(Te) >= 0)
      return;
    a.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Xe, t, "")), e = Te;
  }
  (o || t) && this.props.push(e, t, o[e]);
}, bg = function(e) {
  e.translate && (e.removeProperty("translate"), e.removeProperty("scale"), e.removeProperty("rotate"));
}, NC = function() {
  var e = this.props, t = this.target, r = t.style, i = t._gsap, o, a;
  for (o = 0; o < e.length; o += 3)
    e[o + 1] ? e[o + 1] === 2 ? t[e[o]](e[o + 2]) : t[e[o]] = e[o + 2] : e[o + 2] ? r[e[o]] = e[o + 2] : r.removeProperty(e[o].substr(0, 2) === "--" ? e[o] : e[o].replace(Uu, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      i[a] = this.tfm[a];
    i.svg && (i.renderTransform(), t.setAttribute("data-svg-origin", this.svgo || "")), o = Bu(), (!o || !o.isStart) && !r[Te] && (bg(r), i.zOrigin && r[Xe] && (r[Xe] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, yg = function(e, t) {
  var r = {
    target: e,
    props: [],
    revert: NC,
    save: IC
  };
  return e._gsap || Ke.core.getCache(e), t && e.style && e.nodeType && t.split(",").forEach(function(i) {
    return r.save(i);
  }), r;
}, Cg, Vl = function(e, t) {
  var r = Qt.createElementNS ? Qt.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e) : Qt.createElement(e);
  return r && r.style ? r : Qt.createElement(e);
}, ft = function n(e, t, r) {
  var i = getComputedStyle(e);
  return i[t] || i.getPropertyValue(t.replace(Uu, "-$1").toLowerCase()) || i.getPropertyValue(t) || !r && n(e, en(t) || t, 1) || "";
}, Dh = "O,Moz,ms,Ms,Webkit".split(","), en = function(e, t, r) {
  var i = t || br, o = i.style, a = 5;
  if (e in o && !r)
    return e;
  for (e = e.charAt(0).toUpperCase() + e.substr(1); a-- && !(Dh[a] + e in o); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? Dh[a] : "") + e;
}, zl = function() {
  mC() && window.document && (Ih = window, Qt = Ih.document, Wr = Qt.documentElement, br = Vl("div") || {
    style: {}
  }, Vl("div"), Te = en(Te), Xe = Te + "Origin", br.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Cg = !!en("perspective"), Bu = Ke.core.reverting, qu = 1);
}, Rh = function(e) {
  var t = e.ownerSVGElement, r = Vl("svg", t && t.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = e.cloneNode(!0), o;
  i.style.display = "block", r.appendChild(i), Wr.appendChild(r);
  try {
    o = i.getBBox();
  } catch {
  }
  return r.removeChild(i), Wr.removeChild(r), o;
}, Ph = function(e, t) {
  for (var r = t.length; r--; )
    if (e.hasAttribute(t[r]))
      return e.getAttribute(t[r]);
}, wg = function(e) {
  var t, r;
  try {
    t = e.getBBox();
  } catch {
    t = Rh(e), r = 1;
  }
  return t && (t.width || t.height) || r || (t = Rh(e)), t && !t.width && !t.x && !t.y ? {
    x: +Ph(e, ["x", "cx", "x1"]) || 0,
    y: +Ph(e, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : t;
}, Tg = function(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && wg(e));
}, Ir = function(e, t) {
  if (t) {
    var r = e.style, i;
    t in Ht && t !== Xe && (t = Te), r.removeProperty ? (i = t.substr(0, 2), (i === "ms" || t.substr(0, 6) === "webkit") && (t = "-" + t), r.removeProperty(i === "--" ? t : t.replace(Uu, "-$1").toLowerCase())) : r.removeAttribute(t);
  }
}, Jt = function(e, t, r, i, o, a) {
  var s = new Ze(e._pt, t, r, 0, 1, a ? _g : mg);
  return e._pt = s, s.b = i, s.e = o, e._props.push(r), s;
}, Mh = {
  deg: 1,
  rad: 1,
  turn: 1
}, kC = {
  grid: 1,
  flex: 1
}, ar = function n(e, t, r, i) {
  var o = parseFloat(r) || 0, a = (r + "").trim().substr((o + "").length) || "px", s = br.style, l = _C.test(t), u = e.tagName.toLowerCase() === "svg", c = (u ? "client" : "offset") + (l ? "Width" : "Height"), d = 100, f = i === "px", h = i === "%", g, p, v, b;
  if (i === a || !o || Mh[i] || Mh[a])
    return o;
  if (a !== "px" && !f && (o = n(e, t, r, "px")), b = e.getCTM && Tg(e), (h || a === "%") && (Ht[t] || ~t.indexOf("adius")))
    return g = b ? e.getBBox()[l ? "width" : "height"] : e[c], xe(h ? o / g * d : o / 100 * g);
  if (s[l ? "width" : "height"] = d + (f ? a : i), p = i !== "rem" && ~t.indexOf("adius") || i === "em" && e.appendChild && !u ? e : e.parentNode, b && (p = (e.ownerSVGElement || {}).parentNode), (!p || p === Qt || !p.appendChild) && (p = Qt.body), v = p._gsap, v && h && v.width && l && v.time === tt.time && !v.uncache)
    return xe(o / v.width * d);
  if (h && (t === "height" || t === "width")) {
    var _ = e.style[t];
    e.style[t] = d + i, g = e[c], _ ? e.style[t] = _ : Ir(e, t);
  } else
    (h || a === "%") && !kC[ft(p, "display")] && (s.position = ft(e, "position")), p === e && (s.position = "static"), p.appendChild(br), g = br[c], p.removeChild(br), s.position = "absolute";
  return l && h && (v = Cr(p), v.time = tt.time, v.width = p[c]), xe(f ? g * o / d : g && o ? d / g * o : 0);
}, Rt = function(e, t, r, i) {
  var o;
  return qu || zl(), t in Tt && t !== "transform" && (t = Tt[t], ~t.indexOf(",") && (t = t.split(",")[0])), Ht[t] && t !== "transform" ? (o = jn(e, i), o = t !== "transformOrigin" ? o[t] : o.svg ? o.origin : _i(ft(e, Xe)) + " " + o.zOrigin + "px") : (o = e.style[t], (!o || o === "auto" || i || ~(o + "").indexOf("calc(")) && (o = mi[t] && mi[t](e, t, r) || ft(e, t) || Uv(e, t) || (t === "opacity" ? 1 : 0))), r && !~(o + "").trim().indexOf(" ") ? ar(e, t, o, r) + r : o;
}, DC = function(e, t, r, i) {
  if (!r || r === "none") {
    var o = en(t, e, 1), a = o && ft(e, o, 1);
    a && a !== r ? (t = o, r = a) : t === "borderColor" && (r = ft(e, "borderTopColor"));
  }
  var s = new Ze(this._pt, e.style, t, 0, 1, pg), l = 0, u = 0, c, d, f, h, g, p, v, b, _, y, C, w;
  if (s.b = r, s.e = i, r += "", i += "", i.substring(0, 6) === "var(--" && (i = ft(e, i.substring(4, i.indexOf(")")))), i === "auto" && (p = e.style[t], e.style[t] = i, i = ft(e, t) || i, p ? e.style[t] = p : Ir(e, t)), c = [r, i], ig(c), r = c[0], i = c[1], f = r.match(Ur) || [], w = i.match(Ur) || [], w.length) {
    for (; d = Ur.exec(i); )
      v = d[0], _ = i.substring(l, d.index), g ? g = (g + 1) % 5 : (_.substr(-5) === "rgba(" || _.substr(-5) === "hsla(") && (g = 1), v !== (p = f[u++] || "") && (h = parseFloat(p) || 0, C = p.substr((h + "").length), v.charAt(1) === "=" && (v = zr(h, v) + C), b = parseFloat(v), y = v.substr((b + "").length), l = Ur.lastIndex - y.length, y || (y = y || it.units[t] || C, l === i.length && (i += y, s.e += y)), C !== y && (h = ar(e, t, p, y) || 0), s._pt = {
        _next: s._pt,
        p: _ || u === 1 ? _ : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: h,
        c: b - h,
        m: g && g < 4 || t === "zIndex" ? Math.round : 0
      });
    s.c = l < i.length ? i.substring(l, i.length) : "";
  } else
    s.r = t === "display" && i === "none" ? _g : mg;
  return Rv.test(i) && (s.e = 0), this._pt = s, s;
}, Lh = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, RC = function(e) {
  var t = e.split(" "), r = t[0], i = t[1] || "50%";
  return (r === "top" || r === "bottom" || i === "left" || i === "right") && (e = r, r = i, i = e), t[0] = Lh[r] || r, t[1] = Lh[i] || i, t.join(" ");
}, PC = function(e, t) {
  if (t.tween && t.tween._time === t.tween._dur) {
    var r = t.t, i = r.style, o = t.u, a = r._gsap, s, l, u;
    if (o === "all" || o === !0)
      i.cssText = "", l = 1;
    else
      for (o = o.split(","), u = o.length; --u > -1; )
        s = o[u], Ht[s] && (l = 1, s = s === "transformOrigin" ? Xe : Te), Ir(r, s);
    l && (Ir(r, Te), a && (a.svg && r.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", jn(r, 1), a.uncache = 1, bg(i)));
  }
}, mi = {
  clearProps: function(e, t, r, i, o) {
    if (o.data !== "isFromStart") {
      var a = e._pt = new Ze(e._pt, t, r, 0, 0, PC);
      return a.u = i, a.pr = -10, a.tween = o, e._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, Un = [1, 0, 0, 1, 0, 0], Sg = {}, xg = function(e) {
  return e === "matrix(1, 0, 0, 1, 0, 0)" || e === "none" || !e;
}, qh = function(e) {
  var t = ft(e, Te);
  return xg(t) ? Un : t.substr(7).match(Dv).map(xe);
}, ju = function(e, t) {
  var r = e._gsap || Cr(e), i = e.style, o = qh(e), a, s, l, u;
  return r.svg && e.getAttribute("transform") ? (l = e.transform.baseVal.consolidate().matrix, o = [l.a, l.b, l.c, l.d, l.e, l.f], o.join(",") === "1,0,0,1,0,0" ? Un : o) : (o === Un && !e.offsetParent && e !== Wr && !r.svg && (l = i.display, i.display = "block", a = e.parentNode, (!a || !e.offsetParent && !e.getBoundingClientRect().width) && (u = 1, s = e.nextElementSibling, Wr.appendChild(e)), o = qh(e), l ? i.display = l : Ir(e, "display"), u && (s ? a.insertBefore(e, s) : a ? a.appendChild(e) : Wr.removeChild(e))), t && o.length > 6 ? [o[0], o[1], o[4], o[5], o[12], o[13]] : o);
}, Wl = function(e, t, r, i, o, a) {
  var s = e._gsap, l = o || ju(e, !0), u = s.xOrigin || 0, c = s.yOrigin || 0, d = s.xOffset || 0, f = s.yOffset || 0, h = l[0], g = l[1], p = l[2], v = l[3], b = l[4], _ = l[5], y = t.split(" "), C = parseFloat(y[0]) || 0, w = parseFloat(y[1]) || 0, m, T, x, A;
  r ? l !== Un && (T = h * v - g * p) && (x = C * (v / T) + w * (-p / T) + (p * _ - v * b) / T, A = C * (-g / T) + w * (h / T) - (h * _ - g * b) / T, C = x, w = A) : (m = wg(e), C = m.x + (~y[0].indexOf("%") ? C / 100 * m.width : C), w = m.y + (~(y[1] || y[0]).indexOf("%") ? w / 100 * m.height : w)), i || i !== !1 && s.smooth ? (b = C - u, _ = w - c, s.xOffset = d + (b * h + _ * p) - b, s.yOffset = f + (b * g + _ * v) - _) : s.xOffset = s.yOffset = 0, s.xOrigin = C, s.yOrigin = w, s.smooth = !!i, s.origin = t, s.originIsAbsolute = !!r, e.style[Xe] = "0px 0px", a && (Jt(a, s, "xOrigin", u, C), Jt(a, s, "yOrigin", c, w), Jt(a, s, "xOffset", d, s.xOffset), Jt(a, s, "yOffset", f, s.yOffset)), e.setAttribute("data-svg-origin", C + " " + w);
}, jn = function(e, t) {
  var r = e._gsap || new lg(e);
  if ("x" in r && !t && !r.uncache)
    return r;
  var i = e.style, o = r.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(e), u = ft(e, Xe) || "0", c, d, f, h, g, p, v, b, _, y, C, w, m, T, x, A, M, O, S, P, N, E, L, H, z, te, le, ce, ae, ue, de, ye;
  return c = d = f = p = v = b = _ = y = C = 0, h = g = 1, r.svg = !!(e.getCTM && Tg(e)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (i[Te] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[Te] !== "none" ? l[Te] : "")), i.scale = i.rotate = i.translate = "none"), T = ju(e, r.svg), r.svg && (r.uncache ? (z = e.getBBox(), u = r.xOrigin - z.x + "px " + (r.yOrigin - z.y) + "px", H = "") : H = !t && e.getAttribute("data-svg-origin"), Wl(e, H || u, !!H || r.originIsAbsolute, r.smooth !== !1, T)), w = r.xOrigin || 0, m = r.yOrigin || 0, T !== Un && (O = T[0], S = T[1], P = T[2], N = T[3], c = E = T[4], d = L = T[5], T.length === 6 ? (h = Math.sqrt(O * O + S * S), g = Math.sqrt(N * N + P * P), p = O || S ? Mr(S, O) * gr : 0, _ = P || N ? Mr(P, N) * gr + p : 0, _ && (g *= Math.abs(Math.cos(_ * Gr))), r.svg && (c -= w - (w * O + m * P), d -= m - (w * S + m * N))) : (ye = T[6], ue = T[7], le = T[8], ce = T[9], ae = T[10], de = T[11], c = T[12], d = T[13], f = T[14], x = Mr(ye, ae), v = x * gr, x && (A = Math.cos(-x), M = Math.sin(-x), H = E * A + le * M, z = L * A + ce * M, te = ye * A + ae * M, le = E * -M + le * A, ce = L * -M + ce * A, ae = ye * -M + ae * A, de = ue * -M + de * A, E = H, L = z, ye = te), x = Mr(-P, ae), b = x * gr, x && (A = Math.cos(-x), M = Math.sin(-x), H = O * A - le * M, z = S * A - ce * M, te = P * A - ae * M, de = N * M + de * A, O = H, S = z, P = te), x = Mr(S, O), p = x * gr, x && (A = Math.cos(x), M = Math.sin(x), H = O * A + S * M, z = E * A + L * M, S = S * A - O * M, L = L * A - E * M, O = H, E = z), v && Math.abs(v) + Math.abs(p) > 359.9 && (v = p = 0, b = 180 - b), h = xe(Math.sqrt(O * O + S * S + P * P)), g = xe(Math.sqrt(L * L + ye * ye)), x = Mr(E, L), _ = Math.abs(x) > 2e-4 ? x * gr : 0, C = de ? 1 / (de < 0 ? -de : de) : 0), r.svg && (H = e.getAttribute("transform"), r.forceCSS = e.setAttribute("transform", "") || !xg(ft(e, Te)), H && e.setAttribute("transform", H))), Math.abs(_) > 90 && Math.abs(_) < 270 && (o ? (h *= -1, _ += p <= 0 ? 180 : -180, p += p <= 0 ? 180 : -180) : (g *= -1, _ += _ <= 0 ? 180 : -180)), t = t || r.uncache, r.x = c - ((r.xPercent = c && (!t && r.xPercent || (Math.round(e.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? e.offsetWidth * r.xPercent / 100 : 0) + a, r.y = d - ((r.yPercent = d && (!t && r.yPercent || (Math.round(e.offsetHeight / 2) === Math.round(-d) ? -50 : 0))) ? e.offsetHeight * r.yPercent / 100 : 0) + a, r.z = f + a, r.scaleX = xe(h), r.scaleY = xe(g), r.rotation = xe(p) + s, r.rotationX = xe(v) + s, r.rotationY = xe(b) + s, r.skewX = _ + s, r.skewY = y + s, r.transformPerspective = C + a, (r.zOrigin = parseFloat(u.split(" ")[2]) || !t && r.zOrigin || 0) && (i[Xe] = _i(u)), r.xOffset = r.yOffset = 0, r.force3D = it.force3D, r.renderTransform = r.svg ? LC : Cg ? Ag : MC, r.uncache = 0, r;
}, _i = function(e) {
  return (e = e.split(" "))[0] + " " + e[1];
}, Gs = function(e, t, r) {
  var i = Be(t);
  return xe(parseFloat(t) + parseFloat(ar(e, "x", r + "px", i))) + i;
}, MC = function(e, t) {
  t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, Ag(e, t);
}, pr = "0deg", un = "0px", vr = ") ", Ag = function(e, t) {
  var r = t || this, i = r.xPercent, o = r.yPercent, a = r.x, s = r.y, l = r.z, u = r.rotation, c = r.rotationY, d = r.rotationX, f = r.skewX, h = r.skewY, g = r.scaleX, p = r.scaleY, v = r.transformPerspective, b = r.force3D, _ = r.target, y = r.zOrigin, C = "", w = b === "auto" && e && e !== 1 || b === !0;
  if (y && (d !== pr || c !== pr)) {
    var m = parseFloat(c) * Gr, T = Math.sin(m), x = Math.cos(m), A;
    m = parseFloat(d) * Gr, A = Math.cos(m), a = Gs(_, a, T * A * -y), s = Gs(_, s, -Math.sin(m) * -y), l = Gs(_, l, x * A * -y + y);
  }
  v !== un && (C += "perspective(" + v + vr), (i || o) && (C += "translate(" + i + "%, " + o + "%) "), (w || a !== un || s !== un || l !== un) && (C += l !== un || w ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + vr), u !== pr && (C += "rotate(" + u + vr), c !== pr && (C += "rotateY(" + c + vr), d !== pr && (C += "rotateX(" + d + vr), (f !== pr || h !== pr) && (C += "skew(" + f + ", " + h + vr), (g !== 1 || p !== 1) && (C += "scale(" + g + ", " + p + vr), _.style[Te] = C || "translate(0, 0)";
}, LC = function(e, t) {
  var r = t || this, i = r.xPercent, o = r.yPercent, a = r.x, s = r.y, l = r.rotation, u = r.skewX, c = r.skewY, d = r.scaleX, f = r.scaleY, h = r.target, g = r.xOrigin, p = r.yOrigin, v = r.xOffset, b = r.yOffset, _ = r.forceCSS, y = parseFloat(a), C = parseFloat(s), w, m, T, x, A;
  l = parseFloat(l), u = parseFloat(u), c = parseFloat(c), c && (c = parseFloat(c), u += c, l += c), l || u ? (l *= Gr, u *= Gr, w = Math.cos(l) * d, m = Math.sin(l) * d, T = Math.sin(l - u) * -f, x = Math.cos(l - u) * f, u && (c *= Gr, A = Math.tan(u - c), A = Math.sqrt(1 + A * A), T *= A, x *= A, c && (A = Math.tan(c), A = Math.sqrt(1 + A * A), w *= A, m *= A)), w = xe(w), m = xe(m), T = xe(T), x = xe(x)) : (w = d, x = f, m = T = 0), (y && !~(a + "").indexOf("px") || C && !~(s + "").indexOf("px")) && (y = ar(h, "x", a, "px"), C = ar(h, "y", s, "px")), (g || p || v || b) && (y = xe(y + g - (g * w + p * T) + v), C = xe(C + p - (g * m + p * x) + b)), (i || o) && (A = h.getBBox(), y = xe(y + i / 100 * A.width), C = xe(C + o / 100 * A.height)), A = "matrix(" + w + "," + m + "," + T + "," + x + "," + y + "," + C + ")", h.setAttribute("transform", A), _ && (h.style[Te] = A);
}, qC = function(e, t, r, i, o) {
  var a = 360, s = Re(o), l = parseFloat(o) * (s && ~o.indexOf("rad") ? gr : 1), u = l - i, c = i + u + "deg", d, f;
  return s && (d = o.split("_")[1], d === "short" && (u %= a, u !== u % (a / 2) && (u += u < 0 ? a : -a)), d === "cw" && u < 0 ? u = (u + a * kh) % a - ~~(u / a) * a : d === "ccw" && u > 0 && (u = (u - a * kh) % a - ~~(u / a) * a)), e._pt = f = new Ze(e._pt, t, r, i, u, yC), f.e = c, f.u = "deg", e._props.push(r), f;
}, Bh = function(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}, BC = function(e, t, r) {
  var i = Bh({}, r._gsap), o = "perspective,force3D,transformOrigin,svgOrigin", a = r.style, s, l, u, c, d, f, h, g;
  i.svg ? (u = r.getAttribute("transform"), r.setAttribute("transform", ""), a[Te] = t, s = jn(r, 1), Ir(r, Te), r.setAttribute("transform", u)) : (u = getComputedStyle(r)[Te], a[Te] = t, s = jn(r, 1), a[Te] = u);
  for (l in Ht)
    u = i[l], c = s[l], u !== c && o.indexOf(l) < 0 && (h = Be(u), g = Be(c), d = h !== g ? ar(r, l, u, g) : parseFloat(u), f = parseFloat(c), e._pt = new Ze(e._pt, s, l, d, f - d, Fl), e._pt.u = g || 0, e._props.push(l));
  Bh(s, i);
};
Ye("padding,margin,Width,Radius", function(n, e) {
  var t = "Top", r = "Right", i = "Bottom", o = "Left", a = (e < 3 ? [t, r, i, o] : [t + o, t + r, i + r, i + o]).map(function(s) {
    return e < 2 ? n + s : "border" + s + n;
  });
  mi[e > 1 ? "border" + n : n] = function(s, l, u, c, d) {
    var f, h;
    if (arguments.length < 4)
      return f = a.map(function(g) {
        return Rt(s, g, u);
      }), h = f.join(" "), h.split(f[0]).length === 5 ? f[0] : h;
    f = (c + "").split(" "), h = {}, a.forEach(function(g, p) {
      return h[g] = f[p] = f[p] || f[(p - 1) / 2 | 0];
    }), s.init(l, h, d);
  };
});
var Og = {
  name: "css",
  register: zl,
  targetTest: function(e) {
    return e.style && e.nodeType;
  },
  init: function(e, t, r, i, o) {
    var a = this._props, s = e.style, l = r.vars.startAt, u, c, d, f, h, g, p, v, b, _, y, C, w, m, T, x;
    qu || zl(), this.styles = this.styles || yg(e), x = this.styles.props, this.tween = r;
    for (p in t)
      if (p !== "autoRound" && (c = t[p], !(Je[p] && ug(p, t, r, i, e, o)))) {
        if (h = typeof c, g = mi[p], h === "function" && (c = c.call(r, i, e, o), h = typeof c), h === "string" && ~c.indexOf("random(") && (c = Ln(c)), g)
          g(this, e, p, c, r) && (T = 1);
        else if (p.substr(0, 2) === "--")
          u = (getComputedStyle(e).getPropertyValue(p) + "").trim(), c += "", rr.lastIndex = 0, rr.test(u) || (v = Be(u), b = Be(c)), b ? v !== b && (u = ar(e, p, u, b) + b) : v && (c += v), this.add(s, "setProperty", u, c, i, o, 0, 0, p), a.push(p), x.push(p, 0, s[p]);
        else if (h !== "undefined") {
          if (l && p in l ? (u = typeof l[p] == "function" ? l[p].call(r, i, e, o) : l[p], Re(u) && ~u.indexOf("random(") && (u = Ln(u)), Be(u + "") || u === "auto" || (u += it.units[p] || Be(Rt(e, p)) || ""), (u + "").charAt(1) === "=" && (u = Rt(e, p))) : u = Rt(e, p), f = parseFloat(u), _ = h === "string" && c.charAt(1) === "=" && c.substr(0, 2), _ && (c = c.substr(2)), d = parseFloat(c), p in Tt && (p === "autoAlpha" && (f === 1 && Rt(e, "visibility") === "hidden" && d && (f = 0), x.push("visibility", 0, s.visibility), Jt(this, s, "visibility", f ? "inherit" : "hidden", d ? "inherit" : "hidden", !d)), p !== "scale" && p !== "transform" && (p = Tt[p], ~p.indexOf(",") && (p = p.split(",")[0]))), y = p in Ht, y) {
            if (this.styles.save(p), h === "string" && c.substring(0, 6) === "var(--" && (c = ft(e, c.substring(4, c.indexOf(")"))), d = parseFloat(c)), C || (w = e._gsap, w.renderTransform && !t.parseTransform || jn(e, t.parseTransform), m = t.smoothOrigin !== !1 && w.smooth, C = this._pt = new Ze(this._pt, s, Te, 0, 1, w.renderTransform, w, 0, -1), C.dep = 1), p === "scale")
              this._pt = new Ze(this._pt, w, "scaleY", w.scaleY, (_ ? zr(w.scaleY, _ + d) : d) - w.scaleY || 0, Fl), this._pt.u = 0, a.push("scaleY", p), p += "X";
            else if (p === "transformOrigin") {
              x.push(Xe, 0, s[Xe]), c = RC(c), w.svg ? Wl(e, c, 0, m, 0, this) : (b = parseFloat(c.split(" ")[2]) || 0, b !== w.zOrigin && Jt(this, w, "zOrigin", w.zOrigin, b), Jt(this, s, p, _i(u), _i(c)));
              continue;
            } else if (p === "svgOrigin") {
              Wl(e, c, 1, m, 0, this);
              continue;
            } else if (p in Sg) {
              qC(this, w, p, f, _ ? zr(f, _ + c) : c);
              continue;
            } else if (p === "smoothOrigin") {
              Jt(this, w, "smooth", w.smooth, c);
              continue;
            } else if (p === "force3D") {
              w[p] = c;
              continue;
            } else if (p === "transform") {
              BC(this, c, e);
              continue;
            }
          } else p in s || (p = en(p) || p);
          if (y || (d || d === 0) && (f || f === 0) && !bC.test(c) && p in s)
            v = (u + "").substr((f + "").length), d || (d = 0), b = Be(c) || (p in it.units ? it.units[p] : v), v !== b && (f = ar(e, p, u, b)), this._pt = new Ze(this._pt, y ? w : s, p, f, (_ ? zr(f, _ + d) : d) - f, !y && (b === "px" || p === "zIndex") && t.autoRound !== !1 ? wC : Fl), this._pt.u = b || 0, v !== b && b !== "%" && (this._pt.b = u, this._pt.r = CC);
          else if (p in s)
            DC.call(this, e, p, u, _ ? _ + c : c);
          else if (p in e)
            this.add(e, p, u || e[p], _ ? _ + c : c, i, o);
          else if (p !== "parseTransform") {
            Ou(p, c);
            continue;
          }
          y || (p in s ? x.push(p, 0, s[p]) : typeof e[p] == "function" ? x.push(p, 2, e[p]()) : x.push(p, 1, u || e[p])), a.push(p);
        }
      }
    T && vg(this);
  },
  render: function(e, t) {
    if (t.tween._time || !Bu())
      for (var r = t._pt; r; )
        r.r(e, r.d), r = r._next;
    else
      t.styles.revert();
  },
  get: Rt,
  aliases: Tt,
  getSetter: function(e, t, r) {
    var i = Tt[t];
    return i && i.indexOf(",") < 0 && (t = i), t in Ht && t !== Xe && (e._gsap.x || Rt(e, "x")) ? r && Nh === r ? t === "scale" ? AC : xC : (Nh = r || {}) && (t === "scale" ? OC : EC) : e.style && !Su(e.style[t]) ? TC : ~t.indexOf("-") ? SC : Mu(e, t);
  },
  core: {
    _removeProperty: Ir,
    _getMatrix: ju
  }
};
Ke.utils.checkPrefix = en;
Ke.core.getStyleSaver = yg;
(function(n, e, t, r) {
  var i = Ye(n + "," + e + "," + t, function(o) {
    Ht[o] = 1;
  });
  Ye(e, function(o) {
    it.units[o] = "deg", Sg[o] = 1;
  }), Tt[i[13]] = n + "," + e, Ye(r, function(o) {
    var a = o.split(":");
    Tt[a[1]] = i[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Ye("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(n) {
  it.units[n] = "px";
});
Ke.registerPlugin(Og);
var Gl = Ke.registerPlugin(Og) || Ke;
Gl.core.Tween;
function Eg(n, e = {}) {
  const {
    fadeDuration: t = 0.4,
    fadeEase: r = "power2.out",
    fromScale: i = 0.95,
    toScale: o = 1,
    autoPlay: a = !0
  } = e;
  let s;
  const l = () => {
    const u = (lp(n) ? n : J(n)).value;
    if (u)
      return s && s.kill(), Gl.set(u, { opacity: 0, scale: i, willChange: "transform,opacity" }), s = Gl.to(u, {
        opacity: 1,
        scale: o,
        duration: t,
        ease: r,
        clearProps: "willChange"
      }), s;
  };
  return mt(() => {
    a && l();
  }), Yl(() => s && s.kill()), { play: l };
}
const UC = {
  __name: "ContentNode",
  props: {
    modelValue: { type: Object, default: () => ({}) },
    level: { type: Number, default: 0 },
    inAccordion: Boolean,
    isEditable: Boolean,
    isActiveNode: Boolean
  },
  setup(n) {
    const e = n, t = Oe("state"), r = op(e, "modelValue"), i = {
      EditableAccordionNode: G(
        () => import("./EditableAccordionNode-9ckEjbqn.js")
      ),
      EditableAccordionPanelNode: G(
        () => import("./EditableAccordionPanelNode-C7CRS1oZ.js")
      ),
      EditableButtonNode: G(
        () => import("./EditableButtonNode-FPIMM4SP.js")
      ),
      EditableCardNode: G(
        () => import("./EditableCardNode-0mrxA0tp.js")
      ),
      EditableCodeNode: G(
        () => import("./EditableCodeNode-BrmqPQDl.js")
      ),
      EditableFormNode: G(
        () => import("./EditableFormNode-BA0mJA23.js")
      ),
      EditableGalleryNode: G(
        () => import("./EditableGalleryNode--aa88mrH.js")
      ),
      EditableHeadingNode: G(
        () => import("./EditableHeadingNode-BrF1hhMx.js")
      ),
      EditableImageNode: G(
        () => import("./EditableImageNode-CSPCKKNQ.js")
      ),
      EditableListNode: G(
        () => import("./EditableListNode-0h9whISc.js")
      ),
      EditableQuoteNode: G(
        () => import("./EditableQuoteNode-OVAJLYyP.js")
      ),
      EditableSeparatorNode: G(
        () => import("./EditableSeparatorNode-Pk-BYBFT.js")
      ),
      EditableSpacerNode: G(
        () => import("./EditableSpacerNode-h2Kpu_n5.js")
      ),
      EditableTableNode: G(
        () => import("./EditableTableNode-CK89vmMC.js")
      ),
      EditableTextNode: G(
        () => import("./EditableTextNode-Dl_luyjB.js")
      ),
      EditableVideoNode: G(
        () => import("./EditableVideoNode-BE1XQEMN.js")
      ),
      EditableSliderNode: G(
        () => import("./EditableSliderNode-BB6IFBgi.js")
      ),
      EditableNavigationNode: G(
        () => import("./EditableNavigationNode-DQNH80in.js")
      ),
      EditableSharedContentErrorNode: G(
        () => import("./EditableSharedContentErrorNode-BODC2ZL7.js")
      ),
      AccordionNode: G(
        () => import("./AccordionNode-BJCKX9DD.js")
      ),
      AccordionPanelNode: G(
        () => import("./AccordionPanelNode-BLpUizuw.js")
      ),
      ButtonNode: G(() => import("./ButtonNode-hSIkLyLj.js").then((v) => v.b)),
      CardNode: G(() => import("./CardNode-BASl8LD4.js")),
      CodeNode: G(() => import("./CodeNode-CvT1-o6R.js")),
      FormNode: G(() => import("./FormNode-DJl9p2iK.js").then((v) => v.a)),
      GalleryNode: G(() => import("./GalleryNode-gV2t5uRX.js").then((v) => v.b)),
      HeadingNode: G(() => import("./HeadingNode-Dlwlnpd3.js")),
      ImageNode: G(() => import("./ImageNode-D-pXJnqJ.js").then((v) => v.a)),
      ListNode: G(() => import("./ListNode-De80-P1Y.js")),
      NavigationNode: G(
        () => import("./NavigationNode-CwlcdwAw.js")
      ),
      QuoteNode: G(() => import("./QuoteNode-BE7PNL8c.js")),
      SeparatorNode: G(
        () => import("./SeparatorNode-BdLqlCK4.js")
      ),
      SliderNode: G(() => import("./SliderNode-BZRAwHl1.js")),
      SpacerNode: G(() => import("./SpacerNode-Nt8KAeCf.js")),
      TableNode: G(() => import("./TableNode-DqcQIWGm.js")),
      TextNode: G(() => import("./TextNode-BDdwLAk1.js")),
      VideoNode: G(() => import("./VideoNode-D2DxeqS0.js").then((v) => v.a)),
      SharedContentErrorNode: G(
        () => import("./SharedContentErrorNode-BTg8ADn8.js")
      )
    }, o = Oe("insideSharedContentLayout"), a = I(
      () => e.isEditable && o.value
    ), s = I(
      () => e.isEditable && !o.value
    ), l = I(() => {
      const b = [...yi, ...gp].find(
        (y) => y.type === r.value.type
      );
      return (s.value ? `Editable${b.component}` : b.component) || "div";
    }), u = I(() => [
      `content-level-${e.level}`,
      { "in-accordion": e.inAccordion },
      { "is-active": e.isActiveNode && s.value },
      { "is-editable": s.value }
    ]), c = I(
      () => {
        var v, b, _, y, C;
        return ((b = (v = t == null ? void 0 : t.value) == null ? void 0 : v.nodeDragging) == null ? void 0 : b.type) === Ut && ((y = (_ = t == null ? void 0 : t.value) == null ? void 0 : _.nodeDragging) == null ? void 0 : y.id) !== ((C = r.value) == null ? void 0 : C.id);
      }
    ), d = I(
      () => {
        var v, b, _;
        return ((_ = (b = (v = t == null ? void 0 : t.value) == null ? void 0 : v.builder) == null ? void 0 : b.customProperties) == null ? void 0 : _[r.value.type]) || {};
      }
    );
    function f() {
      var v;
      (v = t == null ? void 0 : t.value) == null || v.setActiveNode(r.value);
    }
    function h(v, b) {
      var _;
      b && ((_ = t == null ? void 0 : t.value) == null || _.setActiveNode(r.value)), t.value.editor = v;
    }
    const g = I(() => {
      var v, b, _, y, C, w, m, T;
      return {
        "--root-elements-width": ((y = (_ = (b = (v = t == null ? void 0 : t.value) == null ? void 0 : v.builder) == null ? void 0 : b.customProperties) == null ? void 0 : _.global) == null ? void 0 : y.rootElementsWidth) || "100%",
        "--root-elements-max-width": ((T = (m = (w = (C = t == null ? void 0 : t.value) == null ? void 0 : C.builder) == null ? void 0 : w.customProperties) == null ? void 0 : m.global) == null ? void 0 : T.rootElementsMaxWidth) || "100%"
      };
    });
    if (e.isEditable && !r.value.hasAnimated && r.value.id !== "root") {
      const v = yn(r.value.id), { play: b } = Eg(v);
      b(), r.value.hasAnimated = !0;
    }
    return (v, b) => (D(), U("div", {
      ref: r.value.id
    }, [
      (D(), W(Yg, null, {
        default: j(() => [
          (D(), W(si(i[l.value]), {
            ref: r.value.id,
            modelValue: r.value,
            "onUpdate:modelValue": [
              b[0] || (b[0] = (_) => r.value = _),
              b[1] || (b[1] = (_) => r.value = _)
            ],
            class: He(["content-node", u.value]),
            "is-editable": s.value,
            assets: V(t).builder.assets,
            "is-active-node": n.isActiveNode && s.value,
            "is-accordion-dragging": c.value,
            level: n.level,
            "in-accordion": n.inAccordion,
            "custom-properties": d.value,
            style: ht(g.value),
            "is-editable-shared-content-layout": a.value,
            onSetActive: f,
            onFocusEditor: h,
            onAssetEntry: b[2] || (b[2] = (_) => V(t).addAsset(_)),
            onCloseSidebar: b[3] || (b[3] = (_) => V(t).clearActiveNode())
          }, null, 40, ["modelValue", "class", "is-editable", "assets", "is-active-node", "is-accordion-dragging", "level", "in-accordion", "custom-properties", "style", "is-editable-shared-content-layout"]))
        ]),
        _: 1
      }))
    ], 512));
  }
}, jC = /* @__PURE__ */ K(UC, [["__scopeId", "data-v-7616c8d7"]]);
var HC = Ev();
const $C = /* @__PURE__ */ $t(HC), FC = (n) => {
  var e, t, r, i;
  return (t = (e = n == null ? void 0 : n.properties) == null ? void 0 : e.backgroundColor) != null && t.toggle ? (i = (r = n == null ? void 0 : n.properties) == null ? void 0 : r.backgroundColor) == null ? void 0 : i.value : null;
}, VC = (n, e) => {
  var i, o;
  const t = Math.min(e.width, e.height) / 2;
  return `${((o = (i = n == null ? void 0 : n.properties) == null ? void 0 : i.borderRadius) == null ? void 0 : o.value) / 100 * t}px`;
}, zC = (n, e) => {
  var r, i, o, a, s, l, u, c, d, f, h;
  return !((i = (r = n == null ? void 0 : n.properties) == null ? void 0 : r.backgroundImage) != null && i.toggle) || !((l = (s = (a = (o = n == null ? void 0 : n.properties) == null ? void 0 : o.backgroundImage) == null ? void 0 : a.image) == null ? void 0 : s.content) != null && l.assetId) ? null : `url(${((h = e[(f = (d = (c = (u = n == null ? void 0 : n.properties) == null ? void 0 : u.backgroundImage) == null ? void 0 : c.image) == null ? void 0 : d.content) == null ? void 0 : f.assetId]) == null ? void 0 : h.url) || ""})`;
}, WC = (n) => {
  var t, r, i, o, a;
  const e = ((i = (r = (t = n == null ? void 0 : n.properties) == null ? void 0 : t.backgroundImage) == null ? void 0 : r.image) == null ? void 0 : i.properties) || {};
  switch (e == null ? void 0 : e.backgroundPosition) {
    case "center":
      return {
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "contain",
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    case "fill":
      return {
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-position": `${((o = e == null ? void 0 : e.focalPointPosition) == null ? void 0 : o.x) || 50}% ${((a = e == null ? void 0 : e.focalPointPosition) == null ? void 0 : a.y) || 50}%`,
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    case "tile":
      return {
        "background-position": "center",
        "background-repeat": "repeat",
        "background-size": `${(e == null ? void 0 : e.tilePercentage) || 100}%`,
        transform: `rotate(${(e == null ? void 0 : e.rotation) || 0}deg)`
      };
    default:
      return {};
  }
}, Uh = (n, e, t) => ["top", "bottom", "left", "right"].reduce((r, i) => {
  var o, a, s;
  return {
    ...r,
    [`${e}${$C(i)}`]: ((o = n == null ? void 0 : n.properties[e]) != null && o.linked ? (a = n == null ? void 0 : n.properties[e]) == null ? void 0 : a.value : ((s = n == null ? void 0 : n.properties[e]) == null ? void 0 : s[i]) || 0) / t + "px"
  };
}, {}), GC = (n, e, t, r) => {
  var v, b, _, y, C;
  const { customProperties: i, assets: o } = n, a = e.id === "root";
  if (ev(e) && !a) return {};
  const s = 1, l = a ? !!((v = i == null ? void 0 : i.global) != null && v.backgroundColorAllowed) : !!((b = i == null ? void 0 : i[e.type]) != null && b.backgroundColorAllowed), u = a ? !!((_ = i == null ? void 0 : i.global) != null && _.backgroundImageAllowed) : !!((y = i == null ? void 0 : i[e.type]) != null && y.backgroundImageAllowed), c = l && FC(e), d = u && zC(e, o), f = !!((C = i == null ? void 0 : i.experimentalFeatures) != null && C.roundedLayouts) && VC(e, r), h = WC(e), g = Uh(e, "margin", s), p = Uh(e, "padding", s);
  return {
    backgroundImage: d,
    backgroundColor: c,
    borderRadius: f,
    ...h,
    ...g,
    ...p
  };
}, YC = {
  __name: "ActiveNodeAction",
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    icon: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = () => {
      r("click");
    };
    return (o, a) => {
      const s = $("a-icon"), l = $("a-button"), u = $("a-tooltip");
      return D(), W(u, {
        label: t.tooltipText,
        position: t.position
      }, {
        default: j(() => [
          q(l, {
            class: "node-action",
            variant: "none",
            onClick: i
          }, {
            default: j(() => [
              nt(o.$slots, "default", {}, () => [
                R("p", { class: "node-action-icon" }, [
                  q(s, {
                    icon: t.icon
                  }, null, 8, ["icon"])
                ])
              ], !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["label", "position"]);
    };
  }
}, ei = /* @__PURE__ */ K(YC, [["__scopeId", "data-v-2aeb3fd3"]]), ZC = {};
function XC(n, e) {
  return D(), U("svg", {
    width: "12",
    height: "24",
    viewBox: "0 0 12 24",
    fill: "none"
  }, [
    R("circle", {
      cx: "4",
      cy: "6",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "10",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "14",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "6",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "10",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "14",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "4",
      cy: "18",
      r: "1",
      fill: "white"
    }),
    R("circle", {
      cx: "8",
      cy: "18",
      r: "1",
      fill: "white"
    })
  ]);
}
const Ig = /* @__PURE__ */ K(ZC, [["render", XC]]), Sw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ig
}, Symbol.toStringTag, { value: "Module" }));
var Ys, jh;
function KC() {
  if (jh) return Ys;
  jh = 1;
  var n = Gp(), e = ki(), t = au(), r = lr(), i = $n(), o = Ei(), a = Oi(), s = uu(), l = "[object Map]", u = "[object Set]", c = Object.prototype, d = c.hasOwnProperty;
  function f(h) {
    if (h == null)
      return !0;
    if (i(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || o(h) || s(h) || t(h)))
      return !h.length;
    var g = e(h);
    if (g == l || g == u)
      return !h.size;
    if (a(h))
      return !n(h).length;
    for (var p in h)
      if (d.call(h, p))
        return !1;
    return !0;
  }
  return Ys = f, Ys;
}
var QC = KC();
const JC = /* @__PURE__ */ $t(QC);
var Zs, Hh;
function e2() {
  if (Hh) return Zs;
  Hh = 1;
  var n = "__lodash_hash_undefined__";
  function e(t) {
    return this.__data__.set(t, n), this;
  }
  return Zs = e, Zs;
}
var Xs, $h;
function t2() {
  if ($h) return Xs;
  $h = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return Xs = n, Xs;
}
var Ks, Fh;
function r2() {
  if (Fh) return Ks;
  Fh = 1;
  var n = ru(), e = e2(), t = t2();
  function r(i) {
    var o = -1, a = i == null ? 0 : i.length;
    for (this.__data__ = new n(); ++o < a; )
      this.add(i[o]);
  }
  return r.prototype.add = r.prototype.push = e, r.prototype.has = t, Ks = r, Ks;
}
var Qs, Vh;
function n2() {
  if (Vh) return Qs;
  Vh = 1;
  function n(e, t, r, i) {
    for (var o = e.length, a = r + (i ? 1 : -1); i ? a-- : ++a < o; )
      if (t(e[a], a, e))
        return a;
    return -1;
  }
  return Qs = n, Qs;
}
var Js, zh;
function i2() {
  if (zh) return Js;
  zh = 1;
  function n(e) {
    return e !== e;
  }
  return Js = n, Js;
}
var el, Wh;
function o2() {
  if (Wh) return el;
  Wh = 1;
  function n(e, t, r) {
    for (var i = r - 1, o = e.length; ++i < o; )
      if (e[i] === t)
        return i;
    return -1;
  }
  return el = n, el;
}
var tl, Gh;
function a2() {
  if (Gh) return tl;
  Gh = 1;
  var n = n2(), e = i2(), t = o2();
  function r(i, o, a) {
    return o === o ? t(i, o, a) : n(i, e, a);
  }
  return tl = r, tl;
}
var rl, Yh;
function s2() {
  if (Yh) return rl;
  Yh = 1;
  var n = a2();
  function e(t, r) {
    var i = t == null ? 0 : t.length;
    return !!i && n(t, r, 0) > -1;
  }
  return rl = e, rl;
}
var nl, Zh;
function l2() {
  if (Zh) return nl;
  Zh = 1;
  function n(e, t, r) {
    for (var i = -1, o = e == null ? 0 : e.length; ++i < o; )
      if (r(t, e[i]))
        return !0;
    return !1;
  }
  return nl = n, nl;
}
var il, Xh;
function u2() {
  if (Xh) return il;
  Xh = 1;
  function n(e, t) {
    return e.has(t);
  }
  return il = n, il;
}
var ol, Kh;
function c2() {
  if (Kh) return ol;
  Kh = 1;
  function n() {
  }
  return ol = n, ol;
}
var al, Qh;
function Ng() {
  if (Qh) return al;
  Qh = 1;
  function n(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i) {
      r[++t] = i;
    }), r;
  }
  return al = n, al;
}
var sl, Jh;
function d2() {
  if (Jh) return sl;
  Jh = 1;
  var n = Qp(), e = c2(), t = Ng(), r = 1 / 0, i = n && 1 / t(new n([, -0]))[1] == r ? function(o) {
    return new n(o);
  } : e;
  return sl = i, sl;
}
var ll, ep;
function f2() {
  if (ep) return ll;
  ep = 1;
  var n = r2(), e = s2(), t = l2(), r = u2(), i = d2(), o = Ng(), a = 200;
  function s(l, u, c) {
    var d = -1, f = e, h = l.length, g = !0, p = [], v = p;
    if (c)
      g = !1, f = t;
    else if (h >= a) {
      var b = u ? null : i(l);
      if (b)
        return o(b);
      g = !1, f = r, v = new n();
    } else
      v = u ? [] : p;
    e:
      for (; ++d < h; ) {
        var _ = l[d], y = u ? u(_) : _;
        if (_ = c || _ !== 0 ? _ : 0, g && y === y) {
          for (var C = v.length; C--; )
            if (v[C] === y)
              continue e;
          u && v.push(y), p.push(_);
        } else f(v, y, c) || (v !== p && v.push(y), p.push(_));
      }
    return p;
  }
  return ll = s, ll;
}
var ul, tp;
function h2() {
  if (tp) return ul;
  tp = 1;
  var n = f2();
  function e(t) {
    return t && t.length ? n(t) : [];
  }
  return ul = e, ul;
}
var p2 = h2();
const v2 = /* @__PURE__ */ $t(p2);
function _t({ state: n = {} }) {
  var Y;
  const e = ((Y = n == null ? void 0 : n.value) == null ? void 0 : Y.builder) || {}, t = e.sharedContent || {}, r = t.onContentCreated, i = t.onOpenSettings, o = t.onSaveContentEdited, a = t.onCancelContentEdited, s = t.onContentDetached, l = t.onSharedContentDeleted, u = I(
    () => {
      var k, B, F, Z;
      return !!((Z = (F = (B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.builder) == null ? void 0 : B.customProperties) == null ? void 0 : F.global) != null && Z.sharedContentAllowed);
    }
  ), c = I(
    () => {
      var k, B, F;
      return !!u.value && !!((F = (B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.builder) == null ? void 0 : B.sharedContent) != null && F.createSharedContentAllowed);
    }
  ), d = I(
    () => {
      var k, B, F;
      return !!u.value && !!((F = (B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.builder) == null ? void 0 : B.sharedContent) != null && F.editSharedContentAllowed);
    }
  ), f = I(
    () => {
      var k, B, F;
      return !!u.value && !!((F = (B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.builder) == null ? void 0 : B.sharedContent) != null && F.detachSharedContentAllowed);
    }
  ), h = I(
    () => {
      var k, B, F;
      return !JC(((F = (B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.builder) == null ? void 0 : B.sharedContent) == null ? void 0 : F.content) || {});
    }
  ), g = I(
    () => Object.keys(t.content || {}).length
  ), p = (k) => (k == null ? void 0 : k.type) === et, v = I(
    () => {
      var k, B;
      return c.value && !p((k = n == null ? void 0 : n.value) == null ? void 0 : k.activeNode) && !A((B = n == null ? void 0 : n.value) == null ? void 0 : B.activeNode);
    }
  ), b = I(
    () => {
      var k;
      return d.value && p((k = n == null ? void 0 : n.value) == null ? void 0 : k.activeNode);
    }
  ), _ = I(
    () => {
      var k;
      return f.value && p((k = n == null ? void 0 : n.value) == null ? void 0 : k.activeNode);
    }
  ), y = async ({
    node: k = null,
    name: B = "New shared content",
    icon: F = "16:paper-plane",
    accordionId: Z = null,
    preventNodeTypes: oe = []
  } = {}) => {
    var ne, Ce, Qe, Gn;
    if (!k && !((ne = n == null ? void 0 : n.value) != null && ne.activeNode)) return;
    Z && (k = qt(e.structure, Z)), ((Qe = (Ce = n == null ? void 0 : n.value) == null ? void 0 : Ce.activeNode) == null ? void 0 : Qe.type) === St && (k = qt(e.structure, n.value.activeNode.parentAccordionId));
    let ge = se();
    const X = k || ((Gn = n == null ? void 0 : n.value) == null ? void 0 : Gn.activeNode);
    let $e = kn(X);
    if ($e = de($e), !(oe.length > 0 && oe.some(
      (bt) => !!nv(X, bt)
    ))) {
      if (typeof r == "function") {
        const Nt = await r([$e]);
        if (!Nt) return;
        ge = Nt.id || ge, B = Nt.name || B;
      }
      L({
        id: ge,
        name: B,
        icon: F,
        content: $e
      }), H({
        sharedContentId: ge,
        idToReplace: X.id
      });
    }
  }, C = async (k) => {
    typeof i == "function" && i(k);
  }, w = (k, B, F, Z) => {
    var oe, ge;
    n.value && (n.value.editingSharedContent.node = (oe = n == null ? void 0 : n.value) == null ? void 0 : oe.activeNode, n.value.editingSharedContent.boundingRect = {
      top: k,
      left: B,
      width: F,
      height: Z
    }, n.value.editingSharedContent.originalContent = Or(
      t.content[(ge = n == null ? void 0 : n.value) == null ? void 0 : ge.activeNode.sharedContentId].content
    ));
  }, m = (k) => {
    var B;
    t.content[(B = n == null ? void 0 : n.value) == null ? void 0 : B.editingSharedContent.node.sharedContentId].content.push(k);
  }, T = I(
    () => {
      var k, B;
      return ((B = (k = n == null ? void 0 : n.value) == null ? void 0 : k.editingSharedContent) == null ? void 0 : B.node) || null;
    }
  ), x = I({
    get: () => {
      var k, B;
      return ((B = t == null ? void 0 : t.content) == null ? void 0 : B[(k = T.value) == null ? void 0 : k.sharedContentId]) || {};
    },
    set: (k) => {
      var B;
      return t.content[(B = T.value) == null ? void 0 : B.sharedContentId] = k;
    }
  }), A = (k) => !!qt(T.value, k.id), M = (k) => {
    var B;
    return ((B = T.value) == null ? void 0 : B.id) === k.id;
  }, O = I(() => T.value ? {
    isBlocked: !1,
    message: ""
  } : {
    isBlocked: !0,
    message: "builder.cannotNestSharedContent"
  }), S = I(() => (k) => M(k)), P = async () => {
    var B;
    const k = (B = n == null ? void 0 : n.value) == null ? void 0 : B.editingSharedContent.node.sharedContentId;
    if (k) {
      if (typeof o == "function") {
        const F = t.content[k].content || [];
        if (!await o(
          k,
          F
        )) return;
      }
      ue();
    }
  }, N = async () => {
    var B, F, Z;
    const k = (B = n == null ? void 0 : n.value) == null ? void 0 : B.editingSharedContent.node.sharedContentId;
    k && (typeof a == "function" && !await a(k) || (t.content[(F = n == null ? void 0 : n.value) == null ? void 0 : F.editingSharedContent.node.sharedContentId].content = (Z = n == null ? void 0 : n.value) == null ? void 0 : Z.editingSharedContent.originalContent, ue()));
  }, E = (k) => {
    var F, Z;
    const B = (Z = t == null ? void 0 : t.content[(F = k == null ? void 0 : k.value) == null ? void 0 : F.sharedContentId]) == null ? void 0 : Z.content;
    return B ? k.value.nodes[0].nodes = B : (t.content[k.value.sharedContentId] = {
      content: [
        {
          id: k.value.sharedContentId,
          name: "Shared Component Error",
          type: Nn
        }
      ]
    }, k.value.nodes[0].nodes = t.content[k.value.sharedContentId].content);
  };
  function L({ id: k, name: B, icon: F, content: Z }) {
    t.content[k] = { name: B, icon: F, content: [Z] };
  }
  function H({ sharedContentId: k, idToReplace: B }) {
    var ge;
    const F = ze({
      sharedContentId: k,
      type: et
    }), { parent: Z, index: oe } = Mt(
      e.structure,
      B
    );
    Z.nodes.splice(oe, 1, F), (ge = n == null ? void 0 : n.value) == null || ge.setActiveNode(F);
  }
  const z = async () => {
    var oe, ge, X, $e;
    const k = (ge = (oe = n == null ? void 0 : n.value) == null ? void 0 : oe.activeNode) == null ? void 0 : ge.sharedContentId;
    if (!f.value || !k || typeof s == "function" && !await s(k))
      return;
    const B = kn({
      ...t.content[k].content[0]
    }), { parent: F, index: Z } = Mt(
      e.structure,
      ($e = (X = n == null ? void 0 : n.value) == null ? void 0 : X.activeNode) == null ? void 0 : $e.id
    );
    F.nodes.splice(Z, 1, B);
  }, te = I(() => Object.entries(t.content || {}).map(([k, B]) => ({
    name: B.name,
    icon: B.icon,
    sharedContentId: k,
    type: et
  }))), le = (k) => {
    const { sharedContentId: B, name: F, type: Z } = k;
    return ze({ sharedContentId: B, type: Z });
  }, ce = (k) => {
    var Z;
    const B = ze({
      type: Cn
    }), F = {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    return B.properties = {
      ...B.properties,
      margin: { ...F },
      padding: { ...F }
    }, B.nodes[0].nodes = ((Z = t.content[k]) == null ? void 0 : Z.content) || [], B;
  }, ae = (k) => t.content[k] || {};
  function ue() {
    var k;
    (k = n == null ? void 0 : n.value) == null || k.clearActiveNode(), n.value.editingSharedContent.node = null, n.value.editingSharedContent.boundingRect = null, n.value.editingSharedContent.originalContent = null;
  }
  function de(k) {
    var B, F;
    switch (k.type) {
      case Hn: {
        k.content.assetUrl = ((B = n == null ? void 0 : n.value) == null ? void 0 : B.builder.assets[k.content.assetId].url) || "";
        break;
      }
      case On:
      case En: {
        k.content.images = k.content.images.map((Z) => {
          var oe;
          return Z.content.assetUrl = ((oe = n == null ? void 0 : n.value) == null ? void 0 : oe.builder.assets[Z.content.assetId].url) || "", Z;
        });
        break;
      }
      case In: {
        k.content.image.content.assetUrl = ((F = n == null ? void 0 : n.value) == null ? void 0 : F.builder.assets[k.content.image.content.assetId].url) || "";
        break;
      }
    }
    return k;
  }
  const ye = ({ allowDuplicates: k = !1 } = {}) => {
    var B, F;
    return (F = (B = n == null ? void 0 : n.value) == null ? void 0 : B.builder) != null && F.structure ? pt(n.value.builder.structure, k) : [];
  };
  function pt(k, B = !1) {
    const F = [], Z = (oe) => {
      (oe == null ? void 0 : oe.type) === et && F.push(oe == null ? void 0 : oe.sharedContentId);
      let ge = (oe == null ? void 0 : oe.nodes) || {};
      Ri(ge, (X) => {
        Di(X) && Z(X);
      });
    };
    return Z(k), B ? F : v2(F);
  }
  return {
    amountOfSharedContent: g,
    isSharedContentAllowed: u,
    canCreateSharedContent: c,
    canEditSharedContent: d,
    canDetachSharedContent: f,
    showCreateSharedContentButton: v,
    showEditSharedContentButton: b,
    showDetachSharedContentButton: _,
    hasSharedContent: h,
    isSharedContentLayout: p,
    createSharedContent: y,
    openSharedContentSettings: C,
    isolateSharedContent: w,
    applyContentToSharedContentLayout: E,
    getSharedContentSidebarNodes: te,
    onSidebarCloneSharedContent: le,
    generateDialogPreview: ce,
    getSharedContentById: ae,
    editingSharedContent: T,
    editingSharedContentNodes: x,
    isNodeInsideEditingSharedContentLayout: A,
    isCurrentSharedContentBeingEdited: M,
    showEditingSharedContentActions: S,
    blockSharedContentLayout: O,
    detachSharedContent: z,
    saveEditingSharedContent: P,
    cancelEditingSharedContent: N,
    addNodeToEditingSharedContent: m,
    extractSharedContentIds: ye,
    deleteSharedContent: async (k) => {
      typeof l != "function" || !await l(k) || delete t.content[k];
    }
  };
}
let Yr = null;
const g2 = Mp((n) => (Yr || (Yr = Vp(n, {
  deep: !0,
  debounce: 500,
  flush: "post",
  clone: Or
})), Yr)), m2 = () => {
  Yr && (Yr.clear(), Yr = null);
};
function Hu(n) {
  return {
    ...g2(n),
    clearSharedHistory: m2
  };
}
const _2 = {
  __name: "VerticalScrollText",
  props: {
    text: {
      type: String,
      default: ""
    },
    colorOnHover: {
      type: String,
      default: null
    },
    isHovering: Boolean,
    strikethrough: Boolean,
    activateScroll: Boolean
  },
  setup(n) {
    const e = n, t = J(null), r = J(null), i = J(3), o = J(0), a = () => {
      !t.value || !r.value || Ct(() => {
        const s = t.value, l = r.value, u = s.scrollWidth, c = l.clientWidth;
        o.value = Math.max(0, u - c), i.value = u > c ? Math.ceil(o.value / 50) : 0;
      });
    };
    return mt(() => {
      a();
    }), (s, l) => (D(), U("div", {
      ref_key: "containerRef",
      ref: r,
      class: "text-container"
    }, [
      R("p", {
        ref_key: "textRef",
        ref: t,
        class: He(["scrollable-text", { "scroll-active": !!e.activateScroll }]),
        style: ht({
          color: e.colorOnHover && e.isHovering ? e.colorOnHover : "inherit",
          textDecoration: e.strikethrough ? "line-through" : "none",
          "--scroll-duration": `${i.value}s`,
          "--scroll-distance": `${o.value}px`
        })
      }, [
        nt(s.$slots, "default", {}, () => [
          Me(Q(e.text), 1)
        ], !0)
      ], 6)
    ], 512));
  }
}, kg = /* @__PURE__ */ K(_2, [["__scopeId", "data-v-98180b20"]]), b2 = {
  __name: "ActiveNodeToolbar",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    activeAccordionId: {
      type: String,
      default: null
    }
  },
  emits: ["delete", "edit-shared-content"],
  setup(n, { emit: e }) {
    up((Y) => ({
      ff206aac: b.value
    }));
    const t = J(!1), r = n, i = e, o = Oe("state"), a = J(!1), s = I(() => {
      var Y, k, B, F, Z, oe, ge, X;
      return ((F = (B = (k = (Y = o == null ? void 0 : o.value) == null ? void 0 : Y.builder) == null ? void 0 : k.customProperties) == null ? void 0 : B.global) == null ? void 0 : F.confirmOnDeleteDialogAllowed) && ((X = (ge = (oe = (Z = o == null ? void 0 : o.value) == null ? void 0 : Z.builder) == null ? void 0 : oe.customProperties) == null ? void 0 : ge.global) == null ? void 0 : X.showConfirmOnDeleteDialog);
    }), l = I(() => {
      var Y;
      return P(r.node) && ((Y = E(r.node.sharedContentId)) == null ? void 0 : Y.name) || r.node.name;
    }), u = I(() => `${r.node.name.toLowerCase().replace(" ", "-")}-toolbar`), c = I(() => {
      var k, B, F, Z, oe, ge;
      const Y = ((Z = (F = (B = (k = r.node) == null ? void 0 : k.nodes) == null ? void 0 : B[0]) == null ? void 0 : F.nodes) == null ? void 0 : Z[0]) || {};
      return !!qt(Y, (ge = (oe = o == null ? void 0 : o.value) == null ? void 0 : oe.activeNode) == null ? void 0 : ge.id);
    }), d = I(() => {
      var k, B, F;
      const Y = !!((k = o == null ? void 0 : o.value) != null && k.activeNode) && z(r.node) && !z((B = o == null ? void 0 : o.value) == null ? void 0 : B.activeNode) && ce((F = o == null ? void 0 : o.value) == null ? void 0 : F.activeNode);
      return !!L.value && Y;
    }), f = I(() => r.node.type.includes(Ut)), h = I(() => r.node.type === St), g = I(() => f.value ? c.value : !1), p = I(() => {
      var k, B;
      const Y = qt(
        (k = o == null ? void 0 : o.value) == null ? void 0 : k.builder.structure,
        r.node.parentAccordionId
      );
      return h.value && ((B = Y == null ? void 0 : Y.nodes[0]) == null ? void 0 : B.nodes.length) === 1;
    }), v = I(() => p.value ? "builder.content.accordion.accordionMustHavePanels" : "builder.toolbar.deleteElement"), b = I(() => {
      var B, F;
      let k = ir(r.node) ? 10 : 0;
      return (F = (B = r.node) == null ? void 0 : B.properties) != null && F.margin && (k = r.node.properties.margin.linked ? r.node.properties.margin.value : r.node.properties.margin.top), `${-15 + k}px`;
    }), _ = I(() => {
      var Y;
      return ((Y = o == null ? void 0 : o.value) == null ? void 0 : Y.userAgent) === "mac" ? "⌘" : "Ctrl";
    }), y = (Y) => {
      if (Y === "add-custom-code") {
        x();
        return;
      }
      i(Y);
    }, C = I(() => [
      {
        id: "copy-node",
        label: "Copy element",
        shortkey: `${_.value} + C`,
        icon: "CopyIcon"
      },
      {
        id: "cut-node",
        label: "Cut element",
        shortkey: `${_.value} + X`,
        icon: "CutIcon"
      },
      {
        id: "paste-node",
        label: "Paste element",
        shortkey: `${_.value} + V`,
        icon: "PasteIcon"
      },
      {
        id: "add-custom-code",
        label: "Add custom attributes",
        shortkey: "",
        icon: "AddCustomCodeIcon"
      }
    ]), w = I(() => {
      var Y, k, B, F;
      return !!((F = (B = (k = (Y = o == null ? void 0 : o.value) == null ? void 0 : Y.builder) == null ? void 0 : k.customProperties) == null ? void 0 : B.global) != null && F.customAttributesAllowed) && !P(r.node);
    }), m = () => {
      p.value || (s.value ? a.value = !0 : i("delete-node"));
    }, T = () => {
      var Y;
      (Y = o == null ? void 0 : o.value) == null || Y.setActiveNode(r.node);
    }, x = () => {
      o.value.showCustomAttributesSidebar = !0;
    }, {
      showCreateSharedContentButton: A,
      showDetachSharedContentButton: M,
      createSharedContent: O,
      detachSharedContent: S,
      isSharedContentLayout: P,
      showEditSharedContentButton: N,
      getSharedContentById: E,
      editingSharedContent: L,
      showEditingSharedContentActions: H,
      isCurrentSharedContentBeingEdited: z,
      saveEditingSharedContent: te,
      cancelEditingSharedContent: le,
      isNodeInsideEditingSharedContentLayout: ce
    } = _t({
      state: o
    }), { resume: ae } = Hu(o.value.builder), ue = () => {
      ae(), te();
    }, de = () => {
      ae(), le();
    }, ye = [
      {
        id: "create-shared-content",
        showAction: A.value && !h.value,
        tooltipText: "builder.toolbar.createSharedContent",
        icon: G(
          () => import("./CreateSharedContentIcon-DgBKD09h.js")
        ),
        onClick: () => {
          O({
            accordionId: r.activeAccordionId
          });
        }
      },
      {
        id: "edit-shared-content",
        showAction: N.value && !h.value,
        tooltipText: "builder.toolbar.editSharedContent",
        icon: G(
          () => import("./EditSharedContentIcon-B5BH88a4.js")
        ),
        onClick: () => i("edit-shared-content")
      },
      {
        id: "detach-shared-content",
        showAction: M.value && !h.value,
        tooltipText: "builder.toolbar.detachSharedContent",
        icon: G(
          () => import("./DetachSharedContentIcon-mPPijyef.js")
        ),
        onClick: S
      },
      {
        id: "add-custom-code",
        showAction: w.value,
        tooltipText: "builder.toolbar.addCustomAttributes",
        icon: G(
          () => import("./AddCustomCodeIcon-DdtmTSCR.js")
        ),
        onClick: x
      },
      {
        id: "duplicate-node",
        showAction: !0,
        tooltipText: "builder.toolbar.duplicateElement",
        icon: G(
          () => import("./DuplicateIcon-CTRB4Lug.js")
        ),
        onClick: () => i("duplicate-node")
      },
      {
        id: "delete-node",
        showAction: !0,
        tooltipText: v.value,
        icon: G(
          () => import("./DeleteIcon-CCYwqs-D.js")
        ),
        onClick: m
      }
    ], pt = [
      "create-shared-content",
      "edit-shared-content",
      "detach-shared-content",
      "duplicate-node",
      "delete-node"
    ], cr = I(
      () => ye.filter(({ id: Y }) => pt.includes(Y))
    );
    return (Y, k) => {
      const B = $("a-text"), F = $("a-button"), Z = $("a-dropdown"), oe = $("a-alert-header"), ge = $("a-alert-content"), X = $("a-alert-footer"), $e = $("a-dialog"), ne = $("portal");
      return D(), U("div", {
        class: He([
          "toolbar",
          u.value,
          {
            "is-first-accordion-panel-active": g.value,
            "is-editing-shared-content": !!V(L),
            "shared-content-first-child-active": d.value
          }
        ]),
        style: ht({ zIndex: t.value ? 3 : 2 }),
        onClick: k[6] || (k[6] = cl(() => {
        }, ["stop"]))
      }, [
        R("div", { class: "elements-container" }, [
          R("div", { class: "elements" }, [
            V(H)(r.node) ? ee("", !0) : (D(), W(Ig, {
              key: 0,
              class: "handler"
            })),
            q(F, {
              class: "node-name",
              variant: "link",
              onClick: cl(T, ["stop"]),
              disabled: !f.value
            }, {
              default: j(() => [
                q(kg, { style: { maxWidth: "200px" } }, {
                  default: j(() => [
                    q(B, { variant: "h4" }, {
                      default: j(() => [
                        Me(Q(l.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            V(H)(r.node) ? (D(), U("div", {
              key: 1,
              class: "actions-group"
            }, [
              q(ei, {
                "tooltip-text": Y.$t("builder.toolbar.saveEditingSharedContent"),
                icon: "16:checkmark",
                onClick: ue
              }, null, 8, ["tooltip-text"]),
              q(ei, {
                "tooltip-text": Y.$t("builder.toolbar.cancelEditingSharedContent"),
                icon: "16:close",
                onClick: de
              }, null, 8, ["tooltip-text"])
            ])) : (D(), U("div", {
              key: 2,
              class: "actions-group"
            }, [
              (D(!0), U(gt, null, nr(cr.value, (Ce) => (D(), U("div", { class: "action-icon" }, [
                Ce.showAction ? (D(), W(ei, {
                  key: Ce.id,
                  "tooltip-text": Y.$t(Ce.tooltipText),
                  onClick: Ce.onClick
                }, {
                  default: j(() => [
                    (D(), W(si(Ce.icon)))
                  ]),
                  _: 2
                }, 1032, ["tooltip-text", "onClick"])) : ee("", !0)
              ]))), 256)),
              q(Z, {
                align: "right",
                class: "moreOptions",
                items: C.value,
                onItemClick: y,
                onOpen: k[1] || (k[1] = (Ce) => t.value = !0),
                onClose: k[2] || (k[2] = (Ce) => t.value = !1)
              }, Zl({
                dropdownTrigger: j(() => [
                  q(ei, {
                    "tooltip-text": Y.$t("builder.toolbar.moreOptions"),
                    icon: "16:shishkebab",
                    onClick: k[0] || (k[0] = (Ce) => Y.showSettings = !0)
                  }, null, 8, ["tooltip-text"])
                ]),
                _: 2
              }, [
                nr(C.value, (Ce) => ({
                  name: `dropdown_item_${Ce.id}`,
                  fn: j(({ item: Qe }) => [
                    R("div", { class: "dropdown-item" }, [
                      (D(), W(si(Qe.icon))),
                      R("p", { class: "dropdown-item-label" }, Q(Qe.label), 1),
                      R("p", { class: "dropdown-item-shortkey" }, Q(Qe.shortkey), 1)
                    ])
                  ])
                }))
              ]), 1032, ["items"])
            ]))
          ])
        ]),
        a.value ? (D(), W(ne, {
          key: 0,
          to: "root-dialog-container"
        }, {
          default: j(() => [
            q($e, {
              show: a.value,
              "no-close-on-overlay": "",
              size: "l",
              onClose: k[5] || (k[5] = (Ce) => a.value = !1)
            }, {
              default: j(() => [
                q(oe, { alertMode: "warning" }, {
                  default: j(() => [
                    Me(Q(Y.$t("builder.deleteNodeConfirmation")), 1)
                  ]),
                  _: 1
                }),
                q(ge, null, {
                  default: j(() => [
                    R("span")
                  ]),
                  _: 1
                }),
                q(X, null, {
                  default: j(() => [
                    q(F, {
                      autofocus: "",
                      variant: "primary",
                      mode: "error",
                      onClick: k[3] || (k[3] = (Ce) => Y.$emit("delete-node"))
                    }, {
                      default: j(() => [
                        Me(Q(Y.$t("builder.delete")), 1)
                      ]),
                      _: 1
                    }),
                    q(F, {
                      variant: "default",
                      mode: "error",
                      onClick: k[4] || (k[4] = (Ce) => a.value = !1)
                    }, {
                      default: j(() => [
                        Me(Q(Y.$t("builder.cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })) : ee("", !0)
      ], 6);
    };
  }
}, y2 = /* @__PURE__ */ K(b2, [["__scopeId", "data-v-56038b4d"]]), Lr = J(/* @__PURE__ */ new Map()), Dg = Mp(() => {
  function n(r, i) {
    if (!i) return null;
    if (Lr.value.has(r))
      return Lr.value.get(r);
    const o = Vp(i, {
      deep: !0,
      debounce: 500,
      clone: Or
    });
    return Lr.value.set(r, o), o;
  }
  function e(r) {
    return Lr.value.get(r);
  }
  function t(r) {
    Lr.value.has(r) && Lr.value.delete(r);
  }
  return {
    createHistory: n,
    getHistory: e,
    deleteHistory: t
  };
}), C2 = {
  __name: "ActiveNodeWrapper",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean
  },
  setup(n) {
    const e = Oe("state"), t = n, { node: r, isEditable: i } = Kl(t), o = I(() => I_(r.value)), a = Oe("insideSharedContentLayout"), s = I(() => {
      var w, m, T, x;
      if (!i.value) return !1;
      if (g.value) {
        if (!h(r.value) && a.value)
          return !1;
        const A = ((m = (w = e == null ? void 0 : e.value) == null ? void 0 : w.activeNode) == null ? void 0 : m.id) === r.value.id && v(r.value);
        return h(r.value) || A;
      }
      return ((x = (T = e == null ? void 0 : e.value) == null ? void 0 : T.activeNode) == null ? void 0 : x.id) === r.value.id || u.value;
    }), l = (w) => {
      var m;
      return (m = w.nodes) != null && m.length ? w.nodes.some(
        (T) => {
          var x, A;
          return T.id === ((A = (x = e == null ? void 0 : e.value) == null ? void 0 : x.activeNode) == null ? void 0 : A.id) || l(T);
        }
      ) : !1;
    }, u = I(() => {
      var m, T;
      return [
        Ut,
        St
      ].includes(r.value.type) && ((T = (m = e == null ? void 0 : e.value) == null ? void 0 : m.activeNode) == null ? void 0 : T.id) && l(r.value);
    }), c = J(null), {
      isSharedContentLayout: d,
      isolateSharedContent: f,
      isCurrentSharedContentBeingEdited: h,
      editingSharedContent: g,
      editingSharedContentNodes: p,
      isNodeInsideEditingSharedContentLayout: v
    } = _t({
      state: e
    }), { pause: b } = Hu(e.value.builder), { createHistory: _ } = Dg(e), y = () => {
      b();
      const { top: w, left: m, width: T, height: x } = zp(c);
      f(w, m, T, x), _(
        g.value.sharedContentId,
        p
      );
    }, C = I(() => {
      let w = "var(--pb-black)", m = "var(--primary-white)";
      switch (o.value) {
        case mr:
          w = "var(--color-layout)";
          break;
        case _r:
          w = "var(--color-content)";
          break;
        case Ql:
          w = "var(--color-sub-content)", m = "var(--purple)";
          break;
      }
      return d(r.value) && (w = "var(--color-shared-content)"), {
        "--node-group-toolbar-bg-color": w,
        "--node-group-toolbar-color": m
      };
    });
    return (w, m) => {
      var T;
      return D(), U("div", {
        ref_key: "activeNodeRef",
        ref: c,
        class: He([
          `${o.value}-active-wrapper`,
          { "is-editing-shared-content": V(h)(V(r)) }
        ]),
        style: ht(C.value)
      }, [
        s.value ? (D(), W(y2, {
          key: 0,
          node: V(r),
          "active-accordion-id": u.value && ((T = V(r)) == null ? void 0 : T.id),
          onAddCustomAttributes: m[0] || (m[0] = (x) => w.$emit("add-custom-attributes")),
          onCopyNode: m[1] || (m[1] = (x) => w.$emit("copy-node")),
          onCutNode: m[2] || (m[2] = (x) => w.$emit("cut-node")),
          onPasteNode: m[3] || (m[3] = (x) => w.$emit("paste-node")),
          onDuplicateNode: m[4] || (m[4] = (x) => w.$emit("duplicate-node")),
          onFavorite: m[5] || (m[5] = (x) => w.$emit("favorite")),
          onDeleteNode: m[6] || (m[6] = (x) => w.$emit("delete-node")),
          onEditSharedContent: y
        }, null, 8, ["node", "active-accordion-id"])) : ee("", !0),
        nt(w.$slots, "default", {}, void 0, !0)
      ], 6);
    };
  }
}, w2 = /* @__PURE__ */ K(C2, [["__scopeId", "data-v-cd4af42f"]]);
function Rg({ node: n, state: e, maxNestingLevelsAllowed: t, isDraggableEditable: r, parentNodeId: i, isInsideSharedContentLayout: o = !1 }) {
  const a = ({ draggedContext: d, to: f }) => {
    const h = Number(f.getAttribute("data-level")) + 1;
    if (ir(d.element) && h >= t.value)
      return !1;
    const p = f.getAttribute("data-in-accordion") === "true";
    if (d.element.type === Ut && p)
      return !1;
  }, s = (d) => {
    e.nodeDragging = d.item._underlying_vm_;
  }, l = () => {
    e.nodeDragging = null;
  }, u = (d) => {
    var h;
    const f = (h = d.added) == null ? void 0 : h.element;
    if (d.added && f.type === St) {
      const g = f.parentAccordionId, { parentAccordionId: p } = n.nodes.find(
        (v) => v.parentAccordionId !== g
      );
      p && (f.parentAccordionId = p);
    }
  }, c = I(() => {
    var f;
    const d = (f = e == null ? void 0 : e.editingSharedContent) == null ? void 0 : f.node;
    return o ? !!d : d && i ? d.id === i || !!qt(d, i) : r.value;
  });
  return {
    handleDraggableNodeMoved: a,
    handleNodeDraggingStarted: s,
    handleNodeDraggingEnded: l,
    handleDraggableNodeChanged: u,
    isDraggableEnabled: c
  };
}
function Pg({
  state: n = {}
}) {
  const { copy: e, isSupported: t } = O0(), r = (c, d, f) => {
    if (n.isLinkModalOpen) return;
    const h = kn(c);
    Lf(c) && (h.parentAccordionId = c.parentAccordionId), d.nodes.splice(f + 1, 0, h), n == null || n.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "added",
      attributes: {
        method: "duplicate",
        component: h.type
      }
    });
  }, i = (c, d, f = !1) => {
    if (n.isLinkModalOpen) return;
    const h = c.nodes[d];
    c.nodes.splice(d, 1), n == null || n.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "removed",
      attributes: {
        method: f ? "cut" : "delete",
        component: h.type
      }
    });
  }, o = () => {
    var f, h;
    if (!n.activeNode || !t || n.isLinkModalOpen) return;
    a();
    const { parent: c, index: d } = Mt((f = n.builder) == null ? void 0 : f.structure, (h = n.activeNode) == null ? void 0 : h.id);
    i(c, d, !0), n.clearActiveNode(), n.clearEditor();
  }, a = () => {
    !n.activeNode || !t || n.isLinkModalOpen || e(JSON.stringify(n.activeNode));
  }, s = async () => {
    const c = await navigator.clipboard.readText();
    let d = !1;
    try {
      const f = JSON.parse(c), h = Array.isArray(f) ? [...f] : [f];
      return d = h.some((g) => (g.component || "").includes("ts-")), {
        clipboardData: h,
        isValidNode: !0,
        isLegacyNode: d
      };
    } catch {
      return {
        clipboardData: [c],
        isValidNode: !1,
        isLegacyNode: d
      };
    }
  }, l = async (c = null) => {
    if (!c) {
      const { clipboardData: v = [], isLegacyNode: b } = await s();
      c = v, b && (c = u(c));
    }
    const d = !(n != null && n.activeNode), f = !!(n != null && n.activeNode) && ir(n == null ? void 0 : n.activeNode), h = !!(n != null && n.activeNode) && Jp(n == null ? void 0 : n.activeNode), g = !!(n != null && n.activeNode) && Lf(n == null ? void 0 : n.activeNode);
    (Array.isArray(c) ? c : [c]).forEach((v, b) => {
      var C, w, m, T, x;
      const _ = kn(v), y = b;
      if (n == null || n.emitToConsumingApp("amplitude-event", {
        type: _.name,
        action: "added",
        attributes: {
          method: "paste",
          component: _.type
        }
      }), d) {
        (m = (w = (C = n == null ? void 0 : n.builder) == null ? void 0 : C.structure) == null ? void 0 : w.nodes) == null || m.push(_);
        return;
      }
      if (f) {
        n.activeNode.nodes[0].nodes.push(_);
        return;
      }
      if (h) {
        const { parent: A, index: M } = Mt((T = n.builder) == null ? void 0 : T.structure, (x = n.activeNode) == null ? void 0 : x.id), O = M + y + 1;
        A.nodes.splice(O, 0, _);
        return;
      }
      if (g) {
        if (rv(_))
          return;
        n.activeNode.nodes[0].nodes.push(_);
        return;
      }
    });
  }, u = (c = [{}]) => {
    var f, h;
    if (!n) return;
    let d = null;
    if (typeof ((h = (f = n == null ? void 0 : n.builder) == null ? void 0 : f.legacyAdapters) == null ? void 0 : h.pageToBuilder) == "function") {
      const { structure: g, assets: p } = n.builder.legacyAdapters.pageToBuilder(c);
      p && n.addAsset(p), g.id && g.id === "root" ? d = g.nodes || [{}] : d = g || [{}];
    }
    return d;
  };
  return {
    duplicateNode: r,
    deleteNode: i,
    cutSelectedNode: o,
    copySelectedNode: a,
    isClipboardSupported: t,
    dataInClipboard: s,
    pasteNode: l,
    convertLegacyStructureToBuilderStructure: u
  };
}
const T2 = {
  __name: "DraggableNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    parentNodeId: {
      type: String,
      default: ""
    },
    inAccordion: Boolean,
    isEditable: Boolean
  },
  setup(n) {
    const e = G(() => Promise.resolve().then(() => Lg)), t = Oe("state"), r = Oe("maxNestingLevelsAllowed"), i = n, o = I(() => i.modelValue), a = I(() => i.isEditable);
    function s() {
      var A, M, O, S, P, N;
      (A = t == null ? void 0 : t.value) != null && A.nodeDragging && ((N = t == null ? void 0 : t.value) == null || N.emitToConsumingApp("amplitude-event", {
        type: (O = (M = t == null ? void 0 : t.value) == null ? void 0 : M.nodeDragging) == null ? void 0 : O.name,
        action: "added",
        attributes: {
          method: "drag-and-drop",
          component: (P = (S = t == null ? void 0 : t.value) == null ? void 0 : S.nodeDragging) == null ? void 0 : P.type
        }
      }), t.value.nodeDragging = null);
    }
    function l(A) {
      var M, O;
      (M = t == null ? void 0 : t.value) == null || M.clearEditor(), (O = t == null ? void 0 : t.value) == null || O.clearActiveNode(), y(o.value, A);
    }
    const u = Oe("insideSharedContentLayout");
    function c(A, M) {
      var O, S;
      if (m.value) {
        w(M) && (A.stopPropagation(), (O = t == null ? void 0 : t.value) == null || O.setActiveNode(M));
        return;
      }
      u.value || a.value && (A.stopPropagation(), (S = t == null ? void 0 : t.value) == null || S.setActiveNode(M));
    }
    const {
      handleDraggableNodeMoved: d,
      handleNodeDraggingStarted: f,
      handleNodeDraggingEnded: h,
      handleDraggableNodeChanged: g,
      isDraggableEnabled: p
    } = Rg({
      node: o,
      state: t.value,
      maxNestingLevelsAllowed: r,
      isDraggableEditable: a,
      parentNodeId: i.parentNodeId,
      isInsideSharedContentLayout: u.value
    }), {
      copySelectedNode: v,
      cutSelectedNode: b,
      pasteNode: _,
      deleteNode: y,
      duplicateNode: C
    } = Pg({ state: t.value }), { isNodeInsideEditingSharedContentLayout: w, editingSharedContent: m } = _t({
      state: t
    }), T = /* @__PURE__ */ new Map();
    function x(A) {
      const M = A.id;
      if (!T.has(M)) {
        const O = fe(null);
        du(O, {
          onEnter() {
            var P, N, E;
            const S = ((N = (P = T.get(M)) == null ? void 0 : P.childNode) == null ? void 0 : N.type) || "";
            [
              Hn,
              On,
              En,
              In
            ].includes(S) && ((E = t == null ? void 0 : t.value) == null || E.setActiveNode(T.get(M).childNode));
          },
          dataTypes: ["image/png", "image/jpg", "image/jpeg", "image/gif"]
        }), T.set(M, { elRef: O, childNode: A });
      }
      return (O) => {
        const S = T.get(M);
        S && (S.elRef.value = O);
      };
    }
    return (A, M) => o.value.nodes ? (D(), U("div", {
      key: 0,
      class: "draggable-node-list-container"
    }, [
      q(V(fp), {
        ref: "builder-draggable",
        list: o.value.nodes,
        "ghost-class": "ghost-class",
        handle: ".handler",
        class: He([
          "draggable-node-list",
          { "empty-node": !o.value.nodes.length },
          `draggable-level-${n.level}`
        ]),
        group: n.draggableGroup,
        "swap-threshold": 0.5,
        "data-level": n.level,
        disabled: !V(p),
        "item-key": "id",
        "data-in-accordion": n.inAccordion,
        move: V(d),
        onStart: V(f),
        onEnd: V(h),
        onChange: V(g),
        onDrop: s
      }, {
        item: j(({ element: O, index: S }) => [
          o.value.nodes.length ? (D(), W(w2, {
            class: He({ "accordion-panel-active-wrapper": n.inAccordion }),
            key: O.id,
            node: O,
            "is-editable": a.value,
            "in-accordion": n.inAccordion,
            onCopyNode: V(v),
            onCutNode: V(b),
            onPasteNode: V(_),
            onDuplicateNode: (P) => V(C)(O, o.value, S),
            onDeleteNode: (P) => l(S)
          }, {
            default: j(() => [
              q(V(e), {
                modelValue: o.value.nodes[S],
                "onUpdate:modelValue": (P) => o.value.nodes[S] = P,
                level: n.level + 1,
                "in-accordion": n.inAccordion,
                "is-editable": a.value,
                onClick: (P) => c(P, O),
                ref: x(O)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "level", "in-accordion", "is-editable", "onClick"])
            ]),
            _: 2
          }, 1032, ["class", "node", "is-editable", "in-accordion", "onCopyNode", "onCutNode", "onPasteNode", "onDuplicateNode", "onDeleteNode"])) : n.inAccordion ? (D(), U("div", {
            key: 1,
            style: { "pointer-events": "auto" },
            class: "accordion-panel-placeholder"
          }, Q(A.$t("builder.content.accordion.emptyAccordionMessage")), 1)) : ee("", !0)
        ]),
        _: 1
      }, 8, ["list", "class", "group", "data-level", "disabled", "data-in-accordion", "move", "onStart", "onEnd", "onChange"])
    ])) : ee("", !0);
  }
}, S2 = /* @__PURE__ */ K(T2, [["__scopeId", "data-v-fe0943de"]]), x2 = {
  name: "DraggableBlocker",
  props: {
    message: {
      type: String,
      required: !0
    }
  }
};
function A2(n, e, t, r, i, o) {
  return D(), U("div", {
    class: "blockage-mask",
    "blocked-layout-message": t.message
  }, null, 8, ["blocked-layout-message"]);
}
const O2 = /* @__PURE__ */ K(x2, [["render", A2], ["__scopeId", "data-v-a3ecc03c"]]), E2 = {
  __name: "BorderRadiusControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = I({
      get: () => {
        var o, a, s;
        return ((s = (a = (o = t.node) == null ? void 0 : o.properties) == null ? void 0 : a.borderRadius) == null ? void 0 : s.value) || 0;
      },
      set: (o) => {
        r("update", o);
      }
    });
    return (o, a) => {
      const s = $("a-form-input");
      return D(), W(xr, null, {
        title: j(() => [
          R("h4", null, Q(o.$t("builder.borderStyles.borderRadius")), 1)
        ]),
        control: j(() => [
          q(s, {
            modelValue: i.value,
            "onUpdate:modelValue": a[0] || (a[0] = (l) => i.value = l),
            width: "70px",
            type: "number",
            min: 0,
            max: 100
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}, I2 = /* @__PURE__ */ K(E2, [["__scopeId", "data-v-36b970f3"]]), N2 = {
  name: "MarginControl",
  components: {
    NodeControl: xr
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    property: {
      type: String,
      default: "margin"
    }
  },
  computed: {
    toggleLinked: {
      get() {
        var n, e, t;
        return (t = (e = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : e[this.property]) == null ? void 0 : t.linked;
      },
      set(n) {
        this.$emit("toggle", n);
      }
    }
  },
  methods: {
    updateLinkedValue(n) {
      var e, t;
      this.$emit("update", {
        ...((t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t[this.property]) || {},
        value: Number(n)
      });
    },
    updateMarginPadding(n, e) {
      var t, r;
      this.$emit("update", {
        ...((r = (t = this.node) == null ? void 0 : t.properties) == null ? void 0 : r[this.property]) || {},
        [n]: Number(e)
      });
    }
  }
};
function k2(n, e, t, r, i, o) {
  const a = $("a-form-input"), s = $("a-text"), l = $("a-tooltip"), u = $("a-toggle"), c = $("NodeControl");
  return D(), W(c, null, {
    title: j(() => [
      R("h4", null, Q(n.$t(`builder.borderStyles.${t.property}`)), 1)
    ]),
    content: j(() => {
      var d, f, h, g, p, v, b, _, y;
      return [
        R("div", { class: "inline-control" }, [
          q(a, {
            type: "number",
            width: "70px",
            label: "",
            min: 0,
            step: 2,
            disabled: !((h = (f = (d = t.node) == null ? void 0 : d.properties) == null ? void 0 : f[t.property]) != null && h.linked),
            "model-value": ((v = (p = (g = t.node) == null ? void 0 : g.properties) == null ? void 0 : p[t.property]) == null ? void 0 : v.value) || 0,
            "onUpdate:modelValue": o.updateLinkedValue
          }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"]),
          R("div", { class: "more-options-toggle" }, [
            q(l, {
              label: n.$t("builder.linkedTooltip"),
              position: "left",
              size: "small"
            }, {
              default: j(() => [
                q(s, null, {
                  default: j(() => [
                    Me(Q(n.$t("builder.linked")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            q(u, {
              modelValue: o.toggleLinked,
              "onUpdate:modelValue": e[0] || (e[0] = (C) => o.toggleLinked = C)
            }, null, 8, ["modelValue"])
          ])
        ]),
        (y = (_ = (b = t.node) == null ? void 0 : b.properties) == null ? void 0 : _[t.property]) != null && y.linked ? ee("", !0) : (D(), U("div", {
          key: 0,
          class: "more-options-row"
        }, [
          (D(), U(gt, null, nr(["top", "right", "bottom", "left"], (C) => {
            var w, m, T;
            return R("div", {
              key: C,
              class: "more-options-input-wrapper"
            }, [
              q(a, {
                class: "more-options-input",
                type: "number",
                width: "70px",
                label: C,
                min: 0,
                step: 2,
                modelValue: ((T = (m = (w = t.node) == null ? void 0 : w.properties) == null ? void 0 : m[t.property]) == null ? void 0 : T[C]) || 0,
                "onUpdate:modelValue": (x) => o.updateMarginPadding(C, x)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]);
          }), 64))
        ]))
      ];
    }),
    _: 1
  });
}
const D2 = /* @__PURE__ */ K(N2, [["render", k2], ["__scopeId", "data-v-88077f9b"]]), R2 = {
  name: "LayoutNodeControl",
  components: {
    BackgroundColorControl: Pp,
    BackgroundImageControl: Sv,
    BorderRadiusControl: I2,
    MarginPaddingControl: D2,
    SidebarHeader: wu
  },
  inject: ["state"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    layoutCustomProperties() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t[this.node.type]) || {};
    },
    node() {
      return this.modelValue;
    },
    experimentalFeatures() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.experimentalFeatures) || {};
    }
  }
};
function P2(n, e, t, r, i, o) {
  const a = $("SidebarHeader"), s = $("BackgroundColorControl"), l = $("BackgroundImageControl"), u = $("BorderRadiusControl"), c = $("MarginPaddingControl"), d = $("portal");
  return D(), W(d, {
    to: o.node.id
  }, {
    default: j(() => [
      q(a, {
        title: o.node.name,
        onCloseSidebar: e[0] || (e[0] = (f) => n.$emit("close-sidebar"))
      }, null, 8, ["title"]),
      R("div", null, [
        o.layoutCustomProperties.backgroundColorAllowed ? (D(), W(s, {
          key: 0,
          node: o.node,
          onUpdate: e[1] || (e[1] = (f, h) => o.node.properties.backgroundColor[f] = h)
        }, null, 8, ["node"])) : ee("", !0),
        o.layoutCustomProperties.backgroundImageAllowed ? (D(), W(l, {
          key: 1,
          node: o.node,
          assets: o.state.builder.assets,
          "upload-api": o.state.builder.api.images,
          onUpdate: e[2] || (e[2] = (f, h) => o.node.properties.backgroundImage[f] = h),
          onAssetEntry: e[3] || (e[3] = (f) => o.state.addAsset(f))
        }, null, 8, ["node", "assets", "upload-api"])) : ee("", !0),
        o.experimentalFeatures.roundedLayouts ? (D(), W(u, {
          key: 2,
          node: o.node,
          onUpdate: e[4] || (e[4] = (f) => o.node.properties.borderRadius.value = f)
        }, null, 8, ["node"])) : ee("", !0),
        o.layoutCustomProperties.marginAllowed ? (D(), W(c, {
          key: 3,
          node: o.node,
          property: "margin",
          onUpdate: e[5] || (e[5] = (f) => o.node.properties.margin = f),
          onToggle: e[6] || (e[6] = (f) => o.node.properties.margin.linked = f)
        }, null, 8, ["node"])) : ee("", !0),
        o.layoutCustomProperties.paddingAllowed ? (D(), W(c, {
          key: 4,
          node: o.node,
          property: "padding",
          onUpdate: e[7] || (e[7] = (f) => o.node.properties.padding = f),
          onToggle: e[8] || (e[8] = (f) => o.node.properties.padding.linked = f)
        }, null, 8, ["node"])) : ee("", !0)
      ])
    ]),
    _: 1
  }, 8, ["to"]);
}
const M2 = /* @__PURE__ */ K(R2, [["render", P2]]);
function L2(n) {
  const e = I(() => {
    var i;
    return ((i = n.value) == null ? void 0 : i.properties) || {};
  }), t = I(() => e.value.customClasses || []), r = I(() => e.value.anchorTag || "");
  return {
    nodeProperties: e,
    customClasses: t,
    anchorTag: r
  };
}
const q2 = {
  __name: "LayoutNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    inAccordion: Boolean,
    isActiveNode: Boolean,
    isEditable: Boolean,
    isEmptyBuilder: Boolean
  },
  setup(n) {
    up((E) => ({
      "58798d59": y.value
    }));
    const e = Oe("state"), t = Oe("isRenderMode"), r = Oe("maxNestingLevelsAllowed"), i = n, {
      modelValue: o,
      level: a,
      draggableGroup: s,
      inAccordion: l,
      isActiveNode: u,
      isEditable: c,
      isEmptyBuilder: d
    } = Kl(i);
    if (!t.value && !o.value.hasAnimated && o.value.id !== "root") {
      const E = yn(o.value.id), { play: L } = Eg(E);
      L(), o.value.hasAnimated = !0;
    }
    const h = J({ width: 700, height: 70 }), g = J(null);
    mt(() => {
      g.value && (h.value.width = g.value.clientWidth || 0, h.value.height = g.value.clientHeight || 0);
    }), fu(g, (E) => {
      var te;
      const L = E[0], { inlineSize: H, blockSize: z } = ((te = L.borderBoxSize) == null ? void 0 : te[0]) || {};
      h.value.width = H || g.value.clientWidth, h.value.height = z || g.value.clientHeight;
    });
    const p = I(() => {
      var E;
      return {
        ...GC(
          (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder,
          o.value,
          !1,
          h.value
        ),
        "--root-level-width": `calc(${C.value} - ${A.value})`,
        "--root-level-max-width": `calc(${w.value} - ${A.value})`
      };
    }), v = I(() => o.value.type.replace(/_/g, "-").toLowerCase().replace("layout-node-", "")), b = I(() => {
      var te, le, ce, ae, ue, de;
      const E = ((le = (te = e == null ? void 0 : e.value) == null ? void 0 : te.nodeDragging) == null ? void 0 : le.id) === ((ce = o.value) == null ? void 0 : ce.id);
      if (!((ae = e == null ? void 0 : e.value) != null && ae.nodeDragging) || E)
        return {
          isBlocked: !1,
          message: ""
        };
      if (O(o.value)) return S.value;
      const L = a.value + 1 >= r.value, H = ir((ue = e == null ? void 0 : e.value) == null ? void 0 : ue.nodeDragging), z = !!qt(
        (de = e == null ? void 0 : e.value) == null ? void 0 : de.nodeDragging,
        o.value.id
      );
      return {
        isBlocked: L && H && !z,
        message: "builder.cannotNestMoreLayouts"
      };
    }), _ = (E) => ir(o.value) || O(o.value) ? o.value.nodes[E] : o.value, y = I(() => {
      switch (o.value.type) {
        case qe:
        case Cn:
        case Hr:
        case et:
          return 1;
        case wn:
        case xn:
        case An:
          return 2;
        case Tn:
          return 3;
        case Sn:
          return 4;
        default:
          return 0;
      }
    }), C = I(() => {
      var E, L, H, z;
      return o.value.type === Hr || l.value ? "100%" : ((z = (H = (L = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : L.customProperties) == null ? void 0 : H.global) == null ? void 0 : z.rootElementsWidth) || "100%";
    }), w = I(() => {
      var E, L, H, z;
      return o.value.type === Hr || l.value ? "100%" : ((z = (H = (L = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : L.customProperties) == null ? void 0 : H.global) == null ? void 0 : z.rootElementsMaxWidth) || "100%";
    }), { nodeProperties: m, customClasses: T, anchorTag: x } = L2(o), A = I(() => {
      var te, le, ce, ae, ue, de, ye, pt;
      const E = !!((le = (te = m.value) == null ? void 0 : te.margin) != null && le.linked), L = ((ae = (ce = m.value) == null ? void 0 : ce.margin) == null ? void 0 : ae.left) || 0, H = ((de = (ue = m.value) == null ? void 0 : ue.margin) == null ? void 0 : de.right) || 0, z = ((pt = (ye = m.value) == null ? void 0 : ye.margin) == null ? void 0 : pt.value) || 0;
      return E ? `${z * 2}px` : `${L + H}px`;
    }), M = I(() => {
      var E, L, H;
      return !!u.value && R_(
        (H = (L = (E = e == null ? void 0 : e.value) == null ? void 0 : E.builder) == null ? void 0 : L.customProperties) == null ? void 0 : H[o.value.type]
      );
    }), {
      isSharedContentLayout: O,
      blockSharedContentLayout: S,
      editingSharedContent: P
    } = _t({
      state: e
    }), N = I(() => {
      var E, L;
      return !!((E = P.value) != null && E.id) && ((L = P.value) == null ? void 0 : L.id) === o.value.id;
    });
    return (E, L) => (D(), U("div", {
      ref: V(o).id,
      class: He(["pb-layout-container", [
        `row-level-${V(a)}`,
        { "in-accordion": V(l) },
        { "is-empty-builder": V(d) }
      ]])
    }, [
      R("div", {
        ref_key: "layoutNodeContainer",
        ref: g,
        class: He(["layout-node-container", [
          { "is-active": V(u) || N.value },
          v.value + "-row",
          V(T)
        ]]),
        style: ht(p.value),
        "data-builder-label": E.$t("builder.emptyBuilderLabel"),
        "data-anchor-tag": V(x)
      }, [
        b.value.isBlocked ? (D(), W(O2, {
          key: 0,
          message: E.$t(b.value.message)
        }, null, 8, ["message"])) : ee("", !0),
        (D(!0), U(gt, null, nr(y.value, (H, z) => (D(), U("div", {
          key: z,
          class: He(["column", [v.value, { "is-editable": V(c) }]])
        }, [
          q(S2, {
            "model-value": _(z),
            level: V(a),
            "draggable-group": V(s),
            "is-editable": V(c),
            "in-accordion": V(l),
            "parent-node-id": V(o).id || ""
          }, null, 8, ["model-value", "level", "draggable-group", "is-editable", "in-accordion", "parent-node-id"])
        ], 2))), 128))
      ], 14, ["data-builder-label", "data-anchor-tag"]),
      M.value ? (D(), W(M2, {
        key: 0,
        modelValue: V(o),
        "onUpdate:modelValue": L[0] || (L[0] = (H) => lp(o) ? o.value = H : null),
        onCloseSidebar: L[1] || (L[1] = (H) => V(e).clearActiveNode())
      }, null, 8, ["modelValue"])) : ee("", !0)
    ], 2));
  }
}, B2 = /* @__PURE__ */ K(q2, [["__scopeId", "data-v-c8f73711"]]), U2 = {
  __name: "NodeManager",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    isEditable: Boolean,
    inAccordion: Boolean
  },
  setup(n) {
    const e = Oe("state"), t = n, { modelValue: r, isEditable: i, inAccordion: o, level: a } = Kl(t), s = I(() => (l(r.value) && u(r), r.value)), {
      isSharedContentLayout: l,
      applyContentToSharedContentLayout: u,
      isCurrentSharedContentBeingEdited: c
    } = _t({ state: e }), d = Oe("insideSharedContentLayout"), f = I(
      () => !c(s.value) && (!!(d != null && d.value) || l(s.value))
    );
    ti("insideSharedContentLayout", f);
    const h = I(
      () => ir(s.value) || ev(s.value) || l(s.value)
    ), g = I(
      () => s.value.id === "root" && a.value === 0
    ), p = I(() => {
      var T;
      return i.value ? g.value && ((T = s.value.nodes) == null ? void 0 : T.length) === 0 || E_(s.value, o.value) : !1;
    }), v = I(() => {
      var T, x;
      return i.value && ((T = e == null ? void 0 : e.value) == null ? void 0 : T.activeNode) && ((x = e == null ? void 0 : e.value) == null ? void 0 : x.activeNode.id) === s.value.id;
    }), b = I(() => ({
      "empty-builder": p.value,
      "is-editable": i.value,
      root: g.value
    })), _ = I(() => {
      var T, x;
      return g.value && !!((x = (T = e == null ? void 0 : e.value) == null ? void 0 : T.editingSharedContent) != null && x.node);
    }), y = J(null), { top: C, left: w } = zp(y), m = I(() => {
      var E, L, H;
      if (!((L = (E = e == null ? void 0 : e.value) == null ? void 0 : E.editingSharedContent) != null && L.node)) return {};
      const {
        top: T,
        left: x,
        width: A,
        height: M
      } = (H = e == null ? void 0 : e.value) == null ? void 0 : H.editingSharedContent.boundingRect, O = T - C.value - 40, S = x - w.value, P = A, N = M;
      return {
        clipPath: `polygon(0% 0%, 0% 100%, ${S}px 100%, ${S}px ${O}px, ${S + P}px ${O}px, ${S + P}px ${O + N}px, ${S}px ${O + N}px, ${S}px 100%, 100% 100%, 100% 0%)`
      };
    });
    return (T, x) => (D(), U("div", {
      ref_key: "nodeManagerContainer",
      ref: y,
      class: He(["node-manager-container", b.value])
    }, [
      h.value ? (D(), W(B2, {
        key: 0,
        modelValue: s.value,
        "onUpdate:modelValue": x[0] || (x[0] = (A) => s.value = A),
        level: V(a),
        "is-editable": V(i),
        "in-accordion": V(o),
        "draggable-group": n.draggableGroup,
        "is-active-node": v.value,
        "is-empty-builder": p.value
      }, null, 8, ["modelValue", "level", "is-editable", "in-accordion", "draggable-group", "is-active-node", "is-empty-builder"])) : (D(), W(jC, {
        key: 1,
        modelValue: s.value,
        "onUpdate:modelValue": x[1] || (x[1] = (A) => s.value = A),
        "is-editable": V(i),
        "in-accordion": V(o),
        level: V(a),
        isActiveNode: v.value
      }, null, 8, ["modelValue", "is-editable", "in-accordion", "level", "isActiveNode"])),
      _.value ? (D(), W(Sy, {
        key: 2,
        style: ht(m.value)
      }, null, 8, ["style"])) : ee("", !0)
    ], 2));
  }
}, Mg = /* @__PURE__ */ K(U2, [["__scopeId", "data-v-eff29325"]]), Lg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mg
}, Symbol.toStringTag, { value: "Module" })), j2 = {
  __name: "SharedContentDialog",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    contentPreview: {
      type: Object,
      default: () => ({})
    }
  },
  setup(n) {
    const e = n;
    return (t, r) => {
      const i = $("a-icon"), o = $("a-button");
      return D(), U("div", { class: "shared-content-dialog no-drag" }, [
        R("div", { class: "preview-section" }, [
          q(Mg, {
            "model-value": n.contentPreview,
            "is-editable": !1
          }, null, 8, ["model-value"])
        ]),
        R("div", { class: "info-section" }, [
          R("p", { class: "node-name" }, Q(e.node.name), 1),
          R("div", { class: "info-actions" }, [
            q(o, {
              class: "settings-button",
              variant: "none",
              onClick: r[0] || (r[0] = (a) => t.$emit("open-settings"))
            }, {
              default: j(() => [
                q(i, { icon: "24:settings-1" })
              ]),
              _: 1
            }),
            ee("", !0)
          ])
        ])
      ]);
    };
  }
}, H2 = /* @__PURE__ */ K(j2, [["__scopeId", "data-v-27da9484"]]), $2 = {
  __name: "SharedContentIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  setup(n) {
    const e = Oe("state"), t = n, r = J(!1), i = J(!1), o = (d) => i.value = d, a = (d) => r.value = d, {
      generateDialogPreview: s,
      openSharedContentSettings: l,
      deleteSharedContent: u
    } = _t({
      state: e
    }), c = I(
      () => s(t.node.sharedContentId)
    );
    return (d, f) => {
      const h = $("a-icon");
      return D(), U("div", { class: "shared-content-block" }, [
        bn((D(), U("div", {
          class: "block",
          onDblclick: f[0] || (f[0] = (g) => d.$emit("add-node"))
        }, [
          q(h, {
            class: "icon",
            icon: "32:paper-plane"
          }),
          q(kg, {
            style: { width: "75px" },
            "color-on-hover": "white",
            "is-hovering": r.value,
            "activate-scroll": r.value
          }, {
            default: j(() => [
              R("span", { class: "node-name" }, Q(t.node.name), 1)
            ]),
            _: 1
          }, 8, ["is-hovering", "activate-scroll"])
        ], 32)), [
          [V(kl), [a]]
        ]),
        bn((D(), U("div", null, [
          R("div", { class: "triangle" }, [
            q(h, {
              class: "eye-icon",
              icon: "24:eye-open",
              color: "white"
            })
          ]),
          i.value && !r.value ? (D(), W(H2, {
            key: 0,
            node: t.node,
            "content-preview": c.value,
            onOpenSettings: f[1] || (f[1] = (g) => V(l)(t.node.sharedContentId)),
            onDelete: f[2] || (f[2] = (g) => V(u)(t.node.sharedContentId))
          }, null, 8, ["node", "content-preview"])) : ee("", !0)
        ])), [
          [V(kl), [o, { delayLeave: 150 }]]
        ])
      ]);
    };
  }
}, F2 = /* @__PURE__ */ K($2, [["__scopeId", "data-v-4036c559"]]), V2 = {
  __name: "SidebarNodes",
  props: {
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    },
    isSharedContentSidebar: Boolean
  },
  setup(n) {
    const e = n, t = Oe("state"), r = ai({
      nodes: [
        ...Jl,
        ...yi.filter(
          (O) => ![...nm, ...im].includes(O.type)
        )
      ]
    }), i = I(
      () => {
        var O, S;
        return ((S = (O = t == null ? void 0 : t.value) == null ? void 0 : O.builder) == null ? void 0 : S.customProperties) || {};
      }
    ), {
      isSharedContentLayout: o,
      getSharedContentSidebarNodes: a,
      onSidebarCloneSharedContent: s,
      amountOfSharedContent: l,
      editingSharedContent: u,
      addNodeToEditingSharedContent: c
    } = _t({ state: t }), d = J(""), f = I(
      () => e.isSharedContentSidebar ? [et] : [mr, _r]
    ), h = I(() => {
      let O = e.nodesIncluded.length ? r.nodes.filter((S) => e.nodesIncluded.includes(S.type)) : r.nodes;
      return O = O.filter((S) => {
        var E, L, H;
        const P = !!((H = (L = (E = i.value) == null ? void 0 : E.CONTENT_NODE_NAVIGATION) == null ? void 0 : L.siteMenu) != null && H.length);
        return !(S.type === ui && !P);
      }), O.filter(
        (S) => !e.nodesExcluded.includes(S.type)
      );
    }), g = I(() => {
      var O;
      return ((O = i.value) == null ? void 0 : O.experimentalFeatures) || {};
    }), p = I(() => {
      var O, S;
      return (S = (O = i.value) == null ? void 0 : O.global) == null ? void 0 : S.focusNewNodeOnCreate;
    }), v = (O) => {
      var P, N, E;
      const S = C(O);
      if (u.value) {
        c(S);
        return;
      }
      (N = (P = t == null ? void 0 : t.value) == null ? void 0 : P.builder) == null || N.structure.nodes.push(S), (E = t == null ? void 0 : t.value) == null || E.emitToConsumingApp("amplitude-event", {
        type: S.name,
        action: "added",
        attributes: {
          method: "double-click",
          component: S.type
        }
      });
    }, b = (O) => {
      switch (O) {
        case mr:
          return "Layouts";
        case _r:
          return "Contents";
        case et:
          return "Shared Content";
      }
    }, _ = (O) => ({
      "blocks-container": !0,
      "shared-blocks-container": O === et,
      "layout-blocks-container": O === mr,
      "content-blocks-container": O === _r
    }), y = (O) => O === et ? a.value.filter(
      ({ name: P, sharedContentId: N }) => {
        var E;
        return P.toLowerCase().includes(d.value.toLowerCase().trim()) && N !== ((E = u == null ? void 0 : u.value) == null ? void 0 : E.sharedContentId);
      }
    ) : h.value.filter((S) => S.group === O), C = (O) => o(O) ? m(O) : w(O), w = (O) => {
      var P, N;
      let S = null;
      switch (O.group) {
        case mr:
          S = ze(O, g.value);
          break;
        case _r:
          S = yr(O, (P = t == null ? void 0 : t.value) == null ? void 0 : P.builder.theme);
          break;
      }
      return p.value && ((N = t == null ? void 0 : t.value) == null || N.setActiveNode(S)), S;
    }, m = (O) => {
      var P;
      const S = s(O);
      return p.value && ((P = t == null ? void 0 : t.value) == null || P.setActiveNode(S)), S;
    }, T = Oe("maxNestingLevelsAllowed"), {
      handleDraggableNodeMoved: x,
      handleNodeDraggingStarted: A,
      handleNodeDraggingEnded: M
    } = Rg({
      state: t.value,
      maxNestingLevelsAllowed: T
    });
    return (O, S) => {
      const P = $("a-form-input");
      return D(), U("div", { class: "sidebar-nodes" }, [
        (D(!0), U(gt, null, nr(f.value, (N) => (D(), U("div", {
          key: N,
          class: "group-block"
        }, [
          R("h4", { class: "group-title" }, Q(b(N)), 1),
          N === V(et) && V(l) > 6 ? (D(), W(P, {
            key: 0,
            type: "search",
            placeholder: O.$t("builder.builderTabs.searchSharedContentPlaceholder"),
            modelValue: d.value,
            "onUpdate:modelValue": S[0] || (S[0] = (E) => d.value = E)
          }, null, 8, ["placeholder", "modelValue"])) : ee("", !0),
          q(V(fp), {
            ref_for: !0,
            ref: "sidebar-draggable",
            list: y(N),
            class: He(_(N)),
            filter: ".no-drag",
            group: { name: "structure", pull: "clone", put: !1 },
            clone: C,
            sort: !1,
            "item-key": "id",
            move: V(x),
            onStart: V(A),
            onEnd: V(M)
          }, {
            item: j(({ element: E, index: L }) => [
              N !== V(et) ? (D(), W(Cy, {
                node: E,
                "group-type": N,
                key: `${E.type}-${L}`,
                onAddNode: (H) => v(E)
              }, null, 8, ["node", "group-type", "onAddNode"])) : (D(), W(F2, {
                node: E,
                key: `sc-${E.type}-${L}`,
                onAddNode: (H) => v(E)
              }, null, 8, ["node", "onAddNode"]))
            ]),
            _: 2
          }, 1032, ["list", "class", "move", "onStart", "onEnd"])
        ]))), 128))
      ]);
    };
  }
}, rp = /* @__PURE__ */ K(V2, [["__scopeId", "data-v-e2aa8f9a"]]), z2 = {
  __name: "ContentToolbar",
  props: {
    builder: {
      type: Object,
      default: () => ({})
    },
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    }
  },
  emits: ["switch-tab"],
  setup(n, { emit: e }) {
    const t = Oe("state"), r = J("content"), i = J(!1), { isSharedContentAllowed: o, hasSharedContent: a } = _t({
      state: t
    }), s = I(
      () => o.value && a.value
    );
    Ae(s, (d) => {
      d || (r.value = "content", u("switch-tab", r.value));
    });
    const l = J([
      {
        value: "content",
        label: "Content",
        ariaControls: "Content"
      },
      {
        value: "shared",
        label: "Shared",
        ariaControls: "Shared"
      }
    ]), u = e, c = (d) => {
      r.value = d.target.value, u("switch-tab", r.value);
    };
    return (d, f) => {
      const h = $("a-tabs"), g = $("a-icon"), p = $("a-button");
      return i.value ? (D(), W(rb, {
        key: 0,
        builder: n.builder,
        onCloseSidebar: f[0] || (f[0] = (v) => i.value = !1)
      }, null, 8, ["builder"])) : (D(), U("div", { key: 1 }, [
        R("div", { class: "tabs-section" }, [
          s.value ? (D(), W(h, {
            key: 0,
            selected: r.value,
            tabs: l.value,
            class: "sidebar-tabs",
            onSwitchTabs: c
          }, null, 8, ["selected", "tabs"])) : (D(), U("h3", {
            key: 1,
            class: "sidebar-title"
          }, Q(d.$t("builder.builderTabs.dragAndDropElements")), 1)),
          q(p, {
            class: "settings-button",
            variant: "none",
            onClick: f[1] || (f[1] = (v) => i.value = !0)
          }, {
            default: j(() => [
              q(g, { icon: "24:settings-2" })
            ]),
            _: 1
          })
        ]),
        r.value === "content" ? (D(), U("div", { key: 0 }, [
          q(rp, {
            "nodes-included": n.nodesIncluded,
            "nodes-excluded": n.nodesExcluded
          }, null, 8, ["nodes-included", "nodes-excluded"])
        ])) : ee("", !0),
        r.value === "shared" ? (D(), U("div", { key: 1 }, [
          q(rp, { "is-shared-content-sidebar": "" })
        ])) : ee("", !0)
      ]));
    };
  }
}, W2 = /* @__PURE__ */ K(z2, [["__scopeId", "data-v-a1077ba7"]]), G2 = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
};
function Y2(n, e, t, r, i, o) {
  return D(), U("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("g", { opacity: o.isDisabled }, [
      R("path", {
        d: "M4 11.5823H14.92C17.7256 11.5823 20 13.8567 20 16.6623V18.3333M4 11.5823L9.65217 5M4 11.5823L9.65217 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], 8, ["opacity"])
  ]);
}
const qg = /* @__PURE__ */ K(G2, [["render", Y2]]), xw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qg
}, Symbol.toStringTag, { value: "Module" })), Z2 = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
};
function X2(n, e, t, r, i, o) {
  return D(), U("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    R("g", { opacity: o.isDisabled }, [
      R("path", {
        d: "M20 11.5823H9.08C6.27439 11.5823 4 13.8567 4 16.6623V18.3333M20 11.5823L14.3478 5M20 11.5823L14.3478 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], 8, ["opacity"])
  ]);
}
const Bg = /* @__PURE__ */ K(Z2, [["render", X2]]), Aw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bg
}, Symbol.toStringTag, { value: "Module" })), K2 = {
  name: "BuilderToolbar",
  components: {
    // BreakpointPreview,
    UndoIcon: qg,
    RedoIcon: Bg
  },
  inject: ["state"],
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    },
    redoDisabled: Boolean,
    undoDisabled: Boolean
  },
  computed: {
    editor() {
      var n;
      return ((n = this.state) == null ? void 0 : n.editor) || {
        editor: {},
        editorKey: "",
        enabledOptions: [],
        removeOptions: [],
        colorPalette: {}
      };
    },
    linkModalOptions() {
      return this.customRTEProperties.linkModalOptions || {};
    },
    colorPalette() {
      var e, t, r;
      return {
        enabled: D_(
          ((e = this.state) == null ? void 0 : e.builder) || {}
        ),
        colors: ((r = (t = this.editor) == null ? void 0 : t.colorPalette) == null ? void 0 : r.colors) || ["*"]
      };
    },
    customRTEProperties() {
      var n, e, t;
      return ((t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.RTEBar) || {};
    },
    aiEnabled() {
      var n, e, t, r, i;
      return ((i = (r = (t = (e = (n = this.state) == null ? void 0 : n.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.global) == null ? void 0 : r.aiOptions) == null ? void 0 : i.enabled) || !1;
    },
    getRemoveOptions() {
      const n = this.customRTEProperties.removeOptions || [], e = this.editor.removeOptions || [];
      return [...n, ...e];
    }
  },
  methods: {
    toggleModal(n) {
      this.state.isLinkModalOpen = n, this.$emit("toggle-modal", n);
    }
  }
};
function Q2(n, e, t, r, i, o) {
  const a = $("UndoIcon"), s = $("a-button"), l = $("a-tooltip"), u = $("RedoIcon"), c = $("a-static-rte");
  return D(), U("div", { class: "sticky-header" }, [
    (D(), W(c, {
      key: o.editor.editorKey,
      class: "editor",
      disabled: !!o.customRTEProperties.disabled,
      "remove-default-actions": o.customRTEProperties.removeDefaultActions,
      "remove-options": o.getRemoveOptions,
      "editor-instance": o.editor.editor,
      "enabled-options": o.editor.enabledOptions,
      "link-modal-options": o.linkModalOptions,
      "color-palette": o.colorPalette,
      "font-sizes": o.customRTEProperties.fontSizes,
      "ai-enabled": o.aiEnabled,
      onToggleModal: o.toggleModal,
      onClick: e[2] || (e[2] = cl(() => {
      }, ["prevent", "stop"]))
    }, {
      "custom-actions": j(() => [
        R("div", { class: "history-buttons" }, [
          q(l, {
            label: n.$t("builder.toolbar.undo"),
            position: "bottom"
          }, {
            default: j(() => [
              q(s, {
                variant: "none",
                disabled: t.undoDisabled,
                onClick: e[0] || (e[0] = (d) => n.$emit("undo"))
              }, {
                default: j(() => [
                  q(a, { disabled: t.undoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          q(l, {
            label: n.$t("builder.toolbar.redo"),
            position: "bottom"
          }, {
            default: j(() => [
              q(s, {
                variant: "none",
                disabled: t.redoDisabled,
                onClick: e[1] || (e[1] = (d) => n.$emit("redo"))
              }, {
                default: j(() => [
                  q(u, { disabled: t.redoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["disabled", "remove-default-actions", "remove-options", "editor-instance", "enabled-options", "link-modal-options", "color-palette", "font-sizes", "ai-enabled", "onToggleModal"]))
  ]);
}
const J2 = /* @__PURE__ */ K(K2, [["render", Q2], ["__scopeId", "data-v-114cea93"]]);
function np(...n) {
  return I(() => n.some((e) => ve(e)));
}
function ew({
  state: n = null,
  undo: e = null,
  redo: t = null,
  duplicateNode: r = null,
  deleteNode: i = null,
  allowArrowNavigation: o = !1,
  copySelectedNode: a = null,
  cutSelectedNode: s = null,
  dataInClipboard: l = null,
  pasteNode: u = null,
  isRenderMode: c = !1
}) {
  if (c) return;
  const { text: d } = L0(), { editingSharedContent: f } = _t({ state: n }), h = Ud(), g = I(() => {
    var C, w, m, T;
    return ((C = h.value) == null ? void 0 : C.tagName) === "INPUT" || ((w = h.value) == null ? void 0 : w.tagName) === "TEXTAREA" || ((T = (m = n == null ? void 0 : n.editor) == null ? void 0 : m.editor) == null ? void 0 : T.isFocused);
  }), p = I(() => !!d.value), v = I(() => {
    var C, w;
    return (w = (C = n == null ? void 0 : n.editor) == null ? void 0 : C.editor) == null ? void 0 : w.isFocused;
  });
  mt(() => {
    s && De(document, "cut", (C) => {
      if (v.value || n.isCodeModalOpen) return !0;
      if (!n || p.value) return !1;
      s();
    }), a && De(document, "copy", (C) => {
      !n || p.value || n.isCodeModalOpen || a();
    }), u && De(document, "paste", (C) => {
      _(C);
    });
  });
  const b = P0({
    passive: !1,
    async onEventFired(C) {
      const w = C.type === "keydown", m = {
        ctrlZ: !!e && (C.ctrlKey || C.metaKey) && C.key.toLowerCase() === "z",
        shiftCtrlZ: !!t && C.shiftKey && (C.ctrlKey || C.metaKey) && C.key.toLowerCase() === "z",
        ctrlD: !!r && C.ctrlKey && C.key.toLowerCase() === "d",
        ctrlBackspace: !!i && C.ctrlKey && C.key === "Backspace",
        arrowUp: !g.value && !!o && C.key === "ArrowUp",
        arrowDown: !g.value && !!o && C.key === "ArrowDown",
        arrowLeft: !g.value && !!o && C.key === "ArrowLeft",
        arrowRight: !g.value && !!o && C.key === "ArrowRight",
        escape: C.key === "Escape"
      };
      w && Object.values(m).some((T) => !!T) && C.preventDefault();
    }
  });
  e && kt(np(b.ctrl_z, b.meta_z), () => {
    n.isCodeModalOpen || e();
  }), t && kt(np(b.shift_ctrl_z, b.meta_shift_z), () => {
    n.isCodeModalOpen || t();
  }), r && kt(b.ctrl_d, () => {
    var m, T;
    if (!(n != null && n.activeNode) || n.isCodeModalOpen) return;
    const { parent: C, index: w } = Mt(
      (m = n.builder) == null ? void 0 : m.structure,
      (T = n.activeNode) == null ? void 0 : T.id
    );
    return r(n.activeNode, C, w);
  }), i && kt(b.ctrl_backspace, () => {
    var m, T;
    if (!(n != null && n.activeNode) || n.isCodeModalOpen) return;
    const { parent: C, index: w } = Mt(
      (m = n.builder) == null ? void 0 : m.structure,
      (T = n.activeNode) == null ? void 0 : T.id
    );
    n.clearActiveNode(), n.clearEditor(), i(C, w);
  }), o && n && kt(b.arrowUp, () => {
    var w, m, T, x, A, M, O;
    if (!o || g.value || n.isCodeModalOpen || f.value) return;
    if (!(n != null && n.activeNode)) {
      n.setActiveNode(((T = (m = (w = n.builder) == null ? void 0 : w.structure) == null ? void 0 : m.nodes) == null ? void 0 : T[0]) || null);
      return;
    }
    const C = Mt(
      (x = n.builder) == null ? void 0 : x.structure,
      (A = n.activeNode) == null ? void 0 : A.id
    );
    C.index - 1 >= 0 && n.setActiveNode(((O = (M = C.parent) == null ? void 0 : M.nodes) == null ? void 0 : O[(C == null ? void 0 : C.index) - 1]) || null);
  }), o && n && kt(b.arrowDown, () => {
    var w, m, T, x, A, M, O, S;
    if (!o || g.value || n.isCodeModalOpen || f.value) return;
    if (!(n != null && n.activeNode)) {
      n.setActiveNode(((T = (m = (w = n.builder) == null ? void 0 : w.structure) == null ? void 0 : m.nodes) == null ? void 0 : T[0]) || null);
      return;
    }
    const C = Mt(
      (x = n.builder) == null ? void 0 : x.structure,
      (A = n.activeNode) == null ? void 0 : A.id
    );
    (((M = C.parent) == null ? void 0 : M.nodes) || []).length - 1 >= C.index + 1 && n.setActiveNode(((S = (O = C.parent) == null ? void 0 : O.nodes) == null ? void 0 : S[C.index + 1]) || null);
  }), o && n && kt(b.arrowLeft, () => {
    var w, m;
    if (!o || g.value || !n.activeNode || n.isCodeModalOpen || f.value) return;
    const C = tv(
      (w = n.builder) == null ? void 0 : w.structure,
      (m = n.activeNode) == null ? void 0 : m.id
    );
    C.grandparent && n.setActiveNode(C.grandparent);
  }), o && n && kt(b.arrowRight, () => {
    var w, m, T, x, A, M, O, S, P, N;
    if (!o || g.value || !n.activeNode || n.isCodeModalOpen || f.value) return;
    const C = ((m = (w = n.activeNode) == null ? void 0 : w.nodes) == null ? void 0 : m.length) > 0 && ((M = (A = (x = (T = n.activeNode) == null ? void 0 : T.nodes) == null ? void 0 : x[0]) == null ? void 0 : A.nodes) == null ? void 0 : M.length) > 0;
    ir(n.activeNode) && C && n.setActiveNode(((N = (P = (S = (O = n.activeNode) == null ? void 0 : O.nodes) == null ? void 0 : S[0]) == null ? void 0 : P.nodes) == null ? void 0 : N[0]) || null);
  }), n && kt(b.escape, async () => {
    n.clearActiveNode(), n.clearEditor();
  });
  async function _(C) {
    var S, P;
    if (n.isCodeModalOpen) return;
    const { value: w = {} } = Ud(), m = !!w.editor, T = w.type;
    if (m || g.value && T !== "text")
      return;
    C.preventDefault();
    const { clipboardData: x, isValidNode: A, isLegacyNode: M } = await l();
    let O = x;
    if (M && typeof ((P = (S = n == null ? void 0 : n.builder) == null ? void 0 : S.legacyAdapters) == null ? void 0 : P.pageToBuilder) == "function") {
      const { structure: N, assets: E } = n.builder.legacyAdapters.pageToBuilder(O);
      E && n.addAsset(E), N.id && N.id === "root" ? O = N.nodes || [{}] : O = N || [{}];
    }
    if (!A) {
      g.value && y(x[0], w);
      return;
    }
    u && u(O);
  }
  function y(C, w) {
    const m = w.selectionStart, T = w.selectionEnd, x = w.value, A = x.slice(0, m) + C + x.slice(T);
    w.value = A, w.selectionStart = w.selectionEnd = m + C.length, w.dispatchEvent(new Event("input"));
  }
}
const tw = {
  __name: "BuilderManager",
  props: {
    isEditable: Boolean
  },
  emits: ["update:modelValue"],
  setup(n, { emit: e }) {
    const t = n, r = e, i = Oe("state"), o = G(() => Promise.resolve().then(() => Lg)), a = I({
      get() {
        var S;
        return (S = i == null ? void 0 : i.value) == null ? void 0 : S.builder;
      },
      set(S) {
        i.value.builder = S, r("update:modelValue", S);
      }
    });
    Ae(a, (S) => r("update:modelValue", S), {
      deep: !0
    });
    const { undo: s, redo: l, canUndo: u, canRedo: c, pause: d, resume: f, clearSharedHistory: h } = Hu(a), { editingSharedContent: g } = _t({
      state: i
    }), { getHistory: p } = Dg(i);
    cp(() => {
      h();
    });
    const v = I(() => {
      if (g.value) {
        const { canUndo: S } = p(
          g.value.sharedContentId
        );
        return !S;
      }
      return !u.value;
    }), b = () => {
      if (d(), g.value) {
        const { undo: S } = p(
          g.value.sharedContentId
        );
        S();
        return;
      }
      s(), Ct(() => {
        f();
      });
    }, _ = I(() => {
      if (g.value) {
        const { canRedo: S } = p(
          g.value.sharedContentId
        );
        return !S;
      }
      return !c.value;
    }), y = () => {
      if (d(), g.value) {
        const { redo: S } = p(
          g.value.sharedContentId
        );
        S();
        return;
      }
      l(), Ct(() => {
        f();
      });
    }, {
      duplicateNode: C,
      deleteNode: w,
      copySelectedNode: m,
      cutSelectedNode: T,
      dataInClipboard: x,
      pasteNode: A
    } = Pg({
      state: i.value
    });
    ew({
      state: i.value,
      duplicateNode: C,
      deleteNode: w,
      copySelectedNode: m,
      cutSelectedNode: T,
      dataInClipboard: x,
      pasteNode: A,
      allowArrowNavigation: !0,
      undo: b,
      redo: y,
      isRenderMode: !t.isEditable
    }), dp();
    function M(S = "header") {
      var P;
      (P = i == null ? void 0 : i.value) == null || P.setActiveNode({ id: S });
    }
    function O() {
      var S;
      (S = i == null ? void 0 : i.value) == null || S.clearActiveNode();
    }
    return (S, P) => {
      var N, E, L, H, z, te;
      return D(), U("div", { class: "builder-manager-container" }, [
        R("section", { class: "builder-toolbar-section" }, [
          n.isEditable ? (D(), W(J2, {
            key: 0,
            builder: a.value,
            "redo-disabled": _.value,
            "undo-disabled": v.value,
            onRedo: y,
            onUndo: b,
            onToggleModal: P[0] || (P[0] = (le) => S.$emit("toggle-modal", le))
          }, {
            "header-preview": j(() => [
              nt(S.$slots, "header-preview", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["builder", "redo-disabled", "undo-disabled"])) : ee("", !0)
        ]),
        R("section", {
          class: He(["builder-draggable-section", { "is-editable": n.isEditable }])
        }, [
          (L = (E = (N = a.value) == null ? void 0 : N.customProperties) == null ? void 0 : E.global) != null && L.showHeaderSlot ? nt(S.$slots, "header", {
            key: 0,
            openSidebar: M,
            closeSidebar: O
          }, void 0, !0) : ee("", !0),
          q(V(o), {
            class: "main-node-manager",
            modelValue: a.value.structure,
            "onUpdate:modelValue": P[1] || (P[1] = (le) => a.value.structure = le),
            "is-editable": n.isEditable
          }, null, 8, ["modelValue", "is-editable"]),
          (te = (z = (H = a.value) == null ? void 0 : H.customProperties) == null ? void 0 : z.global) != null && te.showFooterSlot ? nt(S.$slots, "footer", { key: 1 }, void 0, !0) : ee("", !0)
        ], 2)
      ]);
    };
  }
}, rw = /* @__PURE__ */ K(tw, [["__scopeId", "data-v-d9966ce3"]]), nw = {
  __name: "CustomAttributesSidebar",
  setup(n) {
    const e = Oe("state"), t = J(-1), r = J(null), i = J(null), o = J(null), a = J(!0), s = J(!0), l = I({
      get: () => {
        var S, P;
        return ((P = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : P.anchorTag) || "";
      },
      set: (S) => {
        e.value.activeNode.properties.anchorTag = S;
      }
    }), u = I({
      get: () => {
        var S, P;
        return ((P = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.properties) == null ? void 0 : P.customClasses) || [];
      },
      set: (S) => e.value.activeNode.properties.customClasses = S
    }), c = I(
      () => u.value[t.value]
    ), d = I(() => x(l.value)), f = I(
      () => x(c.value)
    ), h = I(
      () => f.value || d.value
    );
    mt(() => {
      var S;
      r.value = (S = e == null ? void 0 : e.value) == null ? void 0 : S.activeNode.id, !(u.value.length > 0) && (t.value = 0, u.value.push(""));
    }), cp(() => {
      g(r.value);
    });
    const g = (S) => {
      var N, E;
      const P = qt((N = e == null ? void 0 : e.value) == null ? void 0 : N.builder.structure, S);
      !P || !((E = P == null ? void 0 : P.properties) != null && E.customClasses) || (P.properties.customClasses = P.properties.customClasses.filter(
        (L) => !!(L != null && L.trim())
      ));
    }, p = (S) => {
      var E, L;
      if (!S.value) return;
      const P = ((E = S.value) == null ? void 0 : E.$el) || ((L = S.value[0]) == null ? void 0 : L.$el);
      if (!P) return;
      const N = P.querySelector("input");
      N && N.focus();
    }, v = () => {
      s.value = !0, Ct(() => p(o));
    }, b = (S) => {
      f.value || (a.value = !0, t.value = S, Ct(() => p(i)));
    }, _ = I(() => {
      const S = u.value[u.value.length - 1];
      return !f.value && S !== "";
    }), y = () => {
      var S, P;
      (S = e == null ? void 0 : e.value) == null || S.activeNode.properties.customClasses.push(""), a.value = !0, t.value = ((P = e == null ? void 0 : e.value) == null ? void 0 : P.activeNode.properties.customClasses.length) - 1, Ct(() => p(i));
    }, C = () => {
      e.value.activeNode.properties.anchorTag = "", s.value = !0, Ct(() => p(o));
    }, w = I(() => u.value.length > 1), m = (S) => {
      var P;
      (P = e == null ? void 0 : e.value) == null || P.activeNode.properties.customClasses.splice(S, 1), S <= t.value && (t.value -= 1), i.value && Ct(() => p(i));
    }, T = /^(?!-\d)[a-zA-Z_-](?:[a-zA-Z0-9_-]|\\[^\n\r])*$/, x = (S) => S !== "" && !T.test(S), A = () => {
      !l.value || d.value || (s.value = !1);
    }, M = () => {
      !c.value || f.value || (a.value = !1);
    }, O = () => {
      h.value || (e.value.showCustomAttributesSidebar = !1);
    };
    return (S, P) => {
      const N = $("a-form-input"), E = $("a-icon"), L = $("a-button");
      return D(), U(gt, null, [
        q(wu, {
          title: S.$t("builder.controls.customAttributes.title"),
          onCloseSidebar: O
        }, null, 8, ["title"]),
        q(xr, null, {
          title: j(() => [
            R("h4", null, Q(S.$t("builder.controls.customAttributes.anchorTagLabel")), 1)
          ]),
          content: j(() => [
            s.value ? (D(), W(N, {
              key: 0,
              modelValue: l.value,
              "onUpdate:modelValue": P[0] || (P[0] = (H) => l.value = H),
              id: "anchor-tag-input",
              ref_key: "anchorInput",
              ref: o,
              placeholder: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              label: S.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              "sr-only": "",
              "label-for": "anchor-tag-input",
              "show-error": d.value,
              "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                attribute: S.$t("builder.controls.customAttributes.anchorTagLabel")
              }),
              onKeydown: Gu(A, ["enter"]),
              onBlur: A
            }, null, 8, ["modelValue", "placeholder", "label", "show-error", "error-message"])) : (D(), U("div", {
              key: 1,
              class: "non-editable-entry"
            }, [
              R("p", null, Q(l.value), 1),
              R("div", { class: "icons-container" }, [
                q(L, {
                  variant: "default",
                  size: "small",
                  onClick: v
                }, {
                  default: j(() => [
                    q(E, { icon: "16:edit" })
                  ]),
                  _: 1
                }),
                q(L, {
                  variant: "default",
                  size: "small",
                  onClick: C
                }, {
                  default: j(() => [
                    q(E, { icon: "16:trashcan" })
                  ]),
                  _: 1
                })
              ])
            ]))
          ]),
          _: 1
        }),
        q(xr, null, {
          title: j(() => [
            R("h4", null, Q(S.$t("builder.controls.customAttributes.customClassLabel")), 1)
          ]),
          content: j(() => [
            (D(!0), U(gt, null, nr(u.value, (H, z) => (D(), U("div", {
              key: z,
              class: "custom-class-container"
            }, [
              a.value && z === t.value ? (D(), W(N, {
                key: 0,
                modelValue: u.value[z],
                "onUpdate:modelValue": (te) => u.value[z] = te,
                id: `custom-class-input-${z}`,
                ref_for: !0,
                ref_key: "classInput",
                ref: i,
                placeholder: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                label: S.$t("builder.controls.customAttributes.customClassPlaceholder"),
                "sr-only": "",
                "label-for": `custom-class-input-${z}`,
                "show-error": f.value,
                "error-message": S.$t("builder.controls.customAttributes.invalidAttributeError", {
                  attribute: S.$t(
                    "builder.controls.customAttributes.customClassLabel"
                  )
                }),
                onKeydown: Gu(M, ["enter"]),
                onBlur: M
              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "placeholder", "label", "label-for", "show-error", "error-message"])) : (D(), U("div", {
                key: 1,
                class: "non-editable-entry"
              }, [
                R("p", null, Q(H), 1),
                R("div", { class: "icons-container" }, [
                  q(L, {
                    variant: "default",
                    size: "small",
                    onClick: (te) => b(z)
                  }, {
                    default: j(() => [
                      q(E, { icon: "16:edit" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  w.value ? (D(), W(L, {
                    key: 0,
                    variant: "default",
                    size: "small",
                    onClick: (te) => m(z)
                  }, {
                    default: j(() => [
                      q(E, { icon: "16:trashcan" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : ee("", !0)
                ])
              ]))
            ]))), 128)),
            R("div", { class: "button-container" }, [
              q(L, {
                variant: "link",
                disabled: !_.value,
                onClick: y
              }, {
                default: j(() => [
                  q(E, { icon: "16:plus" }),
                  Me(" " + Q(S.$t("builder.controls.customAttributes.addAnotherClass")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ], 64);
    };
  }
};
function iw(n, e, t = { childList: !0, subtree: !0 }, r = 50) {
  const i = J(null), o = J(!1);
  let a = null, s = null;
  const l = () => {
    s && clearTimeout(s), s = setTimeout(() => {
      o.value = !!document.querySelector(e);
    }, r);
  }, u = () => {
    a = new MutationObserver(() => {
      l();
    }), i.value && a.observe(i.value, t);
  };
  return mt(() => {
    if (document) {
      if (i.value = document.querySelector(n), !i.value) {
        console.error(
          `Target element with selector "${n}" not found`
        );
        return;
      }
      o.value = !!document.querySelector(e), u();
    }
  }), Yl(() => {
    a && a.disconnect(), s && clearTimeout(s);
  }), { elementExists: o };
}
const ow = {
  __name: "PageBuilder",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    isRenderMode: Boolean
  },
  emits: [
    "toggle-modal",
    "update:modelValue",
    "ai-on-success",
    "ai-on-loading",
    "ai-on-error",
    "amplitude-event",
    "toast-message"
  ],
  setup(n, { emit: e }) {
    const t = e, r = J(!1), i = (y) => {
      r.value = y, t("toggle-modal", y);
    }, { elementExists: o } = iw(
      ".root-dialog-container",
      ".a-dialog"
    );
    Ae(o, (y) => {
      t("toggle-modal", y);
    });
    const a = n, s = J(o0(t));
    ti("state", s), ti("isRenderMode", a.isRenderMode), mt(() => {
      var y;
      (y = navigator == null ? void 0 : navigator.userAgentData) != null && y.platform && (s.value.userAgent = navigator.userAgentData.platform.toLowerCase().includes("mac") ? "mac" : "windows");
    });
    const l = I(() => {
      var y;
      return (y = s == null ? void 0 : s.value) == null ? void 0 : y.builder.customProperties;
    }), u = I(
      () => l.value.global.maxNestingLevelsAllowed
    );
    ti("maxNestingLevelsAllowed", u);
    const c = I(() => a.modelValue);
    s.value.builder = c.value instanceof Bd ? c.value : new Bd(c.value);
    const d = I(
      () => {
        var y;
        return a0((y = s == null ? void 0 : s.value) == null ? void 0 : y.builder);
      }
    ), { extractSharedContentIds: f } = _t({
      state: s
    });
    c.value.extractSharedContentIds = f;
    const h = I(
      () => {
        var y, C, w;
        return (y = s == null ? void 0 : s.value) != null && y.showCustomAttributesSidebar ? "" : ((w = (C = s == null ? void 0 : s.value) == null ? void 0 : C.activeNode) == null ? void 0 : w.id) || "";
      }
    ), g = I(() => l.value.nodesIncluded), p = I(() => l.value.nodesExcluded), v = J("content"), b = (y) => {
      v.value = y;
    }, _ = I(() => v.value === "content" ? { "overflow-y": "auto", "overflow-x": "hidden" } : {});
    return (y, C) => {
      var w;
      return D(), U("div", {
        style: ht(d.value),
        class: "pb-main"
      }, [
        a.isRenderMode ? ee("", !0) : (D(), U("section", {
          key: 0,
          class: "sidebar-section",
          style: ht(_.value)
        }, [
          R("div", { class: "sidebar-container" }, [
            s.value.showCustomAttributesSidebar ? (D(), W(nw, {
              key: (w = s.value.activeNode) == null ? void 0 : w.id
            })) : (D(), W(V(dl), {
              key: 1,
              name: h.value
            }, {
              default: j(() => [
                q(W2, {
                  builder: s.value.builder,
                  "nodes-included": g.value,
                  "nodes-excluded": p.value,
                  onSwitchTab: b
                }, null, 8, ["builder", "nodes-included", "nodes-excluded"])
              ]),
              _: 1
            }, 8, ["name"]))
          ])
        ], 4)),
        R("section", {
          class: "builder-section",
          style: ht({ "z-index": r.value ? 1 : 0 })
        }, [
          q(rw, {
            "is-editable": !a.isRenderMode,
            "onUpdate:modelValue": C[0] || (C[0] = (m) => y.$emit("update:modelValue", m)),
            onToggleModal: i
          }, {
            header: j(({ openSidebar: m, closeSidebar: T }) => [
              nt(y.$slots, "header", {
                openSidebar: m,
                closeSidebar: T
              }, void 0, !0)
            ]),
            "header-preview": j(() => [
              nt(y.$slots, "header-preview", {}, void 0, !0)
            ]),
            footer: j(() => [
              nt(y.$slots, "footer", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["is-editable"])
        ], 4),
        R("div", { class: "root-dialog-container" }, [
          q(V(dl), { name: "root-dialog-container" })
        ])
      ], 4);
    };
  }
}, aw = /* @__PURE__ */ K(ow, [["__scopeId", "data-v-7fecf522"]]), Ow = {
  install(n) {
    n.use(rm), n.component("ABuilder", aw);
  }
};
export {
  Tw as $,
  au as A,
  Bt as B,
  St as C,
  O2 as D,
  lr as E,
  Zp as F,
  Jm as G,
  Lt as H,
  Y1 as I,
  qm as J,
  $t as K,
  dw as L,
  L2 as M,
  xr as N,
  g_ as O,
  kp as P,
  Ep as Q,
  m_ as R,
  wu as S,
  Pg as T,
  er as U,
  kg as V,
  Ar as W,
  Lp as X,
  It as Y,
  ww as Z,
  K as _,
  mw as a,
  Et as a0,
  Ft as a1,
  vu as a2,
  Ow as a3,
  qe as a4,
  Cn as a5,
  wn as a6,
  Tn as a7,
  Sn as a8,
  Hr as a9,
  yw as aA,
  Cw as aB,
  Sw as aC,
  Lg as aD,
  xw as aE,
  Aw as aF,
  xn as aa,
  An as ab,
  et as ac,
  $r as ad,
  ri as ae,
  Hn as af,
  fl as ag,
  hl as ah,
  On as ai,
  pl as aj,
  vl as ak,
  gl as al,
  ml as am,
  _l as an,
  En as ao,
  In as ap,
  bl as aq,
  Ut as ar,
  li as as,
  ui as at,
  Bd as au,
  ze as av,
  ir as aw,
  vw as ax,
  _w as ay,
  bw as az,
  N_ as b,
  Or as c,
  wv as d,
  gw as e,
  qt as f,
  yr as g,
  hu as h,
  pw as i,
  k_ as j,
  Zu as k,
  fw as l,
  Rp as m,
  U0 as n,
  zb as o,
  JC as p,
  Wp as q,
  du as r,
  r2 as s,
  s2 as t,
  hw as u,
  p_ as v,
  su as w,
  l2 as x,
  u2 as y,
  Si as z
};
